//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.2.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import followIfLoginRedirect from './components/api-authorization/followIfLoginRedirect';

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getMcpHealth(): Promise<void> {
        let url_ = this.baseUrl + "/mcp/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMcpHealth(_response);
        });
    }

    protected processGetMcpHealth(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class Arcolact__ALAcopiosClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfALAcopio> {
        let url_ = this.baseUrl + "/api/Arcolact/ALAcopios?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<PagingOfALAcopio> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfALAcopio.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfALAcopio>(null as any);
    }

    create(entity: ALAcopio): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALAcopios";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById(id: number): Promise<ALAcopio> {
        let url_ = this.baseUrl + "/api/Arcolact/ALAcopios/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<ALAcopio> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ALAcopio.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ALAcopio>(null as any);
    }

    update(id: number, entity: ALAcopio): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALAcopios/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALAcopios/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arcolact__ALAsignacionesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll2(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfALAsignacion> {
        let url_ = this.baseUrl + "/api/Arcolact/ALAsignaciones?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll2(_response);
        });
    }

    protected processGetAll2(response: Response): Promise<PagingOfALAsignacion> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfALAsignacion.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfALAsignacion>(null as any);
    }

    create2(entity: ALAsignacion): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALAsignaciones";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate2(_response);
        });
    }

    protected processCreate2(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById2(id: number): Promise<ALAsignacion> {
        let url_ = this.baseUrl + "/api/Arcolact/ALAsignaciones/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById2(_response);
        });
    }

    protected processGetById2(response: Response): Promise<ALAsignacion> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ALAsignacion.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ALAsignacion>(null as any);
    }

    update2(id: number, entity: ALAsignacion): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALAsignaciones/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate2(_response);
        });
    }

    protected processUpdate2(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete2(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALAsignaciones/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete2(_response);
        });
    }

    protected processDelete2(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getGastoInfo(gastoId2: string): Promise<ALAsignacionGastoInfoResult> {
        let url_ = this.baseUrl + "/api/Arcolact/ALAsignaciones/GastoInfo/{gastoId2}";
        if (gastoId2 === undefined || gastoId2 === null)
            throw new globalThis.Error("The parameter 'gastoId2' must be defined.");
        url_ = url_.replace("{gastoId2}", encodeURIComponent("" + gastoId2));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGastoInfo(_response);
        });
    }

    protected processGetGastoInfo(response: Response): Promise<ALAsignacionGastoInfoResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ALAsignacionGastoInfoResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ALAsignacionGastoInfoResult>(null as any);
    }
}

export class Arcolact__ALConfigClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getConfig(): Promise<ALConfigDTO> {
        let url_ = this.baseUrl + "/api/Arcolact/ALConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConfig(_response);
        });
    }

    protected processGetConfig(response: Response): Promise<ALConfigDTO> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ALConfigDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ALConfigDTO>(null as any);
    }

    updateConfig(config: ALConfigDTO): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateConfig(_response);
        });
    }

    protected processUpdateConfig(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getTablaVolumen(): Promise<BonificacionVolumenDTO[]> {
        let url_ = this.baseUrl + "/api/Arcolact/ALConfig/TablaVolumen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTablaVolumen(_response);
        });
    }

    protected processGetTablaVolumen(response: Response): Promise<BonificacionVolumenDTO[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BonificacionVolumenDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BonificacionVolumenDTO[]>(null as any);
    }

    setTablaVolumen(data: BonificacionVolumenDTO[]): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALConfig/TablaVolumen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetTablaVolumen(_response);
        });
    }

    protected processSetTablaVolumen(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    actualizaCupoCredito(request: ActualizaCupoCreditoRequest): Promise<ActualizaCupoCreditoItemDto[]> {
        let url_ = this.baseUrl + "/api/Arcolact/ALConfig/ActualizaCupoCredito";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActualizaCupoCredito(_response);
        });
    }

    protected processActualizaCupoCredito(response: Response): Promise<ActualizaCupoCreditoItemDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActualizaCupoCreditoItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActualizaCupoCreditoItemDto[]>(null as any);
    }

    listaEgresosBanco(request: ListaEgresosBancoRequest): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALConfig/ListaEgresosBanco";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListaEgresosBanco(_response);
        });
    }

    protected processListaEgresosBanco(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arcolact__ALDescuentosClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll3(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfALDescuento> {
        let url_ = this.baseUrl + "/api/Arcolact/ALDescuentos?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll3(_response);
        });
    }

    protected processGetAll3(response: Response): Promise<PagingOfALDescuento> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfALDescuento.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfALDescuento>(null as any);
    }

    create3(entity: ALDescuento): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALDescuentos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate3(_response);
        });
    }

    protected processCreate3(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById3(id: number): Promise<ALDescuento> {
        let url_ = this.baseUrl + "/api/Arcolact/ALDescuentos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById3(_response);
        });
    }

    protected processGetById3(response: Response): Promise<ALDescuento> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ALDescuento.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ALDescuento>(null as any);
    }

    update3(id: number, entity: ALDescuento): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALDescuentos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate3(_response);
        });
    }

    protected processUpdate3(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete3(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALDescuentos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete3(_response);
        });
    }

    protected processDelete3(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    createBulk(descuentos: ALDescuento[]): Promise<ResponseDto[]> {
        let url_ = this.baseUrl + "/api/Arcolact/ALDescuentos/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(descuentos);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateBulk(_response);
        });
    }

    protected processCreateBulk(response: Response): Promise<ResponseDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto[]>(null as any);
    }

    fromCartera(fechaCorte: Date): Promise<ALDescuentoFromCarteraResult> {
        let url_ = this.baseUrl + "/api/Arcolact/ALDescuentos/FromCartera?";
        if (fechaCorte === undefined || fechaCorte === null)
            throw new globalThis.Error("The parameter 'fechaCorte' must be defined and cannot be null.");
        else
            url_ += "fechaCorte=" + encodeURIComponent(fechaCorte ? "" + fechaCorte.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFromCartera(_response);
        });
    }

    protected processFromCartera(response: Response): Promise<ALDescuentoFromCarteraResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ALDescuentoFromCarteraResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ALDescuentoFromCarteraResult>(null as any);
    }

    deleteAll(): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALDescuentos/DeleteAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getFacturaInfo(facturaId2: string): Promise<ALDescuentoFacturaInfoResult> {
        let url_ = this.baseUrl + "/api/Arcolact/ALDescuentos/FacturaInfo/{facturaId2}";
        if (facturaId2 === undefined || facturaId2 === null)
            throw new globalThis.Error("The parameter 'facturaId2' must be defined.");
        url_ = url_.replace("{facturaId2}", encodeURIComponent("" + facturaId2));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFacturaInfo(_response);
        });
    }

    protected processGetFacturaInfo(response: Response): Promise<ALDescuentoFacturaInfoResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ALDescuentoFacturaInfoResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ALDescuentoFacturaInfoResult>(null as any);
    }

    anticipo(request: ALAnticipoRequest): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALDescuentos/Anticipo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnticipo(_response);
        });
    }

    protected processAnticipo(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseDto.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arcolact__ALDocSoporteClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    generar(request: ArcolactDocSoporteRequest): Promise<ArcolactDocSoporteResponse> {
        let url_ = this.baseUrl + "/api/Arcolact/ALDocSoporte";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerar(_response);
        });
    }

    protected processGenerar(response: Response): Promise<ArcolactDocSoporteResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArcolactDocSoporteResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ArcolactDocSoporteResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArcolactDocSoporteResponse>(null as any);
    }

    bulk(request: ArcolactDocSoporteRequest): Promise<JobCreatedResult> {
        let url_ = this.baseUrl + "/api/Arcolact/ALDocSoporte/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBulk(_response);
        });
    }

    protected processBulk(response: Response): Promise<JobCreatedResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobCreatedResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobCreatedResult>(null as any);
    }

    getPdfImpresion(alPlanillaId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Arcolact/ALDocSoporte/Impresion?";
        if (alPlanillaId === undefined || alPlanillaId === null)
            throw new globalThis.Error("The parameter 'alPlanillaId' must be defined and cannot be null.");
        else
            url_ += "AlPlanillaId=" + encodeURIComponent("" + alPlanillaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPdfImpresion(_response);
        });
    }

    protected processGetPdfImpresion(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class Arcolact__ALEgresosClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    createALEgreso(request: ALEgresoDTO): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALEgresos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateALEgreso(_response);
        });
    }

    protected processCreateALEgreso(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    bulkAlEgreso(request: ALEgresoBulkDTO): Promise<JobCreatedResult> {
        let url_ = this.baseUrl + "/api/Arcolact/ALEgresos/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBulkAlEgreso(_response);
        });
    }

    protected processBulkAlEgreso(response: Response): Promise<JobCreatedResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobCreatedResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobCreatedResult>(null as any);
    }
}

export class Arcolact__ALKardexClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll4(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfALKardex> {
        let url_ = this.baseUrl + "/api/Arcolact/ALKardex?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll4(_response);
        });
    }

    protected processGetAll4(response: Response): Promise<PagingOfALKardex> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfALKardex.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfALKardex>(null as any);
    }

    create4(entity: ALKardex): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALKardex";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate4(_response);
        });
    }

    protected processCreate4(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById4(id: number): Promise<ALKardex> {
        let url_ = this.baseUrl + "/api/Arcolact/ALKardex/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById4(_response);
        });
    }

    protected processGetById4(response: Response): Promise<ALKardex> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ALKardex.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ALKardex>(null as any);
    }

    update4(id: number, entity: ALKardex): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALKardex/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate4(_response);
        });
    }

    protected processUpdate4(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete4(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALKardex/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete4(_response);
        });
    }

    protected processDelete4(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getRutaDia(fecha: Date, rutaId: string): Promise<ALKardexRutaDiaDTO[]> {
        let url_ = this.baseUrl + "/api/Arcolact/ALKardex/RutaDia?";
        if (fecha === undefined || fecha === null)
            throw new globalThis.Error("The parameter 'fecha' must be defined and cannot be null.");
        else
            url_ += "fecha=" + encodeURIComponent(fecha ? "" + fecha.toISOString() : "") + "&";
        if (rutaId === undefined || rutaId === null)
            throw new globalThis.Error("The parameter 'rutaId' must be defined and cannot be null.");
        else
            url_ += "rutaId=" + encodeURIComponent("" + rutaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRutaDia(_response);
        });
    }

    protected processGetRutaDia(response: Response): Promise<ALKardexRutaDiaDTO[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ALKardexRutaDiaDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ALKardexRutaDiaDTO[]>(null as any);
    }

    createBulk2(entities: ALKardex[]): Promise<ResponseDto[]> {
        let url_ = this.baseUrl + "/api/Arcolact/ALKardex/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entities);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateBulk2(_response);
        });
    }

    protected processCreateBulk2(response: Response): Promise<ResponseDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto[]>(null as any);
    }

    sendGuiaRecoleccionEmail(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALKardex/{id}/SendMail";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendGuiaRecoleccionEmail(_response);
        });
    }

    protected processSendGuiaRecoleccionEmail(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arcolact__ALPlanillasClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll5(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfALPlanilla> {
        let url_ = this.baseUrl + "/api/Arcolact/ALPlanillas?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll5(_response);
        });
    }

    protected processGetAll5(response: Response): Promise<PagingOfALPlanilla> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfALPlanilla.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfALPlanilla>(null as any);
    }

    create5(request: ALPlanillaCreateDTO): Promise<number> {
        let url_ = this.baseUrl + "/api/Arcolact/ALPlanillas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate5(_response);
        });
    }

    protected processCreate5(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getById5(planillaId: number): Promise<ALPlanillaViewDTO> {
        let url_ = this.baseUrl + "/api/Arcolact/ALPlanillas/{planillaId}";
        if (planillaId === undefined || planillaId === null)
            throw new globalThis.Error("The parameter 'planillaId' must be defined.");
        url_ = url_.replace("{planillaId}", encodeURIComponent("" + planillaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById5(_response);
        });
    }

    protected processGetById5(response: Response): Promise<ALPlanillaViewDTO> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ALPlanillaViewDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ALPlanillaViewDTO>(null as any);
    }

    delete5(planillaId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Arcolact/ALPlanillas/{planillaId}";
        if (planillaId === undefined || planillaId === null)
            throw new globalThis.Error("The parameter 'planillaId' must be defined.");
        url_ = url_.replace("{planillaId}", encodeURIComponent("" + planillaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete5(_response);
        });
    }

    protected processDelete5(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    procesarPlanilla(request: ProcesarPlanillaRequest): Promise<ProcesarPlanillaResponse> {
        let url_ = this.baseUrl + "/api/Arcolact/ALPlanillas/Paso1";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProcesarPlanilla(_response);
        });
    }

    protected processProcesarPlanilla(response: Response): Promise<ProcesarPlanillaResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcesarPlanillaResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProcesarPlanillaErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcesarPlanillaResponse>(null as any);
    }

    procesarPlanillaPaso2(request: ProcesarPlanillaPaso2Request): Promise<ProcesarPlanillaPaso2Response> {
        let url_ = this.baseUrl + "/api/Arcolact/ALPlanillas/Paso2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProcesarPlanillaPaso2(_response);
        });
    }

    protected processProcesarPlanillaPaso2(response: Response): Promise<ProcesarPlanillaPaso2Response> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcesarPlanillaPaso2Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProcesarPlanillaPaso2Response.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcesarPlanillaPaso2Response>(null as any);
    }

    procesarPlanillaPaso3(request: ProcesarPlanillaPaso3Request): Promise<ProcesarPlanillaPaso3Response> {
        let url_ = this.baseUrl + "/api/Arcolact/ALPlanillas/Paso3";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProcesarPlanillaPaso3(_response);
        });
    }

    protected processProcesarPlanillaPaso3(response: Response): Promise<ProcesarPlanillaPaso3Response> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcesarPlanillaPaso3Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProcesarPlanillaPaso3Response.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcesarPlanillaPaso3Response>(null as any);
    }

    getPdfPlanilla(planillaId: number, soloProductoresSinCorreo: boolean | null | undefined, bancoId: number | null | undefined, rutaId: string | null | undefined, codProductor: number | null | undefined, ordenImpresion: OrdenImpresion | null | undefined, imprimeFullInfo: boolean | undefined, imprimeEgreso: boolean | undefined, imprimeReciboCaja: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Arcolact/ALPlanillas/Impresion/{planillaId}?";
        if (planillaId === undefined || planillaId === null)
            throw new globalThis.Error("The parameter 'planillaId' must be defined.");
        url_ = url_.replace("{planillaId}", encodeURIComponent("" + planillaId));
        if (soloProductoresSinCorreo !== undefined && soloProductoresSinCorreo !== null)
            url_ += "soloProductoresSinCorreo=" + encodeURIComponent("" + soloProductoresSinCorreo) + "&";
        if (bancoId !== undefined && bancoId !== null)
            url_ += "bancoId=" + encodeURIComponent("" + bancoId) + "&";
        if (rutaId !== undefined && rutaId !== null)
            url_ += "rutaId=" + encodeURIComponent("" + rutaId) + "&";
        if (codProductor !== undefined && codProductor !== null)
            url_ += "codProductor=" + encodeURIComponent("" + codProductor) + "&";
        if (ordenImpresion !== undefined && ordenImpresion !== null)
            url_ += "ordenImpresion=" + encodeURIComponent("" + ordenImpresion) + "&";
        if (imprimeFullInfo === null)
            throw new globalThis.Error("The parameter 'imprimeFullInfo' cannot be null.");
        else if (imprimeFullInfo !== undefined)
            url_ += "imprimeFullInfo=" + encodeURIComponent("" + imprimeFullInfo) + "&";
        if (imprimeEgreso === null)
            throw new globalThis.Error("The parameter 'imprimeEgreso' cannot be null.");
        else if (imprimeEgreso !== undefined)
            url_ += "imprimeEgreso=" + encodeURIComponent("" + imprimeEgreso) + "&";
        if (imprimeReciboCaja === null)
            throw new globalThis.Error("The parameter 'imprimeReciboCaja' cannot be null.");
        else if (imprimeReciboCaja !== undefined)
            url_ += "imprimeReciboCaja=" + encodeURIComponent("" + imprimeReciboCaja) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPdfPlanilla(_response);
        });
    }

    protected processGetPdfPlanilla(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sendSms(request: ALSMSProductoresRequest): Promise<ALSMSProductoresResponse> {
        let url_ = this.baseUrl + "/api/Arcolact/ALPlanillas/SendSms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendSms(_response);
        });
    }

    protected processSendSms(response: Response): Promise<ALSMSProductoresResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ALSMSProductoresResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ALSMSProductoresResponse>(null as any);
    }

    setMuestraStandard(request: SetMuestraStandardRequest): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALPlanillas/SetMuestraStandard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetMuestraStandard(_response);
        });
    }

    protected processSetMuestraStandard(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseDto.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    envioEmailMasivo(request: ALPlanillaEnvioEmailRequest): Promise<JobCreatedResult> {
        let url_ = this.baseUrl + "/api/Arcolact/ALPlanillas/EnvioEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEnvioEmailMasivo(_response);
        });
    }

    protected processEnvioEmailMasivo(response: Response): Promise<JobCreatedResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobCreatedResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobCreatedResult>(null as any);
    }

    envioEmail(request: ALPlanillaEnvioEmailRequest): Promise<ALPlanillaEnvioEmailResult> {
        let url_ = this.baseUrl + "/api/Arcolact/ALPlanillas/EnvioEmailAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEnvioEmail(_response);
        });
    }

    protected processEnvioEmail(response: Response): Promise<ALPlanillaEnvioEmailResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ALPlanillaEnvioEmailResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ALPlanillaEnvioEmailResult>(null as any);
    }
}

export class Arcolact__ALRecibosCajaClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    bulkReciboCaja(request: ALReciboCajaBulkDTO): Promise<JobCreatedResult> {
        let url_ = this.baseUrl + "/api/Arcolact/ALRecibosCaja/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBulkReciboCaja(_response);
        });
    }

    protected processBulkReciboCaja(response: Response): Promise<JobCreatedResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobCreatedResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobCreatedResult>(null as any);
    }

    pdfPorPlanilla(planillaId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Arcolact/ALRecibosCaja/Pdf/{planillaId}";
        if (planillaId === undefined || planillaId === null)
            throw new globalThis.Error("The parameter 'planillaId' must be defined.");
        url_ = url_.replace("{planillaId}", encodeURIComponent("" + planillaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPdfPorPlanilla(_response);
        });
    }

    protected processPdfPorPlanilla(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class Arcolact__ALResolucionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    listarAnos(): Promise<number[]> {
        let url_ = this.baseUrl + "/api/Arcolact/ALResolucion";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListarAnos(_response);
        });
    }

    protected processListarAnos(response: Response): Promise<number[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    crear(request: CrearResolucionRequest): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALResolucion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCrear(_response);
        });
    }

    protected processCrear(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getByAno(ano: number): Promise<ALResolucionDTO> {
        let url_ = this.baseUrl + "/api/Arcolact/ALResolucion/{ano}";
        if (ano === undefined || ano === null)
            throw new globalThis.Error("The parameter 'ano' must be defined.");
        url_ = url_.replace("{ano}", encodeURIComponent("" + ano));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByAno(_response);
        });
    }

    protected processGetByAno(response: Response): Promise<ALResolucionDTO> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ALResolucionDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ALResolucionDTO>(null as any);
    }

    modificar(ano: number, datos: ALResolucionDTO): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALResolucion/{ano}";
        if (ano === undefined || ano === null)
            throw new globalThis.Error("The parameter 'ano' must be defined.");
        url_ = url_.replace("{ano}", encodeURIComponent("" + ano));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(datos);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModificar(_response);
        });
    }

    protected processModificar(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arcolact__ALRutasClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll6(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfALRuta> {
        let url_ = this.baseUrl + "/api/Arcolact/ALRutas?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll6(_response);
        });
    }

    protected processGetAll6(response: Response): Promise<PagingOfALRuta> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfALRuta.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfALRuta>(null as any);
    }

    create6(entity: ALRuta): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALRutas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate6(_response);
        });
    }

    protected processCreate6(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById6(id: string): Promise<ALRuta> {
        let url_ = this.baseUrl + "/api/Arcolact/ALRutas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById6(_response);
        });
    }

    protected processGetById6(response: Response): Promise<ALRuta> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ALRuta.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ALRuta>(null as any);
    }

    update5(id: string, entity: ALRuta): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALRutas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate5(_response);
        });
    }

    protected processUpdate5(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete6(id: string): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/ALRutas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete6(_response);
        });
    }

    protected processDelete6(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arcolact__ReportesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    repMinisterio(desdeDate: Date | null | undefined, hastaDate: Date | null | undefined, tipoReporte: number | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Arcolact/Reportes/RepMinisterio?";
        if (desdeDate !== undefined && desdeDate !== null)
            url_ += "desdeDate=" + encodeURIComponent(desdeDate ? "" + desdeDate.toISOString() : "") + "&";
        if (hastaDate !== undefined && hastaDate !== null)
            url_ += "hastaDate=" + encodeURIComponent(hastaDate ? "" + hastaDate.toISOString() : "") + "&";
        if (tipoReporte !== undefined && tipoReporte !== null)
            url_ += "tipoReporte=" + encodeURIComponent("" + tipoReporte) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRepMinisterio(_response);
        });
    }

    protected processRepMinisterio(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ArcoCentral__AWS_SESClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    processNotification(): Promise<void> {
        let url_ = this.baseUrl + "/api/aws-ses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProcessNotification(_response);
        });
    }

    protected processProcessNotification(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class Arco1__BancosClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll7(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfBanco> {
        let url_ = this.baseUrl + "/api/Arco1/Bancos?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll7(_response);
        });
    }

    protected processGetAll7(response: Response): Promise<PagingOfBanco> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfBanco.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfBanco>(null as any);
    }

    create7(entity: Banco): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/Bancos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate7(_response);
        });
    }

    protected processCreate7(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById7(id: number): Promise<Banco> {
        let url_ = this.baseUrl + "/api/Arco1/Bancos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById7(_response);
        });
    }

    protected processGetById7(response: Response): Promise<Banco> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Banco.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Banco>(null as any);
    }

    update6(id: number, entity: Banco): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/Bancos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate6(_response);
        });
    }

    protected processUpdate6(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete7(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/Bancos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete7(_response);
        });
    }

    protected processDelete7(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arco3__BodegasClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll8(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfBodega> {
        let url_ = this.baseUrl + "/api/Arco3/Bodegas?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll8(_response);
        });
    }

    protected processGetAll8(response: Response): Promise<PagingOfBodega> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfBodega.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfBodega>(null as any);
    }

    create8(entity: Bodega): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Bodegas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate8(_response);
        });
    }

    protected processCreate8(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById8(id: string): Promise<Bodega> {
        let url_ = this.baseUrl + "/api/Arco3/Bodegas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById8(_response);
        });
    }

    protected processGetById8(response: Response): Promise<Bodega> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Bodega.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Bodega>(null as any);
    }

    update7(id: string, entity: Bodega): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Bodegas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate7(_response);
        });
    }

    protected processUpdate7(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete8(id: string): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Bodegas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete8(_response);
        });
    }

    protected processDelete8(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arco3__BodegaUbicacionesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll9(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfBodegaUbicacion> {
        let url_ = this.baseUrl + "/api/Arco3/BodegaUbicaciones?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll9(_response);
        });
    }

    protected processGetAll9(response: Response): Promise<PagingOfBodegaUbicacion> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfBodegaUbicacion.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfBodegaUbicacion>(null as any);
    }

    create9(entity: BodegaUbicacion): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/BodegaUbicaciones";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate9(_response);
        });
    }

    protected processCreate9(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById9(id: number): Promise<BodegaUbicacion> {
        let url_ = this.baseUrl + "/api/Arco3/BodegaUbicaciones/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById9(_response);
        });
    }

    protected processGetById9(response: Response): Promise<BodegaUbicacion> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BodegaUbicacion.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BodegaUbicacion>(null as any);
    }

    update8(id: number, entity: BodegaUbicacion): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/BodegaUbicaciones/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate8(_response);
        });
    }

    protected processUpdate8(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete9(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/BodegaUbicaciones/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete9(_response);
        });
    }

    protected processDelete9(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    listByBodegaId(bodegaId: string): Promise<BodegaUbicacionPorBodegaItemDto[]> {
        let url_ = this.baseUrl + "/api/Arco3/BodegaUbicaciones/bodega/{bodegaId}";
        if (bodegaId === undefined || bodegaId === null)
            throw new globalThis.Error("The parameter 'bodegaId' must be defined.");
        url_ = url_.replace("{bodegaId}", encodeURIComponent("" + bodegaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListByBodegaId(_response);
        });
    }

    protected processListByBodegaId(response: Response): Promise<BodegaUbicacionPorBodegaItemDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BodegaUbicacionPorBodegaItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BodegaUbicacionPorBodegaItemDto[]>(null as any);
    }
}

export class Arcolact__CierreRutasClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll10(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfCierreRuta> {
        let url_ = this.baseUrl + "/api/Arcolact/CierreRutas?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll10(_response);
        });
    }

    protected processGetAll10(response: Response): Promise<PagingOfCierreRuta> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfCierreRuta.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfCierreRuta>(null as any);
    }

    create10(entity: CierreRuta): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/CierreRutas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate10(_response);
        });
    }

    protected processCreate10(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById10(id: number): Promise<CierreRuta> {
        let url_ = this.baseUrl + "/api/Arcolact/CierreRutas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById10(_response);
        });
    }

    protected processGetById10(response: Response): Promise<CierreRuta> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CierreRuta.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CierreRuta>(null as any);
    }

    update9(id: number, entity: CierreRuta): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/CierreRutas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate9(_response);
        });
    }

    protected processUpdate9(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete10(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/CierreRutas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete10(_response);
        });
    }

    protected processDelete10(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getViajes(conductorId: number, cierreRutaFecha: Date): Promise<SearchDto[]> {
        let url_ = this.baseUrl + "/api/Arcolact/CierreRutas/viajes?";
        if (conductorId === undefined || conductorId === null)
            throw new globalThis.Error("The parameter 'conductorId' must be defined and cannot be null.");
        else
            url_ += "conductorId=" + encodeURIComponent("" + conductorId) + "&";
        if (cierreRutaFecha === undefined || cierreRutaFecha === null)
            throw new globalThis.Error("The parameter 'cierreRutaFecha' must be defined and cannot be null.");
        else
            url_ += "cierreRutaFecha=" + encodeURIComponent(cierreRutaFecha ? "" + cierreRutaFecha.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetViajes(_response);
        });
    }

    protected processGetViajes(response: Response): Promise<SearchDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchDto[]>(null as any);
    }

    getCierre(cierreRutaFecha: Date, conductorId: number, cierreRutaViaje: number | null | undefined): Promise<CierreRutaDetalleDTO> {
        let url_ = this.baseUrl + "/api/Arcolact/CierreRutas/detalle?";
        if (cierreRutaFecha === undefined || cierreRutaFecha === null)
            throw new globalThis.Error("The parameter 'cierreRutaFecha' must be defined and cannot be null.");
        else
            url_ += "cierreRutaFecha=" + encodeURIComponent(cierreRutaFecha ? "" + cierreRutaFecha.toISOString() : "") + "&";
        if (conductorId === undefined || conductorId === null)
            throw new globalThis.Error("The parameter 'conductorId' must be defined and cannot be null.");
        else
            url_ += "conductorId=" + encodeURIComponent("" + conductorId) + "&";
        if (cierreRutaViaje !== undefined && cierreRutaViaje !== null)
            url_ += "cierreRutaViaje=" + encodeURIComponent("" + cierreRutaViaje) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCierre(_response);
        });
    }

    protected processGetCierre(response: Response): Promise<CierreRutaDetalleDTO> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CierreRutaDetalleDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CierreRutaDetalleDTO>(null as any);
    }
}

export class Arco0__CiudadesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll11(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfCiudad> {
        let url_ = this.baseUrl + "/api/Arco0/Ciudades?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll11(_response);
        });
    }

    protected processGetAll11(response: Response): Promise<PagingOfCiudad> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfCiudad.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfCiudad>(null as any);
    }

    create11(entity: Ciudad): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco0/Ciudades";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate11(_response);
        });
    }

    protected processCreate11(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById11(id: string): Promise<Ciudad> {
        let url_ = this.baseUrl + "/api/Arco0/Ciudades/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById11(_response);
        });
    }

    protected processGetById11(response: Response): Promise<Ciudad> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Ciudad.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ciudad>(null as any);
    }

    update10(id: string, entity: Ciudad): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco0/Ciudades/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate10(_response);
        });
    }

    protected processUpdate10(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete11(id: string): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco0/Ciudades/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete11(_response);
        });
    }

    protected processDelete11(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getSearch(searchTerm: string): Promise<SearchDto[]> {
        let url_ = this.baseUrl + "/api/Arco0/Ciudades/search?";
        if (searchTerm === undefined || searchTerm === null)
            throw new globalThis.Error("The parameter 'searchTerm' must be defined and cannot be null.");
        else
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSearch(_response);
        });
    }

    protected processGetSearch(response: Response): Promise<SearchDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchDto[]>(null as any);
    }
}

export class Arco1__ClientesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll12(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfCliente> {
        let url_ = this.baseUrl + "/api/Arco1/Clientes?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll12(_response);
        });
    }

    protected processGetAll12(response: Response): Promise<PagingOfCliente> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfCliente.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfCliente>(null as any);
    }

    create12(entity: Cliente): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/Clientes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate12(_response);
        });
    }

    protected processCreate12(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById12(id: number): Promise<Cliente> {
        let url_ = this.baseUrl + "/api/Arco1/Clientes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById12(_response);
        });
    }

    protected processGetById12(response: Response): Promise<Cliente> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Cliente.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Cliente>(null as any);
    }

    update11(id: number, entity: Cliente): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/Clientes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate11(_response);
        });
    }

    protected processUpdate11(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete12(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/Clientes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete12(_response);
        });
    }

    protected processDelete12(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getSearch2(searchTerm: string): Promise<SearchDto[]> {
        let url_ = this.baseUrl + "/api/Arco1/Clientes/search?";
        if (searchTerm === undefined || searchTerm === null)
            throw new globalThis.Error("The parameter 'searchTerm' must be defined and cannot be null.");
        else
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSearch2(_response);
        });
    }

    protected processGetSearch2(response: Response): Promise<SearchDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchDto[]>(null as any);
    }
}

export class CommonClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    multiSearch(tableNames: string | null | undefined): Promise<MultiSearchDto[]> {
        let url_ = this.baseUrl + "/api/Common/MultiSearch?";
        if (tableNames !== undefined && tableNames !== null)
            url_ += "TableNames=" + encodeURIComponent("" + tableNames) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMultiSearch(_response);
        });
    }

    protected processMultiSearch(response: Response): Promise<MultiSearchDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MultiSearchDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MultiSearchDto[]>(null as any);
    }

    getNextId(tableName: string): Promise<GetNextIdDto> {
        let url_ = this.baseUrl + "/api/Common/GetNextId?";
        if (tableName === undefined || tableName === null)
            throw new globalThis.Error("The parameter 'tableName' must be defined and cannot be null.");
        else
            url_ += "TableName=" + encodeURIComponent("" + tableName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNextId(_response);
        });
    }

    protected processGetNextId(response: Response): Promise<GetNextIdDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNextIdDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetNextIdDto>(null as any);
    }

    getUserCustomization(key: string): Promise<any> {
        let url_ = this.baseUrl + "/api/Common/GetUserCustomization?";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined and cannot be null.");
        else
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserCustomization(_response);
        });
    }

    protected processGetUserCustomization(response: Response): Promise<any> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    setUserCustomization(request: SetUserCustomizationRequest): Promise<any> {
        let url_ = this.baseUrl + "/api/Common/SetUserCustomization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetUserCustomization(_response);
        });
    }

    protected processSetUserCustomization(response: Response): Promise<any> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    healthCheck(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Common/HealthCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck(_response);
        });
    }

    protected processHealthCheck(response: Response): Promise<boolean> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    startDocument(request: StartDocumentRequest): Promise<StartDocumentResponse> {
        let url_ = this.baseUrl + "/api/Common/startDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartDocument(_response);
        });
    }

    protected processStartDocument(response: Response): Promise<StartDocumentResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartDocumentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StartDocumentResponse>(null as any);
    }
}

export class Arco1__ComprasClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll13(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfCompra> {
        let url_ = this.baseUrl + "/api/Arco1/Compras?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll13(_response);
        });
    }

    protected processGetAll13(response: Response): Promise<PagingOfCompra> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfCompra.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfCompra>(null as any);
    }

    create13(entity: Compra): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/Compras";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate13(_response);
        });
    }

    protected processCreate13(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById13(id: number): Promise<Compra> {
        let url_ = this.baseUrl + "/api/Arco1/Compras/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById13(_response);
        });
    }

    protected processGetById13(response: Response): Promise<Compra> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Compra.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Compra>(null as any);
    }

    anular(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/Compras/{id}/anular";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnular(_response);
        });
    }

    protected processAnular(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    print(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Arco1/Compras/Print/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrint(_response);
        });
    }

    protected processPrint(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sendEmail(id: number, body: SendEmailRequest | undefined): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/Compras/SendEmail/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendEmail(_response);
        });
    }

    protected processSendEmail(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arcolact__ConductoresClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll14(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfConductor> {
        let url_ = this.baseUrl + "/api/Arcolact/Conductores?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll14(_response);
        });
    }

    protected processGetAll14(response: Response): Promise<PagingOfConductor> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfConductor.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfConductor>(null as any);
    }

    create14(entity: Conductor): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/Conductores";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate14(_response);
        });
    }

    protected processCreate14(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById14(id: number): Promise<Conductor> {
        let url_ = this.baseUrl + "/api/Arcolact/Conductores/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById14(_response);
        });
    }

    protected processGetById14(response: Response): Promise<Conductor> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Conductor.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Conductor>(null as any);
    }

    update12(id: number, entity: Conductor): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/Conductores/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate12(_response);
        });
    }

    protected processUpdate12(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete13(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/Conductores/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete13(_response);
        });
    }

    protected processDelete13(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arco3__CotizacionesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll15(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfCotizacion> {
        let url_ = this.baseUrl + "/api/Arco3/Cotizaciones?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll15(_response);
        });
    }

    protected processGetAll15(response: Response): Promise<PagingOfCotizacion> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfCotizacion.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfCotizacion>(null as any);
    }

    create15(entity: Cotizacion): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Cotizaciones";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate15(_response);
        });
    }

    protected processCreate15(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById15(id: number): Promise<Cotizacion> {
        let url_ = this.baseUrl + "/api/Arco3/Cotizaciones/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById15(_response);
        });
    }

    protected processGetById15(response: Response): Promise<Cotizacion> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Cotizacion.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Cotizacion>(null as any);
    }

    anular2(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Cotizaciones/{id}/anular";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnular2(_response);
        });
    }

    protected processAnular2(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    print2(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Arco3/Cotizaciones/Print/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrint2(_response);
        });
    }

    protected processPrint2(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sendEmail2(id: number, body: SendEmailRequest | undefined): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Cotizaciones/SendEmail/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendEmail2(_response);
        });
    }

    protected processSendEmail2(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arco3__DespachosClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll16(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfDespacho> {
        let url_ = this.baseUrl + "/api/Arco3/Despachos?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll16(_response);
        });
    }

    protected processGetAll16(response: Response): Promise<PagingOfDespacho> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfDespacho.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfDespacho>(null as any);
    }

    create16(entity: Despacho): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Despachos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate16(_response);
        });
    }

    protected processCreate16(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById16(id: number): Promise<Despacho> {
        let url_ = this.baseUrl + "/api/Arco3/Despachos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById16(_response);
        });
    }

    protected processGetById16(response: Response): Promise<Despacho> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Despacho.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Despacho>(null as any);
    }

    update13(id: number, entity: Despacho): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Despachos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate13(_response);
        });
    }

    protected processUpdate13(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete14(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Despachos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete14(_response);
        });
    }

    protected processDelete14(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    gXGetDespacho(despachoId: number): Promise<DespachoGetDto> {
        let url_ = this.baseUrl + "/api/Arco3/Despachos/Get/{DespachoId}";
        if (despachoId === undefined || despachoId === null)
            throw new globalThis.Error("The parameter 'despachoId' must be defined.");
        url_ = url_.replace("{DespachoId}", encodeURIComponent("" + despachoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGXGetDespacho(_response);
        });
    }

    protected processGXGetDespacho(response: Response): Promise<DespachoGetDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DespachoGetDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DespachoGetDto>(null as any);
    }

    asignaFacturasDespacho(dto: DespachoFacturasDto): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Despachos/AsignaFacturas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAsignaFacturasDespacho(_response);
        });
    }

    protected processAsignaFacturasDespacho(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    eliminaFacturasDespacho(dto: DespachoFacturasDto): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Despachos/EliminaFacturas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEliminaFacturasDespacho(_response);
        });
    }

    protected processEliminaFacturasDespacho(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getDespachoFacturasPendientes(despachoId: number, facturaFecha: Date, vendedorId: number | null | undefined, vehiculoId: number | null | undefined, rutaId: number | null | undefined): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Despachos/FacturasPendientes?";
        if (despachoId === undefined || despachoId === null)
            throw new globalThis.Error("The parameter 'despachoId' must be defined and cannot be null.");
        else
            url_ += "DespachoId=" + encodeURIComponent("" + despachoId) + "&";
        if (facturaFecha === undefined || facturaFecha === null)
            throw new globalThis.Error("The parameter 'facturaFecha' must be defined and cannot be null.");
        else
            url_ += "FacturaFecha=" + encodeURIComponent(facturaFecha ? "" + facturaFecha.toISOString() : "") + "&";
        if (vendedorId !== undefined && vendedorId !== null)
            url_ += "VendedorId=" + encodeURIComponent("" + vendedorId) + "&";
        if (vehiculoId !== undefined && vehiculoId !== null)
            url_ += "VehiculoId=" + encodeURIComponent("" + vehiculoId) + "&";
        if (rutaId !== undefined && rutaId !== null)
            url_ += "RutaId=" + encodeURIComponent("" + rutaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDespachoFacturasPendientes(_response);
        });
    }

    protected processGetDespachoFacturasPendientes(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    gXCierraDespacho(dto: DespachoIdDto): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Despachos/CierraDespacho";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGXCierraDespacho(_response);
        });
    }

    protected processGXCierraDespacho(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    gXAnulaDespacho(dto: DespachoIdDto): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Despachos/AnulaDespacho";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGXAnulaDespacho(_response);
        });
    }

    protected processGXAnulaDespacho(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    gXReabreDespacho(dto: DespachoIdDto): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Despachos/ReabreDespacho";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGXReabreDespacho(_response);
        });
    }

    protected processGXReabreDespacho(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    gXGuardaDevItemDespacho(factura: Factura): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Despachos/GuardaDevItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(factura);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGXGuardaDevItemDespacho(_response);
        });
    }

    protected processGXGuardaDevItemDespacho(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    gXLiqEntDespacho(dto: LiqEntDto): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Despachos/LiqEnt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGXLiqEntDespacho(_response);
        });
    }

    protected processGXLiqEntDespacho(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    gXLiqNCDespacho(dto: LiqNcDto): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Despachos/LiqNC";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGXLiqNCDespacho(_response);
        });
    }

    protected processGXLiqNCDespacho(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arco0__DocumentosClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll17(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfDocumento> {
        let url_ = this.baseUrl + "/api/Arco0/Documentos?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll17(_response);
        });
    }

    protected processGetAll17(response: Response): Promise<PagingOfDocumento> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfDocumento.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfDocumento>(null as any);
    }

    create17(entity: Documento): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco0/Documentos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate17(_response);
        });
    }

    protected processCreate17(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById17(id: number): Promise<Documento> {
        let url_ = this.baseUrl + "/api/Arco0/Documentos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById17(_response);
        });
    }

    protected processGetById17(response: Response): Promise<Documento> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Documento.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Documento>(null as any);
    }

    update14(id: number, entity: Documento): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco0/Documentos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate14(_response);
        });
    }

    protected processUpdate14(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete15(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco0/Documentos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete15(_response);
        });
    }

    protected processDelete15(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getByFuente(fuenteId: string): Promise<DocumentoIdDescripcionDto[]> {
        let url_ = this.baseUrl + "/api/Arco0/Documentos/by-fuente/{fuenteId}";
        if (fuenteId === undefined || fuenteId === null)
            throw new globalThis.Error("The parameter 'fuenteId' must be defined.");
        url_ = url_.replace("{fuenteId}", encodeURIComponent("" + fuenteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByFuente(_response);
        });
    }

    protected processGetByFuente(response: Response): Promise<DocumentoIdDescripcionDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentoIdDescripcionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentoIdDescripcionDto[]>(null as any);
    }
}

export class Arco1__EgresosClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll18(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfEgreso> {
        let url_ = this.baseUrl + "/api/Arco1/Egresos?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll18(_response);
        });
    }

    protected processGetAll18(response: Response): Promise<PagingOfEgreso> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfEgreso.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfEgreso>(null as any);
    }

    create18(entity: Egreso): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/Egresos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate18(_response);
        });
    }

    protected processCreate18(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById18(id: number): Promise<Egreso> {
        let url_ = this.baseUrl + "/api/Arco1/Egresos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById18(_response);
        });
    }

    protected processGetById18(response: Response): Promise<Egreso> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Egreso.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Egreso>(null as any);
    }

    anular3(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/Egresos/{id}/anular";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnular3(_response);
        });
    }

    protected processAnular3(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    print3(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Arco1/Egresos/Print/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrint3(_response);
        });
    }

    protected processPrint3(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sendEmail3(id: number, body: SendEmailRequest | undefined): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/Egresos/SendEmail/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendEmail3(_response);
        });
    }

    protected processSendEmail3(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arcolact__EncuestasClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll19(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfEncuesta> {
        let url_ = this.baseUrl + "/api/Arcolact/Encuestas?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll19(_response);
        });
    }

    protected processGetAll19(response: Response): Promise<PagingOfEncuesta> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfEncuesta.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfEncuesta>(null as any);
    }

    create19(entity: Encuesta): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/Encuestas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate19(_response);
        });
    }

    protected processCreate19(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById19(id: number): Promise<Encuesta> {
        let url_ = this.baseUrl + "/api/Arcolact/Encuestas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById19(_response);
        });
    }

    protected processGetById19(response: Response): Promise<Encuesta> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Encuesta.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Encuesta>(null as any);
    }

    update15(id: number, entity: Encuesta): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/Encuestas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate15(_response);
        });
    }

    protected processUpdate15(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete16(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/Encuestas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete16(_response);
        });
    }

    protected processDelete16(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getRespuestasArcolact(encuestaId: number, desde: Date | null | undefined, hasta: Date | null | undefined): Promise<GetRespuestasArcolactResult> {
        let url_ = this.baseUrl + "/api/Arcolact/Encuestas/getRespuestasArcolact?";
        if (encuestaId === undefined || encuestaId === null)
            throw new globalThis.Error("The parameter 'encuestaId' must be defined and cannot be null.");
        else
            url_ += "EncuestaId=" + encodeURIComponent("" + encuestaId) + "&";
        if (desde !== undefined && desde !== null)
            url_ += "Desde=" + encodeURIComponent(desde ? "" + desde.toISOString() : "") + "&";
        if (hasta !== undefined && hasta !== null)
            url_ += "Hasta=" + encodeURIComponent(hasta ? "" + hasta.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRespuestasArcolact(_response);
        });
    }

    protected processGetRespuestasArcolact(response: Response): Promise<GetRespuestasArcolactResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRespuestasArcolactResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetRespuestasArcolactResult>(null as any);
    }
}

export class Arco0__ExtFieldsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll20(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfExtField> {
        let url_ = this.baseUrl + "/api/Arco0/ExtFields?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll20(_response);
        });
    }

    protected processGetAll20(response: Response): Promise<PagingOfExtField> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfExtField.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfExtField>(null as any);
    }

    create20(entity: ExtField): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco0/ExtFields";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate20(_response);
        });
    }

    protected processCreate20(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById20(id: number): Promise<ExtField> {
        let url_ = this.baseUrl + "/api/Arco0/ExtFields/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById20(_response);
        });
    }

    protected processGetById20(response: Response): Promise<ExtField> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtField.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExtField>(null as any);
    }

    update16(id: number, entity: ExtField): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco0/ExtFields/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate16(_response);
        });
    }

    protected processUpdate16(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete17(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco0/ExtFields/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete17(_response);
        });
    }

    protected processDelete17(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arco3__FormulasClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll21(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfFormula> {
        let url_ = this.baseUrl + "/api/Arco3/Formulas?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll21(_response);
        });
    }

    protected processGetAll21(response: Response): Promise<PagingOfFormula> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfFormula.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfFormula>(null as any);
    }

    create21(entity: Formula): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Formulas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate21(_response);
        });
    }

    protected processCreate21(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById21(id: string): Promise<Formula> {
        let url_ = this.baseUrl + "/api/Arco3/Formulas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById21(_response);
        });
    }

    protected processGetById21(response: Response): Promise<Formula> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Formula.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Formula>(null as any);
    }

    update17(id: string, entity: Formula): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Formulas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate17(_response);
        });
    }

    protected processUpdate17(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete18(id: string): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Formulas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete18(_response);
        });
    }

    protected processDelete18(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getSearch3(searchTerm: string): Promise<SearchDto[]> {
        let url_ = this.baseUrl + "/api/Arco3/Formulas/search?";
        if (searchTerm === undefined || searchTerm === null)
            throw new globalThis.Error("The parameter 'searchTerm' must be defined and cannot be null.");
        else
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSearch3(_response);
        });
    }

    protected processGetSearch3(response: Response): Promise<SearchDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchDto[]>(null as any);
    }

    getDistribucionCosto(mes: number, ano: number, moPucId: string, cifPucId: string, insumoId: string): Promise<DistribucionCostoResponse> {
        let url_ = this.baseUrl + "/api/Arco3/Formulas/DistribucionCosto?";
        if (mes === undefined || mes === null)
            throw new globalThis.Error("The parameter 'mes' must be defined and cannot be null.");
        else
            url_ += "Mes=" + encodeURIComponent("" + mes) + "&";
        if (ano === undefined || ano === null)
            throw new globalThis.Error("The parameter 'ano' must be defined and cannot be null.");
        else
            url_ += "Ano=" + encodeURIComponent("" + ano) + "&";
        if (moPucId === undefined || moPucId === null)
            throw new globalThis.Error("The parameter 'moPucId' must be defined and cannot be null.");
        else
            url_ += "MoPucId=" + encodeURIComponent("" + moPucId) + "&";
        if (cifPucId === undefined || cifPucId === null)
            throw new globalThis.Error("The parameter 'cifPucId' must be defined and cannot be null.");
        else
            url_ += "CifPucId=" + encodeURIComponent("" + cifPucId) + "&";
        if (insumoId === undefined || insumoId === null)
            throw new globalThis.Error("The parameter 'insumoId' must be defined and cannot be null.");
        else
            url_ += "InsumoId=" + encodeURIComponent("" + insumoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDistribucionCosto(_response);
        });
    }

    protected processGetDistribucionCosto(response: Response): Promise<DistribucionCostoResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DistribucionCostoResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DistribucionCostoResponse>(null as any);
    }

    postDistribucionCosto(request: DistribucionCostoRequest): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Formulas/DistribucionCosto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDistribucionCosto(_response);
        });
    }

    protected processPostDistribucionCosto(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getUnidades(insumoIds: string): Promise<InsumoEquivalencia[]> {
        let url_ = this.baseUrl + "/api/Arco3/Formulas/Unidades?";
        if (insumoIds === undefined || insumoIds === null)
            throw new globalThis.Error("The parameter 'insumoIds' must be defined and cannot be null.");
        else
            url_ += "insumoIds=" + encodeURIComponent("" + insumoIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnidades(_response);
        });
    }

    protected processGetUnidades(response: Response): Promise<InsumoEquivalencia[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InsumoEquivalencia.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsumoEquivalencia[]>(null as any);
    }
}

export class Arco3__FuentesKardexClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll22(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfFuenteKardex> {
        let url_ = this.baseUrl + "/api/Arco3/FuentesKardex?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll22(_response);
        });
    }

    protected processGetAll22(response: Response): Promise<PagingOfFuenteKardex> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfFuenteKardex.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfFuenteKardex>(null as any);
    }

    create22(entity: FuenteKardex): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/FuentesKardex";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate22(_response);
        });
    }

    protected processCreate22(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById22(id: string): Promise<FuenteKardex> {
        let url_ = this.baseUrl + "/api/Arco3/FuentesKardex/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById22(_response);
        });
    }

    protected processGetById22(response: Response): Promise<FuenteKardex> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FuenteKardex.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FuenteKardex>(null as any);
    }

    update18(id: string, entity: FuenteKardex): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/FuentesKardex/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate18(_response);
        });
    }

    protected processUpdate18(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete19(id: string): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/FuentesKardex/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete19(_response);
        });
    }

    protected processDelete19(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arco1__DocumentosClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll23(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfInbox> {
        let url_ = this.baseUrl + "/api/Arco1/Inbox?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll23(_response);
        });
    }

    protected processGetAll23(response: Response): Promise<PagingOfInbox> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfInbox.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfInbox>(null as any);
    }

    getById23(id: number): Promise<Inbox> {
        let url_ = this.baseUrl + "/api/Arco1/Inbox/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById23(_response);
        });
    }

    protected processGetById23(response: Response): Promise<Inbox> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Inbox.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Inbox>(null as any);
    }
}

export class Arco3__InsumosClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll24(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfInsumoDto> {
        let url_ = this.baseUrl + "/api/Arco3/Insumos?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll24(_response);
        });
    }

    protected processGetAll24(response: Response): Promise<PagingOfInsumoDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfInsumoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfInsumoDto>(null as any);
    }

    create23(dto: InsumoDto): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Insumos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate23(_response);
        });
    }

    protected processCreate23(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById24(id: string): Promise<InsumoDto> {
        let url_ = this.baseUrl + "/api/Arco3/Insumos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById24(_response);
        });
    }

    protected processGetById24(response: Response): Promise<InsumoDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsumoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsumoDto>(null as any);
    }

    update19(id: string, dto: InsumoDto): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Insumos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate19(_response);
        });
    }

    protected processUpdate19(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete20(id: string): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Insumos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete20(_response);
        });
    }

    protected processDelete20(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getSearch4(searchTerm: string): Promise<SearchDto[]> {
        let url_ = this.baseUrl + "/api/Arco3/Insumos/search?";
        if (searchTerm === undefined || searchTerm === null)
            throw new globalThis.Error("The parameter 'searchTerm' must be defined and cannot be null.");
        else
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSearch4(_response);
        });
    }

    protected processGetSearch4(response: Response): Promise<SearchDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchDto[]>(null as any);
    }

    createBulk3(insumos: InsumoDto[]): Promise<ResponseDto[]> {
        let url_ = this.baseUrl + "/api/Arco3/Insumos/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(insumos);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateBulk3(_response);
        });
    }

    protected processCreateBulk3(response: Response): Promise<ResponseDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto[]>(null as any);
    }
}

export class IntegrationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCostoEstandar(): Promise<void> {
        let url_ = this.baseUrl + "/api/Integrations/GetCostoEstandar";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCostoEstandar(_response);
        });
    }

    protected processGetCostoEstandar(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAllProductores(): Promise<void> {
        let url_ = this.baseUrl + "/api/Integrations/Productores";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllProductores(_response);
        });
    }

    protected processGetAllProductores(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    syncProductores(): Promise<void> {
        let url_ = this.baseUrl + "/api/Integrations/syncProductores";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSyncProductores(_response);
        });
    }

    protected processSyncProductores(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    crearEntradaLeche(cierreRutaId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Integrations/entradaLeche/{cierreRutaId}";
        if (cierreRutaId === undefined || cierreRutaId === null)
            throw new globalThis.Error("The parameter 'cierreRutaId' must be defined.");
        url_ = url_.replace("{cierreRutaId}", encodeURIComponent("" + cierreRutaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCrearEntradaLeche(_response);
        });
    }

    protected processCrearEntradaLeche(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class JobsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    listJobs(): Promise<JobListEntry[]> {
        let url_ = this.baseUrl + "/api/Jobs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListJobs(_response);
        });
    }

    protected processListJobs(response: Response): Promise<JobListEntry[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobListEntry.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobListEntry[]>(null as any);
    }

    getJob(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Jobs/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJob(_response);
        });
    }

    protected processGetJob(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    cancelJob(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Jobs/{id}/cancel";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCancelJob(_response);
        });
    }

    protected processCancelJob(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class Arco3__KardexClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll25(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfKardex> {
        let url_ = this.baseUrl + "/api/Arco3/Kardex?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll25(_response);
        });
    }

    protected processGetAll25(response: Response): Promise<PagingOfKardex> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfKardex.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfKardex>(null as any);
    }

    create24(entity: Kardex): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Kardex";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate24(_response);
        });
    }

    protected processCreate24(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById25(id: number): Promise<Kardex> {
        let url_ = this.baseUrl + "/api/Arco3/Kardex/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById25(_response);
        });
    }

    protected processGetById25(response: Response): Promise<Kardex> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Kardex.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kardex>(null as any);
    }

    anular4(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Kardex/{id}/anular";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnular4(_response);
        });
    }

    protected processAnular4(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    print4(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Arco3/Kardex/Print/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrint4(_response);
        });
    }

    protected processPrint4(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sendEmail4(id: number, body: SendEmailRequest | undefined): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Kardex/SendEmail/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendEmail4(_response);
        });
    }

    protected processSendEmail4(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    productoIsValid(productoId: string, bodegaId: string, fuenteKardexId: string | null | undefined, precioListaId: string | null | undefined): Promise<ResponseDto2> {
        let url_ = this.baseUrl + "/api/Arco3/Kardex/item-data?";
        if (productoId === undefined || productoId === null)
            throw new globalThis.Error("The parameter 'productoId' must be defined and cannot be null.");
        else
            url_ += "productoId=" + encodeURIComponent("" + productoId) + "&";
        if (bodegaId === undefined || bodegaId === null)
            throw new globalThis.Error("The parameter 'bodegaId' must be defined and cannot be null.");
        else
            url_ += "bodegaId=" + encodeURIComponent("" + bodegaId) + "&";
        if (fuenteKardexId !== undefined && fuenteKardexId !== null)
            url_ += "fuenteKardexId=" + encodeURIComponent("" + fuenteKardexId) + "&";
        if (precioListaId !== undefined && precioListaId !== null)
            url_ += "precioListaId=" + encodeURIComponent("" + precioListaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductoIsValid(_response);
        });
    }

    protected processProductoIsValid(response: Response): Promise<ResponseDto2> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto2.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto2>(null as any);
    }

    listFuenteKardex(fuenteKardexCategoria: string): Promise<ItemDto[]> {
        let url_ = this.baseUrl + "/api/Arco3/Kardex/listFuenteKardex?";
        if (fuenteKardexCategoria === undefined || fuenteKardexCategoria === null)
            throw new globalThis.Error("The parameter 'fuenteKardexCategoria' must be defined and cannot be null.");
        else
            url_ += "fuenteKardexCategoria=" + encodeURIComponent("" + fuenteKardexCategoria) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListFuenteKardex(_response);
        });
    }

    protected processListFuenteKardex(response: Response): Promise<ItemDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ItemDto[]>(null as any);
    }
}

export class Arco0__LFilesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll26(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfLFile> {
        let url_ = this.baseUrl + "/api/Arco0/LFiles?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll26(_response);
        });
    }

    protected processGetAll26(response: Response): Promise<PagingOfLFile> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfLFile.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfLFile>(null as any);
    }

    delete21(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco0/LFiles/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete21(_response);
        });
    }

    protected processDelete21(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    upload(table: string, tableId: string, fileType: string, folder: string | null | undefined, file: FileParameter | null | undefined): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco0/LFiles/upload?";
        if (table === undefined || table === null)
            throw new globalThis.Error("The parameter 'table' must be defined and cannot be null.");
        else
            url_ += "table=" + encodeURIComponent("" + table) + "&";
        if (tableId === undefined || tableId === null)
            throw new globalThis.Error("The parameter 'tableId' must be defined and cannot be null.");
        else
            url_ += "tableId=" + encodeURIComponent("" + tableId) + "&";
        if (fileType === undefined || fileType === null)
            throw new globalThis.Error("The parameter 'fileType' must be defined and cannot be null.");
        else
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (folder !== undefined && folder !== null)
            url_ += "folder=" + encodeURIComponent("" + folder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseDto.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    download(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Arco0/LFiles/{id}/download";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class Arco3__LineasProduccionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll27(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfLineaProduccion> {
        let url_ = this.baseUrl + "/api/Arco3/LineasProduccion?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll27(_response);
        });
    }

    protected processGetAll27(response: Response): Promise<PagingOfLineaProduccion> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfLineaProduccion.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfLineaProduccion>(null as any);
    }

    create25(entity: LineaProduccion): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/LineasProduccion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate25(_response);
        });
    }

    protected processCreate25(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById26(id: number): Promise<LineaProduccion> {
        let url_ = this.baseUrl + "/api/Arco3/LineasProduccion/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById26(_response);
        });
    }

    protected processGetById26(response: Response): Promise<LineaProduccion> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LineaProduccion.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LineaProduccion>(null as any);
    }

    update20(id: number, entity: LineaProduccion): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/LineasProduccion/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate20(_response);
        });
    }

    protected processUpdate20(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete22(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/LineasProduccion/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete22(_response);
        });
    }

    protected processDelete22(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arco0__ListaOpcionesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll28(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfListaOpcion> {
        let url_ = this.baseUrl + "/api/Arco0/ListaOpciones?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll28(_response);
        });
    }

    protected processGetAll28(response: Response): Promise<PagingOfListaOpcion> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfListaOpcion.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfListaOpcion>(null as any);
    }

    create26(entity: ListaOpcion): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco0/ListaOpciones";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate26(_response);
        });
    }

    protected processCreate26(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById27(id: number): Promise<ListaOpcion> {
        let url_ = this.baseUrl + "/api/Arco0/ListaOpciones/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById27(_response);
        });
    }

    protected processGetById27(response: Response): Promise<ListaOpcion> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListaOpcion.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListaOpcion>(null as any);
    }

    update21(id: number, entity: ListaOpcion): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco0/ListaOpciones/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate21(_response);
        });
    }

    protected processUpdate21(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete23(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco0/ListaOpciones/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete23(_response);
        });
    }

    protected processDelete23(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arco0__ListasClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll29(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfLista> {
        let url_ = this.baseUrl + "/api/Arco0/Listas?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll29(_response);
        });
    }

    protected processGetAll29(response: Response): Promise<PagingOfLista> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfLista.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfLista>(null as any);
    }

    create27(entity: Lista): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco0/Listas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate27(_response);
        });
    }

    protected processCreate27(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById28(id: number): Promise<Lista> {
        let url_ = this.baseUrl + "/api/Arco0/Listas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById28(_response);
        });
    }

    protected processGetById28(response: Response): Promise<Lista> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Lista.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Lista>(null as any);
    }

    update22(id: number, entity: Lista): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco0/Listas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate22(_response);
        });
    }

    protected processUpdate22(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete24(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco0/Listas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete24(_response);
        });
    }

    protected processDelete24(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arco3__LotesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll30(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfLote> {
        let url_ = this.baseUrl + "/api/Arco3/Lotes?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll30(_response);
        });
    }

    protected processGetAll30(response: Response): Promise<PagingOfLote> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfLote.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfLote>(null as any);
    }

    create28(entity: Lote): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Lotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate28(_response);
        });
    }

    protected processCreate28(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById29(id: number): Promise<Lote> {
        let url_ = this.baseUrl + "/api/Arco3/Lotes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById29(_response);
        });
    }

    protected processGetById29(response: Response): Promise<Lote> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Lote.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Lote>(null as any);
    }

    update23(id: number, entity: Lote): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Lotes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate23(_response);
        });
    }

    protected processUpdate23(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete25(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Lotes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete25(_response);
        });
    }

    protected processDelete25(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    listLoteProducto(productoId: string, bodegaId: string, isEntrada: boolean | undefined): Promise<LoteProductoItemDto[]> {
        let url_ = this.baseUrl + "/api/Arco3/Lotes/list-producto?";
        if (productoId === undefined || productoId === null)
            throw new globalThis.Error("The parameter 'productoId' must be defined and cannot be null.");
        else
            url_ += "productoId=" + encodeURIComponent("" + productoId) + "&";
        if (bodegaId === undefined || bodegaId === null)
            throw new globalThis.Error("The parameter 'bodegaId' must be defined and cannot be null.");
        else
            url_ += "bodegaId=" + encodeURIComponent("" + bodegaId) + "&";
        if (isEntrada === null)
            throw new globalThis.Error("The parameter 'isEntrada' cannot be null.");
        else if (isEntrada !== undefined)
            url_ += "isEntrada=" + encodeURIComponent("" + isEntrada) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListLoteProducto(_response);
        });
    }

    protected processListLoteProducto(response: Response): Promise<LoteProductoItemDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LoteProductoItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoteProductoItemDto[]>(null as any);
    }

    listMultiLoteProducto(productos: string, bodegaId: string, isEntrada: boolean | undefined): Promise<MultiLoteDto[]> {
        let url_ = this.baseUrl + "/api/Arco3/Lotes/list-multi-producto?";
        if (productos === undefined || productos === null)
            throw new globalThis.Error("The parameter 'productos' must be defined and cannot be null.");
        else
            url_ += "productos=" + encodeURIComponent("" + productos) + "&";
        if (bodegaId === undefined || bodegaId === null)
            throw new globalThis.Error("The parameter 'bodegaId' must be defined and cannot be null.");
        else
            url_ += "bodegaId=" + encodeURIComponent("" + bodegaId) + "&";
        if (isEntrada === null)
            throw new globalThis.Error("The parameter 'isEntrada' cannot be null.");
        else if (isEntrada !== undefined)
            url_ += "isEntrada=" + encodeURIComponent("" + isEntrada) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListMultiLoteProducto(_response);
        });
    }

    protected processListMultiLoteProducto(response: Response): Promise<MultiLoteDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MultiLoteDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MultiLoteDto[]>(null as any);
    }
}

export class Arco3__MPSClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll31(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfMPS> {
        let url_ = this.baseUrl + "/api/Arco3/MPS?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll31(_response);
        });
    }

    protected processGetAll31(response: Response): Promise<PagingOfMPS> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfMPS.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfMPS>(null as any);
    }

    create29(entity: MPS): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/MPS";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate29(_response);
        });
    }

    protected processCreate29(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById30(id: number): Promise<MPS> {
        let url_ = this.baseUrl + "/api/Arco3/MPS/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById30(_response);
        });
    }

    protected processGetById30(response: Response): Promise<MPS> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MPS.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MPS>(null as any);
    }

    update24(id: number, entity: MPS): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/MPS/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate24(_response);
        });
    }

    protected processUpdate24(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete26(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/MPS/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete26(_response);
        });
    }

    protected processDelete26(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    start(mps: MPS): Promise<MPS> {
        let url_ = this.baseUrl + "/api/Arco3/MPS/start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mps);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStart(_response);
        });
    }

    protected processStart(response: Response): Promise<MPS> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MPS.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MPS>(null as any);
    }
}

export class Arcolact__MuestrasClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll32(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfMuestra> {
        let url_ = this.baseUrl + "/api/Arcolact/Muestras?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll32(_response);
        });
    }

    protected processGetAll32(response: Response): Promise<PagingOfMuestra> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfMuestra.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfMuestra>(null as any);
    }

    create30(entity: Muestra): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/Muestras";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate30(_response);
        });
    }

    protected processCreate30(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById31(id: number): Promise<Muestra> {
        let url_ = this.baseUrl + "/api/Arcolact/Muestras/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById31(_response);
        });
    }

    protected processGetById31(response: Response): Promise<Muestra> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Muestra.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Muestra>(null as any);
    }

    update25(id: number, entity: Muestra): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/Muestras/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate25(_response);
        });
    }

    protected processUpdate25(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete27(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/Muestras/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete27(_response);
        });
    }

    protected processDelete27(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    createBulk4(muestras: Muestra[]): Promise<ResponseDto[]> {
        let url_ = this.baseUrl + "/api/Arcolact/Muestras/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(muestras);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateBulk4(_response);
        });
    }

    protected processCreateBulk4(response: Response): Promise<ResponseDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto[]>(null as any);
    }

    getAgrosavia(request: AgrosaviaRangoFechasEndpointRequest): Promise<GetAgrosaviaResult> {
        let url_ = this.baseUrl + "/api/Arcolact/Muestras/GetAgrosavia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgrosavia(_response);
        });
    }

    protected processGetAgrosavia(response: Response): Promise<GetAgrosaviaResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAgrosaviaResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAgrosaviaResult>(null as any);
    }
}

export class Arco1__NotasCreditoClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll33(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfNotaCred> {
        let url_ = this.baseUrl + "/api/Arco1/NotasCredito?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll33(_response);
        });
    }

    protected processGetAll33(response: Response): Promise<PagingOfNotaCred> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfNotaCred.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfNotaCred>(null as any);
    }

    create31(entity: NotaCred): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/NotasCredito";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate31(_response);
        });
    }

    protected processCreate31(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById32(id: number): Promise<NotaCred> {
        let url_ = this.baseUrl + "/api/Arco1/NotasCredito/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById32(_response);
        });
    }

    protected processGetById32(response: Response): Promise<NotaCred> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotaCred.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotaCred>(null as any);
    }

    anular5(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/NotasCredito/{id}/anular";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnular5(_response);
        });
    }

    protected processAnular5(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    print5(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Arco1/NotasCredito/Print/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrint5(_response);
        });
    }

    protected processPrint5(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class Arcolact__ObligacionesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll34(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfObligacion> {
        let url_ = this.baseUrl + "/api/Arcolact/Obligaciones?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll34(_response);
        });
    }

    protected processGetAll34(response: Response): Promise<PagingOfObligacion> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfObligacion.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfObligacion>(null as any);
    }

    create32(entity: Obligacion): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/Obligaciones";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate32(_response);
        });
    }

    protected processCreate32(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById33(id: number): Promise<Obligacion> {
        let url_ = this.baseUrl + "/api/Arcolact/Obligaciones/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById33(_response);
        });
    }

    protected processGetById33(response: Response): Promise<Obligacion> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Obligacion.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Obligacion>(null as any);
    }

    update26(id: number, entity: Obligacion): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/Obligaciones/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate26(_response);
        });
    }

    protected processUpdate26(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete28(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/Obligaciones/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete28(_response);
        });
    }

    protected processDelete28(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arcolact__ObligacionProductorsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAllWithProductors(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfObligacionProductor> {
        let url_ = this.baseUrl + "/api/ObligacionProductors?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllWithProductors(_response);
        });
    }

    protected processGetAllWithProductors(response: Response): Promise<PagingOfObligacionProductor> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfObligacionProductor.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfObligacionProductor>(null as any);
    }
}

export class Arcolact__ObservacionesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll35(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfObservacion> {
        let url_ = this.baseUrl + "/api/Arcolact/Observaciones?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll35(_response);
        });
    }

    protected processGetAll35(response: Response): Promise<PagingOfObservacion> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfObservacion.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfObservacion>(null as any);
    }

    create33(entity: Observacion): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/Observaciones";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate33(_response);
        });
    }

    protected processCreate33(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById34(id: number): Promise<Observacion> {
        let url_ = this.baseUrl + "/api/Arcolact/Observaciones/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById34(_response);
        });
    }

    protected processGetById34(response: Response): Promise<Observacion> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observacion.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observacion>(null as any);
    }

    update27(id: number, entity: Observacion): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/Observaciones/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate27(_response);
        });
    }

    protected processUpdate27(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete29(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/Observaciones/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete29(_response);
        });
    }

    protected processDelete29(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class OpenAIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    streamResponses(request: OpenAiResponsesStreamRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/OpenAI/responses/stream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStreamResponses(_response);
        });
    }

    protected processStreamResponses(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getHealth(): Promise<string> {
        let url_ = this.baseUrl + "/api/OpenAI/responses/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHealth(_response);
        });
    }

    protected processGetHealth(response: Response): Promise<string> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class Arco3__OrdenesCompraClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll36(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfOrdenCompra> {
        let url_ = this.baseUrl + "/api/Arco3/OrdenesCompra?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll36(_response);
        });
    }

    protected processGetAll36(response: Response): Promise<PagingOfOrdenCompra> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfOrdenCompra.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfOrdenCompra>(null as any);
    }

    create34(entity: OrdenCompra): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/OrdenesCompra";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate34(_response);
        });
    }

    protected processCreate34(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById35(id: number): Promise<OrdenCompra> {
        let url_ = this.baseUrl + "/api/Arco3/OrdenesCompra/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById35(_response);
        });
    }

    protected processGetById35(response: Response): Promise<OrdenCompra> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrdenCompra.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrdenCompra>(null as any);
    }

    anular6(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/OrdenesCompra/{id}/anular";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnular6(_response);
        });
    }

    protected processAnular6(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    print6(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Arco3/OrdenesCompra/Print/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrint6(_response);
        });
    }

    protected processPrint6(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sendEmail5(id: number, body: SendEmailRequest | undefined): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/OrdenesCompra/SendEmail/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendEmail5(_response);
        });
    }

    protected processSendEmail5(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arco3__OrdenesProduccionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll37(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfOrdenProduccion> {
        let url_ = this.baseUrl + "/api/Arco3/OrdenesProduccion?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll37(_response);
        });
    }

    protected processGetAll37(response: Response): Promise<PagingOfOrdenProduccion> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfOrdenProduccion.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfOrdenProduccion>(null as any);
    }

    create35(entity: OrdenProduccion): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/OrdenesProduccion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate35(_response);
        });
    }

    protected processCreate35(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById36(id: number): Promise<OrdenProduccion> {
        let url_ = this.baseUrl + "/api/Arco3/OrdenesProduccion/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById36(_response);
        });
    }

    protected processGetById36(response: Response): Promise<OrdenProduccion> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrdenProduccion.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrdenProduccion>(null as any);
    }

    update28(id: number, entity: OrdenProduccion): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/OrdenesProduccion/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate28(_response);
        });
    }

    protected processUpdate28(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    anular7(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/OrdenesProduccion/{id}/anular";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnular7(_response);
        });
    }

    protected processAnular7(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    print7(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Arco3/OrdenesProduccion/Print/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrint7(_response);
        });
    }

    protected processPrint7(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    explosionMateriales(request: ExplosionMaterialesRequest): Promise<ExplosionMaterialesInsumoItem[]> {
        let url_ = this.baseUrl + "/api/Arco3/OrdenesProduccion/explosion-materiales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExplosionMateriales(_response);
        });
    }

    protected processExplosionMateriales(response: Response): Promise<ExplosionMaterialesInsumoItem[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExplosionMaterialesInsumoItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExplosionMaterialesInsumoItem[]>(null as any);
    }

    desagregacionCalcular(request: DesagregacionCalcularRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/Arco3/OrdenesProduccion/desagregacion/calcular";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDesagregacionCalcular(_response);
        });
    }

    protected processDesagregacionCalcular(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    listaMateriales(id: number, origenBodegaId: string | null | undefined, opProcesoId: number | null | undefined): Promise<TrasladoMaterialesItemDto[]> {
        let url_ = this.baseUrl + "/api/Arco3/OrdenesProduccion/{id}/lista-materiales?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (origenBodegaId !== undefined && origenBodegaId !== null)
            url_ += "OrigenBodegaId=" + encodeURIComponent("" + origenBodegaId) + "&";
        if (opProcesoId !== undefined && opProcesoId !== null)
            url_ += "OpProcesoId=" + encodeURIComponent("" + opProcesoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListaMateriales(_response);
        });
    }

    protected processListaMateriales(response: Response): Promise<TrasladoMaterialesItemDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrasladoMaterialesItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrasladoMaterialesItemDto[]>(null as any);
    }

    getItemData(formulaId: string, bodegaId: string): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/OrdenesProduccion/item-data?";
        if (formulaId === undefined || formulaId === null)
            throw new globalThis.Error("The parameter 'formulaId' must be defined and cannot be null.");
        else
            url_ += "FormulaId=" + encodeURIComponent("" + formulaId) + "&";
        if (bodegaId === undefined || bodegaId === null)
            throw new globalThis.Error("The parameter 'bodegaId' must be defined and cannot be null.");
        else
            url_ += "BodegaId=" + encodeURIComponent("" + bodegaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetItemData(_response);
        });
    }

    protected processGetItemData(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    trasladoMateriales(id: number, kardex: Kardex): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/OrdenesProduccion/{id}/traslado-materiales";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(kardex);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTrasladoMateriales(_response);
        });
    }

    protected processTrasladoMateriales(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    listarTraslados(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/OrdenesProduccion/{id}/listar-traslados";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListarTraslados(_response);
        });
    }

    protected processListarTraslados(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arco3__PedidosClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll38(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfPedido> {
        let url_ = this.baseUrl + "/api/Arco3/Pedidos?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll38(_response);
        });
    }

    protected processGetAll38(response: Response): Promise<PagingOfPedido> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfPedido.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfPedido>(null as any);
    }

    create36(entity: Pedido): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Pedidos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate36(_response);
        });
    }

    protected processCreate36(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById37(id: number): Promise<Pedido> {
        let url_ = this.baseUrl + "/api/Arco3/Pedidos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById37(_response);
        });
    }

    protected processGetById37(response: Response): Promise<Pedido> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Pedido.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Pedido>(null as any);
    }

    anular8(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Pedidos/{id}/anular";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnular8(_response);
        });
    }

    protected processAnular8(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    print8(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Arco3/Pedidos/Print/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrint8(_response);
        });
    }

    protected processPrint8(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sendEmail6(id: number, body: SendEmailRequest | undefined): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Pedidos/SendEmail/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendEmail6(_response);
        });
    }

    protected processSendEmail6(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arco1__PrecioListasClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll39(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfPrecioLista> {
        let url_ = this.baseUrl + "/api/Arco1/PrecioListas?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll39(_response);
        });
    }

    protected processGetAll39(response: Response): Promise<PagingOfPrecioLista> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfPrecioLista.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfPrecioLista>(null as any);
    }

    create37(entity: PrecioLista): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/PrecioListas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate37(_response);
        });
    }

    protected processCreate37(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById38(id: string): Promise<PrecioLista> {
        let url_ = this.baseUrl + "/api/Arco1/PrecioListas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById38(_response);
        });
    }

    protected processGetById38(response: Response): Promise<PrecioLista> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrecioLista.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrecioLista>(null as any);
    }

    update29(id: string, entity: PrecioLista): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/PrecioListas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate29(_response);
        });
    }

    protected processUpdate29(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete30(id: string): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/PrecioListas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete30(_response);
        });
    }

    protected processDelete30(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getSearch5(searchTerm: string): Promise<SearchDto[]> {
        let url_ = this.baseUrl + "/api/Arco1/PrecioListas/search?";
        if (searchTerm === undefined || searchTerm === null)
            throw new globalThis.Error("The parameter 'searchTerm' must be defined and cannot be null.");
        else
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSearch5(_response);
        });
    }

    protected processGetSearch5(response: Response): Promise<SearchDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchDto[]>(null as any);
    }
}

export class Arco3__PreciosCompraClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll40(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfPrecioCompra> {
        let url_ = this.baseUrl + "/api/Arco3/PreciosCompra?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll40(_response);
        });
    }

    protected processGetAll40(response: Response): Promise<PagingOfPrecioCompra> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfPrecioCompra.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfPrecioCompra>(null as any);
    }

    create38(entity: PrecioCompra): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/PreciosCompra";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate38(_response);
        });
    }

    protected processCreate38(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById39(id: number): Promise<PrecioCompra> {
        let url_ = this.baseUrl + "/api/Arco3/PreciosCompra/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById39(_response);
        });
    }

    protected processGetById39(response: Response): Promise<PrecioCompra> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrecioCompra.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrecioCompra>(null as any);
    }

    update30(id: number, entity: PrecioCompra): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/PreciosCompra/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate30(_response);
        });
    }

    protected processUpdate30(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete31(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/PreciosCompra/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete31(_response);
        });
    }

    protected processDelete31(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arco3__ProduccionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll41(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfProduccion> {
        let url_ = this.baseUrl + "/api/Arco3/Produccion?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll41(_response);
        });
    }

    protected processGetAll41(response: Response): Promise<PagingOfProduccion> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfProduccion.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfProduccion>(null as any);
    }

    create39(entity: Produccion): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Produccion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate39(_response);
        });
    }

    protected processCreate39(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById40(id: number): Promise<Produccion> {
        let url_ = this.baseUrl + "/api/Arco3/Produccion/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById40(_response);
        });
    }

    protected processGetById40(response: Response): Promise<Produccion> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Produccion.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Produccion>(null as any);
    }

    anular9(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Produccion/{id}/anular";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnular9(_response);
        });
    }

    protected processAnular9(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    print9(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Arco3/Produccion/Print/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrint9(_response);
        });
    }

    protected processPrint9(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sendEmail7(id: number, body: SendEmailRequest | undefined): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Produccion/SendEmail/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendEmail7(_response);
        });
    }

    protected processSendEmail7(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    explosionMaterialesConInventario(request: ExplosionMaterialesConInventarioRequest): Promise<TrasladoMaterialesItemDto[]> {
        let url_ = this.baseUrl + "/api/Arco3/Produccion/explosion-materiales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExplosionMaterialesConInventario(_response);
        });
    }

    protected processExplosionMaterialesConInventario(response: Response): Promise<TrasladoMaterialesItemDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrasladoMaterialesItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrasladoMaterialesItemDto[]>(null as any);
    }
}

export class Arcolact__ProductoresClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll42(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfProductor> {
        let url_ = this.baseUrl + "/api/Arcolact/Productores?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll42(_response);
        });
    }

    protected processGetAll42(response: Response): Promise<PagingOfProductor> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfProductor.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfProductor>(null as any);
    }

    create40(entity: Productor): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/Productores";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate40(_response);
        });
    }

    protected processCreate40(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById41(id: number): Promise<Productor> {
        let url_ = this.baseUrl + "/api/Arcolact/Productores/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById41(_response);
        });
    }

    protected processGetById41(response: Response): Promise<Productor> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Productor.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Productor>(null as any);
    }

    update31(id: number, entity: Productor): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/Productores/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate31(_response);
        });
    }

    protected processUpdate31(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete32(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/Productores/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete32(_response);
        });
    }

    protected processDelete32(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    createBulk5(productores: Productor[]): Promise<ResponseDto[]> {
        let url_ = this.baseUrl + "/api/Arcolact/Productores/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productores);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateBulk5(_response);
        });
    }

    protected processCreateBulk5(response: Response): Promise<ResponseDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto[]>(null as any);
    }

    getSearch6(searchTerm: string): Promise<SearchDto[]> {
        let url_ = this.baseUrl + "/api/Arcolact/Productores/search?";
        if (searchTerm === undefined || searchTerm === null)
            throw new globalThis.Error("The parameter 'searchTerm' must be defined and cannot be null.");
        else
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSearch6(_response);
        });
    }

    protected processGetSearch6(response: Response): Promise<SearchDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchDto[]>(null as any);
    }

    bulkPrice(items: ProductorBulkPriceItem[]): Promise<ResponseDto[]> {
        let url_ = this.baseUrl + "/api/Arcolact/Productores/bulkPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(items);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBulkPrice(_response);
        });
    }

    protected processBulkPrice(response: Response): Promise<ResponseDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto[]>(null as any);
    }

    updateGPS(): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arcolact/Productores/updateGps";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateGPS(_response);
        });
    }

    protected processUpdateGPS(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arco1__ProductosClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll43(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfProducto> {
        let url_ = this.baseUrl + "/api/Arco1/Productos?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll43(_response);
        });
    }

    protected processGetAll43(response: Response): Promise<PagingOfProducto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfProducto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfProducto>(null as any);
    }

    create41(entity: Producto): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/Productos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate41(_response);
        });
    }

    protected processCreate41(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById42(id: string): Promise<Producto> {
        let url_ = this.baseUrl + "/api/Arco1/Productos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById42(_response);
        });
    }

    protected processGetById42(response: Response): Promise<Producto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Producto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Producto>(null as any);
    }

    update32(id: string, entity: Producto): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/Productos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate32(_response);
        });
    }

    protected processUpdate32(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete33(id: string): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/Productos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete33(_response);
        });
    }

    protected processDelete33(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    createBulk6(productos: Producto[]): Promise<ResponseDto[]> {
        let url_ = this.baseUrl + "/api/Arco1/Productos/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productos);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateBulk6(_response);
        });
    }

    protected processCreateBulk6(response: Response): Promise<ResponseDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto[]>(null as any);
    }

    getSearch7(searchTerm: string): Promise<SearchDto[]> {
        let url_ = this.baseUrl + "/api/Arco1/Productos/search?";
        if (searchTerm === undefined || searchTerm === null)
            throw new globalThis.Error("The parameter 'searchTerm' must be defined and cannot be null.");
        else
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSearch7(_response);
        });
    }

    protected processGetSearch7(response: Response): Promise<SearchDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchDto[]>(null as any);
    }

    getSearchRAG(query: string, precioListaId: string | null | undefined, bodegaId: string | null | undefined, topK: number | undefined): Promise<ProductoSearchResponse[]> {
        let url_ = this.baseUrl + "/api/Arco1/Productos/search-rag?";
        if (query === undefined || query === null)
            throw new globalThis.Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (precioListaId !== undefined && precioListaId !== null)
            url_ += "precioListaId=" + encodeURIComponent("" + precioListaId) + "&";
        if (bodegaId !== undefined && bodegaId !== null)
            url_ += "bodegaId=" + encodeURIComponent("" + bodegaId) + "&";
        if (topK === null)
            throw new globalThis.Error("The parameter 'topK' cannot be null.");
        else if (topK !== undefined)
            url_ += "topK=" + encodeURIComponent("" + topK) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSearchRAG(_response);
        });
    }

    protected processGetSearchRAG(response: Response): Promise<ProductoSearchResponse[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductoSearchResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductoSearchResponse[]>(null as any);
    }

    vectorizeProductNames(): Promise<number> {
        let url_ = this.baseUrl + "/api/Arco1/Productos/rag/vectorize";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVectorizeProductNames(_response);
        });
    }

    protected processVectorizeProductNames(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getSugerido(nit: string, precioListaId: string | null | undefined, bodegaId: string | null | undefined): Promise<ProductoSugeridoResponse[]> {
        let url_ = this.baseUrl + "/api/Arco1/Productos/sugerido?";
        if (nit === undefined || nit === null)
            throw new globalThis.Error("The parameter 'nit' must be defined and cannot be null.");
        else
            url_ += "nit=" + encodeURIComponent("" + nit) + "&";
        if (precioListaId !== undefined && precioListaId !== null)
            url_ += "precioListaId=" + encodeURIComponent("" + precioListaId) + "&";
        if (bodegaId !== undefined && bodegaId !== null)
            url_ += "bodegaId=" + encodeURIComponent("" + bodegaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSugerido(_response);
        });
    }

    protected processGetSugerido(response: Response): Promise<ProductoSugeridoResponse[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductoSugeridoResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductoSugeridoResponse[]>(null as any);
    }
}

export class Arco1__PucsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll44(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfPuc> {
        let url_ = this.baseUrl + "/api/Arco1/Pucs?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll44(_response);
        });
    }

    protected processGetAll44(response: Response): Promise<PagingOfPuc> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfPuc.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfPuc>(null as any);
    }

    create42(entity: Puc): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/Pucs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate42(_response);
        });
    }

    protected processCreate42(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById43(id: string): Promise<Puc> {
        let url_ = this.baseUrl + "/api/Arco1/Pucs/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById43(_response);
        });
    }

    protected processGetById43(response: Response): Promise<Puc> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Puc.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Puc>(null as any);
    }

    update33(id: string, entity: Puc): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/Pucs/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate33(_response);
        });
    }

    protected processUpdate33(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete34(id: string): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/Pucs/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete34(_response);
        });
    }

    protected processDelete34(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getSearch8(searchTerm: string): Promise<SearchDto[]> {
        let url_ = this.baseUrl + "/api/Arco1/Pucs/search?";
        if (searchTerm === undefined || searchTerm === null)
            throw new globalThis.Error("The parameter 'searchTerm' must be defined and cannot be null.");
        else
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSearch8(_response);
        });
    }

    protected processGetSearch8(response: Response): Promise<SearchDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchDto[]>(null as any);
    }
}

export class Arco1__RecibosCajaClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll45(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfReciboCaja> {
        let url_ = this.baseUrl + "/api/Arco1/RecibosCaja?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll45(_response);
        });
    }

    protected processGetAll45(response: Response): Promise<PagingOfReciboCaja> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfReciboCaja.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfReciboCaja>(null as any);
    }

    create43(entity: ReciboCaja): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/RecibosCaja";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate43(_response);
        });
    }

    protected processCreate43(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById44(id: number): Promise<ReciboCaja> {
        let url_ = this.baseUrl + "/api/Arco1/RecibosCaja/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById44(_response);
        });
    }

    protected processGetById44(response: Response): Promise<ReciboCaja> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReciboCaja.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReciboCaja>(null as any);
    }

    anular10(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/RecibosCaja/{id}/anular";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnular10(_response);
        });
    }

    protected processAnular10(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    print10(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Arco1/RecibosCaja/Print/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrint10(_response);
        });
    }

    protected processPrint10(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sendEmail8(id: number, body: SendEmailRequest | undefined): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/RecibosCaja/SendEmail/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendEmail8(_response);
        });
    }

    protected processSendEmail8(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class ArcoCentral__Reportes_disponiblesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    listar(modulo: string | null | undefined): Promise<ReporteDisponibleDto[]> {
        let url_ = this.baseUrl + "/api/ReportesDisponibles?";
        if (modulo !== undefined && modulo !== null)
            url_ += "modulo=" + encodeURIComponent("" + modulo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListar(_response);
        });
    }

    protected processListar(response: Response): Promise<ReporteDisponibleDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReporteDisponibleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReporteDisponibleDto[]>(null as any);
    }

    getReport(request: GetReportRequest): Promise<{ [key: string]: any; }[]> {
        let url_ = this.baseUrl + "/api/ReportesDisponibles/GetReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReport(_response);
        });
    }

    protected processGetReport(response: Response): Promise<{ [key: string]: any; }[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: any; }[]>(null as any);
    }
}

export class Arco3__ReprocesoClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    ejecutar(request: ReprocesoRequest): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Reproceso";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEjecutar(_response);
        });
    }

    protected processEjecutar(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResponseDto.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arco3__RequisicionesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll46(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined, documentoId: number | null | undefined): Promise<PagingOfRequisicionDto> {
        let url_ = this.baseUrl + "/api/Arco3/Requisiciones?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (documentoId !== undefined && documentoId !== null)
            url_ += "documentoId=" + encodeURIComponent("" + documentoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll46(_response);
        });
    }

    protected processGetAll46(response: Response): Promise<PagingOfRequisicionDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfRequisicionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfRequisicionDto>(null as any);
    }

    create44(dto: RequisicionDto): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Requisiciones";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate44(_response);
        });
    }

    protected processCreate44(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById45(id: number, includeItems: boolean | undefined): Promise<RequisicionDto> {
        let url_ = this.baseUrl + "/api/Arco3/Requisiciones/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeItems === null)
            throw new globalThis.Error("The parameter 'includeItems' cannot be null.");
        else if (includeItems !== undefined)
            url_ += "includeItems=" + encodeURIComponent("" + includeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById45(_response);
        });
    }

    protected processGetById45(response: Response): Promise<RequisicionDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequisicionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequisicionDto>(null as any);
    }

    getTraslados(id: number): Promise<RequisicionTrasladoDto[]> {
        let url_ = this.baseUrl + "/api/Arco3/Requisiciones/{id}/traslados";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTraslados(_response);
        });
    }

    protected processGetTraslados(response: Response): Promise<RequisicionTrasladoDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RequisicionTrasladoDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequisicionTrasladoDto[]>(null as any);
    }

    anular11(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Requisiciones/{id}/anular";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnular11(_response);
        });
    }

    protected processAnular11(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    cerrar(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Requisiciones/{id}/cerrar";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCerrar(_response);
        });
    }

    protected processCerrar(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    print11(id: number, impresionId: number | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Arco3/Requisiciones/Print/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (impresionId !== undefined && impresionId !== null)
            url_ += "impresionId=" + encodeURIComponent("" + impresionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrint11(_response);
        });
    }

    protected processPrint11(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class Arco3__RutasClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll47(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfRutum> {
        let url_ = this.baseUrl + "/api/Arco3/Rutas?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll47(_response);
        });
    }

    protected processGetAll47(response: Response): Promise<PagingOfRutum> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfRutum.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfRutum>(null as any);
    }

    create45(entity: Rutum): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Rutas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate45(_response);
        });
    }

    protected processCreate45(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById46(id: number): Promise<Rutum> {
        let url_ = this.baseUrl + "/api/Arco3/Rutas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById46(_response);
        });
    }

    protected processGetById46(response: Response): Promise<Rutum> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Rutum.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Rutum>(null as any);
    }

    update34(id: number, entity: Rutum): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Rutas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate34(_response);
        });
    }

    protected processUpdate34(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete35(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Rutas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete35(_response);
        });
    }

    protected processDelete35(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arco0__SecurityClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    login(request: LoginRequest): Promise<any> {
        let url_ = this.baseUrl + "/api/security/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<any> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }
}

export class ArcoCentral__SessionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getByToken(sesToken: string): Promise<Session> {
        let url_ = this.baseUrl + "/api/Sessions/by-token/{sesToken}";
        if (sesToken === undefined || sesToken === null)
            throw new globalThis.Error("The parameter 'sesToken' must be defined.");
        url_ = url_.replace("{sesToken}", encodeURIComponent("" + sesToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByToken(_response);
        });
    }

    protected processGetByToken(response: Response): Promise<Session> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Session.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Session>(null as any);
    }
}

export class TercerosClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll48(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfTercero> {
        let url_ = this.baseUrl + "/api/Terceros?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll48(_response);
        });
    }

    protected processGetAll48(response: Response): Promise<PagingOfTercero> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfTercero.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfTercero>(null as any);
    }

    create46(entity: Tercero): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Terceros";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate46(_response);
        });
    }

    protected processCreate46(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById47(id: number): Promise<Tercero> {
        let url_ = this.baseUrl + "/api/Terceros/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById47(_response);
        });
    }

    protected processGetById47(response: Response): Promise<Tercero> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Tercero.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tercero>(null as any);
    }

    update35(id: number, entity: Tercero): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Terceros/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate35(_response);
        });
    }

    protected processUpdate35(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete36(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Terceros/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete36(_response);
        });
    }

    protected processDelete36(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getTerceroByNit(nit: string): Promise<Tercero> {
        let url_ = this.baseUrl + "/api/Terceros/by-nit/{nit}";
        if (nit === undefined || nit === null)
            throw new globalThis.Error("The parameter 'nit' must be defined.");
        url_ = url_.replace("{nit}", encodeURIComponent("" + nit));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTerceroByNit(_response);
        });
    }

    protected processGetTerceroByNit(response: Response): Promise<Tercero> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Tercero.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tercero>(null as any);
    }

    getSearch9(searchTerm: string): Promise<SearchDto[]> {
        let url_ = this.baseUrl + "/api/Terceros/search?";
        if (searchTerm === undefined || searchTerm === null)
            throw new globalThis.Error("The parameter 'searchTerm' must be defined and cannot be null.");
        else
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSearch9(_response);
        });
    }

    protected processGetSearch9(response: Response): Promise<SearchDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchDto[]>(null as any);
    }
}

export class TodoItemsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getTodoItemsWithPagination(listId: number, pageNumber: number, pageSize: number): Promise<PaginatedListOfTodoItemBriefDto> {
        let url_ = this.baseUrl + "/api/TodoItems?";
        if (listId === undefined || listId === null)
            throw new globalThis.Error("The parameter 'listId' must be defined and cannot be null.");
        else
            url_ += "ListId=" + encodeURIComponent("" + listId) + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTodoItemsWithPagination(_response);
        });
    }

    protected processGetTodoItemsWithPagination(response: Response): Promise<PaginatedListOfTodoItemBriefDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfTodoItemBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfTodoItemBriefDto>(null as any);
    }

    createTodoItem(command: CreateTodoItemCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/TodoItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTodoItem(_response);
        });
    }

    protected processCreateTodoItem(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateTodoItem(id: number, command: UpdateTodoItemCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/TodoItems/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTodoItem(_response);
        });
    }

    protected processUpdateTodoItem(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteTodoItem(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/TodoItems/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTodoItem(_response);
        });
    }

    protected processDeleteTodoItem(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateTodoItemDetail(id: number, command: UpdateTodoItemDetailCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/TodoItems/UpdateDetail/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTodoItemDetail(_response);
        });
    }

    protected processUpdateTodoItemDetail(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TodoListsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getTodoLists(): Promise<TodosVm> {
        let url_ = this.baseUrl + "/api/TodoLists";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTodoLists(_response);
        });
    }

    protected processGetTodoLists(response: Response): Promise<TodosVm> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TodosVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TodosVm>(null as any);
    }

    createTodoList(command: CreateTodoListCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/TodoLists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTodoList(_response);
        });
    }

    protected processCreateTodoList(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateTodoList(id: number, command: UpdateTodoListCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/TodoLists/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTodoList(_response);
        });
    }

    protected processUpdateTodoList(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteTodoList(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/TodoLists/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTodoList(_response);
        });
    }

    protected processDeleteTodoList(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class Arco3__TomaFisicaClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll49(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfTomaFisica> {
        let url_ = this.baseUrl + "/api/Arco3/TomaFisica?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll49(_response);
        });
    }

    protected processGetAll49(response: Response): Promise<PagingOfTomaFisica> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfTomaFisica.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfTomaFisica>(null as any);
    }

    create47(entity: TomaFisica): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/TomaFisica";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate47(_response);
        });
    }

    protected processCreate47(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getTomaFisicaById(id: number): Promise<TomaFisicaCompletoDto> {
        let url_ = this.baseUrl + "/api/Arco3/TomaFisica/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTomaFisicaById(_response);
        });
    }

    protected processGetTomaFisicaById(response: Response): Promise<TomaFisicaCompletoDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TomaFisicaCompletoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TomaFisicaCompletoDto>(null as any);
    }

    anular12(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/TomaFisica/{id}/anular";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnular12(_response);
        });
    }

    protected processAnular12(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    bloquearBodega(body: TomaFisicaBloquearBodegaRequest): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/TomaFisica/bloquear-bodega";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBloquearBodega(_response);
        });
    }

    protected processBloquearBodega(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    aplicar(id: number, body: TomaFisicaAplicarRequest): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/TomaFisica/{id}/aplicar";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAplicar(_response);
        });
    }

    protected processAplicar(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    listarContUbicacion(id: number, bodegaUbicacionId: number): Promise<TomaFisicaContLineaDto[]> {
        let url_ = this.baseUrl + "/api/Arco3/TomaFisica/{id}/ubicacion/{bodegaUbicacionId}/lineas";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (bodegaUbicacionId === undefined || bodegaUbicacionId === null)
            throw new globalThis.Error("The parameter 'bodegaUbicacionId' must be defined.");
        url_ = url_.replace("{bodegaUbicacionId}", encodeURIComponent("" + bodegaUbicacionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListarContUbicacion(_response);
        });
    }

    protected processListarContUbicacion(response: Response): Promise<TomaFisicaContLineaDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TomaFisicaContLineaDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TomaFisicaContLineaDto[]>(null as any);
    }

    itemData(id: number, codigo: string): Promise<TomaFisicaProductoValidarDto> {
        let url_ = this.baseUrl + "/api/Arco3/TomaFisica/{id}/item-data?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (codigo === undefined || codigo === null)
            throw new globalThis.Error("The parameter 'codigo' must be defined and cannot be null.");
        else
            url_ += "codigo=" + encodeURIComponent("" + codigo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processItemData(_response);
        });
    }

    protected processItemData(response: Response): Promise<TomaFisicaProductoValidarDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TomaFisicaProductoValidarDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TomaFisicaProductoValidarDto>(null as any);
    }

    agregarCont(id: number, bodegaUbicacionId: number, body: TomaFisicaContUpsertRequest): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/TomaFisica/{id}/ubicacion/{bodegaUbicacionId}/cont";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (bodegaUbicacionId === undefined || bodegaUbicacionId === null)
            throw new globalThis.Error("The parameter 'bodegaUbicacionId' must be defined.");
        url_ = url_.replace("{bodegaUbicacionId}", encodeURIComponent("" + bodegaUbicacionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAgregarCont(_response);
        });
    }

    protected processAgregarCont(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    modificarCont(id: number, bodegaUbicacionId: number, tomaFisicaContId: number, body: TomaFisicaContUpsertRequest): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/TomaFisica/{id}/ubicacion/{bodegaUbicacionId}/cont/{tomaFisicaContId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (bodegaUbicacionId === undefined || bodegaUbicacionId === null)
            throw new globalThis.Error("The parameter 'bodegaUbicacionId' must be defined.");
        url_ = url_.replace("{bodegaUbicacionId}", encodeURIComponent("" + bodegaUbicacionId));
        if (tomaFisicaContId === undefined || tomaFisicaContId === null)
            throw new globalThis.Error("The parameter 'tomaFisicaContId' must be defined.");
        url_ = url_.replace("{tomaFisicaContId}", encodeURIComponent("" + tomaFisicaContId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModificarCont(_response);
        });
    }

    protected processModificarCont(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    eliminarCont(id: number, tomaFisicaContId: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/TomaFisica/{id}/cont/{tomaFisicaContId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tomaFisicaContId === undefined || tomaFisicaContId === null)
            throw new globalThis.Error("The parameter 'tomaFisicaContId' must be defined.");
        url_ = url_.replace("{tomaFisicaContId}", encodeURIComponent("" + tomaFisicaContId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEliminarCont(_response);
        });
    }

    protected processEliminarCont(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    finalizar(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/TomaFisica/{id}/finalizar";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFinalizar(_response);
        });
    }

    protected processFinalizar(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    cerrar2(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/TomaFisica/{id}/cerrar";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCerrar2(_response);
        });
    }

    protected processCerrar2(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arcolact__TransferenciasClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    descargaArchivo(request: TransArcolactRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/Arcolact/Transferencias";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDescargaArchivo(_response);
        });
    }

    protected processDescargaArchivo(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getTransferenciaInfo(planillaId: number, bancoId: number | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Arcolact/Transferencias/Info/{planillaId}?";
        if (planillaId === undefined || planillaId === null)
            throw new globalThis.Error("The parameter 'planillaId' must be defined.");
        url_ = url_.replace("{planillaId}", encodeURIComponent("" + planillaId));
        if (bancoId !== undefined && bancoId !== null)
            url_ += "bancoId=" + encodeURIComponent("" + bancoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTransferenciaInfo(_response);
        });
    }

    protected processGetTransferenciaInfo(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class Arco3__VehiculosClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll50(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfVehiculo> {
        let url_ = this.baseUrl + "/api/Arco3/Vehiculos?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll50(_response);
        });
    }

    protected processGetAll50(response: Response): Promise<PagingOfVehiculo> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfVehiculo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfVehiculo>(null as any);
    }

    create48(entity: Vehiculo): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Vehiculos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate48(_response);
        });
    }

    protected processCreate48(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById48(id: number): Promise<Vehiculo> {
        let url_ = this.baseUrl + "/api/Arco3/Vehiculos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById48(_response);
        });
    }

    protected processGetById48(response: Response): Promise<Vehiculo> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Vehiculo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Vehiculo>(null as any);
    }

    update36(id: number, entity: Vehiculo): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Vehiculos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate36(_response);
        });
    }

    protected processUpdate36(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete37(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco3/Vehiculos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete37(_response);
        });
    }

    protected processDelete37(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class Arco1__VendedoresClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll51(page: number, pageSize: number, orderBy: string | null | undefined, filter: string | null | undefined): Promise<PagingOfVendedor> {
        let url_ = this.baseUrl + "/api/Arco1/Vendedores?";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll51(_response);
        });
    }

    protected processGetAll51(response: Response): Promise<PagingOfVendedor> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagingOfVendedor.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingOfVendedor>(null as any);
    }

    create49(entity: Vendedor): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/Vendedores";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate49(_response);
        });
    }

    protected processCreate49(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    getById49(id: number): Promise<Vendedor> {
        let url_ = this.baseUrl + "/api/Arco1/Vendedores/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById49(_response);
        });
    }

    protected processGetById49(response: Response): Promise<Vendedor> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Vendedor.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Vendedor>(null as any);
    }

    update37(id: number, entity: Vendedor): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/Vendedores/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate37(_response);
        });
    }

    protected processUpdate37(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }

    delete38(id: number): Promise<ResponseDto> {
        let url_ = this.baseUrl + "/api/Arco1/Vendedores/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete38(_response);
        });
    }

    protected processDelete38(response: Response): Promise<ResponseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDto>(null as any);
    }
}

export class WeatherForecastsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getWeatherForecasts(): Promise<WeatherForecast[]> {
        let url_ = this.baseUrl + "/api/WeatherForecasts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWeatherForecasts(_response);
        });
    }

    protected processGetWeatherForecasts(response: Response): Promise<WeatherForecast[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WeatherForecast.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WeatherForecast[]>(null as any);
    }
}

export class PagingOfALAcopio implements IPagingOfALAcopio {
    count?: number;
    data?: ALAcopio[];

    constructor(data?: IPagingOfALAcopio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ALAcopio.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfALAcopio {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfALAcopio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfALAcopio {
    count?: number;
    data?: ALAcopio[];
}

export class ALAcopio implements IALAcopio {
    alAcopioId?: number;
    alAcopioNombre?: string;
    alAcopioFrioLt?: number;
    alAcopioDistancia?: number;
    alAcopioNIT?: string;

    constructor(data?: IALAcopio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alAcopioId = _data["alAcopioId"];
            this.alAcopioNombre = _data["alAcopioNombre"];
            this.alAcopioFrioLt = _data["alAcopioFrioLt"];
            this.alAcopioDistancia = _data["alAcopioDistancia"];
            this.alAcopioNIT = _data["alAcopioNIT"];
        }
    }

    static fromJS(data: any): ALAcopio {
        data = typeof data === 'object' ? data : {};
        let result = new ALAcopio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alAcopioId"] = this.alAcopioId;
        data["alAcopioNombre"] = this.alAcopioNombre;
        data["alAcopioFrioLt"] = this.alAcopioFrioLt;
        data["alAcopioDistancia"] = this.alAcopioDistancia;
        data["alAcopioNIT"] = this.alAcopioNIT;
        return data;
    }
}

export interface IALAcopio {
    alAcopioId?: number;
    alAcopioNombre?: string;
    alAcopioFrioLt?: number;
    alAcopioDistancia?: number;
    alAcopioNIT?: string;
}

export class ResponseDto implements IResponseDto {
    isOk?: boolean;
    data?: any | undefined;
    messages?: MessageDto[];

    constructor(data?: IResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOk = _data["isOk"];
            this.data = _data["data"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(MessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOk"] = this.isOk;
        data["data"] = this.data;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseDto {
    isOk?: boolean;
    data?: any | undefined;
    messages?: MessageDto[];
}

export class MessageDto implements IMessageDto {
    id?: string;
    type?: number;
    description?: string;

    constructor(data?: IMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): MessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["description"] = this.description;
        return data;
    }
}

export interface IMessageDto {
    id?: string;
    type?: number;
    description?: string;
}

export class PagingOfALAsignacion implements IPagingOfALAsignacion {
    count?: number;
    data?: ALAsignacion[];

    constructor(data?: IPagingOfALAsignacion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ALAsignacion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfALAsignacion {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfALAsignacion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfALAsignacion {
    count?: number;
    data?: ALAsignacion[];
}

export class ALAsignacion implements IALAsignacion {
    alAsignacionId?: number;
    alPlanillaId?: number;
    productorId?: number | undefined;
    productorTerceroNombre?: string | undefined;
    alAsignacionValor?: number;
    pucID?: string | undefined;
    alAsignacionGastoId2?: string | undefined;

    constructor(data?: IALAsignacion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alAsignacionId = _data["alAsignacionId"];
            this.alPlanillaId = _data["alPlanillaId"];
            this.productorId = _data["productorId"];
            this.productorTerceroNombre = _data["productorTerceroNombre"];
            this.alAsignacionValor = _data["alAsignacionValor"];
            this.pucID = _data["pucID"];
            this.alAsignacionGastoId2 = _data["alAsignacionGastoId2"];
        }
    }

    static fromJS(data: any): ALAsignacion {
        data = typeof data === 'object' ? data : {};
        let result = new ALAsignacion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alAsignacionId"] = this.alAsignacionId;
        data["alPlanillaId"] = this.alPlanillaId;
        data["productorId"] = this.productorId;
        data["productorTerceroNombre"] = this.productorTerceroNombre;
        data["alAsignacionValor"] = this.alAsignacionValor;
        data["pucID"] = this.pucID;
        data["alAsignacionGastoId2"] = this.alAsignacionGastoId2;
        return data;
    }
}

export interface IALAsignacion {
    alAsignacionId?: number;
    alPlanillaId?: number;
    productorId?: number | undefined;
    productorTerceroNombre?: string | undefined;
    alAsignacionValor?: number;
    pucID?: string | undefined;
    alAsignacionGastoId2?: string | undefined;
}

export class ALAsignacionGastoInfoResult implements IALAsignacionGastoInfoResult {
    gastoEstado?: string;
    gastoVrAPagar?: number;
    gastoCxPPucId?: string | undefined;

    constructor(data?: IALAsignacionGastoInfoResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gastoEstado = _data["gastoEstado"];
            this.gastoVrAPagar = _data["gastoVrAPagar"];
            this.gastoCxPPucId = _data["gastoCxPPucId"];
        }
    }

    static fromJS(data: any): ALAsignacionGastoInfoResult {
        data = typeof data === 'object' ? data : {};
        let result = new ALAsignacionGastoInfoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gastoEstado"] = this.gastoEstado;
        data["gastoVrAPagar"] = this.gastoVrAPagar;
        data["gastoCxPPucId"] = this.gastoCxPPucId;
        return data;
    }
}

export interface IALAsignacionGastoInfoResult {
    gastoEstado?: string;
    gastoVrAPagar?: number;
    gastoCxPPucId?: string | undefined;
}

export class ALConfigDTO implements IALConfigDTO {
    alAnoResolucion?: number | undefined;
    alBonVolumen?: boolean | undefined;
    alCobraVias?: string | undefined;
    alFechaInicio?: Date | undefined;
    alRegion?: number | undefined;
    alCuentaCompra?: string | undefined;
    alCuentaCxP?: string | undefined;
    alCuentaReteFNG?: string | undefined;
    alCuentaReteRenta?: string | undefined;
    alCuentaBNA?: string | undefined;
    alCuentaFletePropio?: string | undefined;
    alCuentaFleteTercero?: string | undefined;
    alCuentaVias?: string | undefined;
    alCuentaAsociados?: string | undefined;
    alCarteraDescontada?: string | undefined;
    alCuentaAnticipos?: string | undefined;
    alDensidadLeche?: number | undefined;
    alEstandarUFC?: number | undefined;
    alEmpresaDepartamento?: number | undefined;
    alEmpresaDireccion?: string | undefined;
    alEmpresaMunicipio?: number | undefined;
    alEmpresaNIT?: number | undefined;
    alEmpresaNombre?: string | undefined;
    alResponsableCargo?: string | undefined;
    alResponsableIdentificacion?: string | undefined;
    alResponsableNombre?: string | undefined;
    alReteBNA?: number | undefined;
    alReteFNG?: number | undefined;
    alReteRenta?: number | undefined;
    alTopeBNA?: number | undefined;
    alTopeRenta?: number | undefined;
    alTopeFNG?: number | undefined;
    alTipoLaboratorio?: string | undefined;
    alTipoPeriodo?: number | undefined;
    alTipoPrecioAcordado?: string | undefined;
    alTipoBonFrio?: number | undefined;
    alManejaFlete2?: boolean | undefined;
    alTipoSolidos?: string | undefined;
    alNotasEgreso?: string | undefined;
    alLecheId?: string | undefined;
    alBodegaId?: string | undefined;
    alDocumentoId?: number | undefined;
    alNombreBoni1?: string | undefined;
    alNombreBoni2?: string | undefined;
    alNombreBoni3?: string | undefined;
    alNombreBoniVolumen?: string | undefined;
    alNombreDeduAsociado?: string | undefined;
    alDeduccionAsociado?: number | undefined;
    alDeduccionMaxAsociado?: number | undefined;
    alnitfng?: string | undefined;
    alnitbna?: string | undefined;
    alPagoMinimo?: number | undefined;
    alLogoImagen?: number | undefined;
    alFirmaImagen?: number | undefined;
    alImpresionOrdenEgreso?: string | undefined;
    alImpresionOrdenReciboCaja?: string | undefined;
    alImpresionFullyEgreso?: boolean | undefined;
    alImpresionTipoEgreso?: string | undefined;
    alImpresionEgresoPersonalizado?: number | undefined;
    alBasculaDBIP?: string | undefined;
    alBasculaDBName?: string | undefined;
    alBasculaDBUser?: string | undefined;
    alBasculaDBClave?: string | undefined;
    alIntegracionEmpresa?: string | undefined;
    alIntegracionUsuario?: string | undefined;
    alIntegracionClave?: string | undefined;
    alhtmlfull?: string | undefined;
    alTipoFull?: number | undefined;
    alTipoRetencion?: number | undefined;
    alDocSoporteId?: number | undefined;
    alTipoCierreRuta?: number | undefined;
    activacionesMoviles?: ALActivacionMovilSDT | undefined;

    constructor(data?: IALConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alAnoResolucion = _data["alAnoResolucion"];
            this.alBonVolumen = _data["alBonVolumen"];
            this.alCobraVias = _data["alCobraVias"];
            this.alFechaInicio = _data["alFechaInicio"] ? new Date(_data["alFechaInicio"].toString()) : undefined as any;
            this.alRegion = _data["alRegion"];
            this.alCuentaCompra = _data["alCuentaCompra"];
            this.alCuentaCxP = _data["alCuentaCxP"];
            this.alCuentaReteFNG = _data["alCuentaReteFNG"];
            this.alCuentaReteRenta = _data["alCuentaReteRenta"];
            this.alCuentaBNA = _data["alCuentaBNA"];
            this.alCuentaFletePropio = _data["alCuentaFletePropio"];
            this.alCuentaFleteTercero = _data["alCuentaFleteTercero"];
            this.alCuentaVias = _data["alCuentaVias"];
            this.alCuentaAsociados = _data["alCuentaAsociados"];
            this.alCarteraDescontada = _data["alCarteraDescontada"];
            this.alCuentaAnticipos = _data["alCuentaAnticipos"];
            this.alDensidadLeche = _data["alDensidadLeche"];
            this.alEstandarUFC = _data["alEstandarUFC"];
            this.alEmpresaDepartamento = _data["alEmpresaDepartamento"];
            this.alEmpresaDireccion = _data["alEmpresaDireccion"];
            this.alEmpresaMunicipio = _data["alEmpresaMunicipio"];
            this.alEmpresaNIT = _data["alEmpresaNIT"];
            this.alEmpresaNombre = _data["alEmpresaNombre"];
            this.alResponsableCargo = _data["alResponsableCargo"];
            this.alResponsableIdentificacion = _data["alResponsableIdentificacion"];
            this.alResponsableNombre = _data["alResponsableNombre"];
            this.alReteBNA = _data["alReteBNA"];
            this.alReteFNG = _data["alReteFNG"];
            this.alReteRenta = _data["alReteRenta"];
            this.alTopeBNA = _data["alTopeBNA"];
            this.alTopeRenta = _data["alTopeRenta"];
            this.alTopeFNG = _data["alTopeFNG"];
            this.alTipoLaboratorio = _data["alTipoLaboratorio"];
            this.alTipoPeriodo = _data["alTipoPeriodo"];
            this.alTipoPrecioAcordado = _data["alTipoPrecioAcordado"];
            this.alTipoBonFrio = _data["alTipoBonFrio"];
            this.alManejaFlete2 = _data["alManejaFlete2"];
            this.alTipoSolidos = _data["alTipoSolidos"];
            this.alNotasEgreso = _data["alNotasEgreso"];
            this.alLecheId = _data["alLecheId"];
            this.alBodegaId = _data["alBodegaId"];
            this.alDocumentoId = _data["alDocumentoId"];
            this.alNombreBoni1 = _data["alNombreBoni1"];
            this.alNombreBoni2 = _data["alNombreBoni2"];
            this.alNombreBoni3 = _data["alNombreBoni3"];
            this.alNombreBoniVolumen = _data["alNombreBoniVolumen"];
            this.alNombreDeduAsociado = _data["alNombreDeduAsociado"];
            this.alDeduccionAsociado = _data["alDeduccionAsociado"];
            this.alDeduccionMaxAsociado = _data["alDeduccionMaxAsociado"];
            this.alnitfng = _data["alnitfng"];
            this.alnitbna = _data["alnitbna"];
            this.alPagoMinimo = _data["alPagoMinimo"];
            this.alLogoImagen = _data["alLogoImagen"];
            this.alFirmaImagen = _data["alFirmaImagen"];
            this.alImpresionOrdenEgreso = _data["alImpresionOrdenEgreso"];
            this.alImpresionOrdenReciboCaja = _data["alImpresionOrdenReciboCaja"];
            this.alImpresionFullyEgreso = _data["alImpresionFullyEgreso"];
            this.alImpresionTipoEgreso = _data["alImpresionTipoEgreso"];
            this.alImpresionEgresoPersonalizado = _data["alImpresionEgresoPersonalizado"];
            this.alBasculaDBIP = _data["alBasculaDBIP"];
            this.alBasculaDBName = _data["alBasculaDBName"];
            this.alBasculaDBUser = _data["alBasculaDBUser"];
            this.alBasculaDBClave = _data["alBasculaDBClave"];
            this.alIntegracionEmpresa = _data["alIntegracionEmpresa"];
            this.alIntegracionUsuario = _data["alIntegracionUsuario"];
            this.alIntegracionClave = _data["alIntegracionClave"];
            this.alhtmlfull = _data["alhtmlfull"];
            this.alTipoFull = _data["alTipoFull"];
            this.alTipoRetencion = _data["alTipoRetencion"];
            this.alDocSoporteId = _data["alDocSoporteId"];
            this.alTipoCierreRuta = _data["alTipoCierreRuta"];
            this.activacionesMoviles = _data["activacionesMoviles"] ? ALActivacionMovilSDT.fromJS(_data["activacionesMoviles"]) : undefined as any;
        }
    }

    static fromJS(data: any): ALConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ALConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alAnoResolucion"] = this.alAnoResolucion;
        data["alBonVolumen"] = this.alBonVolumen;
        data["alCobraVias"] = this.alCobraVias;
        data["alFechaInicio"] = this.alFechaInicio ? this.alFechaInicio.toISOString() : undefined as any;
        data["alRegion"] = this.alRegion;
        data["alCuentaCompra"] = this.alCuentaCompra;
        data["alCuentaCxP"] = this.alCuentaCxP;
        data["alCuentaReteFNG"] = this.alCuentaReteFNG;
        data["alCuentaReteRenta"] = this.alCuentaReteRenta;
        data["alCuentaBNA"] = this.alCuentaBNA;
        data["alCuentaFletePropio"] = this.alCuentaFletePropio;
        data["alCuentaFleteTercero"] = this.alCuentaFleteTercero;
        data["alCuentaVias"] = this.alCuentaVias;
        data["alCuentaAsociados"] = this.alCuentaAsociados;
        data["alCarteraDescontada"] = this.alCarteraDescontada;
        data["alCuentaAnticipos"] = this.alCuentaAnticipos;
        data["alDensidadLeche"] = this.alDensidadLeche;
        data["alEstandarUFC"] = this.alEstandarUFC;
        data["alEmpresaDepartamento"] = this.alEmpresaDepartamento;
        data["alEmpresaDireccion"] = this.alEmpresaDireccion;
        data["alEmpresaMunicipio"] = this.alEmpresaMunicipio;
        data["alEmpresaNIT"] = this.alEmpresaNIT;
        data["alEmpresaNombre"] = this.alEmpresaNombre;
        data["alResponsableCargo"] = this.alResponsableCargo;
        data["alResponsableIdentificacion"] = this.alResponsableIdentificacion;
        data["alResponsableNombre"] = this.alResponsableNombre;
        data["alReteBNA"] = this.alReteBNA;
        data["alReteFNG"] = this.alReteFNG;
        data["alReteRenta"] = this.alReteRenta;
        data["alTopeBNA"] = this.alTopeBNA;
        data["alTopeRenta"] = this.alTopeRenta;
        data["alTopeFNG"] = this.alTopeFNG;
        data["alTipoLaboratorio"] = this.alTipoLaboratorio;
        data["alTipoPeriodo"] = this.alTipoPeriodo;
        data["alTipoPrecioAcordado"] = this.alTipoPrecioAcordado;
        data["alTipoBonFrio"] = this.alTipoBonFrio;
        data["alManejaFlete2"] = this.alManejaFlete2;
        data["alTipoSolidos"] = this.alTipoSolidos;
        data["alNotasEgreso"] = this.alNotasEgreso;
        data["alLecheId"] = this.alLecheId;
        data["alBodegaId"] = this.alBodegaId;
        data["alDocumentoId"] = this.alDocumentoId;
        data["alNombreBoni1"] = this.alNombreBoni1;
        data["alNombreBoni2"] = this.alNombreBoni2;
        data["alNombreBoni3"] = this.alNombreBoni3;
        data["alNombreBoniVolumen"] = this.alNombreBoniVolumen;
        data["alNombreDeduAsociado"] = this.alNombreDeduAsociado;
        data["alDeduccionAsociado"] = this.alDeduccionAsociado;
        data["alDeduccionMaxAsociado"] = this.alDeduccionMaxAsociado;
        data["alnitfng"] = this.alnitfng;
        data["alnitbna"] = this.alnitbna;
        data["alPagoMinimo"] = this.alPagoMinimo;
        data["alLogoImagen"] = this.alLogoImagen;
        data["alFirmaImagen"] = this.alFirmaImagen;
        data["alImpresionOrdenEgreso"] = this.alImpresionOrdenEgreso;
        data["alImpresionOrdenReciboCaja"] = this.alImpresionOrdenReciboCaja;
        data["alImpresionFullyEgreso"] = this.alImpresionFullyEgreso;
        data["alImpresionTipoEgreso"] = this.alImpresionTipoEgreso;
        data["alImpresionEgresoPersonalizado"] = this.alImpresionEgresoPersonalizado;
        data["alBasculaDBIP"] = this.alBasculaDBIP;
        data["alBasculaDBName"] = this.alBasculaDBName;
        data["alBasculaDBUser"] = this.alBasculaDBUser;
        data["alBasculaDBClave"] = this.alBasculaDBClave;
        data["alIntegracionEmpresa"] = this.alIntegracionEmpresa;
        data["alIntegracionUsuario"] = this.alIntegracionUsuario;
        data["alIntegracionClave"] = this.alIntegracionClave;
        data["alhtmlfull"] = this.alhtmlfull;
        data["alTipoFull"] = this.alTipoFull;
        data["alTipoRetencion"] = this.alTipoRetencion;
        data["alDocSoporteId"] = this.alDocSoporteId;
        data["alTipoCierreRuta"] = this.alTipoCierreRuta;
        data["activacionesMoviles"] = this.activacionesMoviles ? this.activacionesMoviles.toJSON() : undefined as any;
        return data;
    }
}

export interface IALConfigDTO {
    alAnoResolucion?: number | undefined;
    alBonVolumen?: boolean | undefined;
    alCobraVias?: string | undefined;
    alFechaInicio?: Date | undefined;
    alRegion?: number | undefined;
    alCuentaCompra?: string | undefined;
    alCuentaCxP?: string | undefined;
    alCuentaReteFNG?: string | undefined;
    alCuentaReteRenta?: string | undefined;
    alCuentaBNA?: string | undefined;
    alCuentaFletePropio?: string | undefined;
    alCuentaFleteTercero?: string | undefined;
    alCuentaVias?: string | undefined;
    alCuentaAsociados?: string | undefined;
    alCarteraDescontada?: string | undefined;
    alCuentaAnticipos?: string | undefined;
    alDensidadLeche?: number | undefined;
    alEstandarUFC?: number | undefined;
    alEmpresaDepartamento?: number | undefined;
    alEmpresaDireccion?: string | undefined;
    alEmpresaMunicipio?: number | undefined;
    alEmpresaNIT?: number | undefined;
    alEmpresaNombre?: string | undefined;
    alResponsableCargo?: string | undefined;
    alResponsableIdentificacion?: string | undefined;
    alResponsableNombre?: string | undefined;
    alReteBNA?: number | undefined;
    alReteFNG?: number | undefined;
    alReteRenta?: number | undefined;
    alTopeBNA?: number | undefined;
    alTopeRenta?: number | undefined;
    alTopeFNG?: number | undefined;
    alTipoLaboratorio?: string | undefined;
    alTipoPeriodo?: number | undefined;
    alTipoPrecioAcordado?: string | undefined;
    alTipoBonFrio?: number | undefined;
    alManejaFlete2?: boolean | undefined;
    alTipoSolidos?: string | undefined;
    alNotasEgreso?: string | undefined;
    alLecheId?: string | undefined;
    alBodegaId?: string | undefined;
    alDocumentoId?: number | undefined;
    alNombreBoni1?: string | undefined;
    alNombreBoni2?: string | undefined;
    alNombreBoni3?: string | undefined;
    alNombreBoniVolumen?: string | undefined;
    alNombreDeduAsociado?: string | undefined;
    alDeduccionAsociado?: number | undefined;
    alDeduccionMaxAsociado?: number | undefined;
    alnitfng?: string | undefined;
    alnitbna?: string | undefined;
    alPagoMinimo?: number | undefined;
    alLogoImagen?: number | undefined;
    alFirmaImagen?: number | undefined;
    alImpresionOrdenEgreso?: string | undefined;
    alImpresionOrdenReciboCaja?: string | undefined;
    alImpresionFullyEgreso?: boolean | undefined;
    alImpresionTipoEgreso?: string | undefined;
    alImpresionEgresoPersonalizado?: number | undefined;
    alBasculaDBIP?: string | undefined;
    alBasculaDBName?: string | undefined;
    alBasculaDBUser?: string | undefined;
    alBasculaDBClave?: string | undefined;
    alIntegracionEmpresa?: string | undefined;
    alIntegracionUsuario?: string | undefined;
    alIntegracionClave?: string | undefined;
    alhtmlfull?: string | undefined;
    alTipoFull?: number | undefined;
    alTipoRetencion?: number | undefined;
    alDocSoporteId?: number | undefined;
    alTipoCierreRuta?: number | undefined;
    activacionesMoviles?: ALActivacionMovilSDT | undefined;
}

export class ALActivacionMovilSDT implements IALActivacionMovilSDT {
    isMuestraInterna?: boolean | undefined;
    isMuestraLaboratorio?: boolean | undefined;
    isMuestraCompartimiento?: boolean | undefined;
    isPropiedadesOrganolepticas?: boolean | undefined;
    isCambiaRuta?: boolean | undefined;
    isMultiplesViajes?: boolean | undefined;
    inicioDiaObligatorio?: boolean | undefined;
    isEncuestaObligatoria?: boolean | undefined;
    porcentajeMaximoDesviacion?: number | undefined;
    notasPie?: string | undefined;
    empresaNombre?: string | undefined;
    empresaNIT?: string | undefined;

    constructor(data?: IALActivacionMovilSDT) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isMuestraInterna = _data["isMuestraInterna"];
            this.isMuestraLaboratorio = _data["isMuestraLaboratorio"];
            this.isMuestraCompartimiento = _data["isMuestraCompartimiento"];
            this.isPropiedadesOrganolepticas = _data["isPropiedadesOrganolepticas"];
            this.isCambiaRuta = _data["isCambiaRuta"];
            this.isMultiplesViajes = _data["isMultiplesViajes"];
            this.inicioDiaObligatorio = _data["inicioDiaObligatorio"];
            this.isEncuestaObligatoria = _data["isEncuestaObligatoria"];
            this.porcentajeMaximoDesviacion = _data["porcentajeMaximoDesviacion"];
            this.notasPie = _data["notasPie"];
            this.empresaNombre = _data["empresaNombre"];
            this.empresaNIT = _data["empresaNIT"];
        }
    }

    static fromJS(data: any): ALActivacionMovilSDT {
        data = typeof data === 'object' ? data : {};
        let result = new ALActivacionMovilSDT();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMuestraInterna"] = this.isMuestraInterna;
        data["isMuestraLaboratorio"] = this.isMuestraLaboratorio;
        data["isMuestraCompartimiento"] = this.isMuestraCompartimiento;
        data["isPropiedadesOrganolepticas"] = this.isPropiedadesOrganolepticas;
        data["isCambiaRuta"] = this.isCambiaRuta;
        data["isMultiplesViajes"] = this.isMultiplesViajes;
        data["inicioDiaObligatorio"] = this.inicioDiaObligatorio;
        data["isEncuestaObligatoria"] = this.isEncuestaObligatoria;
        data["porcentajeMaximoDesviacion"] = this.porcentajeMaximoDesviacion;
        data["notasPie"] = this.notasPie;
        data["empresaNombre"] = this.empresaNombre;
        data["empresaNIT"] = this.empresaNIT;
        return data;
    }
}

export interface IALActivacionMovilSDT {
    isMuestraInterna?: boolean | undefined;
    isMuestraLaboratorio?: boolean | undefined;
    isMuestraCompartimiento?: boolean | undefined;
    isPropiedadesOrganolepticas?: boolean | undefined;
    isCambiaRuta?: boolean | undefined;
    isMultiplesViajes?: boolean | undefined;
    inicioDiaObligatorio?: boolean | undefined;
    isEncuestaObligatoria?: boolean | undefined;
    porcentajeMaximoDesviacion?: number | undefined;
    notasPie?: string | undefined;
    empresaNombre?: string | undefined;
    empresaNIT?: string | undefined;
}

export class BonificacionVolumenDTO implements IBonificacionVolumenDTO {
    volumenDesde?: number;
    volumenHasta?: number;
    volumenBonificacion?: number;

    constructor(data?: IBonificacionVolumenDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.volumenDesde = _data["volumenDesde"];
            this.volumenHasta = _data["volumenHasta"];
            this.volumenBonificacion = _data["volumenBonificacion"];
        }
    }

    static fromJS(data: any): BonificacionVolumenDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BonificacionVolumenDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["volumenDesde"] = this.volumenDesde;
        data["volumenHasta"] = this.volumenHasta;
        data["volumenBonificacion"] = this.volumenBonificacion;
        return data;
    }
}

export interface IBonificacionVolumenDTO {
    volumenDesde?: number;
    volumenHasta?: number;
    volumenBonificacion?: number;
}

export class ActualizaCupoCreditoItemDto implements IActualizaCupoCreditoItemDto {
    productorId?: number;
    productorTerceroNombre?: string | undefined;
    clienteId?: number;
    base?: number;
    cupo?: number;

    constructor(data?: IActualizaCupoCreditoItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productorId = _data["productorId"];
            this.productorTerceroNombre = _data["productorTerceroNombre"];
            this.clienteId = _data["clienteId"];
            this.base = _data["base"];
            this.cupo = _data["cupo"];
        }
    }

    static fromJS(data: any): ActualizaCupoCreditoItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActualizaCupoCreditoItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productorId"] = this.productorId;
        data["productorTerceroNombre"] = this.productorTerceroNombre;
        data["clienteId"] = this.clienteId;
        data["base"] = this.base;
        data["cupo"] = this.cupo;
        return data;
    }
}

export interface IActualizaCupoCreditoItemDto {
    productorId?: number;
    productorTerceroNombre?: string | undefined;
    clienteId?: number;
    base?: number;
    cupo?: number;
}

export class ActualizaCupoCreditoRequest implements IActualizaCupoCreditoRequest {
    actualizaCupo?: number;
    alPlanillaId?: number;

    constructor(data?: IActualizaCupoCreditoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actualizaCupo = _data["actualizaCupo"];
            this.alPlanillaId = _data["alPlanillaId"];
        }
    }

    static fromJS(data: any): ActualizaCupoCreditoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ActualizaCupoCreditoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actualizaCupo"] = this.actualizaCupo;
        data["alPlanillaId"] = this.alPlanillaId;
        return data;
    }
}

export interface IActualizaCupoCreditoRequest {
    actualizaCupo?: number;
    alPlanillaId?: number;
}

export class ListaEgresosBancoRequest implements IListaEgresosBancoRequest {
    alPlanillaId?: number;

    constructor(data?: IListaEgresosBancoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alPlanillaId = _data["alPlanillaId"];
        }
    }

    static fromJS(data: any): ListaEgresosBancoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListaEgresosBancoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alPlanillaId"] = this.alPlanillaId;
        return data;
    }
}

export interface IListaEgresosBancoRequest {
    alPlanillaId?: number;
}

export class PagingOfALDescuento implements IPagingOfALDescuento {
    count?: number;
    data?: ALDescuento[];

    constructor(data?: IPagingOfALDescuento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ALDescuento.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfALDescuento {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfALDescuento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfALDescuento {
    count?: number;
    data?: ALDescuento[];
}

export class ALDescuento implements IALDescuento {
    alDescuentoId?: number;
    productorId?: number;
    alDescuentoNit?: string;
    alDescuentoCuenta?: string;
    alDescuentoFactura?: string;
    alDescuentoValor?: number;
    alDescuentoCuota?: number;
    alDescuentoPropio?: boolean;
    alDescuentoVrSaldo?: number;
    alDescuentoVrAbonado?: number;
    alDescuentoFacturaId?: number | undefined;
    productorTerceroNombre?: string | undefined;

    constructor(data?: IALDescuento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alDescuentoId = _data["alDescuentoId"];
            this.productorId = _data["productorId"];
            this.alDescuentoNit = _data["alDescuentoNit"];
            this.alDescuentoCuenta = _data["alDescuentoCuenta"];
            this.alDescuentoFactura = _data["alDescuentoFactura"];
            this.alDescuentoValor = _data["alDescuentoValor"];
            this.alDescuentoCuota = _data["alDescuentoCuota"];
            this.alDescuentoPropio = _data["alDescuentoPropio"];
            this.alDescuentoVrSaldo = _data["alDescuentoVrSaldo"];
            this.alDescuentoVrAbonado = _data["alDescuentoVrAbonado"];
            this.alDescuentoFacturaId = _data["alDescuentoFacturaId"];
            this.productorTerceroNombre = _data["productorTerceroNombre"];
        }
    }

    static fromJS(data: any): ALDescuento {
        data = typeof data === 'object' ? data : {};
        let result = new ALDescuento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alDescuentoId"] = this.alDescuentoId;
        data["productorId"] = this.productorId;
        data["alDescuentoNit"] = this.alDescuentoNit;
        data["alDescuentoCuenta"] = this.alDescuentoCuenta;
        data["alDescuentoFactura"] = this.alDescuentoFactura;
        data["alDescuentoValor"] = this.alDescuentoValor;
        data["alDescuentoCuota"] = this.alDescuentoCuota;
        data["alDescuentoPropio"] = this.alDescuentoPropio;
        data["alDescuentoVrSaldo"] = this.alDescuentoVrSaldo;
        data["alDescuentoVrAbonado"] = this.alDescuentoVrAbonado;
        data["alDescuentoFacturaId"] = this.alDescuentoFacturaId;
        data["productorTerceroNombre"] = this.productorTerceroNombre;
        return data;
    }
}

export interface IALDescuento {
    alDescuentoId?: number;
    productorId?: number;
    alDescuentoNit?: string;
    alDescuentoCuenta?: string;
    alDescuentoFactura?: string;
    alDescuentoValor?: number;
    alDescuentoCuota?: number;
    alDescuentoPropio?: boolean;
    alDescuentoVrSaldo?: number;
    alDescuentoVrAbonado?: number;
    alDescuentoFacturaId?: number | undefined;
    productorTerceroNombre?: string | undefined;
}

export class ALDescuentoFromCarteraResult implements IALDescuentoFromCarteraResult {
    cantidadFacturas?: number;
    valorTotal?: number;

    constructor(data?: IALDescuentoFromCarteraResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantidadFacturas = _data["cantidadFacturas"];
            this.valorTotal = _data["valorTotal"];
        }
    }

    static fromJS(data: any): ALDescuentoFromCarteraResult {
        data = typeof data === 'object' ? data : {};
        let result = new ALDescuentoFromCarteraResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantidadFacturas"] = this.cantidadFacturas;
        data["valorTotal"] = this.valorTotal;
        return data;
    }
}

export interface IALDescuentoFromCarteraResult {
    cantidadFacturas?: number;
    valorTotal?: number;
}

export class ALDescuentoFacturaInfoResult implements IALDescuentoFacturaInfoResult {
    facturaId?: number;
    facturaVrSaldo?: number;
    facturaVrAPagar?: number;
    clienteTerceroNombre?: string | undefined;
    terceroId?: number;
    isInAlDescuento?: boolean;

    constructor(data?: IALDescuentoFacturaInfoResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facturaId = _data["facturaId"];
            this.facturaVrSaldo = _data["facturaVrSaldo"];
            this.facturaVrAPagar = _data["facturaVrAPagar"];
            this.clienteTerceroNombre = _data["clienteTerceroNombre"];
            this.terceroId = _data["terceroId"];
            this.isInAlDescuento = _data["isInAlDescuento"];
        }
    }

    static fromJS(data: any): ALDescuentoFacturaInfoResult {
        data = typeof data === 'object' ? data : {};
        let result = new ALDescuentoFacturaInfoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facturaId"] = this.facturaId;
        data["facturaVrSaldo"] = this.facturaVrSaldo;
        data["facturaVrAPagar"] = this.facturaVrAPagar;
        data["clienteTerceroNombre"] = this.clienteTerceroNombre;
        data["terceroId"] = this.terceroId;
        data["isInAlDescuento"] = this.isInAlDescuento;
        return data;
    }
}

export interface IALDescuentoFacturaInfoResult {
    facturaId?: number;
    facturaVrSaldo?: number;
    facturaVrAPagar?: number;
    clienteTerceroNombre?: string | undefined;
    terceroId?: number;
    isInAlDescuento?: boolean;
}

export class ALAnticipoRequest implements IALAnticipoRequest {
    alPlanillaId?: number;
    productorId?: number;
    documentoId?: number;
    alDescuentoValor?: number;
    alDescuentoCuota?: number;
    bancoId?: number;

    constructor(data?: IALAnticipoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alPlanillaId = _data["alPlanillaId"];
            this.productorId = _data["productorId"];
            this.documentoId = _data["documentoId"];
            this.alDescuentoValor = _data["alDescuentoValor"];
            this.alDescuentoCuota = _data["alDescuentoCuota"];
            this.bancoId = _data["bancoId"];
        }
    }

    static fromJS(data: any): ALAnticipoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ALAnticipoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alPlanillaId"] = this.alPlanillaId;
        data["productorId"] = this.productorId;
        data["documentoId"] = this.documentoId;
        data["alDescuentoValor"] = this.alDescuentoValor;
        data["alDescuentoCuota"] = this.alDescuentoCuota;
        data["bancoId"] = this.bancoId;
        return data;
    }
}

export interface IALAnticipoRequest {
    alPlanillaId?: number;
    productorId?: number;
    documentoId?: number;
    alDescuentoValor?: number;
    alDescuentoCuota?: number;
    bancoId?: number;
}

export class ArcolactDocSoporteResponse implements IArcolactDocSoporteResponse {
    isOk?: boolean;
    messages?: string[];
    message?: string | undefined;

    constructor(data?: IArcolactDocSoporteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ArcolactDocSoporteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ArcolactDocSoporteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOk"] = this.isOk;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}

export interface IArcolactDocSoporteResponse {
    isOk?: boolean;
    messages?: string[];
    message?: string | undefined;
}

export class ArcolactDocSoporteRequest implements IArcolactDocSoporteRequest {
    alPlanillaId?: number;
    fecha?: Date;

    constructor(data?: IArcolactDocSoporteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alPlanillaId = _data["alPlanillaId"];
            this.fecha = _data["fecha"] ? new Date(_data["fecha"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ArcolactDocSoporteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ArcolactDocSoporteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alPlanillaId"] = this.alPlanillaId;
        data["fecha"] = this.fecha ? formatDate(this.fecha) : undefined as any;
        return data;
    }
}

export interface IArcolactDocSoporteRequest {
    alPlanillaId?: number;
    fecha?: Date;
}

export class JobCreatedResult implements IJobCreatedResult {
    jobId?: string;

    constructor(data?: IJobCreatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
        }
    }

    static fromJS(data: any): JobCreatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new JobCreatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        return data;
    }
}

export interface IJobCreatedResult {
    jobId?: string;
}

export class ALEgresoDTO implements IALEgresoDTO {
    alPlanillaId?: number;
    productorId?: number;
    documentoId?: number;
    bancoId?: number;
    alEgresoFecha?: Date;

    constructor(data?: IALEgresoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alPlanillaId = _data["alPlanillaId"];
            this.productorId = _data["productorId"];
            this.documentoId = _data["documentoId"];
            this.bancoId = _data["bancoId"];
            this.alEgresoFecha = _data["alEgresoFecha"] ? new Date(_data["alEgresoFecha"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ALEgresoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ALEgresoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alPlanillaId"] = this.alPlanillaId;
        data["productorId"] = this.productorId;
        data["documentoId"] = this.documentoId;
        data["bancoId"] = this.bancoId;
        data["alEgresoFecha"] = this.alEgresoFecha ? formatDate(this.alEgresoFecha) : undefined as any;
        return data;
    }
}

export interface IALEgresoDTO {
    alPlanillaId?: number;
    productorId?: number;
    documentoId?: number;
    bancoId?: number;
    alEgresoFecha?: Date;
}

export class ALEgresoBulkDTO implements IALEgresoBulkDTO {
    alPlanillaId?: number;
    documentoId?: number;
    bancoId?: number;
    alEgresoFecha?: Date;
    productorIds?: number[];

    constructor(data?: IALEgresoBulkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alPlanillaId = _data["alPlanillaId"];
            this.documentoId = _data["documentoId"];
            this.bancoId = _data["bancoId"];
            this.alEgresoFecha = _data["alEgresoFecha"] ? new Date(_data["alEgresoFecha"].toString()) : undefined as any;
            if (Array.isArray(_data["productorIds"])) {
                this.productorIds = [] as any;
                for (let item of _data["productorIds"])
                    this.productorIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ALEgresoBulkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ALEgresoBulkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alPlanillaId"] = this.alPlanillaId;
        data["documentoId"] = this.documentoId;
        data["bancoId"] = this.bancoId;
        data["alEgresoFecha"] = this.alEgresoFecha ? formatDate(this.alEgresoFecha) : undefined as any;
        if (Array.isArray(this.productorIds)) {
            data["productorIds"] = [];
            for (let item of this.productorIds)
                data["productorIds"].push(item);
        }
        return data;
    }
}

export interface IALEgresoBulkDTO {
    alPlanillaId?: number;
    documentoId?: number;
    bancoId?: number;
    alEgresoFecha?: Date;
    productorIds?: number[];
}

export class PagingOfALKardex implements IPagingOfALKardex {
    count?: number;
    data?: ALKardex[];

    constructor(data?: IPagingOfALKardex) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ALKardex.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfALKardex {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfALKardex();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfALKardex {
    count?: number;
    data?: ALKardex[];
}

export class ALKardex implements IALKardex {
    alKardexId?: number;
    codproduK?: number;
    productorTerceroNombre?: string | undefined;
    productorFinca?: string | undefined;
    conductorNombre?: string | undefined;
    alKardexCantidad?: number;
    alKardexTanque?: number;
    alKardexCantinas?: number;
    alKardexTemperatura?: number;
    alKardexObservacion?: string;
    alKardexPosicion?: string;
    alKardexFecha?: Date;
    alKardexDia?: Date | undefined;
    alKardexEstado?: string;
    cierreRutaId?: number | undefined;
    alKardexConductor?: number | undefined;
    alKardexPlanillaId?: number | undefined;
    alKardexExternalId?: string;
    alKardexViaje?: number | undefined;
    alKardexGUID?: string | undefined;
    alKardexCompart?: number | undefined;
    alKardexMuestraInterna?: string | undefined;
    alKardexMuestra?: string | undefined;
    alKardexDensidad?: number | undefined;
    alKardexAlcohol?: string | undefined;
    alKardexAntibiotico?: string | undefined;
    alKardexOlor?: string | undefined;
    alKardexColor?: string | undefined;
    alKardexRechazada?: boolean | undefined;
    alKardexAlcoholLFileId?: number | undefined;
    alKardexFirmaLFileId?: number | undefined;
    alKardexNotas?: string | undefined;
    alKardexProperties?: string | undefined;
    alKardexDistancia?: number | undefined;
    alKardexUser?: string | undefined;
    alKardexInsHr?: Date | undefined;

    constructor(data?: IALKardex) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alKardexId = _data["alKardexId"];
            this.codproduK = _data["codproduK"];
            this.productorTerceroNombre = _data["productorTerceroNombre"];
            this.productorFinca = _data["productorFinca"];
            this.conductorNombre = _data["conductorNombre"];
            this.alKardexCantidad = _data["alKardexCantidad"];
            this.alKardexTanque = _data["alKardexTanque"];
            this.alKardexCantinas = _data["alKardexCantinas"];
            this.alKardexTemperatura = _data["alKardexTemperatura"];
            this.alKardexObservacion = _data["alKardexObservacion"];
            this.alKardexPosicion = _data["alKardexPosicion"];
            this.alKardexFecha = _data["alKardexFecha"] ? new Date(_data["alKardexFecha"].toString()) : undefined as any;
            this.alKardexDia = _data["alKardexDia"] ? new Date(_data["alKardexDia"].toString()) : undefined as any;
            this.alKardexEstado = _data["alKardexEstado"];
            this.cierreRutaId = _data["cierreRutaId"];
            this.alKardexConductor = _data["alKardexConductor"];
            this.alKardexPlanillaId = _data["alKardexPlanillaId"];
            this.alKardexExternalId = _data["alKardexExternalId"];
            this.alKardexViaje = _data["alKardexViaje"];
            this.alKardexGUID = _data["alKardexGUID"];
            this.alKardexCompart = _data["alKardexCompart"];
            this.alKardexMuestraInterna = _data["alKardexMuestraInterna"];
            this.alKardexMuestra = _data["alKardexMuestra"];
            this.alKardexDensidad = _data["alKardexDensidad"];
            this.alKardexAlcohol = _data["alKardexAlcohol"];
            this.alKardexAntibiotico = _data["alKardexAntibiotico"];
            this.alKardexOlor = _data["alKardexOlor"];
            this.alKardexColor = _data["alKardexColor"];
            this.alKardexRechazada = _data["alKardexRechazada"];
            this.alKardexAlcoholLFileId = _data["alKardexAlcoholLFileId"];
            this.alKardexFirmaLFileId = _data["alKardexFirmaLFileId"];
            this.alKardexNotas = _data["alKardexNotas"];
            this.alKardexProperties = _data["alKardexProperties"];
            this.alKardexDistancia = _data["alKardexDistancia"];
            this.alKardexUser = _data["alKardexUser"];
            this.alKardexInsHr = _data["alKardexInsHr"] ? new Date(_data["alKardexInsHr"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ALKardex {
        data = typeof data === 'object' ? data : {};
        let result = new ALKardex();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alKardexId"] = this.alKardexId;
        data["codproduK"] = this.codproduK;
        data["productorTerceroNombre"] = this.productorTerceroNombre;
        data["productorFinca"] = this.productorFinca;
        data["conductorNombre"] = this.conductorNombre;
        data["alKardexCantidad"] = this.alKardexCantidad;
        data["alKardexTanque"] = this.alKardexTanque;
        data["alKardexCantinas"] = this.alKardexCantinas;
        data["alKardexTemperatura"] = this.alKardexTemperatura;
        data["alKardexObservacion"] = this.alKardexObservacion;
        data["alKardexPosicion"] = this.alKardexPosicion;
        data["alKardexFecha"] = this.alKardexFecha ? this.alKardexFecha.toISOString() : undefined as any;
        data["alKardexDia"] = this.alKardexDia ? this.alKardexDia.toISOString() : undefined as any;
        data["alKardexEstado"] = this.alKardexEstado;
        data["cierreRutaId"] = this.cierreRutaId;
        data["alKardexConductor"] = this.alKardexConductor;
        data["alKardexPlanillaId"] = this.alKardexPlanillaId;
        data["alKardexExternalId"] = this.alKardexExternalId;
        data["alKardexViaje"] = this.alKardexViaje;
        data["alKardexGUID"] = this.alKardexGUID;
        data["alKardexCompart"] = this.alKardexCompart;
        data["alKardexMuestraInterna"] = this.alKardexMuestraInterna;
        data["alKardexMuestra"] = this.alKardexMuestra;
        data["alKardexDensidad"] = this.alKardexDensidad;
        data["alKardexAlcohol"] = this.alKardexAlcohol;
        data["alKardexAntibiotico"] = this.alKardexAntibiotico;
        data["alKardexOlor"] = this.alKardexOlor;
        data["alKardexColor"] = this.alKardexColor;
        data["alKardexRechazada"] = this.alKardexRechazada;
        data["alKardexAlcoholLFileId"] = this.alKardexAlcoholLFileId;
        data["alKardexFirmaLFileId"] = this.alKardexFirmaLFileId;
        data["alKardexNotas"] = this.alKardexNotas;
        data["alKardexProperties"] = this.alKardexProperties;
        data["alKardexDistancia"] = this.alKardexDistancia;
        data["alKardexUser"] = this.alKardexUser;
        data["alKardexInsHr"] = this.alKardexInsHr ? this.alKardexInsHr.toISOString() : undefined as any;
        return data;
    }
}

export interface IALKardex {
    alKardexId?: number;
    codproduK?: number;
    productorTerceroNombre?: string | undefined;
    productorFinca?: string | undefined;
    conductorNombre?: string | undefined;
    alKardexCantidad?: number;
    alKardexTanque?: number;
    alKardexCantinas?: number;
    alKardexTemperatura?: number;
    alKardexObservacion?: string;
    alKardexPosicion?: string;
    alKardexFecha?: Date;
    alKardexDia?: Date | undefined;
    alKardexEstado?: string;
    cierreRutaId?: number | undefined;
    alKardexConductor?: number | undefined;
    alKardexPlanillaId?: number | undefined;
    alKardexExternalId?: string;
    alKardexViaje?: number | undefined;
    alKardexGUID?: string | undefined;
    alKardexCompart?: number | undefined;
    alKardexMuestraInterna?: string | undefined;
    alKardexMuestra?: string | undefined;
    alKardexDensidad?: number | undefined;
    alKardexAlcohol?: string | undefined;
    alKardexAntibiotico?: string | undefined;
    alKardexOlor?: string | undefined;
    alKardexColor?: string | undefined;
    alKardexRechazada?: boolean | undefined;
    alKardexAlcoholLFileId?: number | undefined;
    alKardexFirmaLFileId?: number | undefined;
    alKardexNotas?: string | undefined;
    alKardexProperties?: string | undefined;
    alKardexDistancia?: number | undefined;
    alKardexUser?: string | undefined;
    alKardexInsHr?: Date | undefined;
}

export class ALKardexRutaDiaDTO implements IALKardexRutaDiaDTO {
    productorId?: number;
    productorNombre?: string;
    finca?: string | undefined;
    promedio?: number;
    secuencia?: number;
    totalLitros?: number;

    constructor(data?: IALKardexRutaDiaDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productorId = _data["productorId"];
            this.productorNombre = _data["productorNombre"];
            this.finca = _data["finca"];
            this.promedio = _data["promedio"];
            this.secuencia = _data["secuencia"];
            this.totalLitros = _data["totalLitros"];
        }
    }

    static fromJS(data: any): ALKardexRutaDiaDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ALKardexRutaDiaDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productorId"] = this.productorId;
        data["productorNombre"] = this.productorNombre;
        data["finca"] = this.finca;
        data["promedio"] = this.promedio;
        data["secuencia"] = this.secuencia;
        data["totalLitros"] = this.totalLitros;
        return data;
    }
}

export interface IALKardexRutaDiaDTO {
    productorId?: number;
    productorNombre?: string;
    finca?: string | undefined;
    promedio?: number;
    secuencia?: number;
    totalLitros?: number;
}

export class PagingOfALPlanilla implements IPagingOfALPlanilla {
    count?: number;
    data?: ALPlanilla[];

    constructor(data?: IPagingOfALPlanilla) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ALPlanilla.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfALPlanilla {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfALPlanilla();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfALPlanilla {
    count?: number;
    data?: ALPlanilla[];
}

export class ALPlanilla implements IALPlanilla {
    alPlanillaId?: number;
    alPlanillaTipoPeriodo?: number;
    alPlanillaFechaInicio?: Date;
    alPlanillaFechaFin?: Date;
    alpLanillaProductores?: number;
    alPlanillaNumeroLitros?: number;
    alPlanillaEstado?: number | undefined;
    alPlanillaCompraId?: number | undefined;
    alpLanillaCompraId2?: number | undefined;
    alpLanillaAcopio?: number | undefined;

    constructor(data?: IALPlanilla) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alPlanillaId = _data["alPlanillaId"];
            this.alPlanillaTipoPeriodo = _data["alPlanillaTipoPeriodo"];
            this.alPlanillaFechaInicio = _data["alPlanillaFechaInicio"] ? new Date(_data["alPlanillaFechaInicio"].toString()) : undefined as any;
            this.alPlanillaFechaFin = _data["alPlanillaFechaFin"] ? new Date(_data["alPlanillaFechaFin"].toString()) : undefined as any;
            this.alpLanillaProductores = _data["alpLanillaProductores"];
            this.alPlanillaNumeroLitros = _data["alPlanillaNumeroLitros"];
            this.alPlanillaEstado = _data["alPlanillaEstado"];
            this.alPlanillaCompraId = _data["alPlanillaCompraId"];
            this.alpLanillaCompraId2 = _data["alpLanillaCompraId2"];
            this.alpLanillaAcopio = _data["alpLanillaAcopio"];
        }
    }

    static fromJS(data: any): ALPlanilla {
        data = typeof data === 'object' ? data : {};
        let result = new ALPlanilla();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alPlanillaId"] = this.alPlanillaId;
        data["alPlanillaTipoPeriodo"] = this.alPlanillaTipoPeriodo;
        data["alPlanillaFechaInicio"] = this.alPlanillaFechaInicio ? this.alPlanillaFechaInicio.toISOString() : undefined as any;
        data["alPlanillaFechaFin"] = this.alPlanillaFechaFin ? this.alPlanillaFechaFin.toISOString() : undefined as any;
        data["alpLanillaProductores"] = this.alpLanillaProductores;
        data["alPlanillaNumeroLitros"] = this.alPlanillaNumeroLitros;
        data["alPlanillaEstado"] = this.alPlanillaEstado;
        data["alPlanillaCompraId"] = this.alPlanillaCompraId;
        data["alpLanillaCompraId2"] = this.alpLanillaCompraId2;
        data["alpLanillaAcopio"] = this.alpLanillaAcopio;
        return data;
    }
}

export interface IALPlanilla {
    alPlanillaId?: number;
    alPlanillaTipoPeriodo?: number;
    alPlanillaFechaInicio?: Date;
    alPlanillaFechaFin?: Date;
    alpLanillaProductores?: number;
    alPlanillaNumeroLitros?: number;
    alPlanillaEstado?: number | undefined;
    alPlanillaCompraId?: number | undefined;
    alpLanillaCompraId2?: number | undefined;
    alpLanillaAcopio?: number | undefined;
}

export class ALPlanillaViewDTO implements IALPlanillaViewDTO {
    alPlanillaFechaInicio?: Date;
    alPlanillaFechaFin?: Date;
    alPlanillaAcopio?: number | undefined;
    alPlanillaEstado?: number | undefined;
    alPlanillaTipoPeriodo?: number;
    alPlanillaNumeroLitros?: number;
    alPlanillaProductores?: ALPlanillaProductorDTO[];

    constructor(data?: IALPlanillaViewDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alPlanillaFechaInicio = _data["alPlanillaFechaInicio"] ? new Date(_data["alPlanillaFechaInicio"].toString()) : undefined as any;
            this.alPlanillaFechaFin = _data["alPlanillaFechaFin"] ? new Date(_data["alPlanillaFechaFin"].toString()) : undefined as any;
            this.alPlanillaAcopio = _data["alPlanillaAcopio"];
            this.alPlanillaEstado = _data["alPlanillaEstado"];
            this.alPlanillaTipoPeriodo = _data["alPlanillaTipoPeriodo"];
            this.alPlanillaNumeroLitros = _data["alPlanillaNumeroLitros"];
            if (Array.isArray(_data["alPlanillaProductores"])) {
                this.alPlanillaProductores = [] as any;
                for (let item of _data["alPlanillaProductores"])
                    this.alPlanillaProductores!.push(ALPlanillaProductorDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ALPlanillaViewDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ALPlanillaViewDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alPlanillaFechaInicio"] = this.alPlanillaFechaInicio ? this.alPlanillaFechaInicio.toISOString() : undefined as any;
        data["alPlanillaFechaFin"] = this.alPlanillaFechaFin ? this.alPlanillaFechaFin.toISOString() : undefined as any;
        data["alPlanillaAcopio"] = this.alPlanillaAcopio;
        data["alPlanillaEstado"] = this.alPlanillaEstado;
        data["alPlanillaTipoPeriodo"] = this.alPlanillaTipoPeriodo;
        data["alPlanillaNumeroLitros"] = this.alPlanillaNumeroLitros;
        if (Array.isArray(this.alPlanillaProductores)) {
            data["alPlanillaProductores"] = [];
            for (let item of this.alPlanillaProductores)
                data["alPlanillaProductores"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IALPlanillaViewDTO {
    alPlanillaFechaInicio?: Date;
    alPlanillaFechaFin?: Date;
    alPlanillaAcopio?: number | undefined;
    alPlanillaEstado?: number | undefined;
    alPlanillaTipoPeriodo?: number;
    alPlanillaNumeroLitros?: number;
    alPlanillaProductores?: ALPlanillaProductorDTO[];
}

export class ALPlanillaProductorDTO implements IALPlanillaProductorDTO {
    productorId?: number;
    productorNombre?: string;
    productorTerceroNit?: string | undefined;
    productorBancoId?: number | undefined;
    rutaNombre?: string | undefined;
    dia1?: number;
    dia2?: number;
    dia3?: number;
    dia4?: number;
    dia5?: number;
    dia6?: number;
    dia7?: number;
    dia8?: number;
    dia9?: number;
    dia10?: number;
    dia11?: number;
    dia12?: number;
    dia13?: number;
    dia14?: number;
    dia15?: number;
    dia16?: number;
    totalLitros?: number;
    hlt?: number | undefined;
    hlb?: number | undefined;
    frio?: boolean | undefined;
    ufc?: number | undefined;
    grasa?: number | undefined;
    proteina?: number | undefined;
    solidos?: number | undefined;
    fleteLt?: number | undefined;
    fleteLt2?: number | undefined;
    alPlanillaValorBocs?: number | undefined;
    alPlanillaValorFrio?: number | undefined;
    alPlanillaValorUFC?: number | undefined;
    alPlanillaValorLitro?: number | undefined;
    alPlanillaBonVoluntarias?: number | undefined;
    alPlanillaPrecioLt?: number | undefined;
    alPlanillaTotalBase?: number | undefined;
    alPlanillaReteBNA?: number | undefined;
    alPlanillaRenta?: number | undefined;
    alPlanillaAsignaciones?: number | undefined;
    alPlanillaFNG?: number | undefined;
    alPlanillaFlete?: number | undefined;
    alPlanillaFlete2?: number | undefined;
    alPlanillaVias?: number | undefined;
    alPlanillaObligaciones?: number | undefined;
    alPlanillaDescuentos?: number | undefined;
    alPlanillaTotalAPagar?: number | undefined;
    egresoId2?: string | undefined;
    alPlanillaReciboCajaId2?: string | undefined;
    alPlanillaDedAsociado?: number | undefined;

    constructor(data?: IALPlanillaProductorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productorId = _data["productorId"];
            this.productorNombre = _data["productorNombre"];
            this.productorTerceroNit = _data["productorTerceroNit"];
            this.productorBancoId = _data["productorBancoId"];
            this.rutaNombre = _data["rutaNombre"];
            this.dia1 = _data["dia1"];
            this.dia2 = _data["dia2"];
            this.dia3 = _data["dia3"];
            this.dia4 = _data["dia4"];
            this.dia5 = _data["dia5"];
            this.dia6 = _data["dia6"];
            this.dia7 = _data["dia7"];
            this.dia8 = _data["dia8"];
            this.dia9 = _data["dia9"];
            this.dia10 = _data["dia10"];
            this.dia11 = _data["dia11"];
            this.dia12 = _data["dia12"];
            this.dia13 = _data["dia13"];
            this.dia14 = _data["dia14"];
            this.dia15 = _data["dia15"];
            this.dia16 = _data["dia16"];
            this.totalLitros = _data["totalLitros"];
            this.hlt = _data["hlt"];
            this.hlb = _data["hlb"];
            this.frio = _data["frio"];
            this.ufc = _data["ufc"];
            this.grasa = _data["grasa"];
            this.proteina = _data["proteina"];
            this.solidos = _data["solidos"];
            this.fleteLt = _data["fleteLt"];
            this.fleteLt2 = _data["fleteLt2"];
            this.alPlanillaValorBocs = _data["alPlanillaValorBocs"];
            this.alPlanillaValorFrio = _data["alPlanillaValorFrio"];
            this.alPlanillaValorUFC = _data["alPlanillaValorUFC"];
            this.alPlanillaValorLitro = _data["alPlanillaValorLitro"];
            this.alPlanillaBonVoluntarias = _data["alPlanillaBonVoluntarias"];
            this.alPlanillaPrecioLt = _data["alPlanillaPrecioLt"];
            this.alPlanillaTotalBase = _data["alPlanillaTotalBase"];
            this.alPlanillaReteBNA = _data["alPlanillaReteBNA"];
            this.alPlanillaRenta = _data["alPlanillaRenta"];
            this.alPlanillaAsignaciones = _data["alPlanillaAsignaciones"];
            this.alPlanillaFNG = _data["alPlanillaFNG"];
            this.alPlanillaFlete = _data["alPlanillaFlete"];
            this.alPlanillaFlete2 = _data["alPlanillaFlete2"];
            this.alPlanillaVias = _data["alPlanillaVias"];
            this.alPlanillaObligaciones = _data["alPlanillaObligaciones"];
            this.alPlanillaDescuentos = _data["alPlanillaDescuentos"];
            this.alPlanillaTotalAPagar = _data["alPlanillaTotalAPagar"];
            this.egresoId2 = _data["egresoId2"];
            this.alPlanillaReciboCajaId2 = _data["alPlanillaReciboCajaId2"];
            this.alPlanillaDedAsociado = _data["alPlanillaDedAsociado"];
        }
    }

    static fromJS(data: any): ALPlanillaProductorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ALPlanillaProductorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productorId"] = this.productorId;
        data["productorNombre"] = this.productorNombre;
        data["productorTerceroNit"] = this.productorTerceroNit;
        data["productorBancoId"] = this.productorBancoId;
        data["rutaNombre"] = this.rutaNombre;
        data["dia1"] = this.dia1;
        data["dia2"] = this.dia2;
        data["dia3"] = this.dia3;
        data["dia4"] = this.dia4;
        data["dia5"] = this.dia5;
        data["dia6"] = this.dia6;
        data["dia7"] = this.dia7;
        data["dia8"] = this.dia8;
        data["dia9"] = this.dia9;
        data["dia10"] = this.dia10;
        data["dia11"] = this.dia11;
        data["dia12"] = this.dia12;
        data["dia13"] = this.dia13;
        data["dia14"] = this.dia14;
        data["dia15"] = this.dia15;
        data["dia16"] = this.dia16;
        data["totalLitros"] = this.totalLitros;
        data["hlt"] = this.hlt;
        data["hlb"] = this.hlb;
        data["frio"] = this.frio;
        data["ufc"] = this.ufc;
        data["grasa"] = this.grasa;
        data["proteina"] = this.proteina;
        data["solidos"] = this.solidos;
        data["fleteLt"] = this.fleteLt;
        data["fleteLt2"] = this.fleteLt2;
        data["alPlanillaValorBocs"] = this.alPlanillaValorBocs;
        data["alPlanillaValorFrio"] = this.alPlanillaValorFrio;
        data["alPlanillaValorUFC"] = this.alPlanillaValorUFC;
        data["alPlanillaValorLitro"] = this.alPlanillaValorLitro;
        data["alPlanillaBonVoluntarias"] = this.alPlanillaBonVoluntarias;
        data["alPlanillaPrecioLt"] = this.alPlanillaPrecioLt;
        data["alPlanillaTotalBase"] = this.alPlanillaTotalBase;
        data["alPlanillaReteBNA"] = this.alPlanillaReteBNA;
        data["alPlanillaRenta"] = this.alPlanillaRenta;
        data["alPlanillaAsignaciones"] = this.alPlanillaAsignaciones;
        data["alPlanillaFNG"] = this.alPlanillaFNG;
        data["alPlanillaFlete"] = this.alPlanillaFlete;
        data["alPlanillaFlete2"] = this.alPlanillaFlete2;
        data["alPlanillaVias"] = this.alPlanillaVias;
        data["alPlanillaObligaciones"] = this.alPlanillaObligaciones;
        data["alPlanillaDescuentos"] = this.alPlanillaDescuentos;
        data["alPlanillaTotalAPagar"] = this.alPlanillaTotalAPagar;
        data["egresoId2"] = this.egresoId2;
        data["alPlanillaReciboCajaId2"] = this.alPlanillaReciboCajaId2;
        data["alPlanillaDedAsociado"] = this.alPlanillaDedAsociado;
        return data;
    }
}

export interface IALPlanillaProductorDTO {
    productorId?: number;
    productorNombre?: string;
    productorTerceroNit?: string | undefined;
    productorBancoId?: number | undefined;
    rutaNombre?: string | undefined;
    dia1?: number;
    dia2?: number;
    dia3?: number;
    dia4?: number;
    dia5?: number;
    dia6?: number;
    dia7?: number;
    dia8?: number;
    dia9?: number;
    dia10?: number;
    dia11?: number;
    dia12?: number;
    dia13?: number;
    dia14?: number;
    dia15?: number;
    dia16?: number;
    totalLitros?: number;
    hlt?: number | undefined;
    hlb?: number | undefined;
    frio?: boolean | undefined;
    ufc?: number | undefined;
    grasa?: number | undefined;
    proteina?: number | undefined;
    solidos?: number | undefined;
    fleteLt?: number | undefined;
    fleteLt2?: number | undefined;
    alPlanillaValorBocs?: number | undefined;
    alPlanillaValorFrio?: number | undefined;
    alPlanillaValorUFC?: number | undefined;
    alPlanillaValorLitro?: number | undefined;
    alPlanillaBonVoluntarias?: number | undefined;
    alPlanillaPrecioLt?: number | undefined;
    alPlanillaTotalBase?: number | undefined;
    alPlanillaReteBNA?: number | undefined;
    alPlanillaRenta?: number | undefined;
    alPlanillaAsignaciones?: number | undefined;
    alPlanillaFNG?: number | undefined;
    alPlanillaFlete?: number | undefined;
    alPlanillaFlete2?: number | undefined;
    alPlanillaVias?: number | undefined;
    alPlanillaObligaciones?: number | undefined;
    alPlanillaDescuentos?: number | undefined;
    alPlanillaTotalAPagar?: number | undefined;
    egresoId2?: string | undefined;
    alPlanillaReciboCajaId2?: string | undefined;
    alPlanillaDedAsociado?: number | undefined;
}

export class ALPlanillaCreateDTO implements IALPlanillaCreateDTO {
    alPlanillaFechaInicio?: Date;
    alPlanillaFechaFin?: Date;
    alpLanillaAcopio?: number;

    constructor(data?: IALPlanillaCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alPlanillaFechaInicio = _data["alPlanillaFechaInicio"] ? new Date(_data["alPlanillaFechaInicio"].toString()) : undefined as any;
            this.alPlanillaFechaFin = _data["alPlanillaFechaFin"] ? new Date(_data["alPlanillaFechaFin"].toString()) : undefined as any;
            this.alpLanillaAcopio = _data["alpLanillaAcopio"];
        }
    }

    static fromJS(data: any): ALPlanillaCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ALPlanillaCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alPlanillaFechaInicio"] = this.alPlanillaFechaInicio ? this.alPlanillaFechaInicio.toISOString() : undefined as any;
        data["alPlanillaFechaFin"] = this.alPlanillaFechaFin ? this.alPlanillaFechaFin.toISOString() : undefined as any;
        data["alpLanillaAcopio"] = this.alpLanillaAcopio;
        return data;
    }
}

export interface IALPlanillaCreateDTO {
    alPlanillaFechaInicio?: Date;
    alPlanillaFechaFin?: Date;
    alpLanillaAcopio?: number;
}

export class ProcesarPlanillaResponse implements IProcesarPlanillaResponse {
    message?: string;

    constructor(data?: IProcesarPlanillaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ProcesarPlanillaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProcesarPlanillaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface IProcesarPlanillaResponse {
    message?: string;
}

export class ProcesarPlanillaErrorResponse implements IProcesarPlanillaErrorResponse {
    errors?: string[];

    constructor(data?: IProcesarPlanillaErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): ProcesarPlanillaErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProcesarPlanillaErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IProcesarPlanillaErrorResponse {
    errors?: string[];
}

export class ProcesarPlanillaRequest implements IProcesarPlanillaRequest {
    alPlanillaId?: number;

    constructor(data?: IProcesarPlanillaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alPlanillaId = _data["alPlanillaId"];
        }
    }

    static fromJS(data: any): ProcesarPlanillaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProcesarPlanillaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alPlanillaId"] = this.alPlanillaId;
        return data;
    }
}

export interface IProcesarPlanillaRequest {
    alPlanillaId?: number;
}

export class ProcesarPlanillaPaso2Response implements IProcesarPlanillaPaso2Response {
    isOk?: boolean;
    message?: string;
    productoresSinLaboratorio?: ProductorSinLabDTO[];

    constructor(data?: IProcesarPlanillaPaso2Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOk = _data["isOk"];
            this.message = _data["message"];
            if (Array.isArray(_data["productoresSinLaboratorio"])) {
                this.productoresSinLaboratorio = [] as any;
                for (let item of _data["productoresSinLaboratorio"])
                    this.productoresSinLaboratorio!.push(ProductorSinLabDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcesarPlanillaPaso2Response {
        data = typeof data === 'object' ? data : {};
        let result = new ProcesarPlanillaPaso2Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOk"] = this.isOk;
        data["message"] = this.message;
        if (Array.isArray(this.productoresSinLaboratorio)) {
            data["productoresSinLaboratorio"] = [];
            for (let item of this.productoresSinLaboratorio)
                data["productoresSinLaboratorio"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProcesarPlanillaPaso2Response {
    isOk?: boolean;
    message?: string;
    productoresSinLaboratorio?: ProductorSinLabDTO[];
}

export class ProductorSinLabDTO implements IProductorSinLabDTO {
    productorId?: number;
    productorNombre?: string;

    constructor(data?: IProductorSinLabDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productorId = _data["productorId"];
            this.productorNombre = _data["productorNombre"];
        }
    }

    static fromJS(data: any): ProductorSinLabDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductorSinLabDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productorId"] = this.productorId;
        data["productorNombre"] = this.productorNombre;
        return data;
    }
}

export interface IProductorSinLabDTO {
    productorId?: number;
    productorNombre?: string;
}

export class ProcesarPlanillaPaso2Request implements IProcesarPlanillaPaso2Request {
    alPlanillaId?: number;
    proceso?: number;
    reliquidaProductorId?: number | undefined;

    constructor(data?: IProcesarPlanillaPaso2Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alPlanillaId = _data["alPlanillaId"];
            this.proceso = _data["proceso"];
            this.reliquidaProductorId = _data["reliquidaProductorId"];
        }
    }

    static fromJS(data: any): ProcesarPlanillaPaso2Request {
        data = typeof data === 'object' ? data : {};
        let result = new ProcesarPlanillaPaso2Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alPlanillaId"] = this.alPlanillaId;
        data["proceso"] = this.proceso;
        data["reliquidaProductorId"] = this.reliquidaProductorId;
        return data;
    }
}

export interface IProcesarPlanillaPaso2Request {
    alPlanillaId?: number;
    proceso?: number;
    reliquidaProductorId?: number | undefined;
}

export class ProcesarPlanillaPaso3Response implements IProcesarPlanillaPaso3Response {
    isOk?: boolean;
    message?: string;
    messages?: MessageItemDTO[];
    compraId?: number | undefined;
    segundaCompraId?: number | undefined;

    constructor(data?: IProcesarPlanillaPaso3Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOk = _data["isOk"];
            this.message = _data["message"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(MessageItemDTO.fromJS(item));
            }
            this.compraId = _data["compraId"];
            this.segundaCompraId = _data["segundaCompraId"];
        }
    }

    static fromJS(data: any): ProcesarPlanillaPaso3Response {
        data = typeof data === 'object' ? data : {};
        let result = new ProcesarPlanillaPaso3Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOk"] = this.isOk;
        data["message"] = this.message;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item ? item.toJSON() : undefined as any);
        }
        data["compraId"] = this.compraId;
        data["segundaCompraId"] = this.segundaCompraId;
        return data;
    }
}

export interface IProcesarPlanillaPaso3Response {
    isOk?: boolean;
    message?: string;
    messages?: MessageItemDTO[];
    compraId?: number | undefined;
    segundaCompraId?: number | undefined;
}

export class MessageItemDTO implements IMessageItemDTO {
    id?: string;
    type?: number;
    description?: string;

    constructor(data?: IMessageItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): MessageItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MessageItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["description"] = this.description;
        return data;
    }
}

export interface IMessageItemDTO {
    id?: string;
    type?: number;
    description?: string;
}

export class ProcesarPlanillaPaso3Request implements IProcesarPlanillaPaso3Request {
    alPlanillaId?: number;

    constructor(data?: IProcesarPlanillaPaso3Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alPlanillaId = _data["alPlanillaId"];
        }
    }

    static fromJS(data: any): ProcesarPlanillaPaso3Request {
        data = typeof data === 'object' ? data : {};
        let result = new ProcesarPlanillaPaso3Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alPlanillaId"] = this.alPlanillaId;
        return data;
    }
}

export interface IProcesarPlanillaPaso3Request {
    alPlanillaId?: number;
}

export enum OrdenImpresion {
    NoEgreso = 0,
    RutaYProductor = 1,
    RutaYCodigo = 2,
    NoPlanilla = 3,
    RutaYOrdenRecoleccion = 4,
}

export class ALSMSProductoresResponse implements IALSMSProductoresResponse {
    isOk?: boolean;
    message?: string;
    items?: ALSMSProductoresItemResponse[];

    constructor(data?: IALSMSProductoresResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOk = _data["isOk"];
            this.message = _data["message"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ALSMSProductoresItemResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ALSMSProductoresResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ALSMSProductoresResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOk"] = this.isOk;
        data["message"] = this.message;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IALSMSProductoresResponse {
    isOk?: boolean;
    message?: string;
    items?: ALSMSProductoresItemResponse[];
}

export class ALSMSProductoresItemResponse implements IALSMSProductoresItemResponse {
    productorId?: number;
    telefono?: string;
    mensaje?: string;
    enviado?: boolean;
    error?: string | undefined;
    onurixResponse?: OnurixSendSmsResponse | undefined;

    constructor(data?: IALSMSProductoresItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productorId = _data["productorId"];
            this.telefono = _data["telefono"];
            this.mensaje = _data["mensaje"];
            this.enviado = _data["enviado"];
            this.error = _data["error"];
            this.onurixResponse = _data["onurixResponse"] ? OnurixSendSmsResponse.fromJS(_data["onurixResponse"]) : undefined as any;
        }
    }

    static fromJS(data: any): ALSMSProductoresItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ALSMSProductoresItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productorId"] = this.productorId;
        data["telefono"] = this.telefono;
        data["mensaje"] = this.mensaje;
        data["enviado"] = this.enviado;
        data["error"] = this.error;
        data["onurixResponse"] = this.onurixResponse ? this.onurixResponse.toJSON() : undefined as any;
        return data;
    }
}

export interface IALSMSProductoresItemResponse {
    productorId?: number;
    telefono?: string;
    mensaje?: string;
    enviado?: boolean;
    error?: string | undefined;
    onurixResponse?: OnurixSendSmsResponse | undefined;
}

export class OnurixSendSmsResponse implements IOnurixSendSmsResponse {
    code?: number | undefined;
    message?: string | undefined;
    id?: string | undefined;
    status?: string | undefined;

    constructor(data?: IOnurixSendSmsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): OnurixSendSmsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OnurixSendSmsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IOnurixSendSmsResponse {
    code?: number | undefined;
    message?: string | undefined;
    id?: string | undefined;
    status?: string | undefined;
}

export class ALSMSProductoresRequest implements IALSMSProductoresRequest {
    tipo?: number;
    alPlanillaId?: number | undefined;
    productorId?: number | undefined;
    mensaje?: string | undefined;

    constructor(data?: IALSMSProductoresRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipo = _data["tipo"];
            this.alPlanillaId = _data["alPlanillaId"];
            this.productorId = _data["productorId"];
            this.mensaje = _data["mensaje"];
        }
    }

    static fromJS(data: any): ALSMSProductoresRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ALSMSProductoresRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipo"] = this.tipo;
        data["alPlanillaId"] = this.alPlanillaId;
        data["productorId"] = this.productorId;
        data["mensaje"] = this.mensaje;
        return data;
    }
}

export interface IALSMSProductoresRequest {
    tipo?: number;
    alPlanillaId?: number | undefined;
    productorId?: number | undefined;
    mensaje?: string | undefined;
}

export class SetMuestraStandardRequest implements ISetMuestraStandardRequest {
    alPlanillaId?: number;
    productorId?: number;

    constructor(data?: ISetMuestraStandardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alPlanillaId = _data["alPlanillaId"];
            this.productorId = _data["productorId"];
        }
    }

    static fromJS(data: any): SetMuestraStandardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetMuestraStandardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alPlanillaId"] = this.alPlanillaId;
        data["productorId"] = this.productorId;
        return data;
    }
}

export interface ISetMuestraStandardRequest {
    alPlanillaId?: number;
    productorId?: number;
}

export class ALPlanillaEnvioEmailRequest implements IALPlanillaEnvioEmailRequest {
    codPlanilla?: number;
    documentoAEnviar?: DocumentoAEnviar;
    codProductor?: number;
    tipoEnvio?: TipoEnvio;

    constructor(data?: IALPlanillaEnvioEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codPlanilla = _data["codPlanilla"];
            this.documentoAEnviar = _data["documentoAEnviar"];
            this.codProductor = _data["codProductor"];
            this.tipoEnvio = _data["tipoEnvio"];
        }
    }

    static fromJS(data: any): ALPlanillaEnvioEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ALPlanillaEnvioEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codPlanilla"] = this.codPlanilla;
        data["documentoAEnviar"] = this.documentoAEnviar;
        data["codProductor"] = this.codProductor;
        data["tipoEnvio"] = this.tipoEnvio;
        return data;
    }
}

export interface IALPlanillaEnvioEmailRequest {
    codPlanilla?: number;
    documentoAEnviar?: DocumentoAEnviar;
    codProductor?: number;
    tipoEnvio?: TipoEnvio;
}

export enum DocumentoAEnviar {
    Full = 0,
    Egreso = 1,
    FullYEgreso = 2,
}

export enum TipoEnvio {
    PendientesPorEnviar = 0,
    ReenvioCompleto = 1,
}

export class ALPlanillaEnvioEmailResult implements IALPlanillaEnvioEmailResult {
    enviados?: number;
    total?: number;
    errores?: number;
    mensaje?: string | undefined;

    constructor(data?: IALPlanillaEnvioEmailResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enviados = _data["enviados"];
            this.total = _data["total"];
            this.errores = _data["errores"];
            this.mensaje = _data["mensaje"];
        }
    }

    static fromJS(data: any): ALPlanillaEnvioEmailResult {
        data = typeof data === 'object' ? data : {};
        let result = new ALPlanillaEnvioEmailResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enviados"] = this.enviados;
        data["total"] = this.total;
        data["errores"] = this.errores;
        data["mensaje"] = this.mensaje;
        return data;
    }
}

export interface IALPlanillaEnvioEmailResult {
    enviados?: number;
    total?: number;
    errores?: number;
    mensaje?: string | undefined;
}

export class ALReciboCajaBulkDTO implements IALReciboCajaBulkDTO {
    alPlanillaId?: number;
    documentoId?: number;
    reciboCajaFecha?: Date;
    sucursalId?: number | undefined;

    constructor(data?: IALReciboCajaBulkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alPlanillaId = _data["alPlanillaId"];
            this.documentoId = _data["documentoId"];
            this.reciboCajaFecha = _data["reciboCajaFecha"] ? new Date(_data["reciboCajaFecha"].toString()) : undefined as any;
            this.sucursalId = _data["sucursalId"];
        }
    }

    static fromJS(data: any): ALReciboCajaBulkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ALReciboCajaBulkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alPlanillaId"] = this.alPlanillaId;
        data["documentoId"] = this.documentoId;
        data["reciboCajaFecha"] = this.reciboCajaFecha ? this.reciboCajaFecha.toISOString() : undefined as any;
        data["sucursalId"] = this.sucursalId;
        return data;
    }
}

export interface IALReciboCajaBulkDTO {
    alPlanillaId?: number;
    documentoId?: number;
    reciboCajaFecha?: Date;
    sucursalId?: number | undefined;
}

export class ALResolucionDTO implements IALResolucionDTO {
    certificados?: CertificadosItem[];
    uFC?: UFCItem[];
    solidos?: SolidoItem[];
    transporte?: TransporteItem[];

    constructor(data?: IALResolucionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Certificados"])) {
                this.certificados = [] as any;
                for (let item of _data["Certificados"])
                    this.certificados!.push(CertificadosItem.fromJS(item));
            }
            if (Array.isArray(_data["UFC"])) {
                this.uFC = [] as any;
                for (let item of _data["UFC"])
                    this.uFC!.push(UFCItem.fromJS(item));
            }
            if (Array.isArray(_data["Solidos"])) {
                this.solidos = [] as any;
                for (let item of _data["Solidos"])
                    this.solidos!.push(SolidoItem.fromJS(item));
            }
            if (Array.isArray(_data["Transporte"])) {
                this.transporte = [] as any;
                for (let item of _data["Transporte"])
                    this.transporte!.push(TransporteItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ALResolucionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ALResolucionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.certificados)) {
            data["Certificados"] = [];
            for (let item of this.certificados)
                data["Certificados"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.uFC)) {
            data["UFC"] = [];
            for (let item of this.uFC)
                data["UFC"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.solidos)) {
            data["Solidos"] = [];
            for (let item of this.solidos)
                data["Solidos"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.transporte)) {
            data["Transporte"] = [];
            for (let item of this.transporte)
                data["Transporte"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IALResolucionDTO {
    certificados?: CertificadosItem[];
    uFC?: UFCItem[];
    solidos?: SolidoItem[];
    transporte?: TransporteItem[];
}

export class CertificadosItem implements ICertificadosItem {
    certificado?: string | undefined;
    valor?: number | undefined;

    constructor(data?: ICertificadosItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.certificado = _data["Certificado"];
            this.valor = _data["Valor"];
        }
    }

    static fromJS(data: any): CertificadosItem {
        data = typeof data === 'object' ? data : {};
        let result = new CertificadosItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Certificado"] = this.certificado;
        data["Valor"] = this.valor;
        return data;
    }
}

export interface ICertificadosItem {
    certificado?: string | undefined;
    valor?: number | undefined;
}

export class UFCItem implements IUFCItem {
    region?: number | undefined;
    desde?: number | undefined;
    hasta?: number | undefined;
    precioLitro?: number | undefined;
    precioLitroFrio?: number | undefined;

    constructor(data?: IUFCItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.region = _data["Region"];
            this.desde = _data["Desde"];
            this.hasta = _data["Hasta"];
            this.precioLitro = _data["PrecioLitro"];
            this.precioLitroFrio = _data["PrecioLitroFrio"];
        }
    }

    static fromJS(data: any): UFCItem {
        data = typeof data === 'object' ? data : {};
        let result = new UFCItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Region"] = this.region;
        data["Desde"] = this.desde;
        data["Hasta"] = this.hasta;
        data["PrecioLitro"] = this.precioLitro;
        data["PrecioLitroFrio"] = this.precioLitroFrio;
        return data;
    }
}

export interface IUFCItem {
    region?: number | undefined;
    desde?: number | undefined;
    hasta?: number | undefined;
    precioLitro?: number | undefined;
    precioLitroFrio?: number | undefined;
}

export class SolidoItem implements ISolidoItem {
    tipo?: string | undefined;
    region1?: number | undefined;
    region2?: number | undefined;
    promedio?: number | undefined;
    maximo?: number | undefined;

    constructor(data?: ISolidoItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipo = _data["Tipo"];
            this.region1 = _data["Region1"];
            this.region2 = _data["Region2"];
            this.promedio = _data["Promedio"];
            this.maximo = _data["Maximo"];
        }
    }

    static fromJS(data: any): SolidoItem {
        data = typeof data === 'object' ? data : {};
        let result = new SolidoItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Tipo"] = this.tipo;
        data["Region1"] = this.region1;
        data["Region2"] = this.region2;
        data["Promedio"] = this.promedio;
        data["Maximo"] = this.maximo;
        return data;
    }
}

export interface ISolidoItem {
    tipo?: string | undefined;
    region1?: number | undefined;
    region2?: number | undefined;
    promedio?: number | undefined;
    maximo?: number | undefined;
}

export class TransporteItem implements ITransporteItem {
    desde?: number | undefined;
    hasta?: number | undefined;
    tractoCamion?: number | undefined;
    grandeTanque?: number | undefined;
    grandeCantinas?: number | undefined;
    smallTanque?: number | undefined;
    smallCantinas?: number | undefined;

    constructor(data?: ITransporteItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.desde = _data["Desde"];
            this.hasta = _data["Hasta"];
            this.tractoCamion = _data["TractoCamion"];
            this.grandeTanque = _data["GrandeTanque"];
            this.grandeCantinas = _data["GrandeCantinas"];
            this.smallTanque = _data["SmallTanque"];
            this.smallCantinas = _data["SmallCantinas"];
        }
    }

    static fromJS(data: any): TransporteItem {
        data = typeof data === 'object' ? data : {};
        let result = new TransporteItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Desde"] = this.desde;
        data["Hasta"] = this.hasta;
        data["TractoCamion"] = this.tractoCamion;
        data["GrandeTanque"] = this.grandeTanque;
        data["GrandeCantinas"] = this.grandeCantinas;
        data["SmallTanque"] = this.smallTanque;
        data["SmallCantinas"] = this.smallCantinas;
        return data;
    }
}

export interface ITransporteItem {
    desde?: number | undefined;
    hasta?: number | undefined;
    tractoCamion?: number | undefined;
    grandeTanque?: number | undefined;
    grandeCantinas?: number | undefined;
    smallTanque?: number | undefined;
    smallCantinas?: number | undefined;
}

export class CrearResolucionRequest implements ICrearResolucionRequest {
    ano?: number;
    datos?: ALResolucionDTO;

    constructor(data?: ICrearResolucionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ano = _data["ano"];
            this.datos = _data["datos"] ? ALResolucionDTO.fromJS(_data["datos"]) : undefined as any;
        }
    }

    static fromJS(data: any): CrearResolucionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CrearResolucionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ano"] = this.ano;
        data["datos"] = this.datos ? this.datos.toJSON() : undefined as any;
        return data;
    }
}

export interface ICrearResolucionRequest {
    ano?: number;
    datos?: ALResolucionDTO;
}

export class PagingOfALRuta implements IPagingOfALRuta {
    count?: number;
    data?: ALRuta[];

    constructor(data?: IPagingOfALRuta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ALRuta.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfALRuta {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfALRuta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfALRuta {
    count?: number;
    data?: ALRuta[];
}

export class ALRuta implements IALRuta {
    alRutaId?: string;
    alRutaNombre?: string;
    alRutaNit?: string | undefined;
    alRutaTipoCamion?: number | undefined;
    alRutaDescuentoVias?: number | undefined;
    alRutaNitVias?: string | undefined;
    alRutaRegion?: number | undefined;
    alAcopioId?: number | undefined;
    alRutaCCId?: number | undefined;
    alRutaDestino?: string | undefined;
    ciudadId?: string | undefined;

    constructor(data?: IALRuta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alRutaId = _data["alRutaId"];
            this.alRutaNombre = _data["alRutaNombre"];
            this.alRutaNit = _data["alRutaNit"];
            this.alRutaTipoCamion = _data["alRutaTipoCamion"];
            this.alRutaDescuentoVias = _data["alRutaDescuentoVias"];
            this.alRutaNitVias = _data["alRutaNitVias"];
            this.alRutaRegion = _data["alRutaRegion"];
            this.alAcopioId = _data["alAcopioId"];
            this.alRutaCCId = _data["alRutaCCId"];
            this.alRutaDestino = _data["alRutaDestino"];
            this.ciudadId = _data["ciudadId"];
        }
    }

    static fromJS(data: any): ALRuta {
        data = typeof data === 'object' ? data : {};
        let result = new ALRuta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alRutaId"] = this.alRutaId;
        data["alRutaNombre"] = this.alRutaNombre;
        data["alRutaNit"] = this.alRutaNit;
        data["alRutaTipoCamion"] = this.alRutaTipoCamion;
        data["alRutaDescuentoVias"] = this.alRutaDescuentoVias;
        data["alRutaNitVias"] = this.alRutaNitVias;
        data["alRutaRegion"] = this.alRutaRegion;
        data["alAcopioId"] = this.alAcopioId;
        data["alRutaCCId"] = this.alRutaCCId;
        data["alRutaDestino"] = this.alRutaDestino;
        data["ciudadId"] = this.ciudadId;
        return data;
    }
}

export interface IALRuta {
    alRutaId?: string;
    alRutaNombre?: string;
    alRutaNit?: string | undefined;
    alRutaTipoCamion?: number | undefined;
    alRutaDescuentoVias?: number | undefined;
    alRutaNitVias?: string | undefined;
    alRutaRegion?: number | undefined;
    alAcopioId?: number | undefined;
    alRutaCCId?: number | undefined;
    alRutaDestino?: string | undefined;
    ciudadId?: string | undefined;
}

export class PagingOfBanco implements IPagingOfBanco {
    count?: number;
    data?: Banco[];

    constructor(data?: IPagingOfBanco) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Banco.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfBanco {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfBanco();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfBanco {
    count?: number;
    data?: Banco[];
}

export class Banco implements IBanco {
    bancoId?: number;
    bancoNombre?: string;
    bancoNoCuenta?: string;
    bancoTipoCuenta?: string | undefined;
    bancoProxCheque?: number;
    bancoDebitoBancario?: boolean;
    bancoPucId?: string;
    bancoReqNit?: boolean;
    bancoTipoEgreso?: string;
    bancoFormatoTransferencia?: string | undefined;
    bancoEsqueletoCheque?: string;
    bancoTerceroId?: number;
    bancoActivo?: boolean;
    bancoReglas?: string | undefined;
    bancoProperties?: string | undefined;
    bancoSucursalId?: number | undefined;

    constructor(data?: IBanco) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bancoId = _data["bancoId"];
            this.bancoNombre = _data["bancoNombre"];
            this.bancoNoCuenta = _data["bancoNoCuenta"];
            this.bancoTipoCuenta = _data["bancoTipoCuenta"];
            this.bancoProxCheque = _data["bancoProxCheque"];
            this.bancoDebitoBancario = _data["bancoDebitoBancario"];
            this.bancoPucId = _data["bancoPucId"];
            this.bancoReqNit = _data["bancoReqNit"];
            this.bancoTipoEgreso = _data["bancoTipoEgreso"];
            this.bancoFormatoTransferencia = _data["bancoFormatoTransferencia"];
            this.bancoEsqueletoCheque = _data["bancoEsqueletoCheque"];
            this.bancoTerceroId = _data["bancoTerceroId"];
            this.bancoActivo = _data["bancoActivo"];
            this.bancoReglas = _data["bancoReglas"];
            this.bancoProperties = _data["bancoProperties"];
            this.bancoSucursalId = _data["bancoSucursalId"];
        }
    }

    static fromJS(data: any): Banco {
        data = typeof data === 'object' ? data : {};
        let result = new Banco();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bancoId"] = this.bancoId;
        data["bancoNombre"] = this.bancoNombre;
        data["bancoNoCuenta"] = this.bancoNoCuenta;
        data["bancoTipoCuenta"] = this.bancoTipoCuenta;
        data["bancoProxCheque"] = this.bancoProxCheque;
        data["bancoDebitoBancario"] = this.bancoDebitoBancario;
        data["bancoPucId"] = this.bancoPucId;
        data["bancoReqNit"] = this.bancoReqNit;
        data["bancoTipoEgreso"] = this.bancoTipoEgreso;
        data["bancoFormatoTransferencia"] = this.bancoFormatoTransferencia;
        data["bancoEsqueletoCheque"] = this.bancoEsqueletoCheque;
        data["bancoTerceroId"] = this.bancoTerceroId;
        data["bancoActivo"] = this.bancoActivo;
        data["bancoReglas"] = this.bancoReglas;
        data["bancoProperties"] = this.bancoProperties;
        data["bancoSucursalId"] = this.bancoSucursalId;
        return data;
    }
}

export interface IBanco {
    bancoId?: number;
    bancoNombre?: string;
    bancoNoCuenta?: string;
    bancoTipoCuenta?: string | undefined;
    bancoProxCheque?: number;
    bancoDebitoBancario?: boolean;
    bancoPucId?: string;
    bancoReqNit?: boolean;
    bancoTipoEgreso?: string;
    bancoFormatoTransferencia?: string | undefined;
    bancoEsqueletoCheque?: string;
    bancoTerceroId?: number;
    bancoActivo?: boolean;
    bancoReglas?: string | undefined;
    bancoProperties?: string | undefined;
    bancoSucursalId?: number | undefined;
}

export class PagingOfBodega implements IPagingOfBodega {
    count?: number;
    data?: Bodega[];

    constructor(data?: IPagingOfBodega) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Bodega.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfBodega {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfBodega();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfBodega {
    count?: number;
    data?: Bodega[];
}

export class Bodega implements IBodega {
    bodegaId?: string;
    bodegaNombre?: string;
    bodegaInvNegativo?: boolean | undefined;
    bodegaTipo?: string;
    bodegaResponsableNit?: string | undefined;
    bodegaSucursalId?: number | undefined;
    bodegaEstado?: string | undefined;
    bodegaUsuarioResponsable?: string | undefined;

    constructor(data?: IBodega) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bodegaId = _data["bodegaId"];
            this.bodegaNombre = _data["bodegaNombre"];
            this.bodegaInvNegativo = _data["bodegaInvNegativo"];
            this.bodegaTipo = _data["bodegaTipo"];
            this.bodegaResponsableNit = _data["bodegaResponsableNit"];
            this.bodegaSucursalId = _data["bodegaSucursalId"];
            this.bodegaEstado = _data["bodegaEstado"];
            this.bodegaUsuarioResponsable = _data["bodegaUsuarioResponsable"];
        }
    }

    static fromJS(data: any): Bodega {
        data = typeof data === 'object' ? data : {};
        let result = new Bodega();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bodegaId"] = this.bodegaId;
        data["bodegaNombre"] = this.bodegaNombre;
        data["bodegaInvNegativo"] = this.bodegaInvNegativo;
        data["bodegaTipo"] = this.bodegaTipo;
        data["bodegaResponsableNit"] = this.bodegaResponsableNit;
        data["bodegaSucursalId"] = this.bodegaSucursalId;
        data["bodegaEstado"] = this.bodegaEstado;
        data["bodegaUsuarioResponsable"] = this.bodegaUsuarioResponsable;
        return data;
    }
}

export interface IBodega {
    bodegaId?: string;
    bodegaNombre?: string;
    bodegaInvNegativo?: boolean | undefined;
    bodegaTipo?: string;
    bodegaResponsableNit?: string | undefined;
    bodegaSucursalId?: number | undefined;
    bodegaEstado?: string | undefined;
    bodegaUsuarioResponsable?: string | undefined;
}

export class PagingOfBodegaUbicacion implements IPagingOfBodegaUbicacion {
    count?: number;
    data?: BodegaUbicacion[];

    constructor(data?: IPagingOfBodegaUbicacion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(BodegaUbicacion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfBodegaUbicacion {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfBodegaUbicacion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfBodegaUbicacion {
    count?: number;
    data?: BodegaUbicacion[];
}

export class BodegaUbicacion implements IBodegaUbicacion {
    bodegaUbicacionId?: number;
    bodegaUbicacionNombre?: string;
    bodegaId?: string;

    constructor(data?: IBodegaUbicacion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bodegaUbicacionId = _data["bodegaUbicacionId"];
            this.bodegaUbicacionNombre = _data["bodegaUbicacionNombre"];
            this.bodegaId = _data["bodegaId"];
        }
    }

    static fromJS(data: any): BodegaUbicacion {
        data = typeof data === 'object' ? data : {};
        let result = new BodegaUbicacion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bodegaUbicacionId"] = this.bodegaUbicacionId;
        data["bodegaUbicacionNombre"] = this.bodegaUbicacionNombre;
        data["bodegaId"] = this.bodegaId;
        return data;
    }
}

export interface IBodegaUbicacion {
    bodegaUbicacionId?: number;
    bodegaUbicacionNombre?: string;
    bodegaId?: string;
}

export class BodegaUbicacionPorBodegaItemDto implements IBodegaUbicacionPorBodegaItemDto {
    bodegaUbicacionId?: number;
    bodegaUbicacionNombre?: string;

    constructor(data?: IBodegaUbicacionPorBodegaItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bodegaUbicacionId = _data["bodegaUbicacionId"];
            this.bodegaUbicacionNombre = _data["bodegaUbicacionNombre"];
        }
    }

    static fromJS(data: any): BodegaUbicacionPorBodegaItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BodegaUbicacionPorBodegaItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bodegaUbicacionId"] = this.bodegaUbicacionId;
        data["bodegaUbicacionNombre"] = this.bodegaUbicacionNombre;
        return data;
    }
}

export interface IBodegaUbicacionPorBodegaItemDto {
    bodegaUbicacionId?: number;
    bodegaUbicacionNombre?: string;
}

export class PagingOfCierreRuta implements IPagingOfCierreRuta {
    count?: number;
    data?: CierreRuta[];

    constructor(data?: IPagingOfCierreRuta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CierreRuta.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfCierreRuta {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfCierreRuta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfCierreRuta {
    count?: number;
    data?: CierreRuta[];
}

export class CierreRuta implements ICierreRuta {
    cierreRutaId?: number;
    conductorId?: number;
    conductorNombre?: string | undefined;
    cierreRutaFecha?: Date;
    cierreRutaLitrosRecogidos?: number;
    cierreRutaLitrosRecibidos?: number;
    cierreRutaDiferencia?: number;
    cierreRutaTimeStamp?: Date;
    cierreRutaEstado?: number | undefined;
    cierreRutaViaje?: number | undefined;
    cierreRutaRutaId?: string | undefined;
    cierreRutaRutaNombre?: string | undefined;
    cierreRutaInicio?: Date | undefined;
    cierreRutaFin?: Date | undefined;
    cierreRutaSilo?: string | undefined;
    cierreRutaComp1?: number | undefined;
    cierreRutaComp2?: number | undefined;
    cierreRutaComp3?: number | undefined;
    cierreRutaProperties?: string | undefined;

    constructor(data?: ICierreRuta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cierreRutaId = _data["cierreRutaId"];
            this.conductorId = _data["conductorId"];
            this.conductorNombre = _data["conductorNombre"];
            this.cierreRutaFecha = _data["cierreRutaFecha"] ? new Date(_data["cierreRutaFecha"].toString()) : undefined as any;
            this.cierreRutaLitrosRecogidos = _data["cierreRutaLitrosRecogidos"];
            this.cierreRutaLitrosRecibidos = _data["cierreRutaLitrosRecibidos"];
            this.cierreRutaDiferencia = _data["cierreRutaDiferencia"];
            this.cierreRutaTimeStamp = _data["cierreRutaTimeStamp"] ? new Date(_data["cierreRutaTimeStamp"].toString()) : undefined as any;
            this.cierreRutaEstado = _data["cierreRutaEstado"];
            this.cierreRutaViaje = _data["cierreRutaViaje"];
            this.cierreRutaRutaId = _data["cierreRutaRutaId"];
            this.cierreRutaRutaNombre = _data["cierreRutaRutaNombre"];
            this.cierreRutaInicio = _data["cierreRutaInicio"] ? new Date(_data["cierreRutaInicio"].toString()) : undefined as any;
            this.cierreRutaFin = _data["cierreRutaFin"] ? new Date(_data["cierreRutaFin"].toString()) : undefined as any;
            this.cierreRutaSilo = _data["cierreRutaSilo"];
            this.cierreRutaComp1 = _data["cierreRutaComp1"];
            this.cierreRutaComp2 = _data["cierreRutaComp2"];
            this.cierreRutaComp3 = _data["cierreRutaComp3"];
            this.cierreRutaProperties = _data["cierreRutaProperties"];
        }
    }

    static fromJS(data: any): CierreRuta {
        data = typeof data === 'object' ? data : {};
        let result = new CierreRuta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cierreRutaId"] = this.cierreRutaId;
        data["conductorId"] = this.conductorId;
        data["conductorNombre"] = this.conductorNombre;
        data["cierreRutaFecha"] = this.cierreRutaFecha ? this.cierreRutaFecha.toISOString() : undefined as any;
        data["cierreRutaLitrosRecogidos"] = this.cierreRutaLitrosRecogidos;
        data["cierreRutaLitrosRecibidos"] = this.cierreRutaLitrosRecibidos;
        data["cierreRutaDiferencia"] = this.cierreRutaDiferencia;
        data["cierreRutaTimeStamp"] = this.cierreRutaTimeStamp ? this.cierreRutaTimeStamp.toISOString() : undefined as any;
        data["cierreRutaEstado"] = this.cierreRutaEstado;
        data["cierreRutaViaje"] = this.cierreRutaViaje;
        data["cierreRutaRutaId"] = this.cierreRutaRutaId;
        data["cierreRutaRutaNombre"] = this.cierreRutaRutaNombre;
        data["cierreRutaInicio"] = this.cierreRutaInicio ? this.cierreRutaInicio.toISOString() : undefined as any;
        data["cierreRutaFin"] = this.cierreRutaFin ? this.cierreRutaFin.toISOString() : undefined as any;
        data["cierreRutaSilo"] = this.cierreRutaSilo;
        data["cierreRutaComp1"] = this.cierreRutaComp1;
        data["cierreRutaComp2"] = this.cierreRutaComp2;
        data["cierreRutaComp3"] = this.cierreRutaComp3;
        data["cierreRutaProperties"] = this.cierreRutaProperties;
        return data;
    }
}

export interface ICierreRuta {
    cierreRutaId?: number;
    conductorId?: number;
    conductorNombre?: string | undefined;
    cierreRutaFecha?: Date;
    cierreRutaLitrosRecogidos?: number;
    cierreRutaLitrosRecibidos?: number;
    cierreRutaDiferencia?: number;
    cierreRutaTimeStamp?: Date;
    cierreRutaEstado?: number | undefined;
    cierreRutaViaje?: number | undefined;
    cierreRutaRutaId?: string | undefined;
    cierreRutaRutaNombre?: string | undefined;
    cierreRutaInicio?: Date | undefined;
    cierreRutaFin?: Date | undefined;
    cierreRutaSilo?: string | undefined;
    cierreRutaComp1?: number | undefined;
    cierreRutaComp2?: number | undefined;
    cierreRutaComp3?: number | undefined;
    cierreRutaProperties?: string | undefined;
}

export class SearchDto implements ISearchDto {
    value?: string | undefined;
    label?: string | undefined;
    val1?: number | undefined;
    str1?: string | undefined;
    active?: boolean | undefined;

    constructor(data?: ISearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
            this.val1 = _data["val1"];
            this.str1 = _data["str1"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): SearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        data["val1"] = this.val1;
        data["str1"] = this.str1;
        data["active"] = this.active;
        return data;
    }
}

export interface ISearchDto {
    value?: string | undefined;
    label?: string | undefined;
    val1?: number | undefined;
    str1?: string | undefined;
    active?: boolean | undefined;
}

export class CierreRutaDetalleDTO implements ICierreRutaDetalleDTO {
    cierreRuta?: CierreRuta | undefined;
    recolecciones?: CierreRutaRecoleccionDTO[];

    constructor(data?: ICierreRutaDetalleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cierreRuta = _data["cierreRuta"] ? CierreRuta.fromJS(_data["cierreRuta"]) : undefined as any;
            if (Array.isArray(_data["recolecciones"])) {
                this.recolecciones = [] as any;
                for (let item of _data["recolecciones"])
                    this.recolecciones!.push(CierreRutaRecoleccionDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CierreRutaDetalleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CierreRutaDetalleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cierreRuta"] = this.cierreRuta ? this.cierreRuta.toJSON() : undefined as any;
        if (Array.isArray(this.recolecciones)) {
            data["recolecciones"] = [];
            for (let item of this.recolecciones)
                data["recolecciones"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICierreRutaDetalleDTO {
    cierreRuta?: CierreRuta | undefined;
    recolecciones?: CierreRutaRecoleccionDTO[];
}

export class CierreRutaRecoleccionDTO implements ICierreRutaRecoleccionDTO {
    codProductor?: number;
    productor?: string;
    hora?: Date;
    cantidad?: number;
    ruta?: string | undefined;
    promedio?: number | undefined;
    compartimiento?: number;
    idExterno?: string;

    constructor(data?: ICierreRutaRecoleccionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codProductor = _data["codProductor"];
            this.productor = _data["productor"];
            this.hora = _data["hora"] ? new Date(_data["hora"].toString()) : undefined as any;
            this.cantidad = _data["cantidad"];
            this.ruta = _data["ruta"];
            this.promedio = _data["promedio"];
            this.compartimiento = _data["compartimiento"];
            this.idExterno = _data["idExterno"];
        }
    }

    static fromJS(data: any): CierreRutaRecoleccionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CierreRutaRecoleccionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codProductor"] = this.codProductor;
        data["productor"] = this.productor;
        data["hora"] = this.hora ? this.hora.toISOString() : undefined as any;
        data["cantidad"] = this.cantidad;
        data["ruta"] = this.ruta;
        data["promedio"] = this.promedio;
        data["compartimiento"] = this.compartimiento;
        data["idExterno"] = this.idExterno;
        return data;
    }
}

export interface ICierreRutaRecoleccionDTO {
    codProductor?: number;
    productor?: string;
    hora?: Date;
    cantidad?: number;
    ruta?: string | undefined;
    promedio?: number | undefined;
    compartimiento?: number;
    idExterno?: string;
}

export class PagingOfCiudad implements IPagingOfCiudad {
    count?: number;
    data?: Ciudad[];

    constructor(data?: IPagingOfCiudad) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Ciudad.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfCiudad {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfCiudad();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfCiudad {
    count?: number;
    data?: Ciudad[];
}

export class Ciudad implements ICiudad {
    ciudadId?: string;
    ciudadNombre?: string;
    regionId?: string;
    ciudadIndicativo?: number | undefined;

    constructor(data?: ICiudad) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ciudadId = _data["ciudadId"];
            this.ciudadNombre = _data["ciudadNombre"];
            this.regionId = _data["regionId"];
            this.ciudadIndicativo = _data["ciudadIndicativo"];
        }
    }

    static fromJS(data: any): Ciudad {
        data = typeof data === 'object' ? data : {};
        let result = new Ciudad();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ciudadId"] = this.ciudadId;
        data["ciudadNombre"] = this.ciudadNombre;
        data["regionId"] = this.regionId;
        data["ciudadIndicativo"] = this.ciudadIndicativo;
        return data;
    }
}

export interface ICiudad {
    ciudadId?: string;
    ciudadNombre?: string;
    regionId?: string;
    ciudadIndicativo?: number | undefined;
}

export class PagingOfCliente implements IPagingOfCliente {
    count?: number;
    data?: Cliente[];

    constructor(data?: IPagingOfCliente) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Cliente.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfCliente {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfCliente();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfCliente {
    count?: number;
    data?: Cliente[];
}

export class Cliente implements ICliente {
    clienteId?: number;
    clienteTerceroId?: number;
    clienteDireccion?: string;
    clienteTelefono?: string;
    clienteAlmacen?: string;
    clienteContacto?: string;
    clienteEstado?: string;
    clienteLiquidaInteres?: boolean;
    clienteDesde?: Date;
    clienteEmail?: string;
    clienteCiudadId?: string;
    clienteTelefono2?: string;
    clienteDctoComercial?: number;
    clienteCopiasFactura?: number;
    clienteCategoriaId?: number | undefined;
    clienteCupo?: number;
    clienteRutaId?: number | undefined;
    clientePlazo?: number | undefined;
    precioListaId?: string | undefined;
    clienteRestriccionCredito?: number | undefined;
    clientePlazoFinanciero?: number | undefined;
    clienteDctoFinanciero?: number | undefined;
    clienteVrFlete?: number | undefined;
    clienteTipoFlete?: string | undefined;
    clienteCanalId?: number | undefined;
    clienteTerceroNombre?: string | undefined;
    comisionId?: number | undefined;
    clienteVendedorId?: number | undefined;
    clienteUpdated?: Date | undefined;
    clienteZonaId?: number | undefined;
    clienteIdExterno?: number | undefined;
    clienteBarrio?: string | undefined;
    clienteGPS?: string | undefined;
    clienteOrden?: number | undefined;
    clienteDia7?: boolean | undefined;
    clienteDia6?: boolean | undefined;
    clienteDia5?: boolean | undefined;
    clienteDia4?: boolean | undefined;
    clienteDia3?: boolean | undefined;
    clienteDia2?: boolean | undefined;
    clienteDia1?: boolean | undefined;
    clientePuntosRedi?: number | undefined;
    clientePuntos?: number | undefined;
    clienteTipoFactura?: number | undefined;
    clienteNotas?: string | undefined;

    constructor(data?: ICliente) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clienteId = _data["clienteId"];
            this.clienteTerceroId = _data["clienteTerceroId"];
            this.clienteDireccion = _data["clienteDireccion"];
            this.clienteTelefono = _data["clienteTelefono"];
            this.clienteAlmacen = _data["clienteAlmacen"];
            this.clienteContacto = _data["clienteContacto"];
            this.clienteEstado = _data["clienteEstado"];
            this.clienteLiquidaInteres = _data["clienteLiquidaInteres"];
            this.clienteDesde = _data["clienteDesde"] ? new Date(_data["clienteDesde"].toString()) : undefined as any;
            this.clienteEmail = _data["clienteEmail"];
            this.clienteCiudadId = _data["clienteCiudadId"];
            this.clienteTelefono2 = _data["clienteTelefono2"];
            this.clienteDctoComercial = _data["clienteDctoComercial"];
            this.clienteCopiasFactura = _data["clienteCopiasFactura"];
            this.clienteCategoriaId = _data["clienteCategoriaId"];
            this.clienteCupo = _data["clienteCupo"];
            this.clienteRutaId = _data["clienteRutaId"];
            this.clientePlazo = _data["clientePlazo"];
            this.precioListaId = _data["precioListaId"];
            this.clienteRestriccionCredito = _data["clienteRestriccionCredito"];
            this.clientePlazoFinanciero = _data["clientePlazoFinanciero"];
            this.clienteDctoFinanciero = _data["clienteDctoFinanciero"];
            this.clienteVrFlete = _data["clienteVrFlete"];
            this.clienteTipoFlete = _data["clienteTipoFlete"];
            this.clienteCanalId = _data["clienteCanalId"];
            this.clienteTerceroNombre = _data["clienteTerceroNombre"];
            this.comisionId = _data["comisionId"];
            this.clienteVendedorId = _data["clienteVendedorId"];
            this.clienteUpdated = _data["clienteUpdated"] ? new Date(_data["clienteUpdated"].toString()) : undefined as any;
            this.clienteZonaId = _data["clienteZonaId"];
            this.clienteIdExterno = _data["clienteIdExterno"];
            this.clienteBarrio = _data["clienteBarrio"];
            this.clienteGPS = _data["clienteGPS"];
            this.clienteOrden = _data["clienteOrden"];
            this.clienteDia7 = _data["clienteDia7"];
            this.clienteDia6 = _data["clienteDia6"];
            this.clienteDia5 = _data["clienteDia5"];
            this.clienteDia4 = _data["clienteDia4"];
            this.clienteDia3 = _data["clienteDia3"];
            this.clienteDia2 = _data["clienteDia2"];
            this.clienteDia1 = _data["clienteDia1"];
            this.clientePuntosRedi = _data["clientePuntosRedi"];
            this.clientePuntos = _data["clientePuntos"];
            this.clienteTipoFactura = _data["clienteTipoFactura"];
            this.clienteNotas = _data["clienteNotas"];
        }
    }

    static fromJS(data: any): Cliente {
        data = typeof data === 'object' ? data : {};
        let result = new Cliente();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clienteId"] = this.clienteId;
        data["clienteTerceroId"] = this.clienteTerceroId;
        data["clienteDireccion"] = this.clienteDireccion;
        data["clienteTelefono"] = this.clienteTelefono;
        data["clienteAlmacen"] = this.clienteAlmacen;
        data["clienteContacto"] = this.clienteContacto;
        data["clienteEstado"] = this.clienteEstado;
        data["clienteLiquidaInteres"] = this.clienteLiquidaInteres;
        data["clienteDesde"] = this.clienteDesde ? this.clienteDesde.toISOString() : undefined as any;
        data["clienteEmail"] = this.clienteEmail;
        data["clienteCiudadId"] = this.clienteCiudadId;
        data["clienteTelefono2"] = this.clienteTelefono2;
        data["clienteDctoComercial"] = this.clienteDctoComercial;
        data["clienteCopiasFactura"] = this.clienteCopiasFactura;
        data["clienteCategoriaId"] = this.clienteCategoriaId;
        data["clienteCupo"] = this.clienteCupo;
        data["clienteRutaId"] = this.clienteRutaId;
        data["clientePlazo"] = this.clientePlazo;
        data["precioListaId"] = this.precioListaId;
        data["clienteRestriccionCredito"] = this.clienteRestriccionCredito;
        data["clientePlazoFinanciero"] = this.clientePlazoFinanciero;
        data["clienteDctoFinanciero"] = this.clienteDctoFinanciero;
        data["clienteVrFlete"] = this.clienteVrFlete;
        data["clienteTipoFlete"] = this.clienteTipoFlete;
        data["clienteCanalId"] = this.clienteCanalId;
        data["clienteTerceroNombre"] = this.clienteTerceroNombre;
        data["comisionId"] = this.comisionId;
        data["clienteVendedorId"] = this.clienteVendedorId;
        data["clienteUpdated"] = this.clienteUpdated ? this.clienteUpdated.toISOString() : undefined as any;
        data["clienteZonaId"] = this.clienteZonaId;
        data["clienteIdExterno"] = this.clienteIdExterno;
        data["clienteBarrio"] = this.clienteBarrio;
        data["clienteGPS"] = this.clienteGPS;
        data["clienteOrden"] = this.clienteOrden;
        data["clienteDia7"] = this.clienteDia7;
        data["clienteDia6"] = this.clienteDia6;
        data["clienteDia5"] = this.clienteDia5;
        data["clienteDia4"] = this.clienteDia4;
        data["clienteDia3"] = this.clienteDia3;
        data["clienteDia2"] = this.clienteDia2;
        data["clienteDia1"] = this.clienteDia1;
        data["clientePuntosRedi"] = this.clientePuntosRedi;
        data["clientePuntos"] = this.clientePuntos;
        data["clienteTipoFactura"] = this.clienteTipoFactura;
        data["clienteNotas"] = this.clienteNotas;
        return data;
    }
}

export interface ICliente {
    clienteId?: number;
    clienteTerceroId?: number;
    clienteDireccion?: string;
    clienteTelefono?: string;
    clienteAlmacen?: string;
    clienteContacto?: string;
    clienteEstado?: string;
    clienteLiquidaInteres?: boolean;
    clienteDesde?: Date;
    clienteEmail?: string;
    clienteCiudadId?: string;
    clienteTelefono2?: string;
    clienteDctoComercial?: number;
    clienteCopiasFactura?: number;
    clienteCategoriaId?: number | undefined;
    clienteCupo?: number;
    clienteRutaId?: number | undefined;
    clientePlazo?: number | undefined;
    precioListaId?: string | undefined;
    clienteRestriccionCredito?: number | undefined;
    clientePlazoFinanciero?: number | undefined;
    clienteDctoFinanciero?: number | undefined;
    clienteVrFlete?: number | undefined;
    clienteTipoFlete?: string | undefined;
    clienteCanalId?: number | undefined;
    clienteTerceroNombre?: string | undefined;
    comisionId?: number | undefined;
    clienteVendedorId?: number | undefined;
    clienteUpdated?: Date | undefined;
    clienteZonaId?: number | undefined;
    clienteIdExterno?: number | undefined;
    clienteBarrio?: string | undefined;
    clienteGPS?: string | undefined;
    clienteOrden?: number | undefined;
    clienteDia7?: boolean | undefined;
    clienteDia6?: boolean | undefined;
    clienteDia5?: boolean | undefined;
    clienteDia4?: boolean | undefined;
    clienteDia3?: boolean | undefined;
    clienteDia2?: boolean | undefined;
    clienteDia1?: boolean | undefined;
    clientePuntosRedi?: number | undefined;
    clientePuntos?: number | undefined;
    clienteTipoFactura?: number | undefined;
    clienteNotas?: string | undefined;
}

export class MultiSearchDto implements IMultiSearchDto {
    table?: string;
    options?: SearchDto[];

    constructor(data?: IMultiSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.table = _data["table"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(SearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MultiSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["table"] = this.table;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMultiSearchDto {
    table?: string;
    options?: SearchDto[];
}

export class GetNextIdDto implements IGetNextIdDto {
    id?: number;

    constructor(data?: IGetNextIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetNextIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetNextIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetNextIdDto {
    id?: number;
}

export class SetUserCustomizationRequest implements ISetUserCustomizationRequest {
    key?: string;
    value?: string;

    constructor(data?: ISetUserCustomizationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SetUserCustomizationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserCustomizationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface ISetUserCustomizationRequest {
    key?: string;
    value?: string;
}

export class StartDocumentResponse implements IStartDocumentResponse {
    documento?: Documento | undefined;
    documentoNumero?: number;
    sucursal?: StartDocumentSucursalDto | undefined;
    autorizacionesCadena?: string;
    activacionesCadena?: string;
    extFields?: ExtField[];
    empresaTercero?: StartDocumentTerceroDto | undefined;

    constructor(data?: IStartDocumentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documento = _data["documento"] ? Documento.fromJS(_data["documento"]) : undefined as any;
            this.documentoNumero = _data["documentoNumero"];
            this.sucursal = _data["sucursal"] ? StartDocumentSucursalDto.fromJS(_data["sucursal"]) : undefined as any;
            this.autorizacionesCadena = _data["autorizacionesCadena"];
            this.activacionesCadena = _data["activacionesCadena"];
            if (Array.isArray(_data["extFields"])) {
                this.extFields = [] as any;
                for (let item of _data["extFields"])
                    this.extFields!.push(ExtField.fromJS(item));
            }
            this.empresaTercero = _data["empresaTercero"] ? StartDocumentTerceroDto.fromJS(_data["empresaTercero"]) : undefined as any;
        }
    }

    static fromJS(data: any): StartDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StartDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documento"] = this.documento ? this.documento.toJSON() : undefined as any;
        data["documentoNumero"] = this.documentoNumero;
        data["sucursal"] = this.sucursal ? this.sucursal.toJSON() : undefined as any;
        data["autorizacionesCadena"] = this.autorizacionesCadena;
        data["activacionesCadena"] = this.activacionesCadena;
        if (Array.isArray(this.extFields)) {
            data["extFields"] = [];
            for (let item of this.extFields)
                data["extFields"].push(item ? item.toJSON() : undefined as any);
        }
        data["empresaTercero"] = this.empresaTercero ? this.empresaTercero.toJSON() : undefined as any;
        return data;
    }
}

export interface IStartDocumentResponse {
    documento?: Documento | undefined;
    documentoNumero?: number;
    sucursal?: StartDocumentSucursalDto | undefined;
    autorizacionesCadena?: string;
    activacionesCadena?: string;
    extFields?: ExtField[];
    empresaTercero?: StartDocumentTerceroDto | undefined;
}

export class Documento implements IDocumento {
    documentoId?: number;
    fuenteId?: string;
    documentoCuentas?: string;
    documentoPropiedades?: string;
    documentoDescripcion?: string;
    documentoNoMinCopias?: number;
    documentoNoMaxCopias?: number;
    documentoNoStdCopias?: number;
    documentoNoMaxRegistros?: number;
    documentoDiasAtraso?: number;
    documentoTipoDescripcion?: string;
    documentoNoNotas?: number;
    documentoMinCaracter?: number;
    documentoNoFinal?: number;
    documentoClaveX?: string;
    documentoNoInicial?: number;
    documentoFechaManual?: boolean;
    documentoNumManual?: boolean;
    documentoDescContable?: boolean;
    documentoVariaCuentas?: boolean;
    documentoPregNumCopias?: boolean;
    documentoImpNumSinPrefijo?: boolean;
    documentoImpDocOpcional?: boolean;
    documentoPermiteVariarNotas?: boolean;
    prefijoCod?: number | undefined;
    prefijo?: string | undefined;
    docResFacId?: number | undefined;
    documentoIdExterno?: string | undefined;
    documentoActivo!: boolean;
    documentoRestricciones?: string | undefined;
    documentoSucursales?: string | undefined;

    constructor(data?: IDocumento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentoId = _data["documentoId"];
            this.fuenteId = _data["fuenteId"];
            this.documentoCuentas = _data["documentoCuentas"];
            this.documentoPropiedades = _data["documentoPropiedades"];
            this.documentoDescripcion = _data["documentoDescripcion"];
            this.documentoNoMinCopias = _data["documentoNoMinCopias"];
            this.documentoNoMaxCopias = _data["documentoNoMaxCopias"];
            this.documentoNoStdCopias = _data["documentoNoStdCopias"];
            this.documentoNoMaxRegistros = _data["documentoNoMaxRegistros"];
            this.documentoDiasAtraso = _data["documentoDiasAtraso"];
            this.documentoTipoDescripcion = _data["documentoTipoDescripcion"];
            this.documentoNoNotas = _data["documentoNoNotas"];
            this.documentoMinCaracter = _data["documentoMinCaracter"];
            this.documentoNoFinal = _data["documentoNoFinal"];
            this.documentoClaveX = _data["documentoClaveX"];
            this.documentoNoInicial = _data["documentoNoInicial"];
            this.documentoFechaManual = _data["documentoFechaManual"];
            this.documentoNumManual = _data["documentoNumManual"];
            this.documentoDescContable = _data["documentoDescContable"];
            this.documentoVariaCuentas = _data["documentoVariaCuentas"];
            this.documentoPregNumCopias = _data["documentoPregNumCopias"];
            this.documentoImpNumSinPrefijo = _data["documentoImpNumSinPrefijo"];
            this.documentoImpDocOpcional = _data["documentoImpDocOpcional"];
            this.documentoPermiteVariarNotas = _data["documentoPermiteVariarNotas"];
            this.prefijoCod = _data["prefijoCod"];
            this.prefijo = _data["prefijo"];
            this.docResFacId = _data["docResFacId"];
            this.documentoIdExterno = _data["documentoIdExterno"];
            this.documentoActivo = _data["documentoActivo"];
            this.documentoRestricciones = _data["documentoRestricciones"];
            this.documentoSucursales = _data["documentoSucursales"];
        }
    }

    static fromJS(data: any): Documento {
        data = typeof data === 'object' ? data : {};
        let result = new Documento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoId"] = this.documentoId;
        data["fuenteId"] = this.fuenteId;
        data["documentoCuentas"] = this.documentoCuentas;
        data["documentoPropiedades"] = this.documentoPropiedades;
        data["documentoDescripcion"] = this.documentoDescripcion;
        data["documentoNoMinCopias"] = this.documentoNoMinCopias;
        data["documentoNoMaxCopias"] = this.documentoNoMaxCopias;
        data["documentoNoStdCopias"] = this.documentoNoStdCopias;
        data["documentoNoMaxRegistros"] = this.documentoNoMaxRegistros;
        data["documentoDiasAtraso"] = this.documentoDiasAtraso;
        data["documentoTipoDescripcion"] = this.documentoTipoDescripcion;
        data["documentoNoNotas"] = this.documentoNoNotas;
        data["documentoMinCaracter"] = this.documentoMinCaracter;
        data["documentoNoFinal"] = this.documentoNoFinal;
        data["documentoClaveX"] = this.documentoClaveX;
        data["documentoNoInicial"] = this.documentoNoInicial;
        data["documentoFechaManual"] = this.documentoFechaManual;
        data["documentoNumManual"] = this.documentoNumManual;
        data["documentoDescContable"] = this.documentoDescContable;
        data["documentoVariaCuentas"] = this.documentoVariaCuentas;
        data["documentoPregNumCopias"] = this.documentoPregNumCopias;
        data["documentoImpNumSinPrefijo"] = this.documentoImpNumSinPrefijo;
        data["documentoImpDocOpcional"] = this.documentoImpDocOpcional;
        data["documentoPermiteVariarNotas"] = this.documentoPermiteVariarNotas;
        data["prefijoCod"] = this.prefijoCod;
        data["prefijo"] = this.prefijo;
        data["docResFacId"] = this.docResFacId;
        data["documentoIdExterno"] = this.documentoIdExterno;
        data["documentoActivo"] = this.documentoActivo;
        data["documentoRestricciones"] = this.documentoRestricciones;
        data["documentoSucursales"] = this.documentoSucursales;
        return data;
    }
}

export interface IDocumento {
    documentoId?: number;
    fuenteId?: string;
    documentoCuentas?: string;
    documentoPropiedades?: string;
    documentoDescripcion?: string;
    documentoNoMinCopias?: number;
    documentoNoMaxCopias?: number;
    documentoNoStdCopias?: number;
    documentoNoMaxRegistros?: number;
    documentoDiasAtraso?: number;
    documentoTipoDescripcion?: string;
    documentoNoNotas?: number;
    documentoMinCaracter?: number;
    documentoNoFinal?: number;
    documentoClaveX?: string;
    documentoNoInicial?: number;
    documentoFechaManual?: boolean;
    documentoNumManual?: boolean;
    documentoDescContable?: boolean;
    documentoVariaCuentas?: boolean;
    documentoPregNumCopias?: boolean;
    documentoImpNumSinPrefijo?: boolean;
    documentoImpDocOpcional?: boolean;
    documentoPermiteVariarNotas?: boolean;
    prefijoCod?: number | undefined;
    prefijo?: string | undefined;
    docResFacId?: number | undefined;
    documentoIdExterno?: string | undefined;
    documentoActivo: boolean;
    documentoRestricciones?: string | undefined;
    documentoSucursales?: string | undefined;
}

export class StartDocumentSucursalDto implements IStartDocumentSucursalDto {
    sucursalId?: number;
    sucursalNombre?: string;
    sucursalDireccion?: string | undefined;
    sucursalTelefono?: string | undefined;

    constructor(data?: IStartDocumentSucursalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sucursalId = _data["sucursalId"];
            this.sucursalNombre = _data["sucursalNombre"];
            this.sucursalDireccion = _data["sucursalDireccion"];
            this.sucursalTelefono = _data["sucursalTelefono"];
        }
    }

    static fromJS(data: any): StartDocumentSucursalDto {
        data = typeof data === 'object' ? data : {};
        let result = new StartDocumentSucursalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sucursalId"] = this.sucursalId;
        data["sucursalNombre"] = this.sucursalNombre;
        data["sucursalDireccion"] = this.sucursalDireccion;
        data["sucursalTelefono"] = this.sucursalTelefono;
        return data;
    }
}

export interface IStartDocumentSucursalDto {
    sucursalId?: number;
    sucursalNombre?: string;
    sucursalDireccion?: string | undefined;
    sucursalTelefono?: string | undefined;
}

export class ExtField implements IExtField {
    extFieldId?: number;
    extFieldNombre?: string;
    extFieldDocumentoId?: number | undefined;
    extFieldTipo?: string;
    extFieldOrden?: number;
    extFieldRequerido?: boolean;
    extFieldListaId?: number | undefined;
    extFieldHabilitado?: boolean;
    extFieldTabla?: string | undefined;
    extFieldGrupo?: string | undefined;

    constructor(data?: IExtField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extFieldId = _data["extFieldId"];
            this.extFieldNombre = _data["extFieldNombre"];
            this.extFieldDocumentoId = _data["extFieldDocumentoId"];
            this.extFieldTipo = _data["extFieldTipo"];
            this.extFieldOrden = _data["extFieldOrden"];
            this.extFieldRequerido = _data["extFieldRequerido"];
            this.extFieldListaId = _data["extFieldListaId"];
            this.extFieldHabilitado = _data["extFieldHabilitado"];
            this.extFieldTabla = _data["extFieldTabla"];
            this.extFieldGrupo = _data["extFieldGrupo"];
        }
    }

    static fromJS(data: any): ExtField {
        data = typeof data === 'object' ? data : {};
        let result = new ExtField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extFieldId"] = this.extFieldId;
        data["extFieldNombre"] = this.extFieldNombre;
        data["extFieldDocumentoId"] = this.extFieldDocumentoId;
        data["extFieldTipo"] = this.extFieldTipo;
        data["extFieldOrden"] = this.extFieldOrden;
        data["extFieldRequerido"] = this.extFieldRequerido;
        data["extFieldListaId"] = this.extFieldListaId;
        data["extFieldHabilitado"] = this.extFieldHabilitado;
        data["extFieldTabla"] = this.extFieldTabla;
        data["extFieldGrupo"] = this.extFieldGrupo;
        return data;
    }
}

export interface IExtField {
    extFieldId?: number;
    extFieldNombre?: string;
    extFieldDocumentoId?: number | undefined;
    extFieldTipo?: string;
    extFieldOrden?: number;
    extFieldRequerido?: boolean;
    extFieldListaId?: number | undefined;
    extFieldHabilitado?: boolean;
    extFieldTabla?: string | undefined;
    extFieldGrupo?: string | undefined;
}

export class StartDocumentTerceroDto implements IStartDocumentTerceroDto {
    terceroId?: number;
    nit?: string;
    razonSocial?: string;
    nombreFull?: string;
    terceroDireccion?: string;
    terceroTelefono?: string | undefined;

    constructor(data?: IStartDocumentTerceroDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.terceroId = _data["terceroId"];
            this.nit = _data["nit"];
            this.razonSocial = _data["razonSocial"];
            this.nombreFull = _data["nombreFull"];
            this.terceroDireccion = _data["terceroDireccion"];
            this.terceroTelefono = _data["terceroTelefono"];
        }
    }

    static fromJS(data: any): StartDocumentTerceroDto {
        data = typeof data === 'object' ? data : {};
        let result = new StartDocumentTerceroDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["terceroId"] = this.terceroId;
        data["nit"] = this.nit;
        data["razonSocial"] = this.razonSocial;
        data["nombreFull"] = this.nombreFull;
        data["terceroDireccion"] = this.terceroDireccion;
        data["terceroTelefono"] = this.terceroTelefono;
        return data;
    }
}

export interface IStartDocumentTerceroDto {
    terceroId?: number;
    nit?: string;
    razonSocial?: string;
    nombreFull?: string;
    terceroDireccion?: string;
    terceroTelefono?: string | undefined;
}

export class StartDocumentRequest implements IStartDocumentRequest {
    documentoId?: number | undefined;
    permisos?: string[] | undefined;
    activaciones?: string[] | undefined;

    constructor(data?: IStartDocumentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentoId = _data["documentoId"];
            if (Array.isArray(_data["permisos"])) {
                this.permisos = [] as any;
                for (let item of _data["permisos"])
                    this.permisos!.push(item);
            }
            if (Array.isArray(_data["activaciones"])) {
                this.activaciones = [] as any;
                for (let item of _data["activaciones"])
                    this.activaciones!.push(item);
            }
        }
    }

    static fromJS(data: any): StartDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StartDocumentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoId"] = this.documentoId;
        if (Array.isArray(this.permisos)) {
            data["permisos"] = [];
            for (let item of this.permisos)
                data["permisos"].push(item);
        }
        if (Array.isArray(this.activaciones)) {
            data["activaciones"] = [];
            for (let item of this.activaciones)
                data["activaciones"].push(item);
        }
        return data;
    }
}

export interface IStartDocumentRequest {
    documentoId?: number | undefined;
    permisos?: string[] | undefined;
    activaciones?: string[] | undefined;
}

export class PagingOfCompra implements IPagingOfCompra {
    count?: number;
    data?: Compra[];

    constructor(data?: IPagingOfCompra) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Compra.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfCompra {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfCompra();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfCompra {
    count?: number;
    data?: Compra[];
}

export class Compra implements ICompra {
    compraId?: number;
    compraFecha?: Date;
    compraPlazo?: number;
    compraFechaPago?: Date;
    compraPRetICA?: number;
    compraPRetIVA?: number;
    compraPRetRenta?: number;
    compraItems?: number;
    compraNumeroFactura?: string;
    compraTotalFlete?: number;
    compraTotal?: number | undefined;
    compraCuentas?: string;
    proveedorId?: number;
    compraId2?: string;
    compraVrBase?: number;
    retencionRentaId?: number | undefined;
    compraVrReteRenta?: number;
    compraVrReteIVA?: number;
    compraReteIVAASumido?: number;
    compraVrReteICA?: number;
    regConId?: number | undefined;
    compraAPagar?: number;
    documentoId?: number | undefined;
    compraSobrecostoItems?: number;
    compraEstado?: string;
    kardexId?: number | undefined;
    compraPDctoFinanciero?: number;
    compraPDctoComercial?: number;
    compraVrPagado?: number;
    compraVrSaldo?: number;
    compraDctoFinanciero?: number;
    compraPrefijo?: string;
    compraNumero?: number;
    compraVrIVA?: number;
    compraSucursalId?: number | undefined;
    compraVrNotaDebito?: number;
    compraInsHr?: Date | undefined;
    compraUser?: string | undefined;
    compraVrImpoconsumo?: number;
    compraVrReteCree?: number | undefined;
    compraVrReteFNG?: number | undefined;
    compraVrAnticipo?: number | undefined;
    compraNoCheque?: string | undefined;
    compraDE?: string | undefined;
    compraCxPPucId?: string | undefined;
    compraOD?: number | undefined;
    compraOrigen?: number;
    compraNotas?: string | undefined;
    compraOrdenNo?: string;
    compraResFactId?: number | undefined;
    compraProperties?: string | undefined;
    compraVrOtrasRete?: number | undefined;
    compraTipoPago?: string | undefined;
    compraPlazoFinanciero?: number | undefined;

    constructor(data?: ICompra) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.compraId = _data["compraId"];
            this.compraFecha = _data["compraFecha"] ? new Date(_data["compraFecha"].toString()) : undefined as any;
            this.compraPlazo = _data["compraPlazo"];
            this.compraFechaPago = _data["compraFechaPago"] ? new Date(_data["compraFechaPago"].toString()) : undefined as any;
            this.compraPRetICA = _data["compraPRetICA"];
            this.compraPRetIVA = _data["compraPRetIVA"];
            this.compraPRetRenta = _data["compraPRetRenta"];
            this.compraItems = _data["compraItems"];
            this.compraNumeroFactura = _data["compraNumeroFactura"];
            this.compraTotalFlete = _data["compraTotalFlete"];
            this.compraTotal = _data["compraTotal"];
            this.compraCuentas = _data["compraCuentas"];
            this.proveedorId = _data["proveedorId"];
            this.compraId2 = _data["compraId2"];
            this.compraVrBase = _data["compraVrBase"];
            this.retencionRentaId = _data["retencionRentaId"];
            this.compraVrReteRenta = _data["compraVrReteRenta"];
            this.compraVrReteIVA = _data["compraVrReteIVA"];
            this.compraReteIVAASumido = _data["compraReteIVAASumido"];
            this.compraVrReteICA = _data["compraVrReteICA"];
            this.regConId = _data["regConId"];
            this.compraAPagar = _data["compraAPagar"];
            this.documentoId = _data["documentoId"];
            this.compraSobrecostoItems = _data["compraSobrecostoItems"];
            this.compraEstado = _data["compraEstado"];
            this.kardexId = _data["kardexId"];
            this.compraPDctoFinanciero = _data["compraPDctoFinanciero"];
            this.compraPDctoComercial = _data["compraPDctoComercial"];
            this.compraVrPagado = _data["compraVrPagado"];
            this.compraVrSaldo = _data["compraVrSaldo"];
            this.compraDctoFinanciero = _data["compraDctoFinanciero"];
            this.compraPrefijo = _data["compraPrefijo"];
            this.compraNumero = _data["compraNumero"];
            this.compraVrIVA = _data["compraVrIVA"];
            this.compraSucursalId = _data["compraSucursalId"];
            this.compraVrNotaDebito = _data["compraVrNotaDebito"];
            this.compraInsHr = _data["compraInsHr"] ? new Date(_data["compraInsHr"].toString()) : undefined as any;
            this.compraUser = _data["compraUser"];
            this.compraVrImpoconsumo = _data["compraVrImpoconsumo"];
            this.compraVrReteCree = _data["compraVrReteCree"];
            this.compraVrReteFNG = _data["compraVrReteFNG"];
            this.compraVrAnticipo = _data["compraVrAnticipo"];
            this.compraNoCheque = _data["compraNoCheque"];
            this.compraDE = _data["compraDE"];
            this.compraCxPPucId = _data["compraCxPPucId"];
            this.compraOD = _data["compraOD"];
            this.compraOrigen = _data["compraOrigen"];
            this.compraNotas = _data["compraNotas"];
            this.compraOrdenNo = _data["compraOrdenNo"];
            this.compraResFactId = _data["compraResFactId"];
            this.compraProperties = _data["compraProperties"];
            this.compraVrOtrasRete = _data["compraVrOtrasRete"];
            this.compraTipoPago = _data["compraTipoPago"];
            this.compraPlazoFinanciero = _data["compraPlazoFinanciero"];
        }
    }

    static fromJS(data: any): Compra {
        data = typeof data === 'object' ? data : {};
        let result = new Compra();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compraId"] = this.compraId;
        data["compraFecha"] = this.compraFecha ? this.compraFecha.toISOString() : undefined as any;
        data["compraPlazo"] = this.compraPlazo;
        data["compraFechaPago"] = this.compraFechaPago ? this.compraFechaPago.toISOString() : undefined as any;
        data["compraPRetICA"] = this.compraPRetICA;
        data["compraPRetIVA"] = this.compraPRetIVA;
        data["compraPRetRenta"] = this.compraPRetRenta;
        data["compraItems"] = this.compraItems;
        data["compraNumeroFactura"] = this.compraNumeroFactura;
        data["compraTotalFlete"] = this.compraTotalFlete;
        data["compraTotal"] = this.compraTotal;
        data["compraCuentas"] = this.compraCuentas;
        data["proveedorId"] = this.proveedorId;
        data["compraId2"] = this.compraId2;
        data["compraVrBase"] = this.compraVrBase;
        data["retencionRentaId"] = this.retencionRentaId;
        data["compraVrReteRenta"] = this.compraVrReteRenta;
        data["compraVrReteIVA"] = this.compraVrReteIVA;
        data["compraReteIVAASumido"] = this.compraReteIVAASumido;
        data["compraVrReteICA"] = this.compraVrReteICA;
        data["regConId"] = this.regConId;
        data["compraAPagar"] = this.compraAPagar;
        data["documentoId"] = this.documentoId;
        data["compraSobrecostoItems"] = this.compraSobrecostoItems;
        data["compraEstado"] = this.compraEstado;
        data["kardexId"] = this.kardexId;
        data["compraPDctoFinanciero"] = this.compraPDctoFinanciero;
        data["compraPDctoComercial"] = this.compraPDctoComercial;
        data["compraVrPagado"] = this.compraVrPagado;
        data["compraVrSaldo"] = this.compraVrSaldo;
        data["compraDctoFinanciero"] = this.compraDctoFinanciero;
        data["compraPrefijo"] = this.compraPrefijo;
        data["compraNumero"] = this.compraNumero;
        data["compraVrIVA"] = this.compraVrIVA;
        data["compraSucursalId"] = this.compraSucursalId;
        data["compraVrNotaDebito"] = this.compraVrNotaDebito;
        data["compraInsHr"] = this.compraInsHr ? this.compraInsHr.toISOString() : undefined as any;
        data["compraUser"] = this.compraUser;
        data["compraVrImpoconsumo"] = this.compraVrImpoconsumo;
        data["compraVrReteCree"] = this.compraVrReteCree;
        data["compraVrReteFNG"] = this.compraVrReteFNG;
        data["compraVrAnticipo"] = this.compraVrAnticipo;
        data["compraNoCheque"] = this.compraNoCheque;
        data["compraDE"] = this.compraDE;
        data["compraCxPPucId"] = this.compraCxPPucId;
        data["compraOD"] = this.compraOD;
        data["compraOrigen"] = this.compraOrigen;
        data["compraNotas"] = this.compraNotas;
        data["compraOrdenNo"] = this.compraOrdenNo;
        data["compraResFactId"] = this.compraResFactId;
        data["compraProperties"] = this.compraProperties;
        data["compraVrOtrasRete"] = this.compraVrOtrasRete;
        data["compraTipoPago"] = this.compraTipoPago;
        data["compraPlazoFinanciero"] = this.compraPlazoFinanciero;
        return data;
    }
}

export interface ICompra {
    compraId?: number;
    compraFecha?: Date;
    compraPlazo?: number;
    compraFechaPago?: Date;
    compraPRetICA?: number;
    compraPRetIVA?: number;
    compraPRetRenta?: number;
    compraItems?: number;
    compraNumeroFactura?: string;
    compraTotalFlete?: number;
    compraTotal?: number | undefined;
    compraCuentas?: string;
    proveedorId?: number;
    compraId2?: string;
    compraVrBase?: number;
    retencionRentaId?: number | undefined;
    compraVrReteRenta?: number;
    compraVrReteIVA?: number;
    compraReteIVAASumido?: number;
    compraVrReteICA?: number;
    regConId?: number | undefined;
    compraAPagar?: number;
    documentoId?: number | undefined;
    compraSobrecostoItems?: number;
    compraEstado?: string;
    kardexId?: number | undefined;
    compraPDctoFinanciero?: number;
    compraPDctoComercial?: number;
    compraVrPagado?: number;
    compraVrSaldo?: number;
    compraDctoFinanciero?: number;
    compraPrefijo?: string;
    compraNumero?: number;
    compraVrIVA?: number;
    compraSucursalId?: number | undefined;
    compraVrNotaDebito?: number;
    compraInsHr?: Date | undefined;
    compraUser?: string | undefined;
    compraVrImpoconsumo?: number;
    compraVrReteCree?: number | undefined;
    compraVrReteFNG?: number | undefined;
    compraVrAnticipo?: number | undefined;
    compraNoCheque?: string | undefined;
    compraDE?: string | undefined;
    compraCxPPucId?: string | undefined;
    compraOD?: number | undefined;
    compraOrigen?: number;
    compraNotas?: string | undefined;
    compraOrdenNo?: string;
    compraResFactId?: number | undefined;
    compraProperties?: string | undefined;
    compraVrOtrasRete?: number | undefined;
    compraTipoPago?: string | undefined;
    compraPlazoFinanciero?: number | undefined;
}

export class SendEmailRequest implements ISendEmailRequest {
    to?: string | undefined;
    subject?: string | undefined;
    logEmailTipo?: string | undefined;
    logEmailCodigo?: string | undefined;

    constructor(data?: ISendEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.to = _data["to"];
            this.subject = _data["subject"];
            this.logEmailTipo = _data["logEmailTipo"];
            this.logEmailCodigo = _data["logEmailCodigo"];
        }
    }

    static fromJS(data: any): SendEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["to"] = this.to;
        data["subject"] = this.subject;
        data["logEmailTipo"] = this.logEmailTipo;
        data["logEmailCodigo"] = this.logEmailCodigo;
        return data;
    }
}

export interface ISendEmailRequest {
    to?: string | undefined;
    subject?: string | undefined;
    logEmailTipo?: string | undefined;
    logEmailCodigo?: string | undefined;
}

export class PagingOfConductor implements IPagingOfConductor {
    count?: number;
    data?: Conductor[];

    constructor(data?: IPagingOfConductor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Conductor.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfConductor {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfConductor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfConductor {
    count?: number;
    data?: Conductor[];
}

export class Conductor implements IConductor {
    conductorId?: number;
    conductorNombre?: string;
    alRutaId?: string;
    conductorClave?: number;
    conductorPlacas?: string;
    conductorIdExterno?: string | undefined;

    constructor(data?: IConductor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conductorId = _data["conductorId"];
            this.conductorNombre = _data["conductorNombre"];
            this.alRutaId = _data["alRutaId"];
            this.conductorClave = _data["conductorClave"];
            this.conductorPlacas = _data["conductorPlacas"];
            this.conductorIdExterno = _data["conductorIdExterno"];
        }
    }

    static fromJS(data: any): Conductor {
        data = typeof data === 'object' ? data : {};
        let result = new Conductor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conductorId"] = this.conductorId;
        data["conductorNombre"] = this.conductorNombre;
        data["alRutaId"] = this.alRutaId;
        data["conductorClave"] = this.conductorClave;
        data["conductorPlacas"] = this.conductorPlacas;
        data["conductorIdExterno"] = this.conductorIdExterno;
        return data;
    }
}

export interface IConductor {
    conductorId?: number;
    conductorNombre?: string;
    alRutaId?: string;
    conductorClave?: number;
    conductorPlacas?: string;
    conductorIdExterno?: string | undefined;
}

export class PagingOfCotizacion implements IPagingOfCotizacion {
    count?: number;
    data?: Cotizacion[];

    constructor(data?: IPagingOfCotizacion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Cotizacion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfCotizacion {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfCotizacion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfCotizacion {
    count?: number;
    data?: Cotizacion[];
}

export class Cotizacion implements ICotizacion {
    cotizacionId?: number;
    cotizacionId2?: string;
    cotizacionFecha?: Date;
    cotizacionFechaDespacho?: Date;
    cotizacionTipoPago?: string;
    cotizacionTipo?: string;
    cotizacionEstado?: string;
    cotizacionDescuento?: number;
    cotizacionClienteId?: number;
    cotizacionVendedorId?: number | undefined;
    cotizacionItems?: number;
    cotizacionPrefijo?: string;
    cotizacionNumero?: number;
    cotizacionBodegaId?: string | undefined;
    cotizacionDocumentoId?: number | undefined;
    cotizacionVehiculoId?: number | undefined;
    cotizacionNotas?: string;
    cotizacionUser?: string;
    cotizacionInsHr?: Date;
    cotizacionVrSuma?: number;
    cotizacionVrSubtotal?: number;
    cotizacionVrBase?: number;
    cotizacionVrDcto?: number;
    cotizacionVrIVA?: number;
    cotizacionVrAPagar?: number;
    cotizacionVrSaldo?: number;
    cotizacionVrImpoconsumo?: number | undefined;
    cotizacionVrReteIVA?: number | undefined;
    cotizacionVrReteICA?: number | undefined;
    cotizacionVrReteRenta?: number | undefined;
    cotizacionOrdenCliente?: string | undefined;
    cotizacionPReteIVA?: number | undefined;
    cotizacionPReteICA?: number | undefined;
    cotizacionPReteRenta?: number | undefined;
    cotizacionReteICAId?: number | undefined;
    cotizacionReteRentaId?: number | undefined;
    cotizacionPedidoId?: number | undefined;
    cotizacionFacturaId?: number | undefined;
    cotizacionTimeStamp?: string | undefined;
    cotizacionMonedaId?: string | undefined;
    cotizacionTipoOperacion?: string | undefined;
    cotizacionBultos?: number | undefined;
    cotizacionVrBulto?: number | undefined;
    cotizacionVrFlete?: number | undefined;
    detalle?: CotizacionDetalle[];

    constructor(data?: ICotizacion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cotizacionId = _data["cotizacionId"];
            this.cotizacionId2 = _data["cotizacionId2"];
            this.cotizacionFecha = _data["cotizacionFecha"] ? new Date(_data["cotizacionFecha"].toString()) : undefined as any;
            this.cotizacionFechaDespacho = _data["cotizacionFechaDespacho"] ? new Date(_data["cotizacionFechaDespacho"].toString()) : undefined as any;
            this.cotizacionTipoPago = _data["cotizacionTipoPago"];
            this.cotizacionTipo = _data["cotizacionTipo"];
            this.cotizacionEstado = _data["cotizacionEstado"];
            this.cotizacionDescuento = _data["cotizacionDescuento"];
            this.cotizacionClienteId = _data["cotizacionClienteId"];
            this.cotizacionVendedorId = _data["cotizacionVendedorId"];
            this.cotizacionItems = _data["cotizacionItems"];
            this.cotizacionPrefijo = _data["cotizacionPrefijo"];
            this.cotizacionNumero = _data["cotizacionNumero"];
            this.cotizacionBodegaId = _data["cotizacionBodegaId"];
            this.cotizacionDocumentoId = _data["cotizacionDocumentoId"];
            this.cotizacionVehiculoId = _data["cotizacionVehiculoId"];
            this.cotizacionNotas = _data["cotizacionNotas"];
            this.cotizacionUser = _data["cotizacionUser"];
            this.cotizacionInsHr = _data["cotizacionInsHr"] ? new Date(_data["cotizacionInsHr"].toString()) : undefined as any;
            this.cotizacionVrSuma = _data["cotizacionVrSuma"];
            this.cotizacionVrSubtotal = _data["cotizacionVrSubtotal"];
            this.cotizacionVrBase = _data["cotizacionVrBase"];
            this.cotizacionVrDcto = _data["cotizacionVrDcto"];
            this.cotizacionVrIVA = _data["cotizacionVrIVA"];
            this.cotizacionVrAPagar = _data["cotizacionVrAPagar"];
            this.cotizacionVrSaldo = _data["cotizacionVrSaldo"];
            this.cotizacionVrImpoconsumo = _data["cotizacionVrImpoconsumo"];
            this.cotizacionVrReteIVA = _data["cotizacionVrReteIVA"];
            this.cotizacionVrReteICA = _data["cotizacionVrReteICA"];
            this.cotizacionVrReteRenta = _data["cotizacionVrReteRenta"];
            this.cotizacionOrdenCliente = _data["cotizacionOrdenCliente"];
            this.cotizacionPReteIVA = _data["cotizacionPReteIVA"];
            this.cotizacionPReteICA = _data["cotizacionPReteICA"];
            this.cotizacionPReteRenta = _data["cotizacionPReteRenta"];
            this.cotizacionReteICAId = _data["cotizacionReteICAId"];
            this.cotizacionReteRentaId = _data["cotizacionReteRentaId"];
            this.cotizacionPedidoId = _data["cotizacionPedidoId"];
            this.cotizacionFacturaId = _data["cotizacionFacturaId"];
            this.cotizacionTimeStamp = _data["cotizacionTimeStamp"];
            this.cotizacionMonedaId = _data["cotizacionMonedaId"];
            this.cotizacionTipoOperacion = _data["cotizacionTipoOperacion"];
            this.cotizacionBultos = _data["cotizacionBultos"];
            this.cotizacionVrBulto = _data["cotizacionVrBulto"];
            this.cotizacionVrFlete = _data["cotizacionVrFlete"];
            if (Array.isArray(_data["detalle"])) {
                this.detalle = [] as any;
                for (let item of _data["detalle"])
                    this.detalle!.push(CotizacionDetalle.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Cotizacion {
        data = typeof data === 'object' ? data : {};
        let result = new Cotizacion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cotizacionId"] = this.cotizacionId;
        data["cotizacionId2"] = this.cotizacionId2;
        data["cotizacionFecha"] = this.cotizacionFecha ? this.cotizacionFecha.toISOString() : undefined as any;
        data["cotizacionFechaDespacho"] = this.cotizacionFechaDespacho ? this.cotizacionFechaDespacho.toISOString() : undefined as any;
        data["cotizacionTipoPago"] = this.cotizacionTipoPago;
        data["cotizacionTipo"] = this.cotizacionTipo;
        data["cotizacionEstado"] = this.cotizacionEstado;
        data["cotizacionDescuento"] = this.cotizacionDescuento;
        data["cotizacionClienteId"] = this.cotizacionClienteId;
        data["cotizacionVendedorId"] = this.cotizacionVendedorId;
        data["cotizacionItems"] = this.cotizacionItems;
        data["cotizacionPrefijo"] = this.cotizacionPrefijo;
        data["cotizacionNumero"] = this.cotizacionNumero;
        data["cotizacionBodegaId"] = this.cotizacionBodegaId;
        data["cotizacionDocumentoId"] = this.cotizacionDocumentoId;
        data["cotizacionVehiculoId"] = this.cotizacionVehiculoId;
        data["cotizacionNotas"] = this.cotizacionNotas;
        data["cotizacionUser"] = this.cotizacionUser;
        data["cotizacionInsHr"] = this.cotizacionInsHr ? this.cotizacionInsHr.toISOString() : undefined as any;
        data["cotizacionVrSuma"] = this.cotizacionVrSuma;
        data["cotizacionVrSubtotal"] = this.cotizacionVrSubtotal;
        data["cotizacionVrBase"] = this.cotizacionVrBase;
        data["cotizacionVrDcto"] = this.cotizacionVrDcto;
        data["cotizacionVrIVA"] = this.cotizacionVrIVA;
        data["cotizacionVrAPagar"] = this.cotizacionVrAPagar;
        data["cotizacionVrSaldo"] = this.cotizacionVrSaldo;
        data["cotizacionVrImpoconsumo"] = this.cotizacionVrImpoconsumo;
        data["cotizacionVrReteIVA"] = this.cotizacionVrReteIVA;
        data["cotizacionVrReteICA"] = this.cotizacionVrReteICA;
        data["cotizacionVrReteRenta"] = this.cotizacionVrReteRenta;
        data["cotizacionOrdenCliente"] = this.cotizacionOrdenCliente;
        data["cotizacionPReteIVA"] = this.cotizacionPReteIVA;
        data["cotizacionPReteICA"] = this.cotizacionPReteICA;
        data["cotizacionPReteRenta"] = this.cotizacionPReteRenta;
        data["cotizacionReteICAId"] = this.cotizacionReteICAId;
        data["cotizacionReteRentaId"] = this.cotizacionReteRentaId;
        data["cotizacionPedidoId"] = this.cotizacionPedidoId;
        data["cotizacionFacturaId"] = this.cotizacionFacturaId;
        data["cotizacionTimeStamp"] = this.cotizacionTimeStamp;
        data["cotizacionMonedaId"] = this.cotizacionMonedaId;
        data["cotizacionTipoOperacion"] = this.cotizacionTipoOperacion;
        data["cotizacionBultos"] = this.cotizacionBultos;
        data["cotizacionVrBulto"] = this.cotizacionVrBulto;
        data["cotizacionVrFlete"] = this.cotizacionVrFlete;
        if (Array.isArray(this.detalle)) {
            data["detalle"] = [];
            for (let item of this.detalle)
                data["detalle"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICotizacion {
    cotizacionId?: number;
    cotizacionId2?: string;
    cotizacionFecha?: Date;
    cotizacionFechaDespacho?: Date;
    cotizacionTipoPago?: string;
    cotizacionTipo?: string;
    cotizacionEstado?: string;
    cotizacionDescuento?: number;
    cotizacionClienteId?: number;
    cotizacionVendedorId?: number | undefined;
    cotizacionItems?: number;
    cotizacionPrefijo?: string;
    cotizacionNumero?: number;
    cotizacionBodegaId?: string | undefined;
    cotizacionDocumentoId?: number | undefined;
    cotizacionVehiculoId?: number | undefined;
    cotizacionNotas?: string;
    cotizacionUser?: string;
    cotizacionInsHr?: Date;
    cotizacionVrSuma?: number;
    cotizacionVrSubtotal?: number;
    cotizacionVrBase?: number;
    cotizacionVrDcto?: number;
    cotizacionVrIVA?: number;
    cotizacionVrAPagar?: number;
    cotizacionVrSaldo?: number;
    cotizacionVrImpoconsumo?: number | undefined;
    cotizacionVrReteIVA?: number | undefined;
    cotizacionVrReteICA?: number | undefined;
    cotizacionVrReteRenta?: number | undefined;
    cotizacionOrdenCliente?: string | undefined;
    cotizacionPReteIVA?: number | undefined;
    cotizacionPReteICA?: number | undefined;
    cotizacionPReteRenta?: number | undefined;
    cotizacionReteICAId?: number | undefined;
    cotizacionReteRentaId?: number | undefined;
    cotizacionPedidoId?: number | undefined;
    cotizacionFacturaId?: number | undefined;
    cotizacionTimeStamp?: string | undefined;
    cotizacionMonedaId?: string | undefined;
    cotizacionTipoOperacion?: string | undefined;
    cotizacionBultos?: number | undefined;
    cotizacionVrBulto?: number | undefined;
    cotizacionVrFlete?: number | undefined;
    detalle?: CotizacionDetalle[];
}

export class CotizacionDetalle implements ICotizacionDetalle {
    cotizacionId?: number;
    cotizacionDetalleId?: number;
    productoId?: string;
    cotizacionCantidad?: number;
    cotizacionVrUnitario?: number;
    cotizacionTasaIVA?: number;
    cotizacionDetalleDcto?: number;
    cotizacionDetalleNotaLong?: string | undefined;
    cotizacionDetalleTotalPC?: number | undefined;
    cotizacionDetalleBodegaId?: string | undefined;

    constructor(data?: ICotizacionDetalle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cotizacionId = _data["cotizacionId"];
            this.cotizacionDetalleId = _data["cotizacionDetalleId"];
            this.productoId = _data["productoId"];
            this.cotizacionCantidad = _data["cotizacionCantidad"];
            this.cotizacionVrUnitario = _data["cotizacionVrUnitario"];
            this.cotizacionTasaIVA = _data["cotizacionTasaIVA"];
            this.cotizacionDetalleDcto = _data["cotizacionDetalleDcto"];
            this.cotizacionDetalleNotaLong = _data["cotizacionDetalleNotaLong"];
            this.cotizacionDetalleTotalPC = _data["cotizacionDetalleTotalPC"];
            this.cotizacionDetalleBodegaId = _data["cotizacionDetalleBodegaId"];
        }
    }

    static fromJS(data: any): CotizacionDetalle {
        data = typeof data === 'object' ? data : {};
        let result = new CotizacionDetalle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cotizacionId"] = this.cotizacionId;
        data["cotizacionDetalleId"] = this.cotizacionDetalleId;
        data["productoId"] = this.productoId;
        data["cotizacionCantidad"] = this.cotizacionCantidad;
        data["cotizacionVrUnitario"] = this.cotizacionVrUnitario;
        data["cotizacionTasaIVA"] = this.cotizacionTasaIVA;
        data["cotizacionDetalleDcto"] = this.cotizacionDetalleDcto;
        data["cotizacionDetalleNotaLong"] = this.cotizacionDetalleNotaLong;
        data["cotizacionDetalleTotalPC"] = this.cotizacionDetalleTotalPC;
        data["cotizacionDetalleBodegaId"] = this.cotizacionDetalleBodegaId;
        return data;
    }
}

export interface ICotizacionDetalle {
    cotizacionId?: number;
    cotizacionDetalleId?: number;
    productoId?: string;
    cotizacionCantidad?: number;
    cotizacionVrUnitario?: number;
    cotizacionTasaIVA?: number;
    cotizacionDetalleDcto?: number;
    cotizacionDetalleNotaLong?: string | undefined;
    cotizacionDetalleTotalPC?: number | undefined;
    cotizacionDetalleBodegaId?: string | undefined;
}

export class PagingOfDespacho implements IPagingOfDespacho {
    count?: number;
    data?: Despacho[];

    constructor(data?: IPagingOfDespacho) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Despacho.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfDespacho {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfDespacho();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfDespacho {
    count?: number;
    data?: Despacho[];
}

export class Despacho implements IDespacho {
    despachoId?: number;
    despachoFecha?: Date;
    despachoEstado?: string;
    despachoVehiculoId?: number;
    despachoVehiculoN?: string;
    despachoReciboCaja?: string | undefined;
    despachoConductorId?: number | undefined;
    despachoConductorNit?: string;
    despachoConductorNombre?: string;
    despachoAuxiliarId?: number | undefined;
    despachoAuxiliarNit?: string;
    despachoAuxiliarNombre?: string;
    despachoSucursalId?: number | undefined;
    despachoSucursalNombre?: string;
    despachoHoraCargue?: Date | undefined;
    despachoHoraDescargue?: Date | undefined;
    despachoUser?: string | undefined;
    facturas?: Factura[];

    constructor(data?: IDespacho) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.despachoId = _data["despachoId"];
            this.despachoFecha = _data["despachoFecha"] ? new Date(_data["despachoFecha"].toString()) : undefined as any;
            this.despachoEstado = _data["despachoEstado"];
            this.despachoVehiculoId = _data["despachoVehiculoId"];
            this.despachoVehiculoN = _data["despachoVehiculoN"];
            this.despachoReciboCaja = _data["despachoReciboCaja"];
            this.despachoConductorId = _data["despachoConductorId"];
            this.despachoConductorNit = _data["despachoConductorNit"];
            this.despachoConductorNombre = _data["despachoConductorNombre"];
            this.despachoAuxiliarId = _data["despachoAuxiliarId"];
            this.despachoAuxiliarNit = _data["despachoAuxiliarNit"];
            this.despachoAuxiliarNombre = _data["despachoAuxiliarNombre"];
            this.despachoSucursalId = _data["despachoSucursalId"];
            this.despachoSucursalNombre = _data["despachoSucursalNombre"];
            this.despachoHoraCargue = _data["despachoHoraCargue"] ? new Date(_data["despachoHoraCargue"].toString()) : undefined as any;
            this.despachoHoraDescargue = _data["despachoHoraDescargue"] ? new Date(_data["despachoHoraDescargue"].toString()) : undefined as any;
            this.despachoUser = _data["despachoUser"];
            if (Array.isArray(_data["facturas"])) {
                this.facturas = [] as any;
                for (let item of _data["facturas"])
                    this.facturas!.push(Factura.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Despacho {
        data = typeof data === 'object' ? data : {};
        let result = new Despacho();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["despachoId"] = this.despachoId;
        data["despachoFecha"] = this.despachoFecha ? this.despachoFecha.toISOString() : undefined as any;
        data["despachoEstado"] = this.despachoEstado;
        data["despachoVehiculoId"] = this.despachoVehiculoId;
        data["despachoVehiculoN"] = this.despachoVehiculoN;
        data["despachoReciboCaja"] = this.despachoReciboCaja;
        data["despachoConductorId"] = this.despachoConductorId;
        data["despachoConductorNit"] = this.despachoConductorNit;
        data["despachoConductorNombre"] = this.despachoConductorNombre;
        data["despachoAuxiliarId"] = this.despachoAuxiliarId;
        data["despachoAuxiliarNit"] = this.despachoAuxiliarNit;
        data["despachoAuxiliarNombre"] = this.despachoAuxiliarNombre;
        data["despachoSucursalId"] = this.despachoSucursalId;
        data["despachoSucursalNombre"] = this.despachoSucursalNombre;
        data["despachoHoraCargue"] = this.despachoHoraCargue ? this.despachoHoraCargue.toISOString() : undefined as any;
        data["despachoHoraDescargue"] = this.despachoHoraDescargue ? this.despachoHoraDescargue.toISOString() : undefined as any;
        data["despachoUser"] = this.despachoUser;
        if (Array.isArray(this.facturas)) {
            data["facturas"] = [];
            for (let item of this.facturas)
                data["facturas"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDespacho {
    despachoId?: number;
    despachoFecha?: Date;
    despachoEstado?: string;
    despachoVehiculoId?: number;
    despachoVehiculoN?: string;
    despachoReciboCaja?: string | undefined;
    despachoConductorId?: number | undefined;
    despachoConductorNit?: string;
    despachoConductorNombre?: string;
    despachoAuxiliarId?: number | undefined;
    despachoAuxiliarNit?: string;
    despachoAuxiliarNombre?: string;
    despachoSucursalId?: number | undefined;
    despachoSucursalNombre?: string;
    despachoHoraCargue?: Date | undefined;
    despachoHoraDescargue?: Date | undefined;
    despachoUser?: string | undefined;
    facturas?: Factura[];
}

export class Factura implements IFactura {
    facturaId?: number;
    facturaId2?: string;
    documentoId?: number | undefined;
    clienteId?: number;
    clienteTerceroNombre?: string;
    clienteAlmacenNombre?: string;
    facturaItems?: number;
    facturaOrdenCliente?: string;
    facturaOrdenInterna?: string;
    facturaDctoComercial?: number;
    facturaPlazoComercial?: number;
    facturaDctoFinanciero?: number;
    facturaPlazoFinanciero?: number;
    facturaTipoOperacion?: string;
    facturaFecha?: Date;
    facturaNotas?: string;
    facturaVrSuma?: number;
    facturaVrDcto?: number;
    facturaVrSubtotal?: number;
    facturaVrIVA?: number;
    facturaVrReteIVA?: number;
    facturaVrReteICA?: number;
    facturaVrReteRenta?: number;
    facturaVrAPagar?: number;
    regConId?: number | undefined;
    facturaPReteICA?: number;
    facturaPReteRenta?: number;
    facturaPReteIVA?: number;
    facturaBodegaId?: string | undefined;
    facturaVrBase?: number;
    kardexId?: number | undefined;
    facturaEstado?: string;
    facturaVrSaldo?: number;
    facturaVrNotasCredito?: number;
    facturaVrNotasDebito?: number;
    facturaVrAbonado?: number;
    vendedorId?: number | undefined;
    vendedorNombre?: string;
    retencionRentaId?: number | undefined;
    retencionICAId?: number | undefined;
    facturaPrefijo?: string;
    facturaNumero?: number;
    facturaVrFlete?: number;
    vehiculoId?: number | undefined;
    facturaNoBultos?: number;
    facturaResolucionId?: number | undefined;
    facturaTipoPago?: string;
    facturaSucursalId?: number | undefined;
    facturaInsHr?: Date | undefined;
    facturaUser?: string | undefined;
    facturaFechaPago?: Date;
    facturaPedidoId?: number | undefined;
    facturaNoCuotas?: number;
    facturaExtensionPlazo?: number | undefined;
    facturaPOSMP2?: number;
    facturaPOSMP1?: number;
    facturaPOSMPT2?: number | undefined;
    facturaPOSMPT1?: number | undefined;
    facturaPOSCheques?: number;
    facturaPOSEfectivo?: number;
    facturaOrigen?: number;
    facturaCxPPucId?: string | undefined;
    facturaTRM?: number;
    facturaCajaId?: number | undefined;
    facturaVrImpoconsumo?: number | undefined;
    despachoId?: number | undefined;
    facturaMsgFE?: string | undefined;
    facturaEstadoFE?: number | undefined;
    facturaCUFE?: string | undefined;
    facturaTimestamp?: string | undefined;
    facturaCCId?: number | undefined;
    facturaURLFE?: string | undefined;
    facturaGPS?: string | undefined;
    facturaFechaDIAN?: Date | undefined;
    facturaPuntosR?: number | undefined;
    facturaPuntos?: number | undefined;
    facturaVrDctoFinanciero?: number | undefined;
    facturaVrBolsas?: number | undefined;
    facturaVrIVAAsumido?: number | undefined;
    facturaExtComId?: number | undefined;
    facturaProperties?: string | undefined;
    facturaVrOtrasRete?: number | undefined;
    facturaReteItems?: number | undefined;
    facturaNDFacturaId?: number | undefined;
    facturaMonedaId?: string | undefined;
    facturaVrAutoRetencion?: number | undefined;
    facturaMPs?: number | undefined;
    detalle?: FacturaDetalle[];

    constructor(data?: IFactura) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facturaId = _data["facturaId"];
            this.facturaId2 = _data["facturaId2"];
            this.documentoId = _data["documentoId"];
            this.clienteId = _data["clienteId"];
            this.clienteTerceroNombre = _data["clienteTerceroNombre"];
            this.clienteAlmacenNombre = _data["clienteAlmacenNombre"];
            this.facturaItems = _data["facturaItems"];
            this.facturaOrdenCliente = _data["facturaOrdenCliente"];
            this.facturaOrdenInterna = _data["facturaOrdenInterna"];
            this.facturaDctoComercial = _data["facturaDctoComercial"];
            this.facturaPlazoComercial = _data["facturaPlazoComercial"];
            this.facturaDctoFinanciero = _data["facturaDctoFinanciero"];
            this.facturaPlazoFinanciero = _data["facturaPlazoFinanciero"];
            this.facturaTipoOperacion = _data["facturaTipoOperacion"];
            this.facturaFecha = _data["facturaFecha"] ? new Date(_data["facturaFecha"].toString()) : undefined as any;
            this.facturaNotas = _data["facturaNotas"];
            this.facturaVrSuma = _data["facturaVrSuma"];
            this.facturaVrDcto = _data["facturaVrDcto"];
            this.facturaVrSubtotal = _data["facturaVrSubtotal"];
            this.facturaVrIVA = _data["facturaVrIVA"];
            this.facturaVrReteIVA = _data["facturaVrReteIVA"];
            this.facturaVrReteICA = _data["facturaVrReteICA"];
            this.facturaVrReteRenta = _data["facturaVrReteRenta"];
            this.facturaVrAPagar = _data["facturaVrAPagar"];
            this.regConId = _data["regConId"];
            this.facturaPReteICA = _data["facturaPReteICA"];
            this.facturaPReteRenta = _data["facturaPReteRenta"];
            this.facturaPReteIVA = _data["facturaPReteIVA"];
            this.facturaBodegaId = _data["facturaBodegaId"];
            this.facturaVrBase = _data["facturaVrBase"];
            this.kardexId = _data["kardexId"];
            this.facturaEstado = _data["facturaEstado"];
            this.facturaVrSaldo = _data["facturaVrSaldo"];
            this.facturaVrNotasCredito = _data["facturaVrNotasCredito"];
            this.facturaVrNotasDebito = _data["facturaVrNotasDebito"];
            this.facturaVrAbonado = _data["facturaVrAbonado"];
            this.vendedorId = _data["vendedorId"];
            this.vendedorNombre = _data["vendedorNombre"];
            this.retencionRentaId = _data["retencionRentaId"];
            this.retencionICAId = _data["retencionICAId"];
            this.facturaPrefijo = _data["facturaPrefijo"];
            this.facturaNumero = _data["facturaNumero"];
            this.facturaVrFlete = _data["facturaVrFlete"];
            this.vehiculoId = _data["vehiculoId"];
            this.facturaNoBultos = _data["facturaNoBultos"];
            this.facturaResolucionId = _data["facturaResolucionId"];
            this.facturaTipoPago = _data["facturaTipoPago"];
            this.facturaSucursalId = _data["facturaSucursalId"];
            this.facturaInsHr = _data["facturaInsHr"] ? new Date(_data["facturaInsHr"].toString()) : undefined as any;
            this.facturaUser = _data["facturaUser"];
            this.facturaFechaPago = _data["facturaFechaPago"] ? new Date(_data["facturaFechaPago"].toString()) : undefined as any;
            this.facturaPedidoId = _data["facturaPedidoId"];
            this.facturaNoCuotas = _data["facturaNoCuotas"];
            this.facturaExtensionPlazo = _data["facturaExtensionPlazo"];
            this.facturaPOSMP2 = _data["facturaPOSMP2"];
            this.facturaPOSMP1 = _data["facturaPOSMP1"];
            this.facturaPOSMPT2 = _data["facturaPOSMPT2"];
            this.facturaPOSMPT1 = _data["facturaPOSMPT1"];
            this.facturaPOSCheques = _data["facturaPOSCheques"];
            this.facturaPOSEfectivo = _data["facturaPOSEfectivo"];
            this.facturaOrigen = _data["facturaOrigen"];
            this.facturaCxPPucId = _data["facturaCxPPucId"];
            this.facturaTRM = _data["facturaTRM"];
            this.facturaCajaId = _data["facturaCajaId"];
            this.facturaVrImpoconsumo = _data["facturaVrImpoconsumo"];
            this.despachoId = _data["despachoId"];
            this.facturaMsgFE = _data["facturaMsgFE"];
            this.facturaEstadoFE = _data["facturaEstadoFE"];
            this.facturaCUFE = _data["facturaCUFE"];
            this.facturaTimestamp = _data["facturaTimestamp"];
            this.facturaCCId = _data["facturaCCId"];
            this.facturaURLFE = _data["facturaURLFE"];
            this.facturaGPS = _data["facturaGPS"];
            this.facturaFechaDIAN = _data["facturaFechaDIAN"] ? new Date(_data["facturaFechaDIAN"].toString()) : undefined as any;
            this.facturaPuntosR = _data["facturaPuntosR"];
            this.facturaPuntos = _data["facturaPuntos"];
            this.facturaVrDctoFinanciero = _data["facturaVrDctoFinanciero"];
            this.facturaVrBolsas = _data["facturaVrBolsas"];
            this.facturaVrIVAAsumido = _data["facturaVrIVAAsumido"];
            this.facturaExtComId = _data["facturaExtComId"];
            this.facturaProperties = _data["facturaProperties"];
            this.facturaVrOtrasRete = _data["facturaVrOtrasRete"];
            this.facturaReteItems = _data["facturaReteItems"];
            this.facturaNDFacturaId = _data["facturaNDFacturaId"];
            this.facturaMonedaId = _data["facturaMonedaId"];
            this.facturaVrAutoRetencion = _data["facturaVrAutoRetencion"];
            this.facturaMPs = _data["facturaMPs"];
            if (Array.isArray(_data["Detalle"])) {
                this.detalle = [] as any;
                for (let item of _data["Detalle"])
                    this.detalle!.push(FacturaDetalle.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Factura {
        data = typeof data === 'object' ? data : {};
        let result = new Factura();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facturaId"] = this.facturaId;
        data["facturaId2"] = this.facturaId2;
        data["documentoId"] = this.documentoId;
        data["clienteId"] = this.clienteId;
        data["clienteTerceroNombre"] = this.clienteTerceroNombre;
        data["clienteAlmacenNombre"] = this.clienteAlmacenNombre;
        data["facturaItems"] = this.facturaItems;
        data["facturaOrdenCliente"] = this.facturaOrdenCliente;
        data["facturaOrdenInterna"] = this.facturaOrdenInterna;
        data["facturaDctoComercial"] = this.facturaDctoComercial;
        data["facturaPlazoComercial"] = this.facturaPlazoComercial;
        data["facturaDctoFinanciero"] = this.facturaDctoFinanciero;
        data["facturaPlazoFinanciero"] = this.facturaPlazoFinanciero;
        data["facturaTipoOperacion"] = this.facturaTipoOperacion;
        data["facturaFecha"] = this.facturaFecha ? this.facturaFecha.toISOString() : undefined as any;
        data["facturaNotas"] = this.facturaNotas;
        data["facturaVrSuma"] = this.facturaVrSuma;
        data["facturaVrDcto"] = this.facturaVrDcto;
        data["facturaVrSubtotal"] = this.facturaVrSubtotal;
        data["facturaVrIVA"] = this.facturaVrIVA;
        data["facturaVrReteIVA"] = this.facturaVrReteIVA;
        data["facturaVrReteICA"] = this.facturaVrReteICA;
        data["facturaVrReteRenta"] = this.facturaVrReteRenta;
        data["facturaVrAPagar"] = this.facturaVrAPagar;
        data["regConId"] = this.regConId;
        data["facturaPReteICA"] = this.facturaPReteICA;
        data["facturaPReteRenta"] = this.facturaPReteRenta;
        data["facturaPReteIVA"] = this.facturaPReteIVA;
        data["facturaBodegaId"] = this.facturaBodegaId;
        data["facturaVrBase"] = this.facturaVrBase;
        data["kardexId"] = this.kardexId;
        data["facturaEstado"] = this.facturaEstado;
        data["facturaVrSaldo"] = this.facturaVrSaldo;
        data["facturaVrNotasCredito"] = this.facturaVrNotasCredito;
        data["facturaVrNotasDebito"] = this.facturaVrNotasDebito;
        data["facturaVrAbonado"] = this.facturaVrAbonado;
        data["vendedorId"] = this.vendedorId;
        data["vendedorNombre"] = this.vendedorNombre;
        data["retencionRentaId"] = this.retencionRentaId;
        data["retencionICAId"] = this.retencionICAId;
        data["facturaPrefijo"] = this.facturaPrefijo;
        data["facturaNumero"] = this.facturaNumero;
        data["facturaVrFlete"] = this.facturaVrFlete;
        data["vehiculoId"] = this.vehiculoId;
        data["facturaNoBultos"] = this.facturaNoBultos;
        data["facturaResolucionId"] = this.facturaResolucionId;
        data["facturaTipoPago"] = this.facturaTipoPago;
        data["facturaSucursalId"] = this.facturaSucursalId;
        data["facturaInsHr"] = this.facturaInsHr ? this.facturaInsHr.toISOString() : undefined as any;
        data["facturaUser"] = this.facturaUser;
        data["facturaFechaPago"] = this.facturaFechaPago ? this.facturaFechaPago.toISOString() : undefined as any;
        data["facturaPedidoId"] = this.facturaPedidoId;
        data["facturaNoCuotas"] = this.facturaNoCuotas;
        data["facturaExtensionPlazo"] = this.facturaExtensionPlazo;
        data["facturaPOSMP2"] = this.facturaPOSMP2;
        data["facturaPOSMP1"] = this.facturaPOSMP1;
        data["facturaPOSMPT2"] = this.facturaPOSMPT2;
        data["facturaPOSMPT1"] = this.facturaPOSMPT1;
        data["facturaPOSCheques"] = this.facturaPOSCheques;
        data["facturaPOSEfectivo"] = this.facturaPOSEfectivo;
        data["facturaOrigen"] = this.facturaOrigen;
        data["facturaCxPPucId"] = this.facturaCxPPucId;
        data["facturaTRM"] = this.facturaTRM;
        data["facturaCajaId"] = this.facturaCajaId;
        data["facturaVrImpoconsumo"] = this.facturaVrImpoconsumo;
        data["despachoId"] = this.despachoId;
        data["facturaMsgFE"] = this.facturaMsgFE;
        data["facturaEstadoFE"] = this.facturaEstadoFE;
        data["facturaCUFE"] = this.facturaCUFE;
        data["facturaTimestamp"] = this.facturaTimestamp;
        data["facturaCCId"] = this.facturaCCId;
        data["facturaURLFE"] = this.facturaURLFE;
        data["facturaGPS"] = this.facturaGPS;
        data["facturaFechaDIAN"] = this.facturaFechaDIAN ? this.facturaFechaDIAN.toISOString() : undefined as any;
        data["facturaPuntosR"] = this.facturaPuntosR;
        data["facturaPuntos"] = this.facturaPuntos;
        data["facturaVrDctoFinanciero"] = this.facturaVrDctoFinanciero;
        data["facturaVrBolsas"] = this.facturaVrBolsas;
        data["facturaVrIVAAsumido"] = this.facturaVrIVAAsumido;
        data["facturaExtComId"] = this.facturaExtComId;
        data["facturaProperties"] = this.facturaProperties;
        data["facturaVrOtrasRete"] = this.facturaVrOtrasRete;
        data["facturaReteItems"] = this.facturaReteItems;
        data["facturaNDFacturaId"] = this.facturaNDFacturaId;
        data["facturaMonedaId"] = this.facturaMonedaId;
        data["facturaVrAutoRetencion"] = this.facturaVrAutoRetencion;
        data["facturaMPs"] = this.facturaMPs;
        if (Array.isArray(this.detalle)) {
            data["Detalle"] = [];
            for (let item of this.detalle)
                data["Detalle"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFactura {
    facturaId?: number;
    facturaId2?: string;
    documentoId?: number | undefined;
    clienteId?: number;
    clienteTerceroNombre?: string;
    clienteAlmacenNombre?: string;
    facturaItems?: number;
    facturaOrdenCliente?: string;
    facturaOrdenInterna?: string;
    facturaDctoComercial?: number;
    facturaPlazoComercial?: number;
    facturaDctoFinanciero?: number;
    facturaPlazoFinanciero?: number;
    facturaTipoOperacion?: string;
    facturaFecha?: Date;
    facturaNotas?: string;
    facturaVrSuma?: number;
    facturaVrDcto?: number;
    facturaVrSubtotal?: number;
    facturaVrIVA?: number;
    facturaVrReteIVA?: number;
    facturaVrReteICA?: number;
    facturaVrReteRenta?: number;
    facturaVrAPagar?: number;
    regConId?: number | undefined;
    facturaPReteICA?: number;
    facturaPReteRenta?: number;
    facturaPReteIVA?: number;
    facturaBodegaId?: string | undefined;
    facturaVrBase?: number;
    kardexId?: number | undefined;
    facturaEstado?: string;
    facturaVrSaldo?: number;
    facturaVrNotasCredito?: number;
    facturaVrNotasDebito?: number;
    facturaVrAbonado?: number;
    vendedorId?: number | undefined;
    vendedorNombre?: string;
    retencionRentaId?: number | undefined;
    retencionICAId?: number | undefined;
    facturaPrefijo?: string;
    facturaNumero?: number;
    facturaVrFlete?: number;
    vehiculoId?: number | undefined;
    facturaNoBultos?: number;
    facturaResolucionId?: number | undefined;
    facturaTipoPago?: string;
    facturaSucursalId?: number | undefined;
    facturaInsHr?: Date | undefined;
    facturaUser?: string | undefined;
    facturaFechaPago?: Date;
    facturaPedidoId?: number | undefined;
    facturaNoCuotas?: number;
    facturaExtensionPlazo?: number | undefined;
    facturaPOSMP2?: number;
    facturaPOSMP1?: number;
    facturaPOSMPT2?: number | undefined;
    facturaPOSMPT1?: number | undefined;
    facturaPOSCheques?: number;
    facturaPOSEfectivo?: number;
    facturaOrigen?: number;
    facturaCxPPucId?: string | undefined;
    facturaTRM?: number;
    facturaCajaId?: number | undefined;
    facturaVrImpoconsumo?: number | undefined;
    despachoId?: number | undefined;
    facturaMsgFE?: string | undefined;
    facturaEstadoFE?: number | undefined;
    facturaCUFE?: string | undefined;
    facturaTimestamp?: string | undefined;
    facturaCCId?: number | undefined;
    facturaURLFE?: string | undefined;
    facturaGPS?: string | undefined;
    facturaFechaDIAN?: Date | undefined;
    facturaPuntosR?: number | undefined;
    facturaPuntos?: number | undefined;
    facturaVrDctoFinanciero?: number | undefined;
    facturaVrBolsas?: number | undefined;
    facturaVrIVAAsumido?: number | undefined;
    facturaExtComId?: number | undefined;
    facturaProperties?: string | undefined;
    facturaVrOtrasRete?: number | undefined;
    facturaReteItems?: number | undefined;
    facturaNDFacturaId?: number | undefined;
    facturaMonedaId?: string | undefined;
    facturaVrAutoRetencion?: number | undefined;
    facturaMPs?: number | undefined;
    detalle?: FacturaDetalle[];
}

export class FacturaDetalle implements IFacturaDetalle {
    facturaDetalleId?: number;
    productoId?: string;
    productoNombre?: string;
    facturaDetalleCantidad?: number;
    facturaDetalleVrUnitario?: number;
    facturaDetalleTasaIVA?: number;
    facturaDetalleDcto?: number;
    facturaDetalleCostoUnt?: number;
    facturaDetalleTipoFlete?: string | undefined;
    facturaDetalleNotaLong?: string | undefined;
    facturaLoteId?: number | undefined;
    facturaDetalleCantDev?: number | undefined;
    facturaDetalleTotalPC?: number | undefined;
    facturaDetalleCantPE?: number | undefined;
    facturaDetalleRemision?: string | undefined;
    facturaDetalleBodegaId?: string | undefined;
    facturaDetalleCCId?: number | undefined;
    facturaProyectoId?: string | undefined;
    facturaSubCCId?: string | undefined;
    facturaDetalleMotivo?: string | undefined;
    facturaDetalleProperties?: string | undefined;
    facturaPrecioListaId?: string | undefined;

    constructor(data?: IFacturaDetalle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facturaDetalleId = _data["facturaDetalleId"];
            this.productoId = _data["productoId"];
            this.productoNombre = _data["productoNombre"];
            this.facturaDetalleCantidad = _data["facturaDetalleCantidad"];
            this.facturaDetalleVrUnitario = _data["facturaDetalleVrUnitario"];
            this.facturaDetalleTasaIVA = _data["facturaDetalleTasaIVA"];
            this.facturaDetalleDcto = _data["facturaDetalleDcto"];
            this.facturaDetalleCostoUnt = _data["facturaDetalleCostoUnt"];
            this.facturaDetalleTipoFlete = _data["facturaDetalleTipoFlete"];
            this.facturaDetalleNotaLong = _data["facturaDetalleNotaLong"];
            this.facturaLoteId = _data["facturaLoteId"];
            this.facturaDetalleCantDev = _data["facturaDetalleCantDev"];
            this.facturaDetalleTotalPC = _data["facturaDetalleTotalPC"];
            this.facturaDetalleCantPE = _data["facturaDetalleCantPE"];
            this.facturaDetalleRemision = _data["facturaDetalleRemision"];
            this.facturaDetalleBodegaId = _data["facturaDetalleBodegaId"];
            this.facturaDetalleCCId = _data["facturaDetalleCCId"];
            this.facturaProyectoId = _data["facturaProyectoId"];
            this.facturaSubCCId = _data["facturaSubCCId"];
            this.facturaDetalleMotivo = _data["facturaDetalleMotivo"];
            this.facturaDetalleProperties = _data["facturaDetalleProperties"];
            this.facturaPrecioListaId = _data["facturaPrecioListaId"];
        }
    }

    static fromJS(data: any): FacturaDetalle {
        data = typeof data === 'object' ? data : {};
        let result = new FacturaDetalle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facturaDetalleId"] = this.facturaDetalleId;
        data["productoId"] = this.productoId;
        data["productoNombre"] = this.productoNombre;
        data["facturaDetalleCantidad"] = this.facturaDetalleCantidad;
        data["facturaDetalleVrUnitario"] = this.facturaDetalleVrUnitario;
        data["facturaDetalleTasaIVA"] = this.facturaDetalleTasaIVA;
        data["facturaDetalleDcto"] = this.facturaDetalleDcto;
        data["facturaDetalleCostoUnt"] = this.facturaDetalleCostoUnt;
        data["facturaDetalleTipoFlete"] = this.facturaDetalleTipoFlete;
        data["facturaDetalleNotaLong"] = this.facturaDetalleNotaLong;
        data["facturaLoteId"] = this.facturaLoteId;
        data["facturaDetalleCantDev"] = this.facturaDetalleCantDev;
        data["facturaDetalleTotalPC"] = this.facturaDetalleTotalPC;
        data["facturaDetalleCantPE"] = this.facturaDetalleCantPE;
        data["facturaDetalleRemision"] = this.facturaDetalleRemision;
        data["facturaDetalleBodegaId"] = this.facturaDetalleBodegaId;
        data["facturaDetalleCCId"] = this.facturaDetalleCCId;
        data["facturaProyectoId"] = this.facturaProyectoId;
        data["facturaSubCCId"] = this.facturaSubCCId;
        data["facturaDetalleMotivo"] = this.facturaDetalleMotivo;
        data["facturaDetalleProperties"] = this.facturaDetalleProperties;
        data["facturaPrecioListaId"] = this.facturaPrecioListaId;
        return data;
    }
}

export interface IFacturaDetalle {
    facturaDetalleId?: number;
    productoId?: string;
    productoNombre?: string;
    facturaDetalleCantidad?: number;
    facturaDetalleVrUnitario?: number;
    facturaDetalleTasaIVA?: number;
    facturaDetalleDcto?: number;
    facturaDetalleCostoUnt?: number;
    facturaDetalleTipoFlete?: string | undefined;
    facturaDetalleNotaLong?: string | undefined;
    facturaLoteId?: number | undefined;
    facturaDetalleCantDev?: number | undefined;
    facturaDetalleTotalPC?: number | undefined;
    facturaDetalleCantPE?: number | undefined;
    facturaDetalleRemision?: string | undefined;
    facturaDetalleBodegaId?: string | undefined;
    facturaDetalleCCId?: number | undefined;
    facturaProyectoId?: string | undefined;
    facturaSubCCId?: string | undefined;
    facturaDetalleMotivo?: string | undefined;
    facturaDetalleProperties?: string | undefined;
    facturaPrecioListaId?: string | undefined;
}

export class DespachoGetDto implements IDespachoGetDto {
    despachoId?: number;
    despachoFecha?: Date;
    despachoEstado?: string;
    despachoVehiculoId?: number;
    despachoVehiculoN?: string;
    despachoReciboCaja?: string | undefined;
    despachoConductorId?: number | undefined;
    despachoConductorNit?: string;
    despachoConductorNombre?: string;
    despachoAuxiliarId?: number | undefined;
    despachoAuxiliarNit?: string;
    despachoAuxiliarNombre?: string;
    despachoSucursalId?: number | undefined;
    despachoSucursalNombre?: string;
    despachoHoraCargue?: Date | undefined;
    despachoHoraDescargue?: Date | undefined;
    despachoUser?: string | undefined;
    facturas?: DespachoFacturaDto[];

    constructor(data?: IDespachoGetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.despachoId = _data["despachoId"];
            this.despachoFecha = _data["despachoFecha"] ? new Date(_data["despachoFecha"].toString()) : undefined as any;
            this.despachoEstado = _data["despachoEstado"];
            this.despachoVehiculoId = _data["despachoVehiculoId"];
            this.despachoVehiculoN = _data["despachoVehiculoN"];
            this.despachoReciboCaja = _data["despachoReciboCaja"];
            this.despachoConductorId = _data["despachoConductorId"];
            this.despachoConductorNit = _data["despachoConductorNit"];
            this.despachoConductorNombre = _data["despachoConductorNombre"];
            this.despachoAuxiliarId = _data["despachoAuxiliarId"];
            this.despachoAuxiliarNit = _data["despachoAuxiliarNit"];
            this.despachoAuxiliarNombre = _data["despachoAuxiliarNombre"];
            this.despachoSucursalId = _data["despachoSucursalId"];
            this.despachoSucursalNombre = _data["despachoSucursalNombre"];
            this.despachoHoraCargue = _data["despachoHoraCargue"] ? new Date(_data["despachoHoraCargue"].toString()) : undefined as any;
            this.despachoHoraDescargue = _data["despachoHoraDescargue"] ? new Date(_data["despachoHoraDescargue"].toString()) : undefined as any;
            this.despachoUser = _data["despachoUser"];
            if (Array.isArray(_data["facturas"])) {
                this.facturas = [] as any;
                for (let item of _data["facturas"])
                    this.facturas!.push(DespachoFacturaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DespachoGetDto {
        data = typeof data === 'object' ? data : {};
        let result = new DespachoGetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["despachoId"] = this.despachoId;
        data["despachoFecha"] = this.despachoFecha ? this.despachoFecha.toISOString() : undefined as any;
        data["despachoEstado"] = this.despachoEstado;
        data["despachoVehiculoId"] = this.despachoVehiculoId;
        data["despachoVehiculoN"] = this.despachoVehiculoN;
        data["despachoReciboCaja"] = this.despachoReciboCaja;
        data["despachoConductorId"] = this.despachoConductorId;
        data["despachoConductorNit"] = this.despachoConductorNit;
        data["despachoConductorNombre"] = this.despachoConductorNombre;
        data["despachoAuxiliarId"] = this.despachoAuxiliarId;
        data["despachoAuxiliarNit"] = this.despachoAuxiliarNit;
        data["despachoAuxiliarNombre"] = this.despachoAuxiliarNombre;
        data["despachoSucursalId"] = this.despachoSucursalId;
        data["despachoSucursalNombre"] = this.despachoSucursalNombre;
        data["despachoHoraCargue"] = this.despachoHoraCargue ? this.despachoHoraCargue.toISOString() : undefined as any;
        data["despachoHoraDescargue"] = this.despachoHoraDescargue ? this.despachoHoraDescargue.toISOString() : undefined as any;
        data["despachoUser"] = this.despachoUser;
        if (Array.isArray(this.facturas)) {
            data["facturas"] = [];
            for (let item of this.facturas)
                data["facturas"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDespachoGetDto {
    despachoId?: number;
    despachoFecha?: Date;
    despachoEstado?: string;
    despachoVehiculoId?: number;
    despachoVehiculoN?: string;
    despachoReciboCaja?: string | undefined;
    despachoConductorId?: number | undefined;
    despachoConductorNit?: string;
    despachoConductorNombre?: string;
    despachoAuxiliarId?: number | undefined;
    despachoAuxiliarNit?: string;
    despachoAuxiliarNombre?: string;
    despachoSucursalId?: number | undefined;
    despachoSucursalNombre?: string;
    despachoHoraCargue?: Date | undefined;
    despachoHoraDescargue?: Date | undefined;
    despachoUser?: string | undefined;
    facturas?: DespachoFacturaDto[];
}

export class DespachoFacturaDto implements IDespachoFacturaDto {
    facturaId?: number;
    facturaId2?: string;
    clienteTerceroNombre?: string | undefined;
    clienteAlmacen?: string | undefined;
    vendedorNombre?: string | undefined;
    clienteDireccion?: string | undefined;
    clienteTelefono?: string | undefined;
    clienteCiudadNombre?: string | undefined;
    facturaPlazoComercial?: number;
    pedidoTipoPago?: string | undefined;
    facturaVrAPagar?: number;
    facturaVrNotasCredito?: number;
    facturaBodegaId?: string;
    facturaNotas?: string;
    detalle?: DespachoFacturaDetalleDto[];

    constructor(data?: IDespachoFacturaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facturaId = _data["facturaId"];
            this.facturaId2 = _data["facturaId2"];
            this.clienteTerceroNombre = _data["clienteTerceroNombre"];
            this.clienteAlmacen = _data["clienteAlmacen"];
            this.vendedorNombre = _data["vendedorNombre"];
            this.clienteDireccion = _data["clienteDireccion"];
            this.clienteTelefono = _data["clienteTelefono"];
            this.clienteCiudadNombre = _data["clienteCiudadNombre"];
            this.facturaPlazoComercial = _data["facturaPlazoComercial"];
            this.pedidoTipoPago = _data["pedidoTipoPago"];
            this.facturaVrAPagar = _data["facturaVrAPagar"];
            this.facturaVrNotasCredito = _data["facturaVrNotasCredito"];
            this.facturaBodegaId = _data["facturaBodegaId"];
            this.facturaNotas = _data["facturaNotas"];
            if (Array.isArray(_data["Detalle"])) {
                this.detalle = [] as any;
                for (let item of _data["Detalle"])
                    this.detalle!.push(DespachoFacturaDetalleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DespachoFacturaDto {
        data = typeof data === 'object' ? data : {};
        let result = new DespachoFacturaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facturaId"] = this.facturaId;
        data["facturaId2"] = this.facturaId2;
        data["clienteTerceroNombre"] = this.clienteTerceroNombre;
        data["clienteAlmacen"] = this.clienteAlmacen;
        data["vendedorNombre"] = this.vendedorNombre;
        data["clienteDireccion"] = this.clienteDireccion;
        data["clienteTelefono"] = this.clienteTelefono;
        data["clienteCiudadNombre"] = this.clienteCiudadNombre;
        data["facturaPlazoComercial"] = this.facturaPlazoComercial;
        data["pedidoTipoPago"] = this.pedidoTipoPago;
        data["facturaVrAPagar"] = this.facturaVrAPagar;
        data["facturaVrNotasCredito"] = this.facturaVrNotasCredito;
        data["facturaBodegaId"] = this.facturaBodegaId;
        data["facturaNotas"] = this.facturaNotas;
        if (Array.isArray(this.detalle)) {
            data["Detalle"] = [];
            for (let item of this.detalle)
                data["Detalle"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDespachoFacturaDto {
    facturaId?: number;
    facturaId2?: string;
    clienteTerceroNombre?: string | undefined;
    clienteAlmacen?: string | undefined;
    vendedorNombre?: string | undefined;
    clienteDireccion?: string | undefined;
    clienteTelefono?: string | undefined;
    clienteCiudadNombre?: string | undefined;
    facturaPlazoComercial?: number;
    pedidoTipoPago?: string | undefined;
    facturaVrAPagar?: number;
    facturaVrNotasCredito?: number;
    facturaBodegaId?: string;
    facturaNotas?: string;
    detalle?: DespachoFacturaDetalleDto[];
}

export class DespachoFacturaDetalleDto implements IDespachoFacturaDetalleDto {
    facturaDetalleId?: number;
    productoId?: string;
    productoNombre?: string;
    productoManejo?: string | undefined;
    productoPeso?: number;
    facturaDetalleCantidad?: number;
    facturaDetalleVrUnitario?: number;
    facturaDetalleCantDev?: number | undefined;
    facturaDetalleRemision?: string;
    facturaDetalleNotaLong?: string;
    facturaDetalleLoteId?: number | undefined;

    constructor(data?: IDespachoFacturaDetalleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facturaDetalleId = _data["facturaDetalleId"];
            this.productoId = _data["productoId"];
            this.productoNombre = _data["productoNombre"];
            this.productoManejo = _data["productoManejo"];
            this.productoPeso = _data["productoPeso"];
            this.facturaDetalleCantidad = _data["facturaDetalleCantidad"];
            this.facturaDetalleVrUnitario = _data["facturaDetalleVrUnitario"];
            this.facturaDetalleCantDev = _data["facturaDetalleCantDev"];
            this.facturaDetalleRemision = _data["facturaDetalleRemision"];
            this.facturaDetalleNotaLong = _data["facturaDetalleNotaLong"];
            this.facturaDetalleLoteId = _data["facturaDetalleLoteId"];
        }
    }

    static fromJS(data: any): DespachoFacturaDetalleDto {
        data = typeof data === 'object' ? data : {};
        let result = new DespachoFacturaDetalleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facturaDetalleId"] = this.facturaDetalleId;
        data["productoId"] = this.productoId;
        data["productoNombre"] = this.productoNombre;
        data["productoManejo"] = this.productoManejo;
        data["productoPeso"] = this.productoPeso;
        data["facturaDetalleCantidad"] = this.facturaDetalleCantidad;
        data["facturaDetalleVrUnitario"] = this.facturaDetalleVrUnitario;
        data["facturaDetalleCantDev"] = this.facturaDetalleCantDev;
        data["facturaDetalleRemision"] = this.facturaDetalleRemision;
        data["facturaDetalleNotaLong"] = this.facturaDetalleNotaLong;
        data["facturaDetalleLoteId"] = this.facturaDetalleLoteId;
        return data;
    }
}

export interface IDespachoFacturaDetalleDto {
    facturaDetalleId?: number;
    productoId?: string;
    productoNombre?: string;
    productoManejo?: string | undefined;
    productoPeso?: number;
    facturaDetalleCantidad?: number;
    facturaDetalleVrUnitario?: number;
    facturaDetalleCantDev?: number | undefined;
    facturaDetalleRemision?: string;
    facturaDetalleNotaLong?: string;
    facturaDetalleLoteId?: number | undefined;
}

export class DespachoFacturasDto implements IDespachoFacturasDto {
    despachoId?: number;
    facturas?: number[];

    constructor(data?: IDespachoFacturasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.despachoId = _data["despachoId"];
            if (Array.isArray(_data["facturas"])) {
                this.facturas = [] as any;
                for (let item of _data["facturas"])
                    this.facturas!.push(item);
            }
        }
    }

    static fromJS(data: any): DespachoFacturasDto {
        data = typeof data === 'object' ? data : {};
        let result = new DespachoFacturasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["despachoId"] = this.despachoId;
        if (Array.isArray(this.facturas)) {
            data["facturas"] = [];
            for (let item of this.facturas)
                data["facturas"].push(item);
        }
        return data;
    }
}

export interface IDespachoFacturasDto {
    despachoId?: number;
    facturas?: number[];
}

export class DespachoIdDto implements IDespachoIdDto {
    despachoId?: number;

    constructor(data?: IDespachoIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.despachoId = _data["despachoId"];
        }
    }

    static fromJS(data: any): DespachoIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new DespachoIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["despachoId"] = this.despachoId;
        return data;
    }
}

export interface IDespachoIdDto {
    despachoId?: number;
}

export class LiqEntDto implements ILiqEntDto {
    despachoId?: number;
    reciboCaja?: ReciboCaja;
    diferenciaEntregador?: number;

    constructor(data?: ILiqEntDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.despachoId = _data["despachoId"];
            this.reciboCaja = _data["reciboCaja"] ? ReciboCaja.fromJS(_data["reciboCaja"]) : undefined as any;
            this.diferenciaEntregador = _data["diferenciaEntregador"];
        }
    }

    static fromJS(data: any): LiqEntDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiqEntDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["despachoId"] = this.despachoId;
        data["reciboCaja"] = this.reciboCaja ? this.reciboCaja.toJSON() : undefined as any;
        data["diferenciaEntregador"] = this.diferenciaEntregador;
        return data;
    }
}

export interface ILiqEntDto {
    despachoId?: number;
    reciboCaja?: ReciboCaja;
    diferenciaEntregador?: number;
}

export class ReciboCaja implements IReciboCaja {
    reciboCajaId?: number;
    reciboCajaId2?: string;
    documentoId?: number;
    reciboCajaFecha?: Date;
    regConId?: number | undefined;
    terceroId?: number;
    reciboCajaEstado?: string;
    bancoId?: number | undefined;
    reciboCajaFechaCheque?: Date;
    reciboCajaVrBanco?: number;
    reciboCajaPrefijo?: string;
    reciboCajaNumero?: number;
    reciboCajaSucursalId?: number | undefined;
    reciboCajaCreditos?: number;
    reciboCajaMPS?: number;
    reciboCajaInsHr?: Date | undefined;
    reciboCajaUser?: string | undefined;
    reciboCajaOrigen?: number;
    reciboCajaEfectivo?: number;
    reciboCajaVendedorId?: number | undefined;
    reciboCajaNotas?: string;
    reciboCajaCajaId?: number | undefined;
    reciboCajaCheque?: number;
    reciboCajaConcepto?: string | undefined;
    reciboCajaVrAnticipo?: number | undefined;
    reciboCajaProperties?: string | undefined;
    reciboCajaClienteId?: number | undefined;
    reciboCajaClienteAlmacen?: string | undefined;
    credito?: ReciboCajaCredito[];
    mediosPago?: ReciboCajaMediosPago[];
    facturas?: ReciboCajaFactura[];

    constructor(data?: IReciboCaja) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reciboCajaId = _data["reciboCajaId"];
            this.reciboCajaId2 = _data["reciboCajaId2"];
            this.documentoId = _data["documentoId"];
            this.reciboCajaFecha = _data["reciboCajaFecha"] ? new Date(_data["reciboCajaFecha"].toString()) : undefined as any;
            this.regConId = _data["regConId"];
            this.terceroId = _data["terceroId"];
            this.reciboCajaEstado = _data["reciboCajaEstado"];
            this.bancoId = _data["bancoId"];
            this.reciboCajaFechaCheque = _data["reciboCajaFechaCheque"] ? new Date(_data["reciboCajaFechaCheque"].toString()) : undefined as any;
            this.reciboCajaVrBanco = _data["reciboCajaVrBanco"];
            this.reciboCajaPrefijo = _data["reciboCajaPrefijo"];
            this.reciboCajaNumero = _data["reciboCajaNumero"];
            this.reciboCajaSucursalId = _data["reciboCajaSucursalId"];
            this.reciboCajaCreditos = _data["reciboCajaCreditos"];
            this.reciboCajaMPS = _data["reciboCajaMPS"];
            this.reciboCajaInsHr = _data["reciboCajaInsHr"] ? new Date(_data["reciboCajaInsHr"].toString()) : undefined as any;
            this.reciboCajaUser = _data["reciboCajaUser"];
            this.reciboCajaOrigen = _data["reciboCajaOrigen"];
            this.reciboCajaEfectivo = _data["reciboCajaEfectivo"];
            this.reciboCajaVendedorId = _data["reciboCajaVendedorId"];
            this.reciboCajaNotas = _data["reciboCajaNotas"];
            this.reciboCajaCajaId = _data["reciboCajaCajaId"];
            this.reciboCajaCheque = _data["reciboCajaCheque"];
            this.reciboCajaConcepto = _data["reciboCajaConcepto"];
            this.reciboCajaVrAnticipo = _data["reciboCajaVrAnticipo"];
            this.reciboCajaProperties = _data["reciboCajaProperties"];
            this.reciboCajaClienteId = _data["reciboCajaClienteId"];
            this.reciboCajaClienteAlmacen = _data["reciboCajaClienteAlmacen"];
            if (Array.isArray(_data["Credito"])) {
                this.credito = [] as any;
                for (let item of _data["Credito"])
                    this.credito!.push(ReciboCajaCredito.fromJS(item));
            }
            if (Array.isArray(_data["MediosPago"])) {
                this.mediosPago = [] as any;
                for (let item of _data["MediosPago"])
                    this.mediosPago!.push(ReciboCajaMediosPago.fromJS(item));
            }
            if (Array.isArray(_data["Facturas"])) {
                this.facturas = [] as any;
                for (let item of _data["Facturas"])
                    this.facturas!.push(ReciboCajaFactura.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReciboCaja {
        data = typeof data === 'object' ? data : {};
        let result = new ReciboCaja();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reciboCajaId"] = this.reciboCajaId;
        data["reciboCajaId2"] = this.reciboCajaId2;
        data["documentoId"] = this.documentoId;
        data["reciboCajaFecha"] = this.reciboCajaFecha ? this.reciboCajaFecha.toISOString() : undefined as any;
        data["regConId"] = this.regConId;
        data["terceroId"] = this.terceroId;
        data["reciboCajaEstado"] = this.reciboCajaEstado;
        data["bancoId"] = this.bancoId;
        data["reciboCajaFechaCheque"] = this.reciboCajaFechaCheque ? this.reciboCajaFechaCheque.toISOString() : undefined as any;
        data["reciboCajaVrBanco"] = this.reciboCajaVrBanco;
        data["reciboCajaPrefijo"] = this.reciboCajaPrefijo;
        data["reciboCajaNumero"] = this.reciboCajaNumero;
        data["reciboCajaSucursalId"] = this.reciboCajaSucursalId;
        data["reciboCajaCreditos"] = this.reciboCajaCreditos;
        data["reciboCajaMPS"] = this.reciboCajaMPS;
        data["reciboCajaInsHr"] = this.reciboCajaInsHr ? this.reciboCajaInsHr.toISOString() : undefined as any;
        data["reciboCajaUser"] = this.reciboCajaUser;
        data["reciboCajaOrigen"] = this.reciboCajaOrigen;
        data["reciboCajaEfectivo"] = this.reciboCajaEfectivo;
        data["reciboCajaVendedorId"] = this.reciboCajaVendedorId;
        data["reciboCajaNotas"] = this.reciboCajaNotas;
        data["reciboCajaCajaId"] = this.reciboCajaCajaId;
        data["reciboCajaCheque"] = this.reciboCajaCheque;
        data["reciboCajaConcepto"] = this.reciboCajaConcepto;
        data["reciboCajaVrAnticipo"] = this.reciboCajaVrAnticipo;
        data["reciboCajaProperties"] = this.reciboCajaProperties;
        data["reciboCajaClienteId"] = this.reciboCajaClienteId;
        data["reciboCajaClienteAlmacen"] = this.reciboCajaClienteAlmacen;
        if (Array.isArray(this.credito)) {
            data["Credito"] = [];
            for (let item of this.credito)
                data["Credito"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.mediosPago)) {
            data["MediosPago"] = [];
            for (let item of this.mediosPago)
                data["MediosPago"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.facturas)) {
            data["Facturas"] = [];
            for (let item of this.facturas)
                data["Facturas"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReciboCaja {
    reciboCajaId?: number;
    reciboCajaId2?: string;
    documentoId?: number;
    reciboCajaFecha?: Date;
    regConId?: number | undefined;
    terceroId?: number;
    reciboCajaEstado?: string;
    bancoId?: number | undefined;
    reciboCajaFechaCheque?: Date;
    reciboCajaVrBanco?: number;
    reciboCajaPrefijo?: string;
    reciboCajaNumero?: number;
    reciboCajaSucursalId?: number | undefined;
    reciboCajaCreditos?: number;
    reciboCajaMPS?: number;
    reciboCajaInsHr?: Date | undefined;
    reciboCajaUser?: string | undefined;
    reciboCajaOrigen?: number;
    reciboCajaEfectivo?: number;
    reciboCajaVendedorId?: number | undefined;
    reciboCajaNotas?: string;
    reciboCajaCajaId?: number | undefined;
    reciboCajaCheque?: number;
    reciboCajaConcepto?: string | undefined;
    reciboCajaVrAnticipo?: number | undefined;
    reciboCajaProperties?: string | undefined;
    reciboCajaClienteId?: number | undefined;
    reciboCajaClienteAlmacen?: string | undefined;
    credito?: ReciboCajaCredito[];
    mediosPago?: ReciboCajaMediosPago[];
    facturas?: ReciboCajaFactura[];
}

export class ReciboCajaCredito implements IReciboCajaCredito {
    reciboCajaId?: number;
    reciboCajaCreditoId?: number;
    reciboCajaPucId?: string;
    reciboCajaCreditoVr?: number;
    reciboCajaCreditoNit?: string | undefined;
    reciboCajaCreditoCC?: number | undefined;
    reciboCajaCreditoDescripcion?: string | undefined;

    constructor(data?: IReciboCajaCredito) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reciboCajaId = _data["reciboCajaId"];
            this.reciboCajaCreditoId = _data["reciboCajaCreditoId"];
            this.reciboCajaPucId = _data["reciboCajaPucId"];
            this.reciboCajaCreditoVr = _data["reciboCajaCreditoVr"];
            this.reciboCajaCreditoNit = _data["reciboCajaCreditoNit"];
            this.reciboCajaCreditoCC = _data["reciboCajaCreditoCC"];
            this.reciboCajaCreditoDescripcion = _data["reciboCajaCreditoDescripcion"];
        }
    }

    static fromJS(data: any): ReciboCajaCredito {
        data = typeof data === 'object' ? data : {};
        let result = new ReciboCajaCredito();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reciboCajaId"] = this.reciboCajaId;
        data["reciboCajaCreditoId"] = this.reciboCajaCreditoId;
        data["reciboCajaPucId"] = this.reciboCajaPucId;
        data["reciboCajaCreditoVr"] = this.reciboCajaCreditoVr;
        data["reciboCajaCreditoNit"] = this.reciboCajaCreditoNit;
        data["reciboCajaCreditoCC"] = this.reciboCajaCreditoCC;
        data["reciboCajaCreditoDescripcion"] = this.reciboCajaCreditoDescripcion;
        return data;
    }
}

export interface IReciboCajaCredito {
    reciboCajaId?: number;
    reciboCajaCreditoId?: number;
    reciboCajaPucId?: string;
    reciboCajaCreditoVr?: number;
    reciboCajaCreditoNit?: string | undefined;
    reciboCajaCreditoCC?: number | undefined;
    reciboCajaCreditoDescripcion?: string | undefined;
}

export class ReciboCajaMediosPago implements IReciboCajaMediosPago {
    reciboCajaId?: number;
    reciboCajaMediosPagoId?: number;
    pucID?: string;
    reciboCajaPagoValor?: number;
    reciboCajaMPCC?: number | undefined;
    reciboCajaMPNit?: string | undefined;
    reciboCajaPagoDoc?: string | undefined;
    reciboCajaPagoTipo?: string | undefined;
    reciboCajaPagoDescripcion?: string | undefined;
    reciboCajaMPFecha?: Date | undefined;

    constructor(data?: IReciboCajaMediosPago) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reciboCajaId = _data["reciboCajaId"];
            this.reciboCajaMediosPagoId = _data["reciboCajaMediosPagoId"];
            this.pucID = _data["pucID"];
            this.reciboCajaPagoValor = _data["reciboCajaPagoValor"];
            this.reciboCajaMPCC = _data["reciboCajaMPCC"];
            this.reciboCajaMPNit = _data["reciboCajaMPNit"];
            this.reciboCajaPagoDoc = _data["reciboCajaPagoDoc"];
            this.reciboCajaPagoTipo = _data["reciboCajaPagoTipo"];
            this.reciboCajaPagoDescripcion = _data["reciboCajaPagoDescripcion"];
            this.reciboCajaMPFecha = _data["reciboCajaMPFecha"] ? new Date(_data["reciboCajaMPFecha"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ReciboCajaMediosPago {
        data = typeof data === 'object' ? data : {};
        let result = new ReciboCajaMediosPago();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reciboCajaId"] = this.reciboCajaId;
        data["reciboCajaMediosPagoId"] = this.reciboCajaMediosPagoId;
        data["pucID"] = this.pucID;
        data["reciboCajaPagoValor"] = this.reciboCajaPagoValor;
        data["reciboCajaMPCC"] = this.reciboCajaMPCC;
        data["reciboCajaMPNit"] = this.reciboCajaMPNit;
        data["reciboCajaPagoDoc"] = this.reciboCajaPagoDoc;
        data["reciboCajaPagoTipo"] = this.reciboCajaPagoTipo;
        data["reciboCajaPagoDescripcion"] = this.reciboCajaPagoDescripcion;
        data["reciboCajaMPFecha"] = this.reciboCajaMPFecha ? this.reciboCajaMPFecha.toISOString() : undefined as any;
        return data;
    }
}

export interface IReciboCajaMediosPago {
    reciboCajaId?: number;
    reciboCajaMediosPagoId?: number;
    pucID?: string;
    reciboCajaPagoValor?: number;
    reciboCajaMPCC?: number | undefined;
    reciboCajaMPNit?: string | undefined;
    reciboCajaPagoDoc?: string | undefined;
    reciboCajaPagoTipo?: string | undefined;
    reciboCajaPagoDescripcion?: string | undefined;
    reciboCajaMPFecha?: Date | undefined;
}

export class ReciboCajaFactura implements IReciboCajaFactura {
    reciboCajaId?: number;
    facturaId?: number;
    reciboCajaValorPagado?: number;
    reciboCajaValorRetencion?: number;
    reciboCajaValorDcto?: number;
    reciboCajaValorSaldo?: number;
    reciboCajaValorExcedente?: number;
    reciboCajaValorReteIVA?: number;
    reciboCajaValorReteICA?: number;
    reciboCajaRetFactId?: number | undefined;
    facturaId2?: string | undefined;
    clienteNit?: string | undefined;
    facturaVrSaldo?: number | undefined;
    facturaVrAbonado?: number | undefined;
    facturaVrBase?: number | undefined;
    facturaVrIVA?: number | undefined;

    constructor(data?: IReciboCajaFactura) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reciboCajaId = _data["reciboCajaId"];
            this.facturaId = _data["facturaId"];
            this.reciboCajaValorPagado = _data["reciboCajaValorPagado"];
            this.reciboCajaValorRetencion = _data["reciboCajaValorRetencion"];
            this.reciboCajaValorDcto = _data["reciboCajaValorDcto"];
            this.reciboCajaValorSaldo = _data["reciboCajaValorSaldo"];
            this.reciboCajaValorExcedente = _data["reciboCajaValorExcedente"];
            this.reciboCajaValorReteIVA = _data["reciboCajaValorReteIVA"];
            this.reciboCajaValorReteICA = _data["reciboCajaValorReteICA"];
            this.reciboCajaRetFactId = _data["reciboCajaRetFactId"];
            this.facturaId2 = _data["facturaId2"];
            this.clienteNit = _data["clienteNit"];
            this.facturaVrSaldo = _data["facturaVrSaldo"];
            this.facturaVrAbonado = _data["facturaVrAbonado"];
            this.facturaVrBase = _data["facturaVrBase"];
            this.facturaVrIVA = _data["facturaVrIVA"];
        }
    }

    static fromJS(data: any): ReciboCajaFactura {
        data = typeof data === 'object' ? data : {};
        let result = new ReciboCajaFactura();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reciboCajaId"] = this.reciboCajaId;
        data["facturaId"] = this.facturaId;
        data["reciboCajaValorPagado"] = this.reciboCajaValorPagado;
        data["reciboCajaValorRetencion"] = this.reciboCajaValorRetencion;
        data["reciboCajaValorDcto"] = this.reciboCajaValorDcto;
        data["reciboCajaValorSaldo"] = this.reciboCajaValorSaldo;
        data["reciboCajaValorExcedente"] = this.reciboCajaValorExcedente;
        data["reciboCajaValorReteIVA"] = this.reciboCajaValorReteIVA;
        data["reciboCajaValorReteICA"] = this.reciboCajaValorReteICA;
        data["reciboCajaRetFactId"] = this.reciboCajaRetFactId;
        data["facturaId2"] = this.facturaId2;
        data["clienteNit"] = this.clienteNit;
        data["facturaVrSaldo"] = this.facturaVrSaldo;
        data["facturaVrAbonado"] = this.facturaVrAbonado;
        data["facturaVrBase"] = this.facturaVrBase;
        data["facturaVrIVA"] = this.facturaVrIVA;
        return data;
    }
}

export interface IReciboCajaFactura {
    reciboCajaId?: number;
    facturaId?: number;
    reciboCajaValorPagado?: number;
    reciboCajaValorRetencion?: number;
    reciboCajaValorDcto?: number;
    reciboCajaValorSaldo?: number;
    reciboCajaValorExcedente?: number;
    reciboCajaValorReteIVA?: number;
    reciboCajaValorReteICA?: number;
    reciboCajaRetFactId?: number | undefined;
    facturaId2?: string | undefined;
    clienteNit?: string | undefined;
    facturaVrSaldo?: number | undefined;
    facturaVrAbonado?: number | undefined;
    facturaVrBase?: number | undefined;
    facturaVrIVA?: number | undefined;
}

export class LiqNcDto implements ILiqNcDto {
    despachoId?: number;
    notaCredDocumentoId?: number;

    constructor(data?: ILiqNcDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.despachoId = _data["despachoId"];
            this.notaCredDocumentoId = _data["notaCredDocumentoId"];
        }
    }

    static fromJS(data: any): LiqNcDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiqNcDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["despachoId"] = this.despachoId;
        data["notaCredDocumentoId"] = this.notaCredDocumentoId;
        return data;
    }
}

export interface ILiqNcDto {
    despachoId?: number;
    notaCredDocumentoId?: number;
}

export class PagingOfDocumento implements IPagingOfDocumento {
    count?: number;
    data?: Documento[];

    constructor(data?: IPagingOfDocumento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Documento.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfDocumento {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfDocumento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfDocumento {
    count?: number;
    data?: Documento[];
}

export class DocumentoIdDescripcionDto implements IDocumentoIdDescripcionDto {
    id?: number;
    descripcion?: string;

    constructor(data?: IDocumentoIdDescripcionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descripcion = _data["descripcion"];
        }
    }

    static fromJS(data: any): DocumentoIdDescripcionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentoIdDescripcionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descripcion"] = this.descripcion;
        return data;
    }
}

export interface IDocumentoIdDescripcionDto {
    id?: number;
    descripcion?: string;
}

export class PagingOfEgreso implements IPagingOfEgreso {
    count?: number;
    data?: Egreso[];

    constructor(data?: IPagingOfEgreso) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Egreso.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfEgreso {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfEgreso();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfEgreso {
    count?: number;
    data?: Egreso[];
}

export class Egreso implements IEgreso {
    egresoId?: number;
    egresoFecha?: Date;
    terceroId?: number;
    egresoId2?: string;
    egresoSerialDocs?: number;
    bancoId?: number | undefined;
    egresoVrPagoBanco?: number;
    egresoMPItems?: number;
    documentoId?: number | undefined;
    egresoEstado?: string;
    egresoPrefijo?: string;
    egresoNumero?: number;
    regConId?: number | undefined;
    egresoSucursalId?: number | undefined;
    egresoDebs?: number;
    egresoConcepto?: string;
    egresoRealizaTransferencia?: boolean | undefined;
    egresoTransferenciaId?: number | undefined;
    egresoInsHr?: Date | undefined;
    egresoUser?: string | undefined;
    egresoOrigen?: number;
    egresoNotas?: string;
    egresoChequeFecha?: Date;
    egresoChequeNo?: number;
    egresoCC?: number | undefined;
    documento?: EgresoDocumento[];
    mediosPago?: EgresoMediosPago[];
    egresoDeb?: EgresoEgresoDeb[];

    constructor(data?: IEgreso) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.egresoId = _data["egresoId"];
            this.egresoFecha = _data["egresoFecha"] ? new Date(_data["egresoFecha"].toString()) : undefined as any;
            this.terceroId = _data["terceroId"];
            this.egresoId2 = _data["egresoId2"];
            this.egresoSerialDocs = _data["egresoSerialDocs"];
            this.bancoId = _data["bancoId"];
            this.egresoVrPagoBanco = _data["egresoVrPagoBanco"];
            this.egresoMPItems = _data["egresoMPItems"];
            this.documentoId = _data["documentoId"];
            this.egresoEstado = _data["egresoEstado"];
            this.egresoPrefijo = _data["egresoPrefijo"];
            this.egresoNumero = _data["egresoNumero"];
            this.regConId = _data["regConId"];
            this.egresoSucursalId = _data["egresoSucursalId"];
            this.egresoDebs = _data["egresoDebs"];
            this.egresoConcepto = _data["egresoConcepto"];
            this.egresoRealizaTransferencia = _data["egresoRealizaTransferencia"];
            this.egresoTransferenciaId = _data["egresoTransferenciaId"];
            this.egresoInsHr = _data["egresoInsHr"] ? new Date(_data["egresoInsHr"].toString()) : undefined as any;
            this.egresoUser = _data["egresoUser"];
            this.egresoOrigen = _data["egresoOrigen"];
            this.egresoNotas = _data["egresoNotas"];
            this.egresoChequeFecha = _data["egresoChequeFecha"] ? new Date(_data["egresoChequeFecha"].toString()) : undefined as any;
            this.egresoChequeNo = _data["egresoChequeNo"];
            this.egresoCC = _data["egresoCC"];
            if (Array.isArray(_data["documento"])) {
                this.documento = [] as any;
                for (let item of _data["documento"])
                    this.documento!.push(EgresoDocumento.fromJS(item));
            }
            if (Array.isArray(_data["mediosPago"])) {
                this.mediosPago = [] as any;
                for (let item of _data["mediosPago"])
                    this.mediosPago!.push(EgresoMediosPago.fromJS(item));
            }
            if (Array.isArray(_data["egresoDeb"])) {
                this.egresoDeb = [] as any;
                for (let item of _data["egresoDeb"])
                    this.egresoDeb!.push(EgresoEgresoDeb.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Egreso {
        data = typeof data === 'object' ? data : {};
        let result = new Egreso();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["egresoId"] = this.egresoId;
        data["egresoFecha"] = this.egresoFecha ? this.egresoFecha.toISOString() : undefined as any;
        data["terceroId"] = this.terceroId;
        data["egresoId2"] = this.egresoId2;
        data["egresoSerialDocs"] = this.egresoSerialDocs;
        data["bancoId"] = this.bancoId;
        data["egresoVrPagoBanco"] = this.egresoVrPagoBanco;
        data["egresoMPItems"] = this.egresoMPItems;
        data["documentoId"] = this.documentoId;
        data["egresoEstado"] = this.egresoEstado;
        data["egresoPrefijo"] = this.egresoPrefijo;
        data["egresoNumero"] = this.egresoNumero;
        data["regConId"] = this.regConId;
        data["egresoSucursalId"] = this.egresoSucursalId;
        data["egresoDebs"] = this.egresoDebs;
        data["egresoConcepto"] = this.egresoConcepto;
        data["egresoRealizaTransferencia"] = this.egresoRealizaTransferencia;
        data["egresoTransferenciaId"] = this.egresoTransferenciaId;
        data["egresoInsHr"] = this.egresoInsHr ? this.egresoInsHr.toISOString() : undefined as any;
        data["egresoUser"] = this.egresoUser;
        data["egresoOrigen"] = this.egresoOrigen;
        data["egresoNotas"] = this.egresoNotas;
        data["egresoChequeFecha"] = this.egresoChequeFecha ? this.egresoChequeFecha.toISOString() : undefined as any;
        data["egresoChequeNo"] = this.egresoChequeNo;
        data["egresoCC"] = this.egresoCC;
        if (Array.isArray(this.documento)) {
            data["documento"] = [];
            for (let item of this.documento)
                data["documento"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.mediosPago)) {
            data["mediosPago"] = [];
            for (let item of this.mediosPago)
                data["mediosPago"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.egresoDeb)) {
            data["egresoDeb"] = [];
            for (let item of this.egresoDeb)
                data["egresoDeb"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEgreso {
    egresoId?: number;
    egresoFecha?: Date;
    terceroId?: number;
    egresoId2?: string;
    egresoSerialDocs?: number;
    bancoId?: number | undefined;
    egresoVrPagoBanco?: number;
    egresoMPItems?: number;
    documentoId?: number | undefined;
    egresoEstado?: string;
    egresoPrefijo?: string;
    egresoNumero?: number;
    regConId?: number | undefined;
    egresoSucursalId?: number | undefined;
    egresoDebs?: number;
    egresoConcepto?: string;
    egresoRealizaTransferencia?: boolean | undefined;
    egresoTransferenciaId?: number | undefined;
    egresoInsHr?: Date | undefined;
    egresoUser?: string | undefined;
    egresoOrigen?: number;
    egresoNotas?: string;
    egresoChequeFecha?: Date;
    egresoChequeNo?: number;
    egresoCC?: number | undefined;
    documento?: EgresoDocumento[];
    mediosPago?: EgresoMediosPago[];
    egresoDeb?: EgresoEgresoDeb[];
}

export class EgresoDocumento implements IEgresoDocumento {
    egresoId?: number;
    egresoDocumentoId?: number;
    gastoId?: number | undefined;
    compraId?: number | undefined;
    egresoVrPagado?: number;
    egresoDocumentoDcto?: number;
    egresoDocumentoId2?: string | undefined;
    egresoDocumentoTipo?: string | undefined;

    constructor(data?: IEgresoDocumento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.egresoId = _data["egresoId"];
            this.egresoDocumentoId = _data["egresoDocumentoId"];
            this.gastoId = _data["gastoId"];
            this.compraId = _data["compraId"];
            this.egresoVrPagado = _data["egresoVrPagado"];
            this.egresoDocumentoDcto = _data["egresoDocumentoDcto"];
            this.egresoDocumentoId2 = _data["egresoDocumentoId2"];
            this.egresoDocumentoTipo = _data["egresoDocumentoTipo"];
        }
    }

    static fromJS(data: any): EgresoDocumento {
        data = typeof data === 'object' ? data : {};
        let result = new EgresoDocumento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["egresoId"] = this.egresoId;
        data["egresoDocumentoId"] = this.egresoDocumentoId;
        data["gastoId"] = this.gastoId;
        data["compraId"] = this.compraId;
        data["egresoVrPagado"] = this.egresoVrPagado;
        data["egresoDocumentoDcto"] = this.egresoDocumentoDcto;
        data["egresoDocumentoId2"] = this.egresoDocumentoId2;
        data["egresoDocumentoTipo"] = this.egresoDocumentoTipo;
        return data;
    }
}

export interface IEgresoDocumento {
    egresoId?: number;
    egresoDocumentoId?: number;
    gastoId?: number | undefined;
    compraId?: number | undefined;
    egresoVrPagado?: number;
    egresoDocumentoDcto?: number;
    egresoDocumentoId2?: string | undefined;
    egresoDocumentoTipo?: string | undefined;
}

export class EgresoMediosPago implements IEgresoMediosPago {
    egresoId?: number;
    egresoMediosPagoId?: number;
    pucID?: string;
    egresoMPValor?: number;
    egresoMPVrBase?: number;
    egresoMPNit?: string | undefined;
    egresoMPTerceroId2?: number | undefined;
    egresoMPCC?: number | undefined;
    egresoAnticipoId2?: string | undefined;
    egresoMPDoc?: string | undefined;
    egresoMPDocTipo?: string | undefined;
    egresoMPDescripcion?: string | undefined;
    egresoMPSucId?: number | undefined;

    constructor(data?: IEgresoMediosPago) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.egresoId = _data["egresoId"];
            this.egresoMediosPagoId = _data["egresoMediosPagoId"];
            this.pucID = _data["pucID"];
            this.egresoMPValor = _data["egresoMPValor"];
            this.egresoMPVrBase = _data["egresoMPVrBase"];
            this.egresoMPNit = _data["egresoMPNit"];
            this.egresoMPTerceroId2 = _data["egresoMPTerceroId2"];
            this.egresoMPCC = _data["egresoMPCC"];
            this.egresoAnticipoId2 = _data["egresoAnticipoId2"];
            this.egresoMPDoc = _data["egresoMPDoc"];
            this.egresoMPDocTipo = _data["egresoMPDocTipo"];
            this.egresoMPDescripcion = _data["egresoMPDescripcion"];
            this.egresoMPSucId = _data["egresoMPSucId"];
        }
    }

    static fromJS(data: any): EgresoMediosPago {
        data = typeof data === 'object' ? data : {};
        let result = new EgresoMediosPago();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["egresoId"] = this.egresoId;
        data["egresoMediosPagoId"] = this.egresoMediosPagoId;
        data["pucID"] = this.pucID;
        data["egresoMPValor"] = this.egresoMPValor;
        data["egresoMPVrBase"] = this.egresoMPVrBase;
        data["egresoMPNit"] = this.egresoMPNit;
        data["egresoMPTerceroId2"] = this.egresoMPTerceroId2;
        data["egresoMPCC"] = this.egresoMPCC;
        data["egresoAnticipoId2"] = this.egresoAnticipoId2;
        data["egresoMPDoc"] = this.egresoMPDoc;
        data["egresoMPDocTipo"] = this.egresoMPDocTipo;
        data["egresoMPDescripcion"] = this.egresoMPDescripcion;
        data["egresoMPSucId"] = this.egresoMPSucId;
        return data;
    }
}

export interface IEgresoMediosPago {
    egresoId?: number;
    egresoMediosPagoId?: number;
    pucID?: string;
    egresoMPValor?: number;
    egresoMPVrBase?: number;
    egresoMPNit?: string | undefined;
    egresoMPTerceroId2?: number | undefined;
    egresoMPCC?: number | undefined;
    egresoAnticipoId2?: string | undefined;
    egresoMPDoc?: string | undefined;
    egresoMPDocTipo?: string | undefined;
    egresoMPDescripcion?: string | undefined;
    egresoMPSucId?: number | undefined;
}

export class EgresoEgresoDeb implements IEgresoEgresoDeb {
    egresoId?: number;
    egresoDebId?: number;
    egresoPucId?: string;
    egresoDebValor?: number;
    egresoDebTerceroId?: number | undefined;
    egresoCC?: number | undefined;
    egresoDebDescripcion?: string | undefined;
    egresoDebSucId?: number | undefined;

    constructor(data?: IEgresoEgresoDeb) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.egresoId = _data["egresoId"];
            this.egresoDebId = _data["egresoDebId"];
            this.egresoPucId = _data["egresoPucId"];
            this.egresoDebValor = _data["egresoDebValor"];
            this.egresoDebTerceroId = _data["egresoDebTerceroId"];
            this.egresoCC = _data["egresoCC"];
            this.egresoDebDescripcion = _data["egresoDebDescripcion"];
            this.egresoDebSucId = _data["egresoDebSucId"];
        }
    }

    static fromJS(data: any): EgresoEgresoDeb {
        data = typeof data === 'object' ? data : {};
        let result = new EgresoEgresoDeb();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["egresoId"] = this.egresoId;
        data["egresoDebId"] = this.egresoDebId;
        data["egresoPucId"] = this.egresoPucId;
        data["egresoDebValor"] = this.egresoDebValor;
        data["egresoDebTerceroId"] = this.egresoDebTerceroId;
        data["egresoCC"] = this.egresoCC;
        data["egresoDebDescripcion"] = this.egresoDebDescripcion;
        data["egresoDebSucId"] = this.egresoDebSucId;
        return data;
    }
}

export interface IEgresoEgresoDeb {
    egresoId?: number;
    egresoDebId?: number;
    egresoPucId?: string;
    egresoDebValor?: number;
    egresoDebTerceroId?: number | undefined;
    egresoCC?: number | undefined;
    egresoDebDescripcion?: string | undefined;
    egresoDebSucId?: number | undefined;
}

export class PagingOfEncuesta implements IPagingOfEncuesta {
    count?: number;
    data?: Encuesta[];

    constructor(data?: IPagingOfEncuesta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Encuesta.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfEncuesta {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfEncuesta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfEncuesta {
    count?: number;
    data?: Encuesta[];
}

export class Encuesta implements IEncuesta {
    encuestaId?: number;
    encuestaNombre?: string;
    encuestaStructure?: string;
    encuestaEstado?: number;
    encuestaDesde?: Date;
    encuestaHasta?: Date;
    encuestaTipo?: string | undefined;

    constructor(data?: IEncuesta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.encuestaId = _data["encuestaId"];
            this.encuestaNombre = _data["encuestaNombre"];
            this.encuestaStructure = _data["encuestaStructure"];
            this.encuestaEstado = _data["encuestaEstado"];
            this.encuestaDesde = _data["encuestaDesde"] ? new Date(_data["encuestaDesde"].toString()) : undefined as any;
            this.encuestaHasta = _data["encuestaHasta"] ? new Date(_data["encuestaHasta"].toString()) : undefined as any;
            this.encuestaTipo = _data["encuestaTipo"];
        }
    }

    static fromJS(data: any): Encuesta {
        data = typeof data === 'object' ? data : {};
        let result = new Encuesta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["encuestaId"] = this.encuestaId;
        data["encuestaNombre"] = this.encuestaNombre;
        data["encuestaStructure"] = this.encuestaStructure;
        data["encuestaEstado"] = this.encuestaEstado;
        data["encuestaDesde"] = this.encuestaDesde ? this.encuestaDesde.toISOString() : undefined as any;
        data["encuestaHasta"] = this.encuestaHasta ? this.encuestaHasta.toISOString() : undefined as any;
        data["encuestaTipo"] = this.encuestaTipo;
        return data;
    }
}

export interface IEncuesta {
    encuestaId?: number;
    encuestaNombre?: string;
    encuestaStructure?: string;
    encuestaEstado?: number;
    encuestaDesde?: Date;
    encuestaHasta?: Date;
    encuestaTipo?: string | undefined;
}

export class GetRespuestasArcolactResult implements IGetRespuestasArcolactResult {
    structure?: GetRespuestasArcolactStructure;
    data?: string[][];

    constructor(data?: IGetRespuestasArcolactResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.structure = _data["structure"] ? GetRespuestasArcolactStructure.fromJS(_data["structure"]) : undefined as any;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRespuestasArcolactResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetRespuestasArcolactResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["structure"] = this.structure ? this.structure.toJSON() : undefined as any;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        return data;
    }
}

export interface IGetRespuestasArcolactResult {
    structure?: GetRespuestasArcolactStructure;
    data?: string[][];
}

export class GetRespuestasArcolactStructure implements IGetRespuestasArcolactStructure {
    id?: string;
    reportCols?: ReportColDto[];
    slice?: SliceDto;

    constructor(data?: IGetRespuestasArcolactStructure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["reportCols"])) {
                this.reportCols = [] as any;
                for (let item of _data["reportCols"])
                    this.reportCols!.push(ReportColDto.fromJS(item));
            }
            this.slice = _data["slice"] ? SliceDto.fromJS(_data["slice"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetRespuestasArcolactStructure {
        data = typeof data === 'object' ? data : {};
        let result = new GetRespuestasArcolactStructure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.reportCols)) {
            data["reportCols"] = [];
            for (let item of this.reportCols)
                data["reportCols"].push(item ? item.toJSON() : undefined as any);
        }
        data["slice"] = this.slice ? this.slice.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetRespuestasArcolactStructure {
    id?: string;
    reportCols?: ReportColDto[];
    slice?: SliceDto;
}

export class ReportColDto implements IReportColDto {
    name?: string;
    type?: string;

    constructor(data?: IReportColDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ReportColDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportColDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface IReportColDto {
    name?: string;
    type?: string;
}

export class SliceDto implements ISliceDto {
    expands?: ExpandsDto;

    constructor(data?: ISliceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expands = _data["expands"] ? ExpandsDto.fromJS(_data["expands"]) : undefined as any;
        }
    }

    static fromJS(data: any): SliceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SliceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expands"] = this.expands ? this.expands.toJSON() : undefined as any;
        return data;
    }
}

export interface ISliceDto {
    expands?: ExpandsDto;
}

export class ExpandsDto implements IExpandsDto {
    expandAll?: boolean;

    constructor(data?: IExpandsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expandAll = _data["expandAll"];
        }
    }

    static fromJS(data: any): ExpandsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpandsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expandAll"] = this.expandAll;
        return data;
    }
}

export interface IExpandsDto {
    expandAll?: boolean;
}

export class PagingOfExtField implements IPagingOfExtField {
    count?: number;
    data?: ExtField[];

    constructor(data?: IPagingOfExtField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ExtField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfExtField {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfExtField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfExtField {
    count?: number;
    data?: ExtField[];
}

export class PagingOfFormula implements IPagingOfFormula {
    count?: number;
    data?: Formula[];

    constructor(data?: IPagingOfFormula) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Formula.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfFormula {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfFormula();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfFormula {
    count?: number;
    data?: Formula[];
}

export class Formula implements IFormula {
    formulaId?: string;
    formulaNombre?: string;
    formulaLoteCant?: number;
    formulaCIFStd?: number;
    formulaMOStd?: number;
    formulaCCId?: number | undefined;
    formulaTipo?: number | undefined;
    lineaProduccionId?: number | undefined;
    formulaLineaEquiv?: number | undefined;
    formulaDiasVencimiento?: number | undefined;
    formulaTipoLote?: number | undefined;
    formulaLoteNoActual?: number | undefined;
    formulaLoteTexto?: string | undefined;
    formulaTotalInsumos?: number;
    formulaFormulaInsumos?: FormulaFormulaInsumo[];
    formulaPTs?: FormulaPT[];

    constructor(data?: IFormula) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formulaId = _data["formulaId"];
            this.formulaNombre = _data["formulaNombre"];
            this.formulaLoteCant = _data["formulaLoteCant"];
            this.formulaCIFStd = _data["formulaCIFStd"];
            this.formulaMOStd = _data["formulaMOStd"];
            this.formulaCCId = _data["formulaCCId"];
            this.formulaTipo = _data["formulaTipo"];
            this.lineaProduccionId = _data["lineaProduccionId"];
            this.formulaLineaEquiv = _data["formulaLineaEquiv"];
            this.formulaDiasVencimiento = _data["formulaDiasVencimiento"];
            this.formulaTipoLote = _data["formulaTipoLote"];
            this.formulaLoteNoActual = _data["formulaLoteNoActual"];
            this.formulaLoteTexto = _data["formulaLoteTexto"];
            this.formulaTotalInsumos = _data["formulaTotalInsumos"];
            if (Array.isArray(_data["formulaFormulaInsumos"])) {
                this.formulaFormulaInsumos = [] as any;
                for (let item of _data["formulaFormulaInsumos"])
                    this.formulaFormulaInsumos!.push(FormulaFormulaInsumo.fromJS(item));
            }
            if (Array.isArray(_data["formulaPTs"])) {
                this.formulaPTs = [] as any;
                for (let item of _data["formulaPTs"])
                    this.formulaPTs!.push(FormulaPT.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Formula {
        data = typeof data === 'object' ? data : {};
        let result = new Formula();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formulaId"] = this.formulaId;
        data["formulaNombre"] = this.formulaNombre;
        data["formulaLoteCant"] = this.formulaLoteCant;
        data["formulaCIFStd"] = this.formulaCIFStd;
        data["formulaMOStd"] = this.formulaMOStd;
        data["formulaCCId"] = this.formulaCCId;
        data["formulaTipo"] = this.formulaTipo;
        data["lineaProduccionId"] = this.lineaProduccionId;
        data["formulaLineaEquiv"] = this.formulaLineaEquiv;
        data["formulaDiasVencimiento"] = this.formulaDiasVencimiento;
        data["formulaTipoLote"] = this.formulaTipoLote;
        data["formulaLoteNoActual"] = this.formulaLoteNoActual;
        data["formulaLoteTexto"] = this.formulaLoteTexto;
        data["formulaTotalInsumos"] = this.formulaTotalInsumos;
        if (Array.isArray(this.formulaFormulaInsumos)) {
            data["formulaFormulaInsumos"] = [];
            for (let item of this.formulaFormulaInsumos)
                data["formulaFormulaInsumos"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.formulaPTs)) {
            data["formulaPTs"] = [];
            for (let item of this.formulaPTs)
                data["formulaPTs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFormula {
    formulaId?: string;
    formulaNombre?: string;
    formulaLoteCant?: number;
    formulaCIFStd?: number;
    formulaMOStd?: number;
    formulaCCId?: number | undefined;
    formulaTipo?: number | undefined;
    lineaProduccionId?: number | undefined;
    formulaLineaEquiv?: number | undefined;
    formulaDiasVencimiento?: number | undefined;
    formulaTipoLote?: number | undefined;
    formulaLoteNoActual?: number | undefined;
    formulaLoteTexto?: string | undefined;
    formulaTotalInsumos?: number;
    formulaFormulaInsumos?: FormulaFormulaInsumo[];
    formulaPTs?: FormulaPT[];
}

export class FormulaFormulaInsumo implements IFormulaFormulaInsumo {
    formulaId?: string;
    formulaInsumoId?: string;
    insumoNombre?: string;
    insumoProductoCosto?: number;
    insumoReceta?: number;
    formulaInsumoUnd?: string;
    formulaInsumoCantidad?: number | undefined;
    formulaInsumoActivo?: boolean | undefined;
    formulaInsumoHeredado?: boolean | undefined;

    constructor(data?: IFormulaFormulaInsumo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formulaId = _data["formulaId"];
            this.formulaInsumoId = _data["formulaInsumoId"];
            this.insumoNombre = _data["insumoNombre"];
            this.insumoProductoCosto = _data["insumoProductoCosto"];
            this.insumoReceta = _data["insumoReceta"];
            this.formulaInsumoUnd = _data["formulaInsumoUnd"];
            this.formulaInsumoCantidad = _data["formulaInsumoCantidad"];
            this.formulaInsumoActivo = _data["formulaInsumoActivo"];
            this.formulaInsumoHeredado = _data["formulaInsumoHeredado"];
        }
    }

    static fromJS(data: any): FormulaFormulaInsumo {
        data = typeof data === 'object' ? data : {};
        let result = new FormulaFormulaInsumo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formulaId"] = this.formulaId;
        data["formulaInsumoId"] = this.formulaInsumoId;
        data["insumoNombre"] = this.insumoNombre;
        data["insumoProductoCosto"] = this.insumoProductoCosto;
        data["insumoReceta"] = this.insumoReceta;
        data["formulaInsumoUnd"] = this.formulaInsumoUnd;
        data["formulaInsumoCantidad"] = this.formulaInsumoCantidad;
        data["formulaInsumoActivo"] = this.formulaInsumoActivo;
        data["formulaInsumoHeredado"] = this.formulaInsumoHeredado;
        return data;
    }
}

export interface IFormulaFormulaInsumo {
    formulaId?: string;
    formulaInsumoId?: string;
    insumoNombre?: string;
    insumoProductoCosto?: number;
    insumoReceta?: number;
    formulaInsumoUnd?: string;
    formulaInsumoCantidad?: number | undefined;
    formulaInsumoActivo?: boolean | undefined;
    formulaInsumoHeredado?: boolean | undefined;
}

export class FormulaPT implements IFormulaPT {
    formulaId?: string;
    formulaProductoId?: string;
    productoNombre?: string | undefined;
    formulaPTCantidad?: number;
    formulaPTFactor?: number;

    constructor(data?: IFormulaPT) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formulaId = _data["formulaId"];
            this.formulaProductoId = _data["formulaProductoId"];
            this.productoNombre = _data["productoNombre"];
            this.formulaPTCantidad = _data["formulaPTCantidad"];
            this.formulaPTFactor = _data["formulaPTFactor"];
        }
    }

    static fromJS(data: any): FormulaPT {
        data = typeof data === 'object' ? data : {};
        let result = new FormulaPT();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formulaId"] = this.formulaId;
        data["formulaProductoId"] = this.formulaProductoId;
        data["productoNombre"] = this.productoNombre;
        data["formulaPTCantidad"] = this.formulaPTCantidad;
        data["formulaPTFactor"] = this.formulaPTFactor;
        return data;
    }
}

export interface IFormulaPT {
    formulaId?: string;
    formulaProductoId?: string;
    productoNombre?: string | undefined;
    formulaPTCantidad?: number;
    formulaPTFactor?: number;
}

export class DistribucionCostoResponse implements IDistribucionCostoResponse {
    distribucionPorCentroCosto?: DistribucionPorCentroCostoDto[];
    distribucionPorProducto?: DistribucionPorProductoDto[];

    constructor(data?: IDistribucionCostoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["distribucionPorCentroCosto"])) {
                this.distribucionPorCentroCosto = [] as any;
                for (let item of _data["distribucionPorCentroCosto"])
                    this.distribucionPorCentroCosto!.push(DistribucionPorCentroCostoDto.fromJS(item));
            }
            if (Array.isArray(_data["distribucionPorProducto"])) {
                this.distribucionPorProducto = [] as any;
                for (let item of _data["distribucionPorProducto"])
                    this.distribucionPorProducto!.push(DistribucionPorProductoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DistribucionCostoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DistribucionCostoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.distribucionPorCentroCosto)) {
            data["distribucionPorCentroCosto"] = [];
            for (let item of this.distribucionPorCentroCosto)
                data["distribucionPorCentroCosto"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.distribucionPorProducto)) {
            data["distribucionPorProducto"] = [];
            for (let item of this.distribucionPorProducto)
                data["distribucionPorProducto"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDistribucionCostoResponse {
    distribucionPorCentroCosto?: DistribucionPorCentroCostoDto[];
    distribucionPorProducto?: DistribucionPorProductoDto[];
}

export class DistribucionPorCentroCostoDto implements IDistribucionPorCentroCostoDto {
    centroCostoId?: number;
    centroCostoNombre?: string;
    litrosProcesados?: number;
    porcentaje?: number;
    totalMOEstandar?: number;
    totalMORegistrada?: number;
    totalCIFRegistrado?: number;
    totalMOInteresGeneral?: number;
    totalCIFInteresGeneral?: number;

    constructor(data?: IDistribucionPorCentroCostoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.centroCostoId = _data["centroCostoId"];
            this.centroCostoNombre = _data["centroCostoNombre"];
            this.litrosProcesados = _data["litrosProcesados"];
            this.porcentaje = _data["porcentaje"];
            this.totalMOEstandar = _data["totalMOEstandar"];
            this.totalMORegistrada = _data["totalMORegistrada"];
            this.totalCIFRegistrado = _data["totalCIFRegistrado"];
            this.totalMOInteresGeneral = _data["totalMOInteresGeneral"];
            this.totalCIFInteresGeneral = _data["totalCIFInteresGeneral"];
        }
    }

    static fromJS(data: any): DistribucionPorCentroCostoDto {
        data = typeof data === 'object' ? data : {};
        let result = new DistribucionPorCentroCostoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["centroCostoId"] = this.centroCostoId;
        data["centroCostoNombre"] = this.centroCostoNombre;
        data["litrosProcesados"] = this.litrosProcesados;
        data["porcentaje"] = this.porcentaje;
        data["totalMOEstandar"] = this.totalMOEstandar;
        data["totalMORegistrada"] = this.totalMORegistrada;
        data["totalCIFRegistrado"] = this.totalCIFRegistrado;
        data["totalMOInteresGeneral"] = this.totalMOInteresGeneral;
        data["totalCIFInteresGeneral"] = this.totalCIFInteresGeneral;
        return data;
    }
}

export interface IDistribucionPorCentroCostoDto {
    centroCostoId?: number;
    centroCostoNombre?: string;
    litrosProcesados?: number;
    porcentaje?: number;
    totalMOEstandar?: number;
    totalMORegistrada?: number;
    totalCIFRegistrado?: number;
    totalMOInteresGeneral?: number;
    totalCIFInteresGeneral?: number;
}

export class DistribucionPorProductoDto implements IDistribucionPorProductoDto {
    centroCostoNombre?: string;
    formulaId?: string;
    formulaNombre?: string;
    undsProducidas?: number;
    litroStd?: number;
    litrosProcesados?: number;
    formulaMOStd?: number;
    moTotalStd?: number;
    moVrUnitario?: number;
    moCentroCosto?: number;
    formulaCIFStd?: number;
    cifTotalStd?: number;
    cifVrUnitario?: number;
    cifTotalMes?: number;

    constructor(data?: IDistribucionPorProductoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.centroCostoNombre = _data["centroCostoNombre"];
            this.formulaId = _data["formulaId"];
            this.formulaNombre = _data["formulaNombre"];
            this.undsProducidas = _data["undsProducidas"];
            this.litroStd = _data["litroStd"];
            this.litrosProcesados = _data["litrosProcesados"];
            this.formulaMOStd = _data["formulaMOStd"];
            this.moTotalStd = _data["moTotalStd"];
            this.moVrUnitario = _data["moVrUnitario"];
            this.moCentroCosto = _data["moCentroCosto"];
            this.formulaCIFStd = _data["formulaCIFStd"];
            this.cifTotalStd = _data["cifTotalStd"];
            this.cifVrUnitario = _data["cifVrUnitario"];
            this.cifTotalMes = _data["cifTotalMes"];
        }
    }

    static fromJS(data: any): DistribucionPorProductoDto {
        data = typeof data === 'object' ? data : {};
        let result = new DistribucionPorProductoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["centroCostoNombre"] = this.centroCostoNombre;
        data["formulaId"] = this.formulaId;
        data["formulaNombre"] = this.formulaNombre;
        data["undsProducidas"] = this.undsProducidas;
        data["litroStd"] = this.litroStd;
        data["litrosProcesados"] = this.litrosProcesados;
        data["formulaMOStd"] = this.formulaMOStd;
        data["moTotalStd"] = this.moTotalStd;
        data["moVrUnitario"] = this.moVrUnitario;
        data["moCentroCosto"] = this.moCentroCosto;
        data["formulaCIFStd"] = this.formulaCIFStd;
        data["cifTotalStd"] = this.cifTotalStd;
        data["cifVrUnitario"] = this.cifVrUnitario;
        data["cifTotalMes"] = this.cifTotalMes;
        return data;
    }
}

export interface IDistribucionPorProductoDto {
    centroCostoNombre?: string;
    formulaId?: string;
    formulaNombre?: string;
    undsProducidas?: number;
    litroStd?: number;
    litrosProcesados?: number;
    formulaMOStd?: number;
    moTotalStd?: number;
    moVrUnitario?: number;
    moCentroCosto?: number;
    formulaCIFStd?: number;
    cifTotalStd?: number;
    cifVrUnitario?: number;
    cifTotalMes?: number;
}

export class DistribucionCostoRequest implements IDistribucionCostoRequest {
    mes?: number;
    ano?: number;
    moPucId?: string;
    cifPucId?: string;
    insumoId?: string;

    constructor(data?: IDistribucionCostoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mes = _data["mes"];
            this.ano = _data["ano"];
            this.moPucId = _data["moPucId"];
            this.cifPucId = _data["cifPucId"];
            this.insumoId = _data["insumoId"];
        }
    }

    static fromJS(data: any): DistribucionCostoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DistribucionCostoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mes"] = this.mes;
        data["ano"] = this.ano;
        data["moPucId"] = this.moPucId;
        data["cifPucId"] = this.cifPucId;
        data["insumoId"] = this.insumoId;
        return data;
    }
}

export interface IDistribucionCostoRequest {
    mes?: number;
    ano?: number;
    moPucId?: string;
    cifPucId?: string;
    insumoId?: string;
}

export class InsumoEquivalencia implements IInsumoEquivalencia {
    productoId?: string;
    insumoUndEquivalente?: string;
    insumoEquivalencia1?: number;

    constructor(data?: IInsumoEquivalencia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productoId = _data["productoId"];
            this.insumoUndEquivalente = _data["insumoUndEquivalente"];
            this.insumoEquivalencia1 = _data["insumoEquivalencia1"];
        }
    }

    static fromJS(data: any): InsumoEquivalencia {
        data = typeof data === 'object' ? data : {};
        let result = new InsumoEquivalencia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productoId"] = this.productoId;
        data["insumoUndEquivalente"] = this.insumoUndEquivalente;
        data["insumoEquivalencia1"] = this.insumoEquivalencia1;
        return data;
    }
}

export interface IInsumoEquivalencia {
    productoId?: string;
    insumoUndEquivalente?: string;
    insumoEquivalencia1?: number;
}

export class PagingOfFuenteKardex implements IPagingOfFuenteKardex {
    count?: number;
    data?: FuenteKardex[];

    constructor(data?: IPagingOfFuenteKardex) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FuenteKardex.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfFuenteKardex {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfFuenteKardex();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfFuenteKardex {
    count?: number;
    data?: FuenteKardex[];
}

export class FuenteKardex implements IFuenteKardex {
    fuenteKardexId?: string;
    fuenteKardexTipo?: string;
    fuenteKardexContab?: boolean;
    fuenteKardexAfectaPromedio?: boolean;
    fuenteKardexAccesoLogico?: boolean;
    fuenteKardexCtaDebito?: string;
    fuenteKardexCtaCredito?: string;
    fuenteKardexOrdenReproceso?: number;
    fuenteKardexDescContable?: string;
    fuenteKardexReqCentroCostos?: boolean;
    fuenteKardexReqOrdenProduccion?: boolean;
    fuenteKardexActiva?: boolean;
    fuenteKardexDescripcion?: string;
    fuenteKardexSistema?: boolean;
    fuenteKardexReqTercero?: boolean;
    fuenteKardexReqBodegaAux?: boolean;
    fuenteKardexImprimeCosto?: boolean;
    fuenteKardexCategoria?: string | undefined;
    fuenteKardexReqCliente?: boolean;
    fuenteKardexManejoIPC?: boolean | undefined;
    fuenteKardexReqAprobacion?: number | undefined;

    constructor(data?: IFuenteKardex) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuenteKardexId = _data["fuenteKardexId"];
            this.fuenteKardexTipo = _data["fuenteKardexTipo"];
            this.fuenteKardexContab = _data["fuenteKardexContab"];
            this.fuenteKardexAfectaPromedio = _data["fuenteKardexAfectaPromedio"];
            this.fuenteKardexAccesoLogico = _data["fuenteKardexAccesoLogico"];
            this.fuenteKardexCtaDebito = _data["fuenteKardexCtaDebito"];
            this.fuenteKardexCtaCredito = _data["fuenteKardexCtaCredito"];
            this.fuenteKardexOrdenReproceso = _data["fuenteKardexOrdenReproceso"];
            this.fuenteKardexDescContable = _data["fuenteKardexDescContable"];
            this.fuenteKardexReqCentroCostos = _data["fuenteKardexReqCentroCostos"];
            this.fuenteKardexReqOrdenProduccion = _data["fuenteKardexReqOrdenProduccion"];
            this.fuenteKardexActiva = _data["fuenteKardexActiva"];
            this.fuenteKardexDescripcion = _data["fuenteKardexDescripcion"];
            this.fuenteKardexSistema = _data["fuenteKardexSistema"];
            this.fuenteKardexReqTercero = _data["fuenteKardexReqTercero"];
            this.fuenteKardexReqBodegaAux = _data["fuenteKardexReqBodegaAux"];
            this.fuenteKardexImprimeCosto = _data["fuenteKardexImprimeCosto"];
            this.fuenteKardexCategoria = _data["fuenteKardexCategoria"];
            this.fuenteKardexReqCliente = _data["fuenteKardexReqCliente"];
            this.fuenteKardexManejoIPC = _data["fuenteKardexManejoIPC"];
            this.fuenteKardexReqAprobacion = _data["fuenteKardexReqAprobacion"];
        }
    }

    static fromJS(data: any): FuenteKardex {
        data = typeof data === 'object' ? data : {};
        let result = new FuenteKardex();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuenteKardexId"] = this.fuenteKardexId;
        data["fuenteKardexTipo"] = this.fuenteKardexTipo;
        data["fuenteKardexContab"] = this.fuenteKardexContab;
        data["fuenteKardexAfectaPromedio"] = this.fuenteKardexAfectaPromedio;
        data["fuenteKardexAccesoLogico"] = this.fuenteKardexAccesoLogico;
        data["fuenteKardexCtaDebito"] = this.fuenteKardexCtaDebito;
        data["fuenteKardexCtaCredito"] = this.fuenteKardexCtaCredito;
        data["fuenteKardexOrdenReproceso"] = this.fuenteKardexOrdenReproceso;
        data["fuenteKardexDescContable"] = this.fuenteKardexDescContable;
        data["fuenteKardexReqCentroCostos"] = this.fuenteKardexReqCentroCostos;
        data["fuenteKardexReqOrdenProduccion"] = this.fuenteKardexReqOrdenProduccion;
        data["fuenteKardexActiva"] = this.fuenteKardexActiva;
        data["fuenteKardexDescripcion"] = this.fuenteKardexDescripcion;
        data["fuenteKardexSistema"] = this.fuenteKardexSistema;
        data["fuenteKardexReqTercero"] = this.fuenteKardexReqTercero;
        data["fuenteKardexReqBodegaAux"] = this.fuenteKardexReqBodegaAux;
        data["fuenteKardexImprimeCosto"] = this.fuenteKardexImprimeCosto;
        data["fuenteKardexCategoria"] = this.fuenteKardexCategoria;
        data["fuenteKardexReqCliente"] = this.fuenteKardexReqCliente;
        data["fuenteKardexManejoIPC"] = this.fuenteKardexManejoIPC;
        data["fuenteKardexReqAprobacion"] = this.fuenteKardexReqAprobacion;
        return data;
    }
}

export interface IFuenteKardex {
    fuenteKardexId?: string;
    fuenteKardexTipo?: string;
    fuenteKardexContab?: boolean;
    fuenteKardexAfectaPromedio?: boolean;
    fuenteKardexAccesoLogico?: boolean;
    fuenteKardexCtaDebito?: string;
    fuenteKardexCtaCredito?: string;
    fuenteKardexOrdenReproceso?: number;
    fuenteKardexDescContable?: string;
    fuenteKardexReqCentroCostos?: boolean;
    fuenteKardexReqOrdenProduccion?: boolean;
    fuenteKardexActiva?: boolean;
    fuenteKardexDescripcion?: string;
    fuenteKardexSistema?: boolean;
    fuenteKardexReqTercero?: boolean;
    fuenteKardexReqBodegaAux?: boolean;
    fuenteKardexImprimeCosto?: boolean;
    fuenteKardexCategoria?: string | undefined;
    fuenteKardexReqCliente?: boolean;
    fuenteKardexManejoIPC?: boolean | undefined;
    fuenteKardexReqAprobacion?: number | undefined;
}

export class PagingOfInbox implements IPagingOfInbox {
    count?: number;
    data?: Inbox[];

    constructor(data?: IPagingOfInbox) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Inbox.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfInbox {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfInbox();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfInbox {
    count?: number;
    data?: Inbox[];
}

export class Inbox implements IInbox {
    inboxId?: number;
    inboxTipo?: string;
    inboxDescripcion?: string;
    inboxParametros?: string;
    inboxDatetime?: Date;
    inboxEstado?: number;
    inboxCreadoPor?: string;
    inboxAsignadoA?: string;
    inboxDocNo?: string | undefined;
    inboxDocOC?: string | undefined;
    inboxPDF?: string | undefined;
    inboxDocArco?: string | undefined;
    inboxCUFE?: string | undefined;
    inboxVrPagar?: number | undefined;
    inboxExtComId?: number | undefined;
    inboxEventoDIAN?: string | undefined;

    constructor(data?: IInbox) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inboxId = _data["inboxId"];
            this.inboxTipo = _data["inboxTipo"];
            this.inboxDescripcion = _data["inboxDescripcion"];
            this.inboxParametros = _data["inboxParametros"];
            this.inboxDatetime = _data["inboxDatetime"] ? new Date(_data["inboxDatetime"].toString()) : undefined as any;
            this.inboxEstado = _data["inboxEstado"];
            this.inboxCreadoPor = _data["inboxCreadoPor"];
            this.inboxAsignadoA = _data["inboxAsignadoA"];
            this.inboxDocNo = _data["inboxDocNo"];
            this.inboxDocOC = _data["inboxDocOC"];
            this.inboxPDF = _data["inboxPDF"];
            this.inboxDocArco = _data["inboxDocArco"];
            this.inboxCUFE = _data["inboxCUFE"];
            this.inboxVrPagar = _data["inboxVrPagar"];
            this.inboxExtComId = _data["inboxExtComId"];
            this.inboxEventoDIAN = _data["inboxEventoDIAN"];
        }
    }

    static fromJS(data: any): Inbox {
        data = typeof data === 'object' ? data : {};
        let result = new Inbox();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inboxId"] = this.inboxId;
        data["inboxTipo"] = this.inboxTipo;
        data["inboxDescripcion"] = this.inboxDescripcion;
        data["inboxParametros"] = this.inboxParametros;
        data["inboxDatetime"] = this.inboxDatetime ? this.inboxDatetime.toISOString() : undefined as any;
        data["inboxEstado"] = this.inboxEstado;
        data["inboxCreadoPor"] = this.inboxCreadoPor;
        data["inboxAsignadoA"] = this.inboxAsignadoA;
        data["inboxDocNo"] = this.inboxDocNo;
        data["inboxDocOC"] = this.inboxDocOC;
        data["inboxPDF"] = this.inboxPDF;
        data["inboxDocArco"] = this.inboxDocArco;
        data["inboxCUFE"] = this.inboxCUFE;
        data["inboxVrPagar"] = this.inboxVrPagar;
        data["inboxExtComId"] = this.inboxExtComId;
        data["inboxEventoDIAN"] = this.inboxEventoDIAN;
        return data;
    }
}

export interface IInbox {
    inboxId?: number;
    inboxTipo?: string;
    inboxDescripcion?: string;
    inboxParametros?: string;
    inboxDatetime?: Date;
    inboxEstado?: number;
    inboxCreadoPor?: string;
    inboxAsignadoA?: string;
    inboxDocNo?: string | undefined;
    inboxDocOC?: string | undefined;
    inboxPDF?: string | undefined;
    inboxDocArco?: string | undefined;
    inboxCUFE?: string | undefined;
    inboxVrPagar?: number | undefined;
    inboxExtComId?: number | undefined;
    inboxEventoDIAN?: string | undefined;
}

export class PagingOfInsumoDto implements IPagingOfInsumoDto {
    count?: number;
    data?: InsumoDto[];

    constructor(data?: IPagingOfInsumoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(InsumoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfInsumoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfInsumoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfInsumoDto {
    count?: number;
    data?: InsumoDto[];
}

export class InsumoDto implements IInsumoDto {
    productoId?: string;
    productoNombre?: string;
    insumoTipo?: string | undefined;
    insumoUnidad?: string | undefined;
    insumoStockMinimo?: number | undefined;
    insumoStockMaximo?: number | undefined;
    insumoValorUltimaCompra?: number | undefined;
    insumoValorPromedio?: number | undefined;
    insumoFormulable?: boolean | undefined;
    productoGrupoContable?: number | undefined;
    productoLineaId?: number | undefined;
    productoMarcaId?: number | undefined;
    productoFormulaId?: string | undefined;
    productoCosto?: number;
    insumoCategoriaId?: number | undefined;
    insumoCategoria?: string | undefined;
    productoPeso?: number | undefined;
    productoEstado?: string | undefined;
    productoOrigen?: string | undefined;
    productoManejo?: string | undefined;
    productoImpuestoId?: string | undefined;
    productoPadreId?: string | undefined;
    concGastoPucId?: string | undefined;
    productoReteRentaId?: number | undefined;
    productoLineaN2Id?: number | undefined;
    productoLineaN3Id?: number | undefined;
    productoManejaKardex?: boolean | undefined;
    equivalencias?: InsumoEquivalenciaDto[] | undefined;
    extData?: ExtData[] | undefined;

    constructor(data?: IInsumoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productoId = _data["productoId"];
            this.productoNombre = _data["productoNombre"];
            this.insumoTipo = _data["insumoTipo"];
            this.insumoUnidad = _data["insumoUnidad"];
            this.insumoStockMinimo = _data["insumoStockMinimo"];
            this.insumoStockMaximo = _data["insumoStockMaximo"];
            this.insumoValorUltimaCompra = _data["insumoValorUltimaCompra"];
            this.insumoValorPromedio = _data["insumoValorPromedio"];
            this.insumoFormulable = _data["insumoFormulable"];
            this.productoGrupoContable = _data["productoGrupoContable"];
            this.productoLineaId = _data["productoLineaId"];
            this.productoMarcaId = _data["productoMarcaId"];
            this.productoFormulaId = _data["productoFormulaId"];
            this.productoCosto = _data["productoCosto"];
            this.insumoCategoriaId = _data["insumoCategoriaId"];
            this.insumoCategoria = _data["insumoCategoria"];
            this.productoPeso = _data["productoPeso"];
            this.productoEstado = _data["productoEstado"];
            this.productoOrigen = _data["productoOrigen"];
            this.productoManejo = _data["productoManejo"];
            this.productoImpuestoId = _data["productoImpuestoId"];
            this.productoPadreId = _data["productoPadreId"];
            this.concGastoPucId = _data["concGastoPucId"];
            this.productoReteRentaId = _data["productoReteRentaId"];
            this.productoLineaN2Id = _data["productoLineaN2Id"];
            this.productoLineaN3Id = _data["productoLineaN3Id"];
            this.productoManejaKardex = _data["productoManejaKardex"];
            if (Array.isArray(_data["equivalencias"])) {
                this.equivalencias = [] as any;
                for (let item of _data["equivalencias"])
                    this.equivalencias!.push(InsumoEquivalenciaDto.fromJS(item));
            }
            if (Array.isArray(_data["extData"])) {
                this.extData = [] as any;
                for (let item of _data["extData"])
                    this.extData!.push(ExtData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsumoDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsumoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productoId"] = this.productoId;
        data["productoNombre"] = this.productoNombre;
        data["insumoTipo"] = this.insumoTipo;
        data["insumoUnidad"] = this.insumoUnidad;
        data["insumoStockMinimo"] = this.insumoStockMinimo;
        data["insumoStockMaximo"] = this.insumoStockMaximo;
        data["insumoValorUltimaCompra"] = this.insumoValorUltimaCompra;
        data["insumoValorPromedio"] = this.insumoValorPromedio;
        data["insumoFormulable"] = this.insumoFormulable;
        data["productoGrupoContable"] = this.productoGrupoContable;
        data["productoLineaId"] = this.productoLineaId;
        data["productoMarcaId"] = this.productoMarcaId;
        data["productoFormulaId"] = this.productoFormulaId;
        data["productoCosto"] = this.productoCosto;
        data["insumoCategoriaId"] = this.insumoCategoriaId;
        data["insumoCategoria"] = this.insumoCategoria;
        data["productoPeso"] = this.productoPeso;
        data["productoEstado"] = this.productoEstado;
        data["productoOrigen"] = this.productoOrigen;
        data["productoManejo"] = this.productoManejo;
        data["productoImpuestoId"] = this.productoImpuestoId;
        data["productoPadreId"] = this.productoPadreId;
        data["concGastoPucId"] = this.concGastoPucId;
        data["productoReteRentaId"] = this.productoReteRentaId;
        data["productoLineaN2Id"] = this.productoLineaN2Id;
        data["productoLineaN3Id"] = this.productoLineaN3Id;
        data["productoManejaKardex"] = this.productoManejaKardex;
        if (Array.isArray(this.equivalencias)) {
            data["equivalencias"] = [];
            for (let item of this.equivalencias)
                data["equivalencias"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.extData)) {
            data["extData"] = [];
            for (let item of this.extData)
                data["extData"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsumoDto {
    productoId?: string;
    productoNombre?: string;
    insumoTipo?: string | undefined;
    insumoUnidad?: string | undefined;
    insumoStockMinimo?: number | undefined;
    insumoStockMaximo?: number | undefined;
    insumoValorUltimaCompra?: number | undefined;
    insumoValorPromedio?: number | undefined;
    insumoFormulable?: boolean | undefined;
    productoGrupoContable?: number | undefined;
    productoLineaId?: number | undefined;
    productoMarcaId?: number | undefined;
    productoFormulaId?: string | undefined;
    productoCosto?: number;
    insumoCategoriaId?: number | undefined;
    insumoCategoria?: string | undefined;
    productoPeso?: number | undefined;
    productoEstado?: string | undefined;
    productoOrigen?: string | undefined;
    productoManejo?: string | undefined;
    productoImpuestoId?: string | undefined;
    productoPadreId?: string | undefined;
    concGastoPucId?: string | undefined;
    productoReteRentaId?: number | undefined;
    productoLineaN2Id?: number | undefined;
    productoLineaN3Id?: number | undefined;
    productoManejaKardex?: boolean | undefined;
    equivalencias?: InsumoEquivalenciaDto[] | undefined;
    extData?: ExtData[] | undefined;
}

export class InsumoEquivalenciaDto implements IInsumoEquivalenciaDto {
    insumoUndEquivalente?: string;
    insumoEquivalencia?: number;

    constructor(data?: IInsumoEquivalenciaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.insumoUndEquivalente = _data["insumoUndEquivalente"];
            this.insumoEquivalencia = _data["insumoEquivalencia"];
        }
    }

    static fromJS(data: any): InsumoEquivalenciaDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsumoEquivalenciaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insumoUndEquivalente"] = this.insumoUndEquivalente;
        data["insumoEquivalencia"] = this.insumoEquivalencia;
        return data;
    }
}

export interface IInsumoEquivalenciaDto {
    insumoUndEquivalente?: string;
    insumoEquivalencia?: number;
}

export class ExtData implements IExtData {
    extFieldId?: number;
    extDataValue?: string;
    extFieldName?: string | undefined;

    constructor(data?: IExtData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extFieldId = _data["extFieldId"];
            this.extDataValue = _data["extDataValue"];
            this.extFieldName = _data["extFieldName"];
        }
    }

    static fromJS(data: any): ExtData {
        data = typeof data === 'object' ? data : {};
        let result = new ExtData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extFieldId"] = this.extFieldId;
        data["extDataValue"] = this.extDataValue;
        data["extFieldName"] = this.extFieldName;
        return data;
    }
}

export interface IExtData {
    extFieldId?: number;
    extDataValue?: string;
    extFieldName?: string | undefined;
}

export class JobListEntry implements IJobListEntry {
    jobId?: string;
    state?: JobState;

    constructor(data?: IJobListEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.state = _data["state"] ? JobState.fromJS(_data["state"]) : undefined as any;
        }
    }

    static fromJS(data: any): JobListEntry {
        data = typeof data === 'object' ? data : {};
        let result = new JobListEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["state"] = this.state ? this.state.toJSON() : undefined as any;
        return data;
    }
}

export interface IJobListEntry {
    jobId?: string;
    state?: JobState;
}

export class JobState implements IJobState {
    name?: string | undefined;
    status?: JobStatus;
    progress?: JobProgress | undefined;
    result?: any | undefined;
    error?: string | undefined;
    createdAt?: Date;

    constructor(data?: IJobState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.status = _data["status"];
            this.progress = _data["progress"] ? JobProgress.fromJS(_data["progress"]) : undefined as any;
            this.result = _data["result"];
            this.error = _data["error"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): JobState {
        data = typeof data === 'object' ? data : {};
        let result = new JobState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["status"] = this.status;
        data["progress"] = this.progress ? this.progress.toJSON() : undefined as any;
        data["result"] = this.result;
        data["error"] = this.error;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IJobState {
    name?: string | undefined;
    status?: JobStatus;
    progress?: JobProgress | undefined;
    result?: any | undefined;
    error?: string | undefined;
    createdAt?: Date;
}

export enum JobStatus {
    Pending = 0,
    Running = 1,
    Completed = 2,
    Failed = 3,
}

export class JobProgress implements IJobProgress {
    current?: number;
    total?: number;
    message?: string | undefined;

    constructor(data?: IJobProgress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.current = _data["current"];
            this.total = _data["total"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): JobProgress {
        data = typeof data === 'object' ? data : {};
        let result = new JobProgress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["total"] = this.total;
        data["message"] = this.message;
        return data;
    }
}

export interface IJobProgress {
    current?: number;
    total?: number;
    message?: string | undefined;
}

export class PagingOfKardex implements IPagingOfKardex {
    count?: number;
    data?: Kardex[];

    constructor(data?: IPagingOfKardex) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Kardex.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfKardex {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfKardex();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfKardex {
    count?: number;
    data?: Kardex[];
}

export class Kardex implements IKardex {
    kardexId?: number;
    kardexId2?: string;
    fuenteKardexId?: string;
    kardexFecha?: Date;
    kardexDescripcion?: string;
    kardexDetalleItems?: number;
    kardexEstado?: string;
    kardexNotas?: string;
    kardexRegConId?: number | undefined;
    kardexPrefijo?: string;
    kardexNumero?: number;
    kardexDocumentoId?: number | undefined;
    kardexTerceroId?: number | undefined;
    kardexClienteId?: number | undefined;
    kardexUser?: string | undefined;
    kardexInsHr?: Date | undefined;
    kardexProperties?: string | undefined;
    kardexBodegaDestinoId?: string | undefined;
    kardexBodegaOrigenId?: string | undefined;
    kardexTerceroNombre?: string | undefined;
    kardexTerceroNIT?: string | undefined;
    kardexClienteNombre?: string | undefined;
    kardexClienteZonaId?: number | undefined;
    kardexClienteZona?: string | undefined;
    kardexBodegaDestinoNombre?: string | undefined;
    kardexBodegaOrigenNombre?: string | undefined;
    kardexDocPrefijo?: string | undefined;
    producto?: KardexProducto[];

    constructor(data?: IKardex) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kardexId = _data["kardexId"];
            this.kardexId2 = _data["kardexId2"];
            this.fuenteKardexId = _data["fuenteKardexId"];
            this.kardexFecha = _data["kardexFecha"] ? new Date(_data["kardexFecha"].toString()) : undefined as any;
            this.kardexDescripcion = _data["kardexDescripcion"];
            this.kardexDetalleItems = _data["kardexDetalleItems"];
            this.kardexEstado = _data["kardexEstado"];
            this.kardexNotas = _data["kardexNotas"];
            this.kardexRegConId = _data["kardexRegConId"];
            this.kardexPrefijo = _data["kardexPrefijo"];
            this.kardexNumero = _data["kardexNumero"];
            this.kardexDocumentoId = _data["kardexDocumentoId"];
            this.kardexTerceroId = _data["kardexTerceroId"];
            this.kardexClienteId = _data["kardexClienteId"];
            this.kardexUser = _data["kardexUser"];
            this.kardexInsHr = _data["kardexInsHr"] ? new Date(_data["kardexInsHr"].toString()) : undefined as any;
            this.kardexProperties = _data["kardexProperties"];
            this.kardexBodegaDestinoId = _data["kardexBodegaDestinoId"];
            this.kardexBodegaOrigenId = _data["kardexBodegaOrigenId"];
            this.kardexTerceroNombre = _data["kardexTerceroNombre"];
            this.kardexTerceroNIT = _data["kardexTerceroNIT"];
            this.kardexClienteNombre = _data["kardexClienteNombre"];
            this.kardexClienteZonaId = _data["kardexClienteZonaId"];
            this.kardexClienteZona = _data["kardexClienteZona"];
            this.kardexBodegaDestinoNombre = _data["kardexBodegaDestinoNombre"];
            this.kardexBodegaOrigenNombre = _data["kardexBodegaOrigenNombre"];
            this.kardexDocPrefijo = _data["kardexDocPrefijo"];
            if (Array.isArray(_data["producto"])) {
                this.producto = [] as any;
                for (let item of _data["producto"])
                    this.producto!.push(KardexProducto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Kardex {
        data = typeof data === 'object' ? data : {};
        let result = new Kardex();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kardexId"] = this.kardexId;
        data["kardexId2"] = this.kardexId2;
        data["fuenteKardexId"] = this.fuenteKardexId;
        data["kardexFecha"] = this.kardexFecha ? this.kardexFecha.toISOString() : undefined as any;
        data["kardexDescripcion"] = this.kardexDescripcion;
        data["kardexDetalleItems"] = this.kardexDetalleItems;
        data["kardexEstado"] = this.kardexEstado;
        data["kardexNotas"] = this.kardexNotas;
        data["kardexRegConId"] = this.kardexRegConId;
        data["kardexPrefijo"] = this.kardexPrefijo;
        data["kardexNumero"] = this.kardexNumero;
        data["kardexDocumentoId"] = this.kardexDocumentoId;
        data["kardexTerceroId"] = this.kardexTerceroId;
        data["kardexClienteId"] = this.kardexClienteId;
        data["kardexUser"] = this.kardexUser;
        data["kardexInsHr"] = this.kardexInsHr ? this.kardexInsHr.toISOString() : undefined as any;
        data["kardexProperties"] = this.kardexProperties;
        data["kardexBodegaDestinoId"] = this.kardexBodegaDestinoId;
        data["kardexBodegaOrigenId"] = this.kardexBodegaOrigenId;
        data["kardexTerceroNombre"] = this.kardexTerceroNombre;
        data["kardexTerceroNIT"] = this.kardexTerceroNIT;
        data["kardexClienteNombre"] = this.kardexClienteNombre;
        data["kardexClienteZonaId"] = this.kardexClienteZonaId;
        data["kardexClienteZona"] = this.kardexClienteZona;
        data["kardexBodegaDestinoNombre"] = this.kardexBodegaDestinoNombre;
        data["kardexBodegaOrigenNombre"] = this.kardexBodegaOrigenNombre;
        data["kardexDocPrefijo"] = this.kardexDocPrefijo;
        if (Array.isArray(this.producto)) {
            data["producto"] = [];
            for (let item of this.producto)
                data["producto"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IKardex {
    kardexId?: number;
    kardexId2?: string;
    fuenteKardexId?: string;
    kardexFecha?: Date;
    kardexDescripcion?: string;
    kardexDetalleItems?: number;
    kardexEstado?: string;
    kardexNotas?: string;
    kardexRegConId?: number | undefined;
    kardexPrefijo?: string;
    kardexNumero?: number;
    kardexDocumentoId?: number | undefined;
    kardexTerceroId?: number | undefined;
    kardexClienteId?: number | undefined;
    kardexUser?: string | undefined;
    kardexInsHr?: Date | undefined;
    kardexProperties?: string | undefined;
    kardexBodegaDestinoId?: string | undefined;
    kardexBodegaOrigenId?: string | undefined;
    kardexTerceroNombre?: string | undefined;
    kardexTerceroNIT?: string | undefined;
    kardexClienteNombre?: string | undefined;
    kardexClienteZonaId?: number | undefined;
    kardexClienteZona?: string | undefined;
    kardexBodegaDestinoNombre?: string | undefined;
    kardexBodegaOrigenNombre?: string | undefined;
    kardexDocPrefijo?: string | undefined;
    producto?: KardexProducto[];
}

export class KardexProducto implements IKardexProducto {
    kardexId?: number;
    kardexItem?: number;
    productoId?: string;
    kardexProductoEntradas?: number;
    kardexProductoSalidas?: number;
    kardexProductoValorUnitario?: number;
    kardexBodegaId?: string;
    kardexPucId?: string | undefined;
    kardexCentroCostoId?: number | undefined;
    loteId?: number | undefined;
    loteNo?: string;
    loteFecha?: Date;
    kardexLoteNo?: string | undefined;
    kardexLoteFecha?: Date | undefined;
    kardexProductoPrecio?: number | undefined;
    kardexProductoSubCCId?: string | undefined;
    kardexDetalleTotalPC?: number | undefined;
    productoNombre?: string | undefined;
    productoManejo?: string | undefined;
    productoOrigen?: string | undefined;
    insumoUnidad?: string | undefined;
    productoGrupoContable?: number | undefined;
    productoImpuestoId?: string | undefined;
    productoImpuestoPOrcentaje?: number | undefined;
    kardexBodegaNombre?: string | undefined;
    kardexBodegaEstado?: string | undefined;
    kardexCentroCostosNombre?: string | undefined;
    kardexProductoSubCCNombre?: string | undefined;
    kardexVrTotal?: number;

    constructor(data?: IKardexProducto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kardexId = _data["kardexId"];
            this.kardexItem = _data["kardexItem"];
            this.productoId = _data["productoId"];
            this.kardexProductoEntradas = _data["kardexProductoEntradas"];
            this.kardexProductoSalidas = _data["kardexProductoSalidas"];
            this.kardexProductoValorUnitario = _data["kardexProductoValorUnitario"];
            this.kardexBodegaId = _data["kardexBodegaId"];
            this.kardexPucId = _data["kardexPucId"];
            this.kardexCentroCostoId = _data["kardexCentroCostoId"];
            this.loteId = _data["loteId"];
            this.loteNo = _data["loteNo"];
            this.loteFecha = _data["loteFecha"] ? new Date(_data["loteFecha"].toString()) : undefined as any;
            this.kardexLoteNo = _data["kardexLoteNo"];
            this.kardexLoteFecha = _data["kardexLoteFecha"] ? new Date(_data["kardexLoteFecha"].toString()) : undefined as any;
            this.kardexProductoPrecio = _data["kardexProductoPrecio"];
            this.kardexProductoSubCCId = _data["kardexProductoSubCCId"];
            this.kardexDetalleTotalPC = _data["kardexDetalleTotalPC"];
            this.productoNombre = _data["productoNombre"];
            this.productoManejo = _data["productoManejo"];
            this.productoOrigen = _data["productoOrigen"];
            this.insumoUnidad = _data["insumoUnidad"];
            this.productoGrupoContable = _data["productoGrupoContable"];
            this.productoImpuestoId = _data["productoImpuestoId"];
            this.productoImpuestoPOrcentaje = _data["productoImpuestoPOrcentaje"];
            this.kardexBodegaNombre = _data["kardexBodegaNombre"];
            this.kardexBodegaEstado = _data["kardexBodegaEstado"];
            this.kardexCentroCostosNombre = _data["kardexCentroCostosNombre"];
            this.kardexProductoSubCCNombre = _data["kardexProductoSubCCNombre"];
            this.kardexVrTotal = _data["kardexVrTotal"];
        }
    }

    static fromJS(data: any): KardexProducto {
        data = typeof data === 'object' ? data : {};
        let result = new KardexProducto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kardexId"] = this.kardexId;
        data["kardexItem"] = this.kardexItem;
        data["productoId"] = this.productoId;
        data["kardexProductoEntradas"] = this.kardexProductoEntradas;
        data["kardexProductoSalidas"] = this.kardexProductoSalidas;
        data["kardexProductoValorUnitario"] = this.kardexProductoValorUnitario;
        data["kardexBodegaId"] = this.kardexBodegaId;
        data["kardexPucId"] = this.kardexPucId;
        data["kardexCentroCostoId"] = this.kardexCentroCostoId;
        data["loteId"] = this.loteId;
        data["loteNo"] = this.loteNo;
        data["loteFecha"] = this.loteFecha ? this.loteFecha.toISOString() : undefined as any;
        data["kardexLoteNo"] = this.kardexLoteNo;
        data["kardexLoteFecha"] = this.kardexLoteFecha ? this.kardexLoteFecha.toISOString() : undefined as any;
        data["kardexProductoPrecio"] = this.kardexProductoPrecio;
        data["kardexProductoSubCCId"] = this.kardexProductoSubCCId;
        data["kardexDetalleTotalPC"] = this.kardexDetalleTotalPC;
        data["productoNombre"] = this.productoNombre;
        data["productoManejo"] = this.productoManejo;
        data["productoOrigen"] = this.productoOrigen;
        data["insumoUnidad"] = this.insumoUnidad;
        data["productoGrupoContable"] = this.productoGrupoContable;
        data["productoImpuestoId"] = this.productoImpuestoId;
        data["productoImpuestoPOrcentaje"] = this.productoImpuestoPOrcentaje;
        data["kardexBodegaNombre"] = this.kardexBodegaNombre;
        data["kardexBodegaEstado"] = this.kardexBodegaEstado;
        data["kardexCentroCostosNombre"] = this.kardexCentroCostosNombre;
        data["kardexProductoSubCCNombre"] = this.kardexProductoSubCCNombre;
        data["kardexVrTotal"] = this.kardexVrTotal;
        return data;
    }
}

export interface IKardexProducto {
    kardexId?: number;
    kardexItem?: number;
    productoId?: string;
    kardexProductoEntradas?: number;
    kardexProductoSalidas?: number;
    kardexProductoValorUnitario?: number;
    kardexBodegaId?: string;
    kardexPucId?: string | undefined;
    kardexCentroCostoId?: number | undefined;
    loteId?: number | undefined;
    loteNo?: string;
    loteFecha?: Date;
    kardexLoteNo?: string | undefined;
    kardexLoteFecha?: Date | undefined;
    kardexProductoPrecio?: number | undefined;
    kardexProductoSubCCId?: string | undefined;
    kardexDetalleTotalPC?: number | undefined;
    productoNombre?: string | undefined;
    productoManejo?: string | undefined;
    productoOrigen?: string | undefined;
    insumoUnidad?: string | undefined;
    productoGrupoContable?: number | undefined;
    productoImpuestoId?: string | undefined;
    productoImpuestoPOrcentaje?: number | undefined;
    kardexBodegaNombre?: string | undefined;
    kardexBodegaEstado?: string | undefined;
    kardexCentroCostosNombre?: string | undefined;
    kardexProductoSubCCNombre?: string | undefined;
    kardexVrTotal?: number;
}

export class ResponseDto2 implements IResponseDto2 {
    exists?: boolean;
    productoId?: string | undefined;
    productoNombre?: string | undefined;
    insumoUnidad?: string | undefined;
    kardexProductoValorUnitario?: number;
    productoManejo?: string | undefined;
    cantidadNegativa?: number;
    showLotes?: boolean;
    lotes?: LoteProductoItemDto[];

    constructor(data?: IResponseDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exists = _data["exists"];
            this.productoId = _data["productoId"];
            this.productoNombre = _data["productoNombre"];
            this.insumoUnidad = _data["insumoUnidad"];
            this.kardexProductoValorUnitario = _data["kardexProductoValorUnitario"];
            this.productoManejo = _data["productoManejo"];
            this.cantidadNegativa = _data["cantidadNegativa"];
            this.showLotes = _data["showLotes"];
            if (Array.isArray(_data["lotes"])) {
                this.lotes = [] as any;
                for (let item of _data["lotes"])
                    this.lotes!.push(LoteProductoItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exists"] = this.exists;
        data["productoId"] = this.productoId;
        data["productoNombre"] = this.productoNombre;
        data["insumoUnidad"] = this.insumoUnidad;
        data["kardexProductoValorUnitario"] = this.kardexProductoValorUnitario;
        data["productoManejo"] = this.productoManejo;
        data["cantidadNegativa"] = this.cantidadNegativa;
        data["showLotes"] = this.showLotes;
        if (Array.isArray(this.lotes)) {
            data["lotes"] = [];
            for (let item of this.lotes)
                data["lotes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseDto2 {
    exists?: boolean;
    productoId?: string | undefined;
    productoNombre?: string | undefined;
    insumoUnidad?: string | undefined;
    kardexProductoValorUnitario?: number;
    productoManejo?: string | undefined;
    cantidadNegativa?: number;
    showLotes?: boolean;
    lotes?: LoteProductoItemDto[];
}

export class LoteProductoItemDto implements ILoteProductoItemDto {
    loteId?: number;
    loteNo?: string;
    loteFecha?: Date;
    cantidad?: number;
    loteDescripcion?: string;

    constructor(data?: ILoteProductoItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loteId = _data["loteId"];
            this.loteNo = _data["loteNo"];
            this.loteFecha = _data["loteFecha"] ? new Date(_data["loteFecha"].toString()) : undefined as any;
            this.cantidad = _data["cantidad"];
            this.loteDescripcion = _data["loteDescripcion"];
        }
    }

    static fromJS(data: any): LoteProductoItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoteProductoItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loteId"] = this.loteId;
        data["loteNo"] = this.loteNo;
        data["loteFecha"] = this.loteFecha ? this.loteFecha.toISOString() : undefined as any;
        data["cantidad"] = this.cantidad;
        data["loteDescripcion"] = this.loteDescripcion;
        return data;
    }
}

export interface ILoteProductoItemDto {
    loteId?: number;
    loteNo?: string;
    loteFecha?: Date;
    cantidad?: number;
    loteDescripcion?: string;
}

export class ItemDto implements IItemDto {
    fuenteKardexId?: string;
    fuenteKardexDescripcion?: string;

    constructor(data?: IItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuenteKardexId = _data["fuenteKardexId"];
            this.fuenteKardexDescripcion = _data["fuenteKardexDescripcion"];
        }
    }

    static fromJS(data: any): ItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuenteKardexId"] = this.fuenteKardexId;
        data["fuenteKardexDescripcion"] = this.fuenteKardexDescripcion;
        return data;
    }
}

export interface IItemDto {
    fuenteKardexId?: string;
    fuenteKardexDescripcion?: string;
}

export class PagingOfLFile implements IPagingOfLFile {
    count?: number;
    data?: LFile[];

    constructor(data?: IPagingOfLFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LFile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfLFile {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfLFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfLFile {
    count?: number;
    data?: LFile[];
}

export class LFile implements ILFile {
    lFileId?: number;
    lFileTable?: string;
    lFileTableId?: string;
    lFilename?: string;
    lFileType?: string;
    lFileExternalId?: string;
    lFileCreationDateTime?: Date | undefined;
    lFileProvider?: number | undefined;
    lFileSizeKb?: number | undefined;
    lFileFormat?: string | undefined;
    lFileFolder?: string | undefined;

    constructor(data?: ILFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lFileId = _data["lFileId"];
            this.lFileTable = _data["lFileTable"];
            this.lFileTableId = _data["lFileTableId"];
            this.lFilename = _data["lFilename"];
            this.lFileType = _data["lFileType"];
            this.lFileExternalId = _data["lFileExternalId"];
            this.lFileCreationDateTime = _data["lFileCreationDateTime"] ? new Date(_data["lFileCreationDateTime"].toString()) : undefined as any;
            this.lFileProvider = _data["lFileProvider"];
            this.lFileSizeKb = _data["lFileSizeKb"];
            this.lFileFormat = _data["lFileFormat"];
            this.lFileFolder = _data["lFileFolder"];
        }
    }

    static fromJS(data: any): LFile {
        data = typeof data === 'object' ? data : {};
        let result = new LFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lFileId"] = this.lFileId;
        data["lFileTable"] = this.lFileTable;
        data["lFileTableId"] = this.lFileTableId;
        data["lFilename"] = this.lFilename;
        data["lFileType"] = this.lFileType;
        data["lFileExternalId"] = this.lFileExternalId;
        data["lFileCreationDateTime"] = this.lFileCreationDateTime ? this.lFileCreationDateTime.toISOString() : undefined as any;
        data["lFileProvider"] = this.lFileProvider;
        data["lFileSizeKb"] = this.lFileSizeKb;
        data["lFileFormat"] = this.lFileFormat;
        data["lFileFolder"] = this.lFileFolder;
        return data;
    }
}

export interface ILFile {
    lFileId?: number;
    lFileTable?: string;
    lFileTableId?: string;
    lFilename?: string;
    lFileType?: string;
    lFileExternalId?: string;
    lFileCreationDateTime?: Date | undefined;
    lFileProvider?: number | undefined;
    lFileSizeKb?: number | undefined;
    lFileFormat?: string | undefined;
    lFileFolder?: string | undefined;
}

export class PagingOfLineaProduccion implements IPagingOfLineaProduccion {
    count?: number;
    data?: LineaProduccion[];

    constructor(data?: IPagingOfLineaProduccion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LineaProduccion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfLineaProduccion {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfLineaProduccion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfLineaProduccion {
    count?: number;
    data?: LineaProduccion[];
}

export class LineaProduccion implements ILineaProduccion {
    lineaProduccionId?: number;
    lineaProduccion1?: string;
    lineaProduccionUnd?: string;
    lineaProduccionCapMax?: number;
    lineaProduccionEstado?: number;

    constructor(data?: ILineaProduccion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineaProduccionId = _data["lineaProduccionId"];
            this.lineaProduccion1 = _data["lineaProduccion1"];
            this.lineaProduccionUnd = _data["lineaProduccionUnd"];
            this.lineaProduccionCapMax = _data["lineaProduccionCapMax"];
            this.lineaProduccionEstado = _data["lineaProduccionEstado"];
        }
    }

    static fromJS(data: any): LineaProduccion {
        data = typeof data === 'object' ? data : {};
        let result = new LineaProduccion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineaProduccionId"] = this.lineaProduccionId;
        data["lineaProduccion1"] = this.lineaProduccion1;
        data["lineaProduccionUnd"] = this.lineaProduccionUnd;
        data["lineaProduccionCapMax"] = this.lineaProduccionCapMax;
        data["lineaProduccionEstado"] = this.lineaProduccionEstado;
        return data;
    }
}

export interface ILineaProduccion {
    lineaProduccionId?: number;
    lineaProduccion1?: string;
    lineaProduccionUnd?: string;
    lineaProduccionCapMax?: number;
    lineaProduccionEstado?: number;
}

export class PagingOfListaOpcion implements IPagingOfListaOpcion {
    count?: number;
    data?: ListaOpcion[];

    constructor(data?: IPagingOfListaOpcion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ListaOpcion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfListaOpcion {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfListaOpcion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfListaOpcion {
    count?: number;
    data?: ListaOpcion[];
}

export class ListaOpcion implements IListaOpcion {
    listaOpcionId?: number;
    listaId?: number;
    listaOpcionValor?: string | undefined;
    listaOpcionTexto?: string;
    listaOpcionValorAux?: string | undefined;
    listaOpcionPadreId?: number | undefined;
    listaOpcionEstado?: number | undefined;

    constructor(data?: IListaOpcion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listaOpcionId = _data["listaOpcionId"];
            this.listaId = _data["listaId"];
            this.listaOpcionValor = _data["listaOpcionValor"];
            this.listaOpcionTexto = _data["listaOpcionTexto"];
            this.listaOpcionValorAux = _data["listaOpcionValorAux"];
            this.listaOpcionPadreId = _data["listaOpcionPadreId"];
            this.listaOpcionEstado = _data["listaOpcionEstado"];
        }
    }

    static fromJS(data: any): ListaOpcion {
        data = typeof data === 'object' ? data : {};
        let result = new ListaOpcion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listaOpcionId"] = this.listaOpcionId;
        data["listaId"] = this.listaId;
        data["listaOpcionValor"] = this.listaOpcionValor;
        data["listaOpcionTexto"] = this.listaOpcionTexto;
        data["listaOpcionValorAux"] = this.listaOpcionValorAux;
        data["listaOpcionPadreId"] = this.listaOpcionPadreId;
        data["listaOpcionEstado"] = this.listaOpcionEstado;
        return data;
    }
}

export interface IListaOpcion {
    listaOpcionId?: number;
    listaId?: number;
    listaOpcionValor?: string | undefined;
    listaOpcionTexto?: string;
    listaOpcionValorAux?: string | undefined;
    listaOpcionPadreId?: number | undefined;
    listaOpcionEstado?: number | undefined;
}

export class PagingOfLista implements IPagingOfLista {
    count?: number;
    data?: Lista[];

    constructor(data?: IPagingOfLista) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Lista.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfLista {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfLista();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfLista {
    count?: number;
    data?: Lista[];
}

export class Lista implements ILista {
    listaId?: number;
    listaNombre?: string;
    listaDescripcion?: string;
    listaModulo?: string;
    listaTipo?: string;
    listaPadreNombre?: string | undefined;

    constructor(data?: ILista) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listaId = _data["listaId"];
            this.listaNombre = _data["listaNombre"];
            this.listaDescripcion = _data["listaDescripcion"];
            this.listaModulo = _data["listaModulo"];
            this.listaTipo = _data["listaTipo"];
            this.listaPadreNombre = _data["listaPadreNombre"];
        }
    }

    static fromJS(data: any): Lista {
        data = typeof data === 'object' ? data : {};
        let result = new Lista();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listaId"] = this.listaId;
        data["listaNombre"] = this.listaNombre;
        data["listaDescripcion"] = this.listaDescripcion;
        data["listaModulo"] = this.listaModulo;
        data["listaTipo"] = this.listaTipo;
        data["listaPadreNombre"] = this.listaPadreNombre;
        return data;
    }
}

export interface ILista {
    listaId?: number;
    listaNombre?: string;
    listaDescripcion?: string;
    listaModulo?: string;
    listaTipo?: string;
    listaPadreNombre?: string | undefined;
}

export class PagingOfLote implements IPagingOfLote {
    count?: number;
    data?: Lote[];

    constructor(data?: IPagingOfLote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Lote.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfLote {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfLote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfLote {
    count?: number;
    data?: Lote[];
}

export class Lote implements ILote {
    loteId?: number;
    loteProductoId?: string;
    loteNo?: string;
    loteFecha?: Date;
    loteSaldo?: number;
    loteActivo?: boolean | undefined;
    loteFechaFab?: Date | undefined;

    constructor(data?: ILote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loteId = _data["loteId"];
            this.loteProductoId = _data["loteProductoId"];
            this.loteNo = _data["loteNo"];
            this.loteFecha = _data["loteFecha"] ? new Date(_data["loteFecha"].toString()) : undefined as any;
            this.loteSaldo = _data["loteSaldo"];
            this.loteActivo = _data["loteActivo"];
            this.loteFechaFab = _data["loteFechaFab"] ? new Date(_data["loteFechaFab"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Lote {
        data = typeof data === 'object' ? data : {};
        let result = new Lote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loteId"] = this.loteId;
        data["loteProductoId"] = this.loteProductoId;
        data["loteNo"] = this.loteNo;
        data["loteFecha"] = this.loteFecha ? this.loteFecha.toISOString() : undefined as any;
        data["loteSaldo"] = this.loteSaldo;
        data["loteActivo"] = this.loteActivo;
        data["loteFechaFab"] = this.loteFechaFab ? this.loteFechaFab.toISOString() : undefined as any;
        return data;
    }
}

export interface ILote {
    loteId?: number;
    loteProductoId?: string;
    loteNo?: string;
    loteFecha?: Date;
    loteSaldo?: number;
    loteActivo?: boolean | undefined;
    loteFechaFab?: Date | undefined;
}

export class MultiLoteDto implements IMultiLoteDto {
    productoId?: string;
    lotes?: LoteProductoItemDto[];

    constructor(data?: IMultiLoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productoId = _data["productoId"];
            if (Array.isArray(_data["lotes"])) {
                this.lotes = [] as any;
                for (let item of _data["lotes"])
                    this.lotes!.push(LoteProductoItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MultiLoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiLoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productoId"] = this.productoId;
        if (Array.isArray(this.lotes)) {
            data["lotes"] = [];
            for (let item of this.lotes)
                data["lotes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMultiLoteDto {
    productoId?: string;
    lotes?: LoteProductoItemDto[];
}

export class PagingOfMPS implements IPagingOfMPS {
    count?: number;
    data?: MPS[];

    constructor(data?: IPagingOfMPS) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MPS.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfMPS {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfMPS();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfMPS {
    count?: number;
    data?: MPS[];
}

export class MPS implements IMPS {
    mpsId?: number;
    mpsDesde?: Date;
    mpsHasta?: Date;
    mpStipo?: number;
    lineaProduccionId?: number | undefined;
    mpsProperties?: string;
    mpsUser?: string;
    mpsInsHr?: Date;
    mpsEstado?: string;
    lineaProduccion?: LineaProduccion | undefined;
    insumo?: MPSInsumo[];
    dia?: MPSDias[];
    detalle?: MPSDetalle[];

    constructor(data?: IMPS) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mpsId = _data["mpsId"];
            this.mpsDesde = _data["mpsDesde"] ? new Date(_data["mpsDesde"].toString()) : undefined as any;
            this.mpsHasta = _data["mpsHasta"] ? new Date(_data["mpsHasta"].toString()) : undefined as any;
            this.mpStipo = _data["mpStipo"];
            this.lineaProduccionId = _data["lineaProduccionId"];
            this.mpsProperties = _data["mpsProperties"];
            this.mpsUser = _data["mpsUser"];
            this.mpsInsHr = _data["mpsInsHr"] ? new Date(_data["mpsInsHr"].toString()) : undefined as any;
            this.mpsEstado = _data["mpsEstado"];
            this.lineaProduccion = _data["lineaProduccion"] ? LineaProduccion.fromJS(_data["lineaProduccion"]) : undefined as any;
            if (Array.isArray(_data["Insumo"])) {
                this.insumo = [] as any;
                for (let item of _data["Insumo"])
                    this.insumo!.push(MPSInsumo.fromJS(item));
            }
            if (Array.isArray(_data["Dia"])) {
                this.dia = [] as any;
                for (let item of _data["Dia"])
                    this.dia!.push(MPSDias.fromJS(item));
            }
            if (Array.isArray(_data["Detalle"])) {
                this.detalle = [] as any;
                for (let item of _data["Detalle"])
                    this.detalle!.push(MPSDetalle.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MPS {
        data = typeof data === 'object' ? data : {};
        let result = new MPS();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mpsId"] = this.mpsId;
        data["mpsDesde"] = this.mpsDesde ? this.mpsDesde.toISOString() : undefined as any;
        data["mpsHasta"] = this.mpsHasta ? this.mpsHasta.toISOString() : undefined as any;
        data["mpStipo"] = this.mpStipo;
        data["lineaProduccionId"] = this.lineaProduccionId;
        data["mpsProperties"] = this.mpsProperties;
        data["mpsUser"] = this.mpsUser;
        data["mpsInsHr"] = this.mpsInsHr ? this.mpsInsHr.toISOString() : undefined as any;
        data["mpsEstado"] = this.mpsEstado;
        data["lineaProduccion"] = this.lineaProduccion ? this.lineaProduccion.toJSON() : undefined as any;
        if (Array.isArray(this.insumo)) {
            data["Insumo"] = [];
            for (let item of this.insumo)
                data["Insumo"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dia)) {
            data["Dia"] = [];
            for (let item of this.dia)
                data["Dia"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.detalle)) {
            data["Detalle"] = [];
            for (let item of this.detalle)
                data["Detalle"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMPS {
    mpsId?: number;
    mpsDesde?: Date;
    mpsHasta?: Date;
    mpStipo?: number;
    lineaProduccionId?: number | undefined;
    mpsProperties?: string;
    mpsUser?: string;
    mpsInsHr?: Date;
    mpsEstado?: string;
    lineaProduccion?: LineaProduccion | undefined;
    insumo?: MPSInsumo[];
    dia?: MPSDias[];
    detalle?: MPSDetalle[];
}

export class MPSInsumo implements IMPSInsumo {
    mpsInsumoId?: string;
    mpsInsumoNombre?: string;
    mpsInsumoUnidad?: string;
    mpsInsumoCant?: number;
    mpsInsumoVrUnt?: number;
    proveedorId?: number | undefined;
    mpsInsumoOC?: string;

    constructor(data?: IMPSInsumo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mpsInsumoId = _data["mpsInsumoId"];
            this.mpsInsumoNombre = _data["mpsInsumoNombre"];
            this.mpsInsumoUnidad = _data["mpsInsumoUnidad"];
            this.mpsInsumoCant = _data["mpsInsumoCant"];
            this.mpsInsumoVrUnt = _data["mpsInsumoVrUnt"];
            this.proveedorId = _data["proveedorId"];
            this.mpsInsumoOC = _data["mpsInsumoOC"];
        }
    }

    static fromJS(data: any): MPSInsumo {
        data = typeof data === 'object' ? data : {};
        let result = new MPSInsumo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mpsInsumoId"] = this.mpsInsumoId;
        data["mpsInsumoNombre"] = this.mpsInsumoNombre;
        data["mpsInsumoUnidad"] = this.mpsInsumoUnidad;
        data["mpsInsumoCant"] = this.mpsInsumoCant;
        data["mpsInsumoVrUnt"] = this.mpsInsumoVrUnt;
        data["proveedorId"] = this.proveedorId;
        data["mpsInsumoOC"] = this.mpsInsumoOC;
        return data;
    }
}

export interface IMPSInsumo {
    mpsInsumoId?: string;
    mpsInsumoNombre?: string;
    mpsInsumoUnidad?: string;
    mpsInsumoCant?: number;
    mpsInsumoVrUnt?: number;
    proveedorId?: number | undefined;
    mpsInsumoOC?: string;
}

export class MPSDias implements IMPSDias {
    mpsId?: number;
    mpsDia?: Date;
    mpsDiaCant?: number;
    mpsDiaProductoId?: string;
    mpsDiaLineaId?: number;
    mpsDiaLinea?: string;

    constructor(data?: IMPSDias) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mpsId = _data["mpsId"];
            this.mpsDia = _data["mpsDia"] ? new Date(_data["mpsDia"].toString()) : undefined as any;
            this.mpsDiaCant = _data["mpsDiaCant"];
            this.mpsDiaProductoId = _data["mpsDiaProductoId"];
            this.mpsDiaLineaId = _data["mpsDiaLineaId"];
            this.mpsDiaLinea = _data["mpsDiaLinea"];
        }
    }

    static fromJS(data: any): MPSDias {
        data = typeof data === 'object' ? data : {};
        let result = new MPSDias();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mpsId"] = this.mpsId;
        data["mpsDia"] = this.mpsDia ? formatDate(this.mpsDia) : undefined as any;
        data["mpsDiaCant"] = this.mpsDiaCant;
        data["mpsDiaProductoId"] = this.mpsDiaProductoId;
        data["mpsDiaLineaId"] = this.mpsDiaLineaId;
        data["mpsDiaLinea"] = this.mpsDiaLinea;
        return data;
    }
}

export interface IMPSDias {
    mpsId?: number;
    mpsDia?: Date;
    mpsDiaCant?: number;
    mpsDiaProductoId?: string;
    mpsDiaLineaId?: number;
    mpsDiaLinea?: string;
}

export class MPSDetalle implements IMPSDetalle {
    mpsDetalleProductoId?: string;
    mpsDetalleProductoNombre?: string;
    mpsDetalleProductoUnidad?: string;
    mpsDetalleInsumoUnidad?: number;
    mpsDetalleInvInicial?: number;
    mpsDetalleVentas?: number;
    mpsDetalleProduccion?: number;
    mpsDetalleLineaId?: number;
    mpsDetallelLinea?: string;

    constructor(data?: IMPSDetalle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mpsDetalleProductoId = _data["mpsDetalleProductoId"];
            this.mpsDetalleProductoNombre = _data["mpsDetalleProductoNombre"];
            this.mpsDetalleProductoUnidad = _data["mpsDetalleProductoUnidad"];
            this.mpsDetalleInsumoUnidad = _data["mpsDetalleInsumoUnidad"];
            this.mpsDetalleInvInicial = _data["mpsDetalleInvInicial"];
            this.mpsDetalleVentas = _data["mpsDetalleVentas"];
            this.mpsDetalleProduccion = _data["mpsDetalleProduccion"];
            this.mpsDetalleLineaId = _data["mpsDetalleLineaId"];
            this.mpsDetallelLinea = _data["mpsDetallelLinea"];
        }
    }

    static fromJS(data: any): MPSDetalle {
        data = typeof data === 'object' ? data : {};
        let result = new MPSDetalle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mpsDetalleProductoId"] = this.mpsDetalleProductoId;
        data["mpsDetalleProductoNombre"] = this.mpsDetalleProductoNombre;
        data["mpsDetalleProductoUnidad"] = this.mpsDetalleProductoUnidad;
        data["mpsDetalleInsumoUnidad"] = this.mpsDetalleInsumoUnidad;
        data["mpsDetalleInvInicial"] = this.mpsDetalleInvInicial;
        data["mpsDetalleVentas"] = this.mpsDetalleVentas;
        data["mpsDetalleProduccion"] = this.mpsDetalleProduccion;
        data["mpsDetalleLineaId"] = this.mpsDetalleLineaId;
        data["mpsDetallelLinea"] = this.mpsDetallelLinea;
        return data;
    }
}

export interface IMPSDetalle {
    mpsDetalleProductoId?: string;
    mpsDetalleProductoNombre?: string;
    mpsDetalleProductoUnidad?: string;
    mpsDetalleInsumoUnidad?: number;
    mpsDetalleInvInicial?: number;
    mpsDetalleVentas?: number;
    mpsDetalleProduccion?: number;
    mpsDetalleLineaId?: number;
    mpsDetallelLinea?: string;
}

export class PagingOfMuestra implements IPagingOfMuestra {
    count?: number;
    data?: Muestra[];

    constructor(data?: IPagingOfMuestra) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Muestra.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfMuestra {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfMuestra();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfMuestra {
    count?: number;
    data?: Muestra[];
}

export class Muestra implements IMuestra {
    muestraId?: number;
    muestraNumeroInterno?: string;
    muestraFecha?: Date;
    productorId?: number;
    muestraUFC?: number | undefined;
    muestraRCS?: number | undefined;
    muestraSolidos?: number | undefined;
    muestraGrasa?: number | undefined;
    muestraProteina?: number | undefined;
    muestraDensidad?: number | undefined;
    muestraSNG?: number | undefined;
    muestraAgua?: number | undefined;
    muestraLactosa?: number | undefined;
    muestraTemperatura?: number | undefined;
    muestraObservaciones?: string | undefined;
    muestraMUN?: number | undefined;
    muestraLaboratorioNombre?: string | undefined;
    muestraFechaToma?: Date | undefined;
    muestraNoSolicitud?: string | undefined;

    constructor(data?: IMuestra) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.muestraId = _data["muestraId"];
            this.muestraNumeroInterno = _data["muestraNumeroInterno"];
            this.muestraFecha = _data["muestraFecha"] ? new Date(_data["muestraFecha"].toString()) : undefined as any;
            this.productorId = _data["productorId"];
            this.muestraUFC = _data["muestraUFC"];
            this.muestraRCS = _data["muestraRCS"];
            this.muestraSolidos = _data["muestraSolidos"];
            this.muestraGrasa = _data["muestraGrasa"];
            this.muestraProteina = _data["muestraProteina"];
            this.muestraDensidad = _data["muestraDensidad"];
            this.muestraSNG = _data["muestraSNG"];
            this.muestraAgua = _data["muestraAgua"];
            this.muestraLactosa = _data["muestraLactosa"];
            this.muestraTemperatura = _data["muestraTemperatura"];
            this.muestraObservaciones = _data["muestraObservaciones"];
            this.muestraMUN = _data["muestraMUN"];
            this.muestraLaboratorioNombre = _data["muestraLaboratorioNombre"];
            this.muestraFechaToma = _data["muestraFechaToma"] ? new Date(_data["muestraFechaToma"].toString()) : undefined as any;
            this.muestraNoSolicitud = _data["muestraNoSolicitud"];
        }
    }

    static fromJS(data: any): Muestra {
        data = typeof data === 'object' ? data : {};
        let result = new Muestra();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["muestraId"] = this.muestraId;
        data["muestraNumeroInterno"] = this.muestraNumeroInterno;
        data["muestraFecha"] = this.muestraFecha ? formatDate(this.muestraFecha) : undefined as any;
        data["productorId"] = this.productorId;
        data["muestraUFC"] = this.muestraUFC;
        data["muestraRCS"] = this.muestraRCS;
        data["muestraSolidos"] = this.muestraSolidos;
        data["muestraGrasa"] = this.muestraGrasa;
        data["muestraProteina"] = this.muestraProteina;
        data["muestraDensidad"] = this.muestraDensidad;
        data["muestraSNG"] = this.muestraSNG;
        data["muestraAgua"] = this.muestraAgua;
        data["muestraLactosa"] = this.muestraLactosa;
        data["muestraTemperatura"] = this.muestraTemperatura;
        data["muestraObservaciones"] = this.muestraObservaciones;
        data["muestraMUN"] = this.muestraMUN;
        data["muestraLaboratorioNombre"] = this.muestraLaboratorioNombre;
        data["muestraFechaToma"] = this.muestraFechaToma ? formatDate(this.muestraFechaToma) : undefined as any;
        data["muestraNoSolicitud"] = this.muestraNoSolicitud;
        return data;
    }
}

export interface IMuestra {
    muestraId?: number;
    muestraNumeroInterno?: string;
    muestraFecha?: Date;
    productorId?: number;
    muestraUFC?: number | undefined;
    muestraRCS?: number | undefined;
    muestraSolidos?: number | undefined;
    muestraGrasa?: number | undefined;
    muestraProteina?: number | undefined;
    muestraDensidad?: number | undefined;
    muestraSNG?: number | undefined;
    muestraAgua?: number | undefined;
    muestraLactosa?: number | undefined;
    muestraTemperatura?: number | undefined;
    muestraObservaciones?: string | undefined;
    muestraMUN?: number | undefined;
    muestraLaboratorioNombre?: string | undefined;
    muestraFechaToma?: Date | undefined;
    muestraNoSolicitud?: string | undefined;
}

export class GetAgrosaviaResult implements IGetAgrosaviaResult {
    statusCode?: number;
    mensajeError?: string | undefined;
    datos?: Muestra[] | undefined;

    constructor(data?: IGetAgrosaviaResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.mensajeError = _data["mensajeError"];
            if (Array.isArray(_data["datos"])) {
                this.datos = [] as any;
                for (let item of _data["datos"])
                    this.datos!.push(Muestra.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAgrosaviaResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgrosaviaResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["mensajeError"] = this.mensajeError;
        if (Array.isArray(this.datos)) {
            data["datos"] = [];
            for (let item of this.datos)
                data["datos"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetAgrosaviaResult {
    statusCode?: number;
    mensajeError?: string | undefined;
    datos?: Muestra[] | undefined;
}

export class AgrosaviaRangoFechasEndpointRequest implements IAgrosaviaRangoFechasEndpointRequest {
    fechaInicial?: Date;
    fechaFinal?: Date;

    constructor(data?: IAgrosaviaRangoFechasEndpointRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fechaInicial = _data["fechaInicial"] ? new Date(_data["fechaInicial"].toString()) : undefined as any;
            this.fechaFinal = _data["fechaFinal"] ? new Date(_data["fechaFinal"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AgrosaviaRangoFechasEndpointRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AgrosaviaRangoFechasEndpointRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fechaInicial"] = this.fechaInicial ? formatDate(this.fechaInicial) : undefined as any;
        data["fechaFinal"] = this.fechaFinal ? formatDate(this.fechaFinal) : undefined as any;
        return data;
    }
}

export interface IAgrosaviaRangoFechasEndpointRequest {
    fechaInicial?: Date;
    fechaFinal?: Date;
}

export class PagingOfNotaCred implements IPagingOfNotaCred {
    count?: number;
    data?: NotaCred[];

    constructor(data?: IPagingOfNotaCred) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(NotaCred.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfNotaCred {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfNotaCred();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfNotaCred {
    count?: number;
    data?: NotaCred[];
}

export class NotaCred implements INotaCred {
    notaCredId?: number;
    notaCredId2?: string;
    notaCredFecha?: Date;
    facturaId?: number | undefined;
    notaCredEstado?: string;
    notaCredItems?: number;
    notaCredVrBase?: number;
    notaCredVrIVA?: number;
    notaCredReteIVA?: number;
    notaCredReteICA?: number;
    notaCredReteRenta?: number;
    notaCredTotal?: number;
    notaCredVrAplicado?: number;
    notaCredVrSaldo?: number;
    notaCredBodegaId?: string;
    notaCredNotas?: string;
    notaCredClienteId?: number;
    notaCredDocumentoId?: number;
    notaCredKardexId?: number | undefined;
    notaCredRegConId?: number | undefined;
    notaCredReteRentaId?: number | undefined;
    notaCredReteICAId?: number | undefined;
    notaCredPrefijo?: string;
    notaCredNumero?: number;
    notaCredSucId?: number | undefined;
    notaCredInsHr?: Date | undefined;
    notaCredUser?: string | undefined;
    notaCredReteCREE?: number | undefined;
    notaCredCajaId?: number | undefined;
    notaCredVrFlete?: number | undefined;
    notaCredCUFE?: string | undefined;
    notaCredFEMsg?: string | undefined;
    notaCredFEEstado?: number | undefined;
    notaCreditoVendedorId?: number | undefined;
    notaCredFEUrl?: string | undefined;
    notaCredVrImpoConsumo?: number | undefined;
    notaCredRazon?: number | undefined;
    notaCredFechaDIAN?: Date | undefined;
    notaCredTipo?: number | undefined;
    notaCredBancoId?: number | undefined;
    notaCredExtComId?: number | undefined;
    notaCredMPItems?: number | undefined;
    notaCredEfectivo?: number | undefined;
    notaCredVrAutoRetencion?: number | undefined;
    notaCredPrecioListaId?: string | undefined;
    notaCredPerAplica?: Date | undefined;
    notaCredMonedaId?: string | undefined;
    notaCredVrDctoFinanciero?: number | undefined;
    detalle?: NotaCredDetalle[];
    facturaId2?: string | undefined;

    constructor(data?: INotaCred) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notaCredId = _data["notaCredId"];
            this.notaCredId2 = _data["notaCredId2"];
            this.notaCredFecha = _data["notaCredFecha"] ? new Date(_data["notaCredFecha"].toString()) : undefined as any;
            this.facturaId = _data["facturaId"];
            this.notaCredEstado = _data["notaCredEstado"];
            this.notaCredItems = _data["notaCredItems"];
            this.notaCredVrBase = _data["notaCredVrBase"];
            this.notaCredVrIVA = _data["notaCredVrIVA"];
            this.notaCredReteIVA = _data["notaCredReteIVA"];
            this.notaCredReteICA = _data["notaCredReteICA"];
            this.notaCredReteRenta = _data["notaCredReteRenta"];
            this.notaCredTotal = _data["notaCredTotal"];
            this.notaCredVrAplicado = _data["notaCredVrAplicado"];
            this.notaCredVrSaldo = _data["notaCredVrSaldo"];
            this.notaCredBodegaId = _data["notaCredBodegaId"];
            this.notaCredNotas = _data["notaCredNotas"];
            this.notaCredClienteId = _data["notaCredClienteId"];
            this.notaCredDocumentoId = _data["notaCredDocumentoId"];
            this.notaCredKardexId = _data["notaCredKardexId"];
            this.notaCredRegConId = _data["notaCredRegConId"];
            this.notaCredReteRentaId = _data["notaCredReteRentaId"];
            this.notaCredReteICAId = _data["notaCredReteICAId"];
            this.notaCredPrefijo = _data["notaCredPrefijo"];
            this.notaCredNumero = _data["notaCredNumero"];
            this.notaCredSucId = _data["notaCredSucId"];
            this.notaCredInsHr = _data["notaCredInsHr"] ? new Date(_data["notaCredInsHr"].toString()) : undefined as any;
            this.notaCredUser = _data["notaCredUser"];
            this.notaCredReteCREE = _data["notaCredReteCREE"];
            this.notaCredCajaId = _data["notaCredCajaId"];
            this.notaCredVrFlete = _data["notaCredVrFlete"];
            this.notaCredCUFE = _data["notaCredCUFE"];
            this.notaCredFEMsg = _data["notaCredFEMsg"];
            this.notaCredFEEstado = _data["notaCredFEEstado"];
            this.notaCreditoVendedorId = _data["notaCreditoVendedorId"];
            this.notaCredFEUrl = _data["notaCredFEUrl"];
            this.notaCredVrImpoConsumo = _data["notaCredVrImpoConsumo"];
            this.notaCredRazon = _data["notaCredRazon"];
            this.notaCredFechaDIAN = _data["notaCredFechaDIAN"] ? new Date(_data["notaCredFechaDIAN"].toString()) : undefined as any;
            this.notaCredTipo = _data["notaCredTipo"];
            this.notaCredBancoId = _data["notaCredBancoId"];
            this.notaCredExtComId = _data["notaCredExtComId"];
            this.notaCredMPItems = _data["notaCredMPItems"];
            this.notaCredEfectivo = _data["notaCredEfectivo"];
            this.notaCredVrAutoRetencion = _data["notaCredVrAutoRetencion"];
            this.notaCredPrecioListaId = _data["notaCredPrecioListaId"];
            this.notaCredPerAplica = _data["notaCredPerAplica"] ? new Date(_data["notaCredPerAplica"].toString()) : undefined as any;
            this.notaCredMonedaId = _data["notaCredMonedaId"];
            this.notaCredVrDctoFinanciero = _data["notaCredVrDctoFinanciero"];
            if (Array.isArray(_data["Detalle"])) {
                this.detalle = [] as any;
                for (let item of _data["Detalle"])
                    this.detalle!.push(NotaCredDetalle.fromJS(item));
            }
            this.facturaId2 = _data["FacturaId2"];
        }
    }

    static fromJS(data: any): NotaCred {
        data = typeof data === 'object' ? data : {};
        let result = new NotaCred();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notaCredId"] = this.notaCredId;
        data["notaCredId2"] = this.notaCredId2;
        data["notaCredFecha"] = this.notaCredFecha ? this.notaCredFecha.toISOString() : undefined as any;
        data["facturaId"] = this.facturaId;
        data["notaCredEstado"] = this.notaCredEstado;
        data["notaCredItems"] = this.notaCredItems;
        data["notaCredVrBase"] = this.notaCredVrBase;
        data["notaCredVrIVA"] = this.notaCredVrIVA;
        data["notaCredReteIVA"] = this.notaCredReteIVA;
        data["notaCredReteICA"] = this.notaCredReteICA;
        data["notaCredReteRenta"] = this.notaCredReteRenta;
        data["notaCredTotal"] = this.notaCredTotal;
        data["notaCredVrAplicado"] = this.notaCredVrAplicado;
        data["notaCredVrSaldo"] = this.notaCredVrSaldo;
        data["notaCredBodegaId"] = this.notaCredBodegaId;
        data["notaCredNotas"] = this.notaCredNotas;
        data["notaCredClienteId"] = this.notaCredClienteId;
        data["notaCredDocumentoId"] = this.notaCredDocumentoId;
        data["notaCredKardexId"] = this.notaCredKardexId;
        data["notaCredRegConId"] = this.notaCredRegConId;
        data["notaCredReteRentaId"] = this.notaCredReteRentaId;
        data["notaCredReteICAId"] = this.notaCredReteICAId;
        data["notaCredPrefijo"] = this.notaCredPrefijo;
        data["notaCredNumero"] = this.notaCredNumero;
        data["notaCredSucId"] = this.notaCredSucId;
        data["notaCredInsHr"] = this.notaCredInsHr ? this.notaCredInsHr.toISOString() : undefined as any;
        data["notaCredUser"] = this.notaCredUser;
        data["notaCredReteCREE"] = this.notaCredReteCREE;
        data["notaCredCajaId"] = this.notaCredCajaId;
        data["notaCredVrFlete"] = this.notaCredVrFlete;
        data["notaCredCUFE"] = this.notaCredCUFE;
        data["notaCredFEMsg"] = this.notaCredFEMsg;
        data["notaCredFEEstado"] = this.notaCredFEEstado;
        data["notaCreditoVendedorId"] = this.notaCreditoVendedorId;
        data["notaCredFEUrl"] = this.notaCredFEUrl;
        data["notaCredVrImpoConsumo"] = this.notaCredVrImpoConsumo;
        data["notaCredRazon"] = this.notaCredRazon;
        data["notaCredFechaDIAN"] = this.notaCredFechaDIAN ? this.notaCredFechaDIAN.toISOString() : undefined as any;
        data["notaCredTipo"] = this.notaCredTipo;
        data["notaCredBancoId"] = this.notaCredBancoId;
        data["notaCredExtComId"] = this.notaCredExtComId;
        data["notaCredMPItems"] = this.notaCredMPItems;
        data["notaCredEfectivo"] = this.notaCredEfectivo;
        data["notaCredVrAutoRetencion"] = this.notaCredVrAutoRetencion;
        data["notaCredPrecioListaId"] = this.notaCredPrecioListaId;
        data["notaCredPerAplica"] = this.notaCredPerAplica ? formatDate(this.notaCredPerAplica) : undefined as any;
        data["notaCredMonedaId"] = this.notaCredMonedaId;
        data["notaCredVrDctoFinanciero"] = this.notaCredVrDctoFinanciero;
        if (Array.isArray(this.detalle)) {
            data["Detalle"] = [];
            for (let item of this.detalle)
                data["Detalle"].push(item ? item.toJSON() : undefined as any);
        }
        data["FacturaId2"] = this.facturaId2;
        return data;
    }
}

export interface INotaCred {
    notaCredId?: number;
    notaCredId2?: string;
    notaCredFecha?: Date;
    facturaId?: number | undefined;
    notaCredEstado?: string;
    notaCredItems?: number;
    notaCredVrBase?: number;
    notaCredVrIVA?: number;
    notaCredReteIVA?: number;
    notaCredReteICA?: number;
    notaCredReteRenta?: number;
    notaCredTotal?: number;
    notaCredVrAplicado?: number;
    notaCredVrSaldo?: number;
    notaCredBodegaId?: string;
    notaCredNotas?: string;
    notaCredClienteId?: number;
    notaCredDocumentoId?: number;
    notaCredKardexId?: number | undefined;
    notaCredRegConId?: number | undefined;
    notaCredReteRentaId?: number | undefined;
    notaCredReteICAId?: number | undefined;
    notaCredPrefijo?: string;
    notaCredNumero?: number;
    notaCredSucId?: number | undefined;
    notaCredInsHr?: Date | undefined;
    notaCredUser?: string | undefined;
    notaCredReteCREE?: number | undefined;
    notaCredCajaId?: number | undefined;
    notaCredVrFlete?: number | undefined;
    notaCredCUFE?: string | undefined;
    notaCredFEMsg?: string | undefined;
    notaCredFEEstado?: number | undefined;
    notaCreditoVendedorId?: number | undefined;
    notaCredFEUrl?: string | undefined;
    notaCredVrImpoConsumo?: number | undefined;
    notaCredRazon?: number | undefined;
    notaCredFechaDIAN?: Date | undefined;
    notaCredTipo?: number | undefined;
    notaCredBancoId?: number | undefined;
    notaCredExtComId?: number | undefined;
    notaCredMPItems?: number | undefined;
    notaCredEfectivo?: number | undefined;
    notaCredVrAutoRetencion?: number | undefined;
    notaCredPrecioListaId?: string | undefined;
    notaCredPerAplica?: Date | undefined;
    notaCredMonedaId?: string | undefined;
    notaCredVrDctoFinanciero?: number | undefined;
    detalle?: NotaCredDetalle[];
    facturaId2?: string | undefined;
}

export class NotaCredDetalle implements INotaCredDetalle {
    notaCredId?: number;
    notaCredDetalleId?: number;
    productoId?: string;
    productoNombre?: string;
    productoGrupoContable?: number;
    notaCredCantidad?: number;
    notaCredVrUnitario?: number;
    notaCredTasaIVA?: number;
    notaCredCausal?: string | undefined;
    notaCredDetalleDcto?: number;
    notaCredLoteId?: number | undefined;
    notaCredNotaLong?: string;
    notaCredCosto?: number | undefined;
    notaCredDetalleIMP?: number | undefined;
    notaCredDetalleBodegaId?: string | undefined;
    notaCredProyectoId?: string | undefined;
    notaCredCCId?: number | undefined;
    notaCredSubCCId?: string | undefined;
    notaCredDetalleProperties?: string | undefined;

    constructor(data?: INotaCredDetalle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notaCredId = _data["notaCredId"];
            this.notaCredDetalleId = _data["notaCredDetalleId"];
            this.productoId = _data["productoId"];
            this.productoNombre = _data["productoNombre"];
            this.productoGrupoContable = _data["productoGrupoContable"];
            this.notaCredCantidad = _data["notaCredCantidad"];
            this.notaCredVrUnitario = _data["notaCredVrUnitario"];
            this.notaCredTasaIVA = _data["notaCredTasaIVA"];
            this.notaCredCausal = _data["notaCredCausal"];
            this.notaCredDetalleDcto = _data["notaCredDetalleDcto"];
            this.notaCredLoteId = _data["notaCredLoteId"];
            this.notaCredNotaLong = _data["notaCredNotaLong"];
            this.notaCredCosto = _data["notaCredCosto"];
            this.notaCredDetalleIMP = _data["notaCredDetalleIMP"];
            this.notaCredDetalleBodegaId = _data["notaCredDetalleBodegaId"];
            this.notaCredProyectoId = _data["notaCredProyectoId"];
            this.notaCredCCId = _data["notaCredCCId"];
            this.notaCredSubCCId = _data["notaCredSubCCId"];
            this.notaCredDetalleProperties = _data["notaCredDetalleProperties"];
        }
    }

    static fromJS(data: any): NotaCredDetalle {
        data = typeof data === 'object' ? data : {};
        let result = new NotaCredDetalle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notaCredId"] = this.notaCredId;
        data["notaCredDetalleId"] = this.notaCredDetalleId;
        data["productoId"] = this.productoId;
        data["productoNombre"] = this.productoNombre;
        data["productoGrupoContable"] = this.productoGrupoContable;
        data["notaCredCantidad"] = this.notaCredCantidad;
        data["notaCredVrUnitario"] = this.notaCredVrUnitario;
        data["notaCredTasaIVA"] = this.notaCredTasaIVA;
        data["notaCredCausal"] = this.notaCredCausal;
        data["notaCredDetalleDcto"] = this.notaCredDetalleDcto;
        data["notaCredLoteId"] = this.notaCredLoteId;
        data["notaCredNotaLong"] = this.notaCredNotaLong;
        data["notaCredCosto"] = this.notaCredCosto;
        data["notaCredDetalleIMP"] = this.notaCredDetalleIMP;
        data["notaCredDetalleBodegaId"] = this.notaCredDetalleBodegaId;
        data["notaCredProyectoId"] = this.notaCredProyectoId;
        data["notaCredCCId"] = this.notaCredCCId;
        data["notaCredSubCCId"] = this.notaCredSubCCId;
        data["notaCredDetalleProperties"] = this.notaCredDetalleProperties;
        return data;
    }
}

export interface INotaCredDetalle {
    notaCredId?: number;
    notaCredDetalleId?: number;
    productoId?: string;
    productoNombre?: string;
    productoGrupoContable?: number;
    notaCredCantidad?: number;
    notaCredVrUnitario?: number;
    notaCredTasaIVA?: number;
    notaCredCausal?: string | undefined;
    notaCredDetalleDcto?: number;
    notaCredLoteId?: number | undefined;
    notaCredNotaLong?: string;
    notaCredCosto?: number | undefined;
    notaCredDetalleIMP?: number | undefined;
    notaCredDetalleBodegaId?: string | undefined;
    notaCredProyectoId?: string | undefined;
    notaCredCCId?: number | undefined;
    notaCredSubCCId?: string | undefined;
    notaCredDetalleProperties?: string | undefined;
}

export class PagingOfObligacion implements IPagingOfObligacion {
    count?: number;
    data?: Obligacion[];

    constructor(data?: IPagingOfObligacion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Obligacion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfObligacion {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfObligacion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfObligacion {
    count?: number;
    data?: Obligacion[];
}

export class Obligacion implements IObligacion {
    obligacionId?: number;
    obligacionDescripcion?: string;
    obligacionTipo?: number;
    obligacionFecha?: Date;
    obligacionPeriodicidad?: number;
    obligacionValor?: number;
    obligacionTotalAbonado?: number;
    obligacionSaldo?: number;
    obligacionActivo?: boolean;
    obligacionPucId?: string | undefined;
    obligacionTerceroId?: number | undefined;
    obligacionProductors?: ObligacionProductor[];

    constructor(data?: IObligacion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.obligacionId = _data["obligacionId"];
            this.obligacionDescripcion = _data["obligacionDescripcion"];
            this.obligacionTipo = _data["obligacionTipo"];
            this.obligacionFecha = _data["obligacionFecha"] ? new Date(_data["obligacionFecha"].toString()) : undefined as any;
            this.obligacionPeriodicidad = _data["obligacionPeriodicidad"];
            this.obligacionValor = _data["obligacionValor"];
            this.obligacionTotalAbonado = _data["obligacionTotalAbonado"];
            this.obligacionSaldo = _data["obligacionSaldo"];
            this.obligacionActivo = _data["obligacionActivo"];
            this.obligacionPucId = _data["obligacionPucId"];
            this.obligacionTerceroId = _data["obligacionTerceroId"];
            if (Array.isArray(_data["obligacionProductors"])) {
                this.obligacionProductors = [] as any;
                for (let item of _data["obligacionProductors"])
                    this.obligacionProductors!.push(ObligacionProductor.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Obligacion {
        data = typeof data === 'object' ? data : {};
        let result = new Obligacion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["obligacionId"] = this.obligacionId;
        data["obligacionDescripcion"] = this.obligacionDescripcion;
        data["obligacionTipo"] = this.obligacionTipo;
        data["obligacionFecha"] = this.obligacionFecha ? this.obligacionFecha.toISOString() : undefined as any;
        data["obligacionPeriodicidad"] = this.obligacionPeriodicidad;
        data["obligacionValor"] = this.obligacionValor;
        data["obligacionTotalAbonado"] = this.obligacionTotalAbonado;
        data["obligacionSaldo"] = this.obligacionSaldo;
        data["obligacionActivo"] = this.obligacionActivo;
        data["obligacionPucId"] = this.obligacionPucId;
        data["obligacionTerceroId"] = this.obligacionTerceroId;
        if (Array.isArray(this.obligacionProductors)) {
            data["obligacionProductors"] = [];
            for (let item of this.obligacionProductors)
                data["obligacionProductors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IObligacion {
    obligacionId?: number;
    obligacionDescripcion?: string;
    obligacionTipo?: number;
    obligacionFecha?: Date;
    obligacionPeriodicidad?: number;
    obligacionValor?: number;
    obligacionTotalAbonado?: number;
    obligacionSaldo?: number;
    obligacionActivo?: boolean;
    obligacionPucId?: string | undefined;
    obligacionTerceroId?: number | undefined;
    obligacionProductors?: ObligacionProductor[];
}

export class ObligacionProductor implements IObligacionProductor {
    obligacionId?: number;
    productorId?: number;
    productorTerceroNombre?: string | undefined;
    obligacionCuota?: number;
    oblicacionVrLt?: number;
    obligacionProductorActivo?: boolean;
    obligacionNombre?: string | undefined;
    obligacionTipo?: number | undefined;
    obligacionFecha?: Date | undefined;
    obligacionPeriodicidad?: number | undefined;
    obligacionValor?: number | undefined;
    obligacionTotalAbonado?: number;
    obligacionSaldo?: number;
    obligacionProductorAbonado?: number;

    constructor(data?: IObligacionProductor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.obligacionId = _data["obligacionId"];
            this.productorId = _data["productorId"];
            this.productorTerceroNombre = _data["productorTerceroNombre"];
            this.obligacionCuota = _data["obligacionCuota"];
            this.oblicacionVrLt = _data["oblicacionVrLt"];
            this.obligacionProductorActivo = _data["obligacionProductorActivo"];
            this.obligacionNombre = _data["obligacionNombre"];
            this.obligacionTipo = _data["obligacionTipo"];
            this.obligacionFecha = _data["obligacionFecha"] ? new Date(_data["obligacionFecha"].toString()) : undefined as any;
            this.obligacionPeriodicidad = _data["obligacionPeriodicidad"];
            this.obligacionValor = _data["obligacionValor"];
            this.obligacionTotalAbonado = _data["obligacionTotalAbonado"];
            this.obligacionSaldo = _data["obligacionSaldo"];
            this.obligacionProductorAbonado = _data["obligacionProductorAbonado"];
        }
    }

    static fromJS(data: any): ObligacionProductor {
        data = typeof data === 'object' ? data : {};
        let result = new ObligacionProductor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["obligacionId"] = this.obligacionId;
        data["productorId"] = this.productorId;
        data["productorTerceroNombre"] = this.productorTerceroNombre;
        data["obligacionCuota"] = this.obligacionCuota;
        data["oblicacionVrLt"] = this.oblicacionVrLt;
        data["obligacionProductorActivo"] = this.obligacionProductorActivo;
        data["obligacionNombre"] = this.obligacionNombre;
        data["obligacionTipo"] = this.obligacionTipo;
        data["obligacionFecha"] = this.obligacionFecha ? this.obligacionFecha.toISOString() : undefined as any;
        data["obligacionPeriodicidad"] = this.obligacionPeriodicidad;
        data["obligacionValor"] = this.obligacionValor;
        data["obligacionTotalAbonado"] = this.obligacionTotalAbonado;
        data["obligacionSaldo"] = this.obligacionSaldo;
        data["obligacionProductorAbonado"] = this.obligacionProductorAbonado;
        return data;
    }
}

export interface IObligacionProductor {
    obligacionId?: number;
    productorId?: number;
    productorTerceroNombre?: string | undefined;
    obligacionCuota?: number;
    oblicacionVrLt?: number;
    obligacionProductorActivo?: boolean;
    obligacionNombre?: string | undefined;
    obligacionTipo?: number | undefined;
    obligacionFecha?: Date | undefined;
    obligacionPeriodicidad?: number | undefined;
    obligacionValor?: number | undefined;
    obligacionTotalAbonado?: number;
    obligacionSaldo?: number;
    obligacionProductorAbonado?: number;
}

export class PagingOfObligacionProductor implements IPagingOfObligacionProductor {
    count?: number;
    data?: ObligacionProductor[];

    constructor(data?: IPagingOfObligacionProductor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ObligacionProductor.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfObligacionProductor {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfObligacionProductor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfObligacionProductor {
    count?: number;
    data?: ObligacionProductor[];
}

export class PagingOfObservacion implements IPagingOfObservacion {
    count?: number;
    data?: Observacion[];

    constructor(data?: IPagingOfObservacion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Observacion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfObservacion {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfObservacion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfObservacion {
    count?: number;
    data?: Observacion[];
}

export class Observacion implements IObservacion {
    alObserId?: number;
    obserDesc?: string;

    constructor(data?: IObservacion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alObserId = _data["alObserId"];
            this.obserDesc = _data["obserDesc"];
        }
    }

    static fromJS(data: any): Observacion {
        data = typeof data === 'object' ? data : {};
        let result = new Observacion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alObserId"] = this.alObserId;
        data["obserDesc"] = this.obserDesc;
        return data;
    }
}

export interface IObservacion {
    alObserId?: number;
    obserDesc?: string;
}

export class OpenAiResponsesStreamRequest implements IOpenAiResponsesStreamRequest {
    model?: string | undefined;
    instructions?: string | undefined;
    input?: any;
    tools?: any | undefined;
    mcp?: any | undefined;
    previousResponseId?: string | undefined;

    constructor(data?: IOpenAiResponsesStreamRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"];
            this.instructions = _data["instructions"];
            this.input = _data["input"];
            this.tools = _data["tools"];
            this.mcp = _data["mcp"];
            this.previousResponseId = _data["previousResponseId"];
        }
    }

    static fromJS(data: any): OpenAiResponsesStreamRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OpenAiResponsesStreamRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model;
        data["instructions"] = this.instructions;
        data["input"] = this.input;
        data["tools"] = this.tools;
        data["mcp"] = this.mcp;
        data["previousResponseId"] = this.previousResponseId;
        return data;
    }
}

export interface IOpenAiResponsesStreamRequest {
    model?: string | undefined;
    instructions?: string | undefined;
    input?: any;
    tools?: any | undefined;
    mcp?: any | undefined;
    previousResponseId?: string | undefined;
}

export class PagingOfOrdenCompra implements IPagingOfOrdenCompra {
    count?: number;
    data?: OrdenCompra[];

    constructor(data?: IPagingOfOrdenCompra) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OrdenCompra.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfOrdenCompra {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfOrdenCompra();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfOrdenCompra {
    count?: number;
    data?: OrdenCompra[];
}

export class OrdenCompra implements IOrdenCompra {
    ordenCompraId?: number;
    ordenCompraId2?: string;
    ordenCompraPrefijo?: string;
    ordenCompraNumero?: number;
    proveedorId?: number;
    ordenCompraFecha?: Date;
    ordenCompraPlazo?: number;
    ordenCompraFechaPago?: Date;
    ordenCompraDctoComercial?: number;
    ordenCompraDctoFinanciero?: number;
    ordenCompraItems?: number;
    ordenCompraEstado?: string;
    ordenCompraUser?: string;
    ordenCompraInsHr?: Date;
    ordenCompraDocumentoId?: number | undefined;
    ordenCompraVrBase?: number;
    ordenCompraVrIVA?: number;
    ordenCompraTotal?: number;
    ordenCompraSucursalId?: number | undefined;
    ordenCompraNotas?: string;
    ordenCompraFechaEntrega?: Date;
    ordenCompraPorcentaje?: number;
    ordenCompraVrReteRenta?: number | undefined;
    ordenCompraReteRentaId?: number | undefined;
    ordenCompraVrFlete?: number | undefined;
    ordenCompraFechaDespacho?: Date | undefined;
    ordenCompraVrSaldo?: number | undefined;
    ordenCompraVrAnticipos?: number | undefined;
    ordenCompraMonedaId?: string | undefined;
    ordenCompraTipo?: number | undefined;
    ordenCompraMaxAnticipo?: number | undefined;
    ordenCompraProyectoId?: string | undefined;
    ordenCompraReteICAId?: number | undefined;
    ordenCompraVRreteICA?: number | undefined;
    ordenCompraVrImpoconsumo?: number | undefined;
    ordenCompraPlazoFinanciero?: number | undefined;
    ordenCompraProperties?: string | undefined;

    constructor(data?: IOrdenCompra) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordenCompraId = _data["ordenCompraId"];
            this.ordenCompraId2 = _data["ordenCompraId2"];
            this.ordenCompraPrefijo = _data["ordenCompraPrefijo"];
            this.ordenCompraNumero = _data["ordenCompraNumero"];
            this.proveedorId = _data["proveedorId"];
            this.ordenCompraFecha = _data["ordenCompraFecha"] ? new Date(_data["ordenCompraFecha"].toString()) : undefined as any;
            this.ordenCompraPlazo = _data["ordenCompraPlazo"];
            this.ordenCompraFechaPago = _data["ordenCompraFechaPago"] ? new Date(_data["ordenCompraFechaPago"].toString()) : undefined as any;
            this.ordenCompraDctoComercial = _data["ordenCompraDctoComercial"];
            this.ordenCompraDctoFinanciero = _data["ordenCompraDctoFinanciero"];
            this.ordenCompraItems = _data["ordenCompraItems"];
            this.ordenCompraEstado = _data["ordenCompraEstado"];
            this.ordenCompraUser = _data["ordenCompraUser"];
            this.ordenCompraInsHr = _data["ordenCompraInsHr"] ? new Date(_data["ordenCompraInsHr"].toString()) : undefined as any;
            this.ordenCompraDocumentoId = _data["ordenCompraDocumentoId"];
            this.ordenCompraVrBase = _data["ordenCompraVrBase"];
            this.ordenCompraVrIVA = _data["ordenCompraVrIVA"];
            this.ordenCompraTotal = _data["ordenCompraTotal"];
            this.ordenCompraSucursalId = _data["ordenCompraSucursalId"];
            this.ordenCompraNotas = _data["ordenCompraNotas"];
            this.ordenCompraFechaEntrega = _data["ordenCompraFechaEntrega"] ? new Date(_data["ordenCompraFechaEntrega"].toString()) : undefined as any;
            this.ordenCompraPorcentaje = _data["ordenCompraPorcentaje"];
            this.ordenCompraVrReteRenta = _data["ordenCompraVrReteRenta"];
            this.ordenCompraReteRentaId = _data["ordenCompraReteRentaId"];
            this.ordenCompraVrFlete = _data["ordenCompraVrFlete"];
            this.ordenCompraFechaDespacho = _data["ordenCompraFechaDespacho"] ? new Date(_data["ordenCompraFechaDespacho"].toString()) : undefined as any;
            this.ordenCompraVrSaldo = _data["ordenCompraVrSaldo"];
            this.ordenCompraVrAnticipos = _data["ordenCompraVrAnticipos"];
            this.ordenCompraMonedaId = _data["ordenCompraMonedaId"];
            this.ordenCompraTipo = _data["ordenCompraTipo"];
            this.ordenCompraMaxAnticipo = _data["ordenCompraMaxAnticipo"];
            this.ordenCompraProyectoId = _data["ordenCompraProyectoId"];
            this.ordenCompraReteICAId = _data["ordenCompraReteICAId"];
            this.ordenCompraVRreteICA = _data["ordenCompraVRreteICA"];
            this.ordenCompraVrImpoconsumo = _data["ordenCompraVrImpoconsumo"];
            this.ordenCompraPlazoFinanciero = _data["ordenCompraPlazoFinanciero"];
            this.ordenCompraProperties = _data["ordenCompraProperties"];
        }
    }

    static fromJS(data: any): OrdenCompra {
        data = typeof data === 'object' ? data : {};
        let result = new OrdenCompra();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordenCompraId"] = this.ordenCompraId;
        data["ordenCompraId2"] = this.ordenCompraId2;
        data["ordenCompraPrefijo"] = this.ordenCompraPrefijo;
        data["ordenCompraNumero"] = this.ordenCompraNumero;
        data["proveedorId"] = this.proveedorId;
        data["ordenCompraFecha"] = this.ordenCompraFecha ? this.ordenCompraFecha.toISOString() : undefined as any;
        data["ordenCompraPlazo"] = this.ordenCompraPlazo;
        data["ordenCompraFechaPago"] = this.ordenCompraFechaPago ? this.ordenCompraFechaPago.toISOString() : undefined as any;
        data["ordenCompraDctoComercial"] = this.ordenCompraDctoComercial;
        data["ordenCompraDctoFinanciero"] = this.ordenCompraDctoFinanciero;
        data["ordenCompraItems"] = this.ordenCompraItems;
        data["ordenCompraEstado"] = this.ordenCompraEstado;
        data["ordenCompraUser"] = this.ordenCompraUser;
        data["ordenCompraInsHr"] = this.ordenCompraInsHr ? this.ordenCompraInsHr.toISOString() : undefined as any;
        data["ordenCompraDocumentoId"] = this.ordenCompraDocumentoId;
        data["ordenCompraVrBase"] = this.ordenCompraVrBase;
        data["ordenCompraVrIVA"] = this.ordenCompraVrIVA;
        data["ordenCompraTotal"] = this.ordenCompraTotal;
        data["ordenCompraSucursalId"] = this.ordenCompraSucursalId;
        data["ordenCompraNotas"] = this.ordenCompraNotas;
        data["ordenCompraFechaEntrega"] = this.ordenCompraFechaEntrega ? this.ordenCompraFechaEntrega.toISOString() : undefined as any;
        data["ordenCompraPorcentaje"] = this.ordenCompraPorcentaje;
        data["ordenCompraVrReteRenta"] = this.ordenCompraVrReteRenta;
        data["ordenCompraReteRentaId"] = this.ordenCompraReteRentaId;
        data["ordenCompraVrFlete"] = this.ordenCompraVrFlete;
        data["ordenCompraFechaDespacho"] = this.ordenCompraFechaDespacho ? this.ordenCompraFechaDespacho.toISOString() : undefined as any;
        data["ordenCompraVrSaldo"] = this.ordenCompraVrSaldo;
        data["ordenCompraVrAnticipos"] = this.ordenCompraVrAnticipos;
        data["ordenCompraMonedaId"] = this.ordenCompraMonedaId;
        data["ordenCompraTipo"] = this.ordenCompraTipo;
        data["ordenCompraMaxAnticipo"] = this.ordenCompraMaxAnticipo;
        data["ordenCompraProyectoId"] = this.ordenCompraProyectoId;
        data["ordenCompraReteICAId"] = this.ordenCompraReteICAId;
        data["ordenCompraVRreteICA"] = this.ordenCompraVRreteICA;
        data["ordenCompraVrImpoconsumo"] = this.ordenCompraVrImpoconsumo;
        data["ordenCompraPlazoFinanciero"] = this.ordenCompraPlazoFinanciero;
        data["ordenCompraProperties"] = this.ordenCompraProperties;
        return data;
    }
}

export interface IOrdenCompra {
    ordenCompraId?: number;
    ordenCompraId2?: string;
    ordenCompraPrefijo?: string;
    ordenCompraNumero?: number;
    proveedorId?: number;
    ordenCompraFecha?: Date;
    ordenCompraPlazo?: number;
    ordenCompraFechaPago?: Date;
    ordenCompraDctoComercial?: number;
    ordenCompraDctoFinanciero?: number;
    ordenCompraItems?: number;
    ordenCompraEstado?: string;
    ordenCompraUser?: string;
    ordenCompraInsHr?: Date;
    ordenCompraDocumentoId?: number | undefined;
    ordenCompraVrBase?: number;
    ordenCompraVrIVA?: number;
    ordenCompraTotal?: number;
    ordenCompraSucursalId?: number | undefined;
    ordenCompraNotas?: string;
    ordenCompraFechaEntrega?: Date;
    ordenCompraPorcentaje?: number;
    ordenCompraVrReteRenta?: number | undefined;
    ordenCompraReteRentaId?: number | undefined;
    ordenCompraVrFlete?: number | undefined;
    ordenCompraFechaDespacho?: Date | undefined;
    ordenCompraVrSaldo?: number | undefined;
    ordenCompraVrAnticipos?: number | undefined;
    ordenCompraMonedaId?: string | undefined;
    ordenCompraTipo?: number | undefined;
    ordenCompraMaxAnticipo?: number | undefined;
    ordenCompraProyectoId?: string | undefined;
    ordenCompraReteICAId?: number | undefined;
    ordenCompraVRreteICA?: number | undefined;
    ordenCompraVrImpoconsumo?: number | undefined;
    ordenCompraPlazoFinanciero?: number | undefined;
    ordenCompraProperties?: string | undefined;
}

export class PagingOfOrdenProduccion implements IPagingOfOrdenProduccion {
    count?: number;
    data?: OrdenProduccion[];

    constructor(data?: IPagingOfOrdenProduccion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OrdenProduccion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfOrdenProduccion {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfOrdenProduccion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfOrdenProduccion {
    count?: number;
    data?: OrdenProduccion[];
}

export class OrdenProduccion implements IOrdenProduccion {
    ordenProduccionId?: number;
    ordenProduccionNumero?: number;
    ordenProduccionPrefijo?: string;
    ordenProduccionId2?: string;
    ordenProduccionFecha?: Date;
    ordenProduccionBodegaId?: string;
    ordenProduccionInsBodegaId?: string;
    ordenProduccionItems?: number;
    ordenProduccionFechaProd?: Date;
    ordenProduccionEstado?: string;
    ordenProduccionNotas?: string;
    ordenProduccionDocumentoId?: number;
    ordenProduccionInsHr?: Date | undefined;
    ordenProduccionUser?: string | undefined;
    ordenProduccionConsumos?: number | undefined;
    ordenProduccionModo?: number | undefined;
    ordenProduccionLoteNo?: string | undefined;
    ordenProduccionFechaVenc?: Date | undefined;
    ordenProduccionLineaId?: number | undefined;
    ordenProduccionLineaNombre?: string;
    consumo?: OrdenProduccionCon[];
    pT?: OrdenProduccionPT[];
    proceso?: OrdenProduccionProceso[];

    constructor(data?: IOrdenProduccion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordenProduccionId = _data["ordenProduccionId"];
            this.ordenProduccionNumero = _data["ordenProduccionNumero"];
            this.ordenProduccionPrefijo = _data["ordenProduccionPrefijo"];
            this.ordenProduccionId2 = _data["ordenProduccionId2"];
            this.ordenProduccionFecha = _data["ordenProduccionFecha"] ? new Date(_data["ordenProduccionFecha"].toString()) : undefined as any;
            this.ordenProduccionBodegaId = _data["ordenProduccionBodegaId"];
            this.ordenProduccionInsBodegaId = _data["ordenProduccionInsBodegaId"];
            this.ordenProduccionItems = _data["ordenProduccionItems"];
            this.ordenProduccionFechaProd = _data["ordenProduccionFechaProd"] ? new Date(_data["ordenProduccionFechaProd"].toString()) : undefined as any;
            this.ordenProduccionEstado = _data["ordenProduccionEstado"];
            this.ordenProduccionNotas = _data["ordenProduccionNotas"];
            this.ordenProduccionDocumentoId = _data["ordenProduccionDocumentoId"];
            this.ordenProduccionInsHr = _data["ordenProduccionInsHr"] ? new Date(_data["ordenProduccionInsHr"].toString()) : undefined as any;
            this.ordenProduccionUser = _data["ordenProduccionUser"];
            this.ordenProduccionConsumos = _data["ordenProduccionConsumos"];
            this.ordenProduccionModo = _data["ordenProduccionModo"];
            this.ordenProduccionLoteNo = _data["ordenProduccionLoteNo"];
            this.ordenProduccionFechaVenc = _data["ordenProduccionFechaVenc"] ? new Date(_data["ordenProduccionFechaVenc"].toString()) : undefined as any;
            this.ordenProduccionLineaId = _data["ordenProduccionLineaId"];
            this.ordenProduccionLineaNombre = _data["ordenProduccionLineaNombre"];
            if (Array.isArray(_data["Consumo"])) {
                this.consumo = [] as any;
                for (let item of _data["Consumo"])
                    this.consumo!.push(OrdenProduccionCon.fromJS(item));
            }
            if (Array.isArray(_data["PT"])) {
                this.pT = [] as any;
                for (let item of _data["PT"])
                    this.pT!.push(OrdenProduccionPT.fromJS(item));
            }
            if (Array.isArray(_data["Proceso"])) {
                this.proceso = [] as any;
                for (let item of _data["Proceso"])
                    this.proceso!.push(OrdenProduccionProceso.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrdenProduccion {
        data = typeof data === 'object' ? data : {};
        let result = new OrdenProduccion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordenProduccionId"] = this.ordenProduccionId;
        data["ordenProduccionNumero"] = this.ordenProduccionNumero;
        data["ordenProduccionPrefijo"] = this.ordenProduccionPrefijo;
        data["ordenProduccionId2"] = this.ordenProduccionId2;
        data["ordenProduccionFecha"] = this.ordenProduccionFecha ? this.ordenProduccionFecha.toISOString() : undefined as any;
        data["ordenProduccionBodegaId"] = this.ordenProduccionBodegaId;
        data["ordenProduccionInsBodegaId"] = this.ordenProduccionInsBodegaId;
        data["ordenProduccionItems"] = this.ordenProduccionItems;
        data["ordenProduccionFechaProd"] = this.ordenProduccionFechaProd ? this.ordenProduccionFechaProd.toISOString() : undefined as any;
        data["ordenProduccionEstado"] = this.ordenProduccionEstado;
        data["ordenProduccionNotas"] = this.ordenProduccionNotas;
        data["ordenProduccionDocumentoId"] = this.ordenProduccionDocumentoId;
        data["ordenProduccionInsHr"] = this.ordenProduccionInsHr ? this.ordenProduccionInsHr.toISOString() : undefined as any;
        data["ordenProduccionUser"] = this.ordenProduccionUser;
        data["ordenProduccionConsumos"] = this.ordenProduccionConsumos;
        data["ordenProduccionModo"] = this.ordenProduccionModo;
        data["ordenProduccionLoteNo"] = this.ordenProduccionLoteNo;
        data["ordenProduccionFechaVenc"] = this.ordenProduccionFechaVenc ? this.ordenProduccionFechaVenc.toISOString() : undefined as any;
        data["ordenProduccionLineaId"] = this.ordenProduccionLineaId;
        data["ordenProduccionLineaNombre"] = this.ordenProduccionLineaNombre;
        if (Array.isArray(this.consumo)) {
            data["Consumo"] = [];
            for (let item of this.consumo)
                data["Consumo"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.pT)) {
            data["PT"] = [];
            for (let item of this.pT)
                data["PT"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.proceso)) {
            data["Proceso"] = [];
            for (let item of this.proceso)
                data["Proceso"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrdenProduccion {
    ordenProduccionId?: number;
    ordenProduccionNumero?: number;
    ordenProduccionPrefijo?: string;
    ordenProduccionId2?: string;
    ordenProduccionFecha?: Date;
    ordenProduccionBodegaId?: string;
    ordenProduccionInsBodegaId?: string;
    ordenProduccionItems?: number;
    ordenProduccionFechaProd?: Date;
    ordenProduccionEstado?: string;
    ordenProduccionNotas?: string;
    ordenProduccionDocumentoId?: number;
    ordenProduccionInsHr?: Date | undefined;
    ordenProduccionUser?: string | undefined;
    ordenProduccionConsumos?: number | undefined;
    ordenProduccionModo?: number | undefined;
    ordenProduccionLoteNo?: string | undefined;
    ordenProduccionFechaVenc?: Date | undefined;
    ordenProduccionLineaId?: number | undefined;
    ordenProduccionLineaNombre?: string;
    consumo?: OrdenProduccionCon[];
    pT?: OrdenProduccionPT[];
    proceso?: OrdenProduccionProceso[];
}

export class OrdenProduccionCon implements IOrdenProduccionCon {
    ordenProduccionConId?: number;
    ordenProduccionInsumoId?: string;
    ordenProduccionInsumo?: string;
    ordenProduccionInsumoUnd?: string;
    ordenProduccionInsCantidad?: number;
    ordenProduccionConsumoProceso?: number | undefined;
    ordenProduccionConsumoWIP?: boolean | undefined;

    constructor(data?: IOrdenProduccionCon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordenProduccionConId = _data["ordenProduccionConId"];
            this.ordenProduccionInsumoId = _data["ordenProduccionInsumoId"];
            this.ordenProduccionInsumo = _data["OrdenProduccionInsumo"];
            this.ordenProduccionInsumoUnd = _data["ordenProduccionInsumoUnd"];
            this.ordenProduccionInsCantidad = _data["ordenProduccionInsCantidad"];
            this.ordenProduccionConsumoProceso = _data["ordenProduccionConsumoProceso"];
            this.ordenProduccionConsumoWIP = _data["ordenProduccionConsumoWIP"];
        }
    }

    static fromJS(data: any): OrdenProduccionCon {
        data = typeof data === 'object' ? data : {};
        let result = new OrdenProduccionCon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordenProduccionConId"] = this.ordenProduccionConId;
        data["ordenProduccionInsumoId"] = this.ordenProduccionInsumoId;
        data["OrdenProduccionInsumo"] = this.ordenProduccionInsumo;
        data["ordenProduccionInsumoUnd"] = this.ordenProduccionInsumoUnd;
        data["ordenProduccionInsCantidad"] = this.ordenProduccionInsCantidad;
        data["ordenProduccionConsumoProceso"] = this.ordenProduccionConsumoProceso;
        data["ordenProduccionConsumoWIP"] = this.ordenProduccionConsumoWIP;
        return data;
    }
}

export interface IOrdenProduccionCon {
    ordenProduccionConId?: number;
    ordenProduccionInsumoId?: string;
    ordenProduccionInsumo?: string;
    ordenProduccionInsumoUnd?: string;
    ordenProduccionInsCantidad?: number;
    ordenProduccionConsumoProceso?: number | undefined;
    ordenProduccionConsumoWIP?: boolean | undefined;
}

export class OrdenProduccionPT implements IOrdenProduccionPT {
    ordenProduccionPTId?: number;
    ordenProduccionPT?: string;
    ordenProduccionPTNombre?: string;
    ordenProduccionPTFormula?: string;
    ordenProduccionPTUnd?: string;
    formulaTipoLote?: number | undefined;
    formulaLoteNoActual?: number | undefined;
    formulaLoteTexto?: string | undefined;
    formulaDiasVencimiento?: number | undefined;
    ordenProduccionCant?: number;
    ordenProduccionTipo?: number;
    ordenProduccionFormula?: string | undefined;
    ordenProduccionCantET?: number | undefined;
    ordenProduccionCantProducida?: number | undefined;
    ordenProduccionPTProceso?: number | undefined;

    constructor(data?: IOrdenProduccionPT) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordenProduccionPTId = _data["ordenProduccionPTId"];
            this.ordenProduccionPT = _data["OrdenProduccionPT"];
            this.ordenProduccionPTNombre = _data["ordenProduccionPTNombre"];
            this.ordenProduccionPTFormula = _data["ordenProduccionPTFormula"];
            this.ordenProduccionPTUnd = _data["ordenProduccionPTUnd"];
            this.formulaTipoLote = _data["formulaTipoLote"];
            this.formulaLoteNoActual = _data["formulaLoteNoActual"];
            this.formulaLoteTexto = _data["formulaLoteTexto"];
            this.formulaDiasVencimiento = _data["formulaDiasVencimiento"];
            this.ordenProduccionCant = _data["ordenProduccionCant"];
            this.ordenProduccionTipo = _data["ordenProduccionTipo"];
            this.ordenProduccionFormula = _data["ordenProduccionFormula"];
            this.ordenProduccionCantET = _data["ordenProduccionCantET"];
            this.ordenProduccionCantProducida = _data["ordenProduccionCantProducida"];
            this.ordenProduccionPTProceso = _data["ordenProduccionPTProceso"];
        }
    }

    static fromJS(data: any): OrdenProduccionPT {
        data = typeof data === 'object' ? data : {};
        let result = new OrdenProduccionPT();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordenProduccionPTId"] = this.ordenProduccionPTId;
        data["OrdenProduccionPT"] = this.ordenProduccionPT;
        data["ordenProduccionPTNombre"] = this.ordenProduccionPTNombre;
        data["ordenProduccionPTFormula"] = this.ordenProduccionPTFormula;
        data["ordenProduccionPTUnd"] = this.ordenProduccionPTUnd;
        data["formulaTipoLote"] = this.formulaTipoLote;
        data["formulaLoteNoActual"] = this.formulaLoteNoActual;
        data["formulaLoteTexto"] = this.formulaLoteTexto;
        data["formulaDiasVencimiento"] = this.formulaDiasVencimiento;
        data["ordenProduccionCant"] = this.ordenProduccionCant;
        data["ordenProduccionTipo"] = this.ordenProduccionTipo;
        data["ordenProduccionFormula"] = this.ordenProduccionFormula;
        data["ordenProduccionCantET"] = this.ordenProduccionCantET;
        data["ordenProduccionCantProducida"] = this.ordenProduccionCantProducida;
        data["ordenProduccionPTProceso"] = this.ordenProduccionPTProceso;
        return data;
    }
}

export interface IOrdenProduccionPT {
    ordenProduccionPTId?: number;
    ordenProduccionPT?: string;
    ordenProduccionPTNombre?: string;
    ordenProduccionPTFormula?: string;
    ordenProduccionPTUnd?: string;
    formulaTipoLote?: number | undefined;
    formulaLoteNoActual?: number | undefined;
    formulaLoteTexto?: string | undefined;
    formulaDiasVencimiento?: number | undefined;
    ordenProduccionCant?: number;
    ordenProduccionTipo?: number;
    ordenProduccionFormula?: string | undefined;
    ordenProduccionCantET?: number | undefined;
    ordenProduccionCantProducida?: number | undefined;
    ordenProduccionPTProceso?: number | undefined;
}

export class OrdenProduccionProceso implements IOrdenProduccionProceso {
    ordenProduccionId?: number;
    opProcesoId?: number;
    opProcesoDescripcion?: string;
    opProcesoProperties?: string;
    opProcesoEstado?: number;

    constructor(data?: IOrdenProduccionProceso) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordenProduccionId = _data["ordenProduccionId"];
            this.opProcesoId = _data["opProcesoId"];
            this.opProcesoDescripcion = _data["opProcesoDescripcion"];
            this.opProcesoProperties = _data["opProcesoProperties"];
            this.opProcesoEstado = _data["opProcesoEstado"];
        }
    }

    static fromJS(data: any): OrdenProduccionProceso {
        data = typeof data === 'object' ? data : {};
        let result = new OrdenProduccionProceso();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordenProduccionId"] = this.ordenProduccionId;
        data["opProcesoId"] = this.opProcesoId;
        data["opProcesoDescripcion"] = this.opProcesoDescripcion;
        data["opProcesoProperties"] = this.opProcesoProperties;
        data["opProcesoEstado"] = this.opProcesoEstado;
        return data;
    }
}

export interface IOrdenProduccionProceso {
    ordenProduccionId?: number;
    opProcesoId?: number;
    opProcesoDescripcion?: string;
    opProcesoProperties?: string;
    opProcesoEstado?: number;
}

export class ExplosionMaterialesInsumoItem implements IExplosionMaterialesInsumoItem {
    produccionInsumoId?: string;
    produccionInsumoNombre?: string;
    produccionInsumoUnd?: string;
    produccionInsumoCantidad?: number;
    produccionInsumoFCantidad?: number;

    constructor(data?: IExplosionMaterialesInsumoItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.produccionInsumoId = _data["produccionInsumoId"];
            this.produccionInsumoNombre = _data["produccionInsumoNombre"];
            this.produccionInsumoUnd = _data["produccionInsumoUnd"];
            this.produccionInsumoCantidad = _data["produccionInsumoCantidad"];
            this.produccionInsumoFCantidad = _data["produccionInsumoFCantidad"];
        }
    }

    static fromJS(data: any): ExplosionMaterialesInsumoItem {
        data = typeof data === 'object' ? data : {};
        let result = new ExplosionMaterialesInsumoItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["produccionInsumoId"] = this.produccionInsumoId;
        data["produccionInsumoNombre"] = this.produccionInsumoNombre;
        data["produccionInsumoUnd"] = this.produccionInsumoUnd;
        data["produccionInsumoCantidad"] = this.produccionInsumoCantidad;
        data["produccionInsumoFCantidad"] = this.produccionInsumoFCantidad;
        return data;
    }
}

export interface IExplosionMaterialesInsumoItem {
    produccionInsumoId?: string;
    produccionInsumoNombre?: string;
    produccionInsumoUnd?: string;
    produccionInsumoCantidad?: number;
    produccionInsumoFCantidad?: number;
}

export class ExplosionMaterialesRequest implements IExplosionMaterialesRequest {
    detalle?: ExplosionMaterialesDetalleItem[];

    constructor(data?: IExplosionMaterialesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["detalle"])) {
                this.detalle = [] as any;
                for (let item of _data["detalle"])
                    this.detalle!.push(ExplosionMaterialesDetalleItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExplosionMaterialesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExplosionMaterialesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.detalle)) {
            data["detalle"] = [];
            for (let item of this.detalle)
                data["detalle"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExplosionMaterialesRequest {
    detalle?: ExplosionMaterialesDetalleItem[];
}

export class ExplosionMaterialesDetalleItem implements IExplosionMaterialesDetalleItem {
    productoId?: string;
    cantidad?: number;

    constructor(data?: IExplosionMaterialesDetalleItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productoId = _data["productoId"];
            this.cantidad = _data["cantidad"];
        }
    }

    static fromJS(data: any): ExplosionMaterialesDetalleItem {
        data = typeof data === 'object' ? data : {};
        let result = new ExplosionMaterialesDetalleItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productoId"] = this.productoId;
        data["cantidad"] = this.cantidad;
        return data;
    }
}

export interface IExplosionMaterialesDetalleItem {
    productoId?: string;
    cantidad?: number;
}

export class DesagregacionCalcularRequest implements IDesagregacionCalcularRequest {
    formulaId?: string;
    insumoCantidad?: number;

    constructor(data?: IDesagregacionCalcularRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formulaId = _data["formulaId"];
            this.insumoCantidad = _data["insumoCantidad"];
        }
    }

    static fromJS(data: any): DesagregacionCalcularRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DesagregacionCalcularRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formulaId"] = this.formulaId;
        data["insumoCantidad"] = this.insumoCantidad;
        return data;
    }
}

export interface IDesagregacionCalcularRequest {
    formulaId?: string;
    insumoCantidad?: number;
}

export class TrasladoMaterialesItemDto implements ITrasladoMaterialesItemDto {
    productoId?: string;
    productoNombre?: string;
    productoManejo?: string | undefined;
    insumoUnidad?: string;
    requeridaCantidad?: number;
    opProcesoCantidad?: number;
    inventarioCantidad?: number;
    solicitudCantidad?: number;
    lotesDisponibles?: LoteProductoItemDto[] | undefined;

    constructor(data?: ITrasladoMaterialesItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productoId = _data["productoId"];
            this.productoNombre = _data["productoNombre"];
            this.productoManejo = _data["productoManejo"];
            this.insumoUnidad = _data["insumoUnidad"];
            this.requeridaCantidad = _data["requeridaCantidad"];
            this.opProcesoCantidad = _data["opProcesoCantidad"];
            this.inventarioCantidad = _data["inventarioCantidad"];
            this.solicitudCantidad = _data["solicitudCantidad"];
            if (Array.isArray(_data["lotesDisponibles"])) {
                this.lotesDisponibles = [] as any;
                for (let item of _data["lotesDisponibles"])
                    this.lotesDisponibles!.push(LoteProductoItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrasladoMaterialesItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrasladoMaterialesItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productoId"] = this.productoId;
        data["productoNombre"] = this.productoNombre;
        data["productoManejo"] = this.productoManejo;
        data["insumoUnidad"] = this.insumoUnidad;
        data["requeridaCantidad"] = this.requeridaCantidad;
        data["opProcesoCantidad"] = this.opProcesoCantidad;
        data["inventarioCantidad"] = this.inventarioCantidad;
        data["solicitudCantidad"] = this.solicitudCantidad;
        if (Array.isArray(this.lotesDisponibles)) {
            data["lotesDisponibles"] = [];
            for (let item of this.lotesDisponibles)
                data["lotesDisponibles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITrasladoMaterialesItemDto {
    productoId?: string;
    productoNombre?: string;
    productoManejo?: string | undefined;
    insumoUnidad?: string;
    requeridaCantidad?: number;
    opProcesoCantidad?: number;
    inventarioCantidad?: number;
    solicitudCantidad?: number;
    lotesDisponibles?: LoteProductoItemDto[] | undefined;
}

export class PagingOfPedido implements IPagingOfPedido {
    count?: number;
    data?: Pedido[];

    constructor(data?: IPagingOfPedido) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Pedido.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfPedido {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfPedido();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfPedido {
    count?: number;
    data?: Pedido[];
}

export class Pedido implements IPedido {
    pedidoId?: number;
    pedidoFecha?: Date;
    pedidoFechaEntrega?: Date;
    pedidoClienteId?: number;
    pedidoVendedorId?: number;
    pedidoItems?: number;
    pedidoNotas?: string;
    pedidoId2?: string;
    pedidoHora?: Date;
    pedidoTipoPago?: string;
    pedidoEstado?: string;
    pedidoDescuento?: number;
    pedidoPrefijo?: string;
    pedidoNumero?: number;
    pedidoUser?: string;
    pedidoInsHr?: Date;
    pedidoBodegaId?: string | undefined;
    pedidoVrSuma?: number;
    pedidoVrSubtotal?: number;
    pedidoVrBase?: number;
    pedidoVrDcto?: number;
    pedidoVrIVA?: number;
    pedidoVrAPagar?: number;
    pedidoVrSaldo?: number;
    pedidoDocumentoId?: number;
    pedidoVehiculoId?: number | undefined;
    pedidoPlazoFinanciero?: number;
    pedidoDctoFinanciero?: number;
    pedidoPlazo?: number;
    pedidoOrdenCliente?: string;
    pedidoFacturaId?: number | undefined;
    pedidoGPS?: string | undefined;
    pedidoDireccion?: string | undefined;
    pedidoCantFacturada?: number | undefined;
    pedidoVrImpoconsumo?: number | undefined;
    pedidoProyectoCabId?: string | undefined;
    pedidoRetencionRentaId?: number | undefined;
    pedidoVrReteRenta?: number | undefined;
    pedidoMonedaId?: string | undefined;
    pedidoTipoOperacion?: string | undefined;
    pedidoTimeStamp?: string | undefined;
    pedidoVrRetencionICA?: number | undefined;
    pedidoRetencionICAId?: number | undefined;
    pedidoSucursalId?: number | undefined;
    pedidoOrigen?: number | undefined;
    pedidoProperties?: string | undefined;
    pedidoBultos?: number | undefined;
    pedidoVrBulto?: number | undefined;
    pedidoVrFlete?: number | undefined;
    pedidoUpdate?: Date | undefined;

    constructor(data?: IPedido) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pedidoId = _data["pedidoId"];
            this.pedidoFecha = _data["pedidoFecha"] ? new Date(_data["pedidoFecha"].toString()) : undefined as any;
            this.pedidoFechaEntrega = _data["pedidoFechaEntrega"] ? new Date(_data["pedidoFechaEntrega"].toString()) : undefined as any;
            this.pedidoClienteId = _data["pedidoClienteId"];
            this.pedidoVendedorId = _data["pedidoVendedorId"];
            this.pedidoItems = _data["pedidoItems"];
            this.pedidoNotas = _data["pedidoNotas"];
            this.pedidoId2 = _data["pedidoId2"];
            this.pedidoHora = _data["pedidoHora"] ? new Date(_data["pedidoHora"].toString()) : undefined as any;
            this.pedidoTipoPago = _data["pedidoTipoPago"];
            this.pedidoEstado = _data["pedidoEstado"];
            this.pedidoDescuento = _data["pedidoDescuento"];
            this.pedidoPrefijo = _data["pedidoPrefijo"];
            this.pedidoNumero = _data["pedidoNumero"];
            this.pedidoUser = _data["pedidoUser"];
            this.pedidoInsHr = _data["pedidoInsHr"] ? new Date(_data["pedidoInsHr"].toString()) : undefined as any;
            this.pedidoBodegaId = _data["pedidoBodegaId"];
            this.pedidoVrSuma = _data["pedidoVrSuma"];
            this.pedidoVrSubtotal = _data["pedidoVrSubtotal"];
            this.pedidoVrBase = _data["pedidoVrBase"];
            this.pedidoVrDcto = _data["pedidoVrDcto"];
            this.pedidoVrIVA = _data["pedidoVrIVA"];
            this.pedidoVrAPagar = _data["pedidoVrAPagar"];
            this.pedidoVrSaldo = _data["pedidoVrSaldo"];
            this.pedidoDocumentoId = _data["pedidoDocumentoId"];
            this.pedidoVehiculoId = _data["pedidoVehiculoId"];
            this.pedidoPlazoFinanciero = _data["pedidoPlazoFinanciero"];
            this.pedidoDctoFinanciero = _data["pedidoDctoFinanciero"];
            this.pedidoPlazo = _data["pedidoPlazo"];
            this.pedidoOrdenCliente = _data["pedidoOrdenCliente"];
            this.pedidoFacturaId = _data["pedidoFacturaId"];
            this.pedidoGPS = _data["pedidoGPS"];
            this.pedidoDireccion = _data["pedidoDireccion"];
            this.pedidoCantFacturada = _data["pedidoCantFacturada"];
            this.pedidoVrImpoconsumo = _data["pedidoVrImpoconsumo"];
            this.pedidoProyectoCabId = _data["pedidoProyectoCabId"];
            this.pedidoRetencionRentaId = _data["pedidoRetencionRentaId"];
            this.pedidoVrReteRenta = _data["pedidoVrReteRenta"];
            this.pedidoMonedaId = _data["pedidoMonedaId"];
            this.pedidoTipoOperacion = _data["pedidoTipoOperacion"];
            this.pedidoTimeStamp = _data["pedidoTimeStamp"];
            this.pedidoVrRetencionICA = _data["pedidoVrRetencionICA"];
            this.pedidoRetencionICAId = _data["pedidoRetencionICAId"];
            this.pedidoSucursalId = _data["pedidoSucursalId"];
            this.pedidoOrigen = _data["pedidoOrigen"];
            this.pedidoProperties = _data["pedidoProperties"];
            this.pedidoBultos = _data["pedidoBultos"];
            this.pedidoVrBulto = _data["pedidoVrBulto"];
            this.pedidoVrFlete = _data["pedidoVrFlete"];
            this.pedidoUpdate = _data["pedidoUpdate"] ? new Date(_data["pedidoUpdate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Pedido {
        data = typeof data === 'object' ? data : {};
        let result = new Pedido();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pedidoId"] = this.pedidoId;
        data["pedidoFecha"] = this.pedidoFecha ? this.pedidoFecha.toISOString() : undefined as any;
        data["pedidoFechaEntrega"] = this.pedidoFechaEntrega ? this.pedidoFechaEntrega.toISOString() : undefined as any;
        data["pedidoClienteId"] = this.pedidoClienteId;
        data["pedidoVendedorId"] = this.pedidoVendedorId;
        data["pedidoItems"] = this.pedidoItems;
        data["pedidoNotas"] = this.pedidoNotas;
        data["pedidoId2"] = this.pedidoId2;
        data["pedidoHora"] = this.pedidoHora ? this.pedidoHora.toISOString() : undefined as any;
        data["pedidoTipoPago"] = this.pedidoTipoPago;
        data["pedidoEstado"] = this.pedidoEstado;
        data["pedidoDescuento"] = this.pedidoDescuento;
        data["pedidoPrefijo"] = this.pedidoPrefijo;
        data["pedidoNumero"] = this.pedidoNumero;
        data["pedidoUser"] = this.pedidoUser;
        data["pedidoInsHr"] = this.pedidoInsHr ? this.pedidoInsHr.toISOString() : undefined as any;
        data["pedidoBodegaId"] = this.pedidoBodegaId;
        data["pedidoVrSuma"] = this.pedidoVrSuma;
        data["pedidoVrSubtotal"] = this.pedidoVrSubtotal;
        data["pedidoVrBase"] = this.pedidoVrBase;
        data["pedidoVrDcto"] = this.pedidoVrDcto;
        data["pedidoVrIVA"] = this.pedidoVrIVA;
        data["pedidoVrAPagar"] = this.pedidoVrAPagar;
        data["pedidoVrSaldo"] = this.pedidoVrSaldo;
        data["pedidoDocumentoId"] = this.pedidoDocumentoId;
        data["pedidoVehiculoId"] = this.pedidoVehiculoId;
        data["pedidoPlazoFinanciero"] = this.pedidoPlazoFinanciero;
        data["pedidoDctoFinanciero"] = this.pedidoDctoFinanciero;
        data["pedidoPlazo"] = this.pedidoPlazo;
        data["pedidoOrdenCliente"] = this.pedidoOrdenCliente;
        data["pedidoFacturaId"] = this.pedidoFacturaId;
        data["pedidoGPS"] = this.pedidoGPS;
        data["pedidoDireccion"] = this.pedidoDireccion;
        data["pedidoCantFacturada"] = this.pedidoCantFacturada;
        data["pedidoVrImpoconsumo"] = this.pedidoVrImpoconsumo;
        data["pedidoProyectoCabId"] = this.pedidoProyectoCabId;
        data["pedidoRetencionRentaId"] = this.pedidoRetencionRentaId;
        data["pedidoVrReteRenta"] = this.pedidoVrReteRenta;
        data["pedidoMonedaId"] = this.pedidoMonedaId;
        data["pedidoTipoOperacion"] = this.pedidoTipoOperacion;
        data["pedidoTimeStamp"] = this.pedidoTimeStamp;
        data["pedidoVrRetencionICA"] = this.pedidoVrRetencionICA;
        data["pedidoRetencionICAId"] = this.pedidoRetencionICAId;
        data["pedidoSucursalId"] = this.pedidoSucursalId;
        data["pedidoOrigen"] = this.pedidoOrigen;
        data["pedidoProperties"] = this.pedidoProperties;
        data["pedidoBultos"] = this.pedidoBultos;
        data["pedidoVrBulto"] = this.pedidoVrBulto;
        data["pedidoVrFlete"] = this.pedidoVrFlete;
        data["pedidoUpdate"] = this.pedidoUpdate ? this.pedidoUpdate.toISOString() : undefined as any;
        return data;
    }
}

export interface IPedido {
    pedidoId?: number;
    pedidoFecha?: Date;
    pedidoFechaEntrega?: Date;
    pedidoClienteId?: number;
    pedidoVendedorId?: number;
    pedidoItems?: number;
    pedidoNotas?: string;
    pedidoId2?: string;
    pedidoHora?: Date;
    pedidoTipoPago?: string;
    pedidoEstado?: string;
    pedidoDescuento?: number;
    pedidoPrefijo?: string;
    pedidoNumero?: number;
    pedidoUser?: string;
    pedidoInsHr?: Date;
    pedidoBodegaId?: string | undefined;
    pedidoVrSuma?: number;
    pedidoVrSubtotal?: number;
    pedidoVrBase?: number;
    pedidoVrDcto?: number;
    pedidoVrIVA?: number;
    pedidoVrAPagar?: number;
    pedidoVrSaldo?: number;
    pedidoDocumentoId?: number;
    pedidoVehiculoId?: number | undefined;
    pedidoPlazoFinanciero?: number;
    pedidoDctoFinanciero?: number;
    pedidoPlazo?: number;
    pedidoOrdenCliente?: string;
    pedidoFacturaId?: number | undefined;
    pedidoGPS?: string | undefined;
    pedidoDireccion?: string | undefined;
    pedidoCantFacturada?: number | undefined;
    pedidoVrImpoconsumo?: number | undefined;
    pedidoProyectoCabId?: string | undefined;
    pedidoRetencionRentaId?: number | undefined;
    pedidoVrReteRenta?: number | undefined;
    pedidoMonedaId?: string | undefined;
    pedidoTipoOperacion?: string | undefined;
    pedidoTimeStamp?: string | undefined;
    pedidoVrRetencionICA?: number | undefined;
    pedidoRetencionICAId?: number | undefined;
    pedidoSucursalId?: number | undefined;
    pedidoOrigen?: number | undefined;
    pedidoProperties?: string | undefined;
    pedidoBultos?: number | undefined;
    pedidoVrBulto?: number | undefined;
    pedidoVrFlete?: number | undefined;
    pedidoUpdate?: Date | undefined;
}

export class PagingOfPrecioLista implements IPagingOfPrecioLista {
    count?: number;
    data?: PrecioLista[];

    constructor(data?: IPagingOfPrecioLista) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PrecioLista.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfPrecioLista {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfPrecioLista();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfPrecioLista {
    count?: number;
    data?: PrecioLista[];
}

export class PrecioLista implements IPrecioLista {
    precioListaId?: string;
    precioListaNombre?: string;
    precioListaIVAIncluido?: boolean;
    monedaId?: string | undefined;
    precioListaEstado?: boolean | undefined;
    precioListaMargen?: number | undefined;

    constructor(data?: IPrecioLista) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.precioListaId = _data["precioListaId"];
            this.precioListaNombre = _data["precioListaNombre"];
            this.precioListaIVAIncluido = _data["precioListaIVAIncluido"];
            this.monedaId = _data["monedaId"];
            this.precioListaEstado = _data["precioListaEstado"];
            this.precioListaMargen = _data["precioListaMargen"];
        }
    }

    static fromJS(data: any): PrecioLista {
        data = typeof data === 'object' ? data : {};
        let result = new PrecioLista();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["precioListaId"] = this.precioListaId;
        data["precioListaNombre"] = this.precioListaNombre;
        data["precioListaIVAIncluido"] = this.precioListaIVAIncluido;
        data["monedaId"] = this.monedaId;
        data["precioListaEstado"] = this.precioListaEstado;
        data["precioListaMargen"] = this.precioListaMargen;
        return data;
    }
}

export interface IPrecioLista {
    precioListaId?: string;
    precioListaNombre?: string;
    precioListaIVAIncluido?: boolean;
    monedaId?: string | undefined;
    precioListaEstado?: boolean | undefined;
    precioListaMargen?: number | undefined;
}

export class PagingOfPrecioCompra implements IPagingOfPrecioCompra {
    count?: number;
    data?: PrecioCompra[];

    constructor(data?: IPagingOfPrecioCompra) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PrecioCompra.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfPrecioCompra {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfPrecioCompra();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfPrecioCompra {
    count?: number;
    data?: PrecioCompra[];
}

export class PrecioCompra implements IPrecioCompra {
    precioCompraId?: number;
    proveedorId?: number;
    precioCompraTipo?: number;
    productoId?: string;
    precioCompraFecha?: Date;
    precioCompraValor?: number;
    precioCompraIPC?: number;
    precioCompraImp3?: number;
    precioCompraDcto1?: number;
    precioCompraDcto2?: number;
    precioCompraICUI?: number | undefined;

    constructor(data?: IPrecioCompra) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.precioCompraId = _data["precioCompraId"];
            this.proveedorId = _data["proveedorId"];
            this.precioCompraTipo = _data["precioCompraTipo"];
            this.productoId = _data["productoId"];
            this.precioCompraFecha = _data["precioCompraFecha"] ? new Date(_data["precioCompraFecha"].toString()) : undefined as any;
            this.precioCompraValor = _data["precioCompraValor"];
            this.precioCompraIPC = _data["precioCompraIPC"];
            this.precioCompraImp3 = _data["precioCompraImp3"];
            this.precioCompraDcto1 = _data["precioCompraDcto1"];
            this.precioCompraDcto2 = _data["precioCompraDcto2"];
            this.precioCompraICUI = _data["precioCompraICUI"];
        }
    }

    static fromJS(data: any): PrecioCompra {
        data = typeof data === 'object' ? data : {};
        let result = new PrecioCompra();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["precioCompraId"] = this.precioCompraId;
        data["proveedorId"] = this.proveedorId;
        data["precioCompraTipo"] = this.precioCompraTipo;
        data["productoId"] = this.productoId;
        data["precioCompraFecha"] = this.precioCompraFecha ? this.precioCompraFecha.toISOString() : undefined as any;
        data["precioCompraValor"] = this.precioCompraValor;
        data["precioCompraIPC"] = this.precioCompraIPC;
        data["precioCompraImp3"] = this.precioCompraImp3;
        data["precioCompraDcto1"] = this.precioCompraDcto1;
        data["precioCompraDcto2"] = this.precioCompraDcto2;
        data["precioCompraICUI"] = this.precioCompraICUI;
        return data;
    }
}

export interface IPrecioCompra {
    precioCompraId?: number;
    proveedorId?: number;
    precioCompraTipo?: number;
    productoId?: string;
    precioCompraFecha?: Date;
    precioCompraValor?: number;
    precioCompraIPC?: number;
    precioCompraImp3?: number;
    precioCompraDcto1?: number;
    precioCompraDcto2?: number;
    precioCompraICUI?: number | undefined;
}

export class PagingOfProduccion implements IPagingOfProduccion {
    count?: number;
    data?: Produccion[];

    constructor(data?: IPagingOfProduccion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Produccion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfProduccion {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfProduccion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfProduccion {
    count?: number;
    data?: Produccion[];
}

export class Produccion implements IProduccion {
    produccionId?: number;
    produccionFecha?: Date;
    produccionBodegaId?: string;
    produccionBodegaInsumoId?: string;
    kardexId?: number | undefined;
    produccionEstado?: string;
    produccionPrefijo?: string;
    documentoId?: number | undefined;
    produccionNumero?: number;
    produccionId2?: string;
    produccionConsumoItems?: number | undefined;
    produccionOrdenId?: number | undefined;
    produccionOrdenId2?: string;
    produccionFin?: Date | undefined;
    produccionInicio?: Date | undefined;
    produccionLineaId?: number | undefined;
    consumos?: ProduccionConsumo[];
    pt?: ProduccionPT[];
    produccionTotalMO?: number | undefined;
    produccionTotalCIF?: number | undefined;

    constructor(data?: IProduccion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.produccionId = _data["produccionId"];
            this.produccionFecha = _data["produccionFecha"] ? new Date(_data["produccionFecha"].toString()) : undefined as any;
            this.produccionBodegaId = _data["produccionBodegaId"];
            this.produccionBodegaInsumoId = _data["produccionBodegaInsumoId"];
            this.kardexId = _data["kardexId"];
            this.produccionEstado = _data["produccionEstado"];
            this.produccionPrefijo = _data["produccionPrefijo"];
            this.documentoId = _data["documentoId"];
            this.produccionNumero = _data["produccionNumero"];
            this.produccionId2 = _data["produccionId2"];
            this.produccionConsumoItems = _data["produccionConsumoItems"];
            this.produccionOrdenId = _data["produccionOrdenId"];
            this.produccionOrdenId2 = _data["produccionOrdenId2"];
            this.produccionFin = _data["produccionFin"] ? new Date(_data["produccionFin"].toString()) : undefined as any;
            this.produccionInicio = _data["produccionInicio"] ? new Date(_data["produccionInicio"].toString()) : undefined as any;
            this.produccionLineaId = _data["produccionLineaId"];
            if (Array.isArray(_data["consumos"])) {
                this.consumos = [] as any;
                for (let item of _data["consumos"])
                    this.consumos!.push(ProduccionConsumo.fromJS(item));
            }
            if (Array.isArray(_data["pt"])) {
                this.pt = [] as any;
                for (let item of _data["pt"])
                    this.pt!.push(ProduccionPT.fromJS(item));
            }
            this.produccionTotalMO = _data["produccionTotalMO"];
            this.produccionTotalCIF = _data["produccionTotalCIF"];
        }
    }

    static fromJS(data: any): Produccion {
        data = typeof data === 'object' ? data : {};
        let result = new Produccion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["produccionId"] = this.produccionId;
        data["produccionFecha"] = this.produccionFecha ? this.produccionFecha.toISOString() : undefined as any;
        data["produccionBodegaId"] = this.produccionBodegaId;
        data["produccionBodegaInsumoId"] = this.produccionBodegaInsumoId;
        data["kardexId"] = this.kardexId;
        data["produccionEstado"] = this.produccionEstado;
        data["produccionPrefijo"] = this.produccionPrefijo;
        data["documentoId"] = this.documentoId;
        data["produccionNumero"] = this.produccionNumero;
        data["produccionId2"] = this.produccionId2;
        data["produccionConsumoItems"] = this.produccionConsumoItems;
        data["produccionOrdenId"] = this.produccionOrdenId;
        data["produccionOrdenId2"] = this.produccionOrdenId2;
        data["produccionFin"] = this.produccionFin ? this.produccionFin.toISOString() : undefined as any;
        data["produccionInicio"] = this.produccionInicio ? this.produccionInicio.toISOString() : undefined as any;
        data["produccionLineaId"] = this.produccionLineaId;
        if (Array.isArray(this.consumos)) {
            data["consumos"] = [];
            for (let item of this.consumos)
                data["consumos"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.pt)) {
            data["pt"] = [];
            for (let item of this.pt)
                data["pt"].push(item ? item.toJSON() : undefined as any);
        }
        data["produccionTotalMO"] = this.produccionTotalMO;
        data["produccionTotalCIF"] = this.produccionTotalCIF;
        return data;
    }
}

export interface IProduccion {
    produccionId?: number;
    produccionFecha?: Date;
    produccionBodegaId?: string;
    produccionBodegaInsumoId?: string;
    kardexId?: number | undefined;
    produccionEstado?: string;
    produccionPrefijo?: string;
    documentoId?: number | undefined;
    produccionNumero?: number;
    produccionId2?: string;
    produccionConsumoItems?: number | undefined;
    produccionOrdenId?: number | undefined;
    produccionOrdenId2?: string;
    produccionFin?: Date | undefined;
    produccionInicio?: Date | undefined;
    produccionLineaId?: number | undefined;
    consumos?: ProduccionConsumo[];
    pt?: ProduccionPT[];
    produccionTotalMO?: number | undefined;
    produccionTotalCIF?: number | undefined;
}

export class ProduccionConsumo implements IProduccionConsumo {
    produccionConsumoId?: number;
    produccionInsumoId?: string;
    produccionConsumoR?: number;
    produccionConsumoF?: number;
    produccionConsumoVrUnt?: number | undefined;
    lotes?: ConsumoLoteAsignacion[];
    porcentaje?: number | undefined;
    totalMovimiento?: number | undefined;

    constructor(data?: IProduccionConsumo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.produccionConsumoId = _data["produccionConsumoId"];
            this.produccionInsumoId = _data["produccionInsumoId"];
            this.produccionConsumoR = _data["produccionConsumoR"];
            this.produccionConsumoF = _data["produccionConsumoF"];
            this.produccionConsumoVrUnt = _data["produccionConsumoVrUnt"];
            if (Array.isArray(_data["lotes"])) {
                this.lotes = [] as any;
                for (let item of _data["lotes"])
                    this.lotes!.push(ConsumoLoteAsignacion.fromJS(item));
            }
            this.porcentaje = _data["porcentaje"];
            this.totalMovimiento = _data["totalMovimiento"];
        }
    }

    static fromJS(data: any): ProduccionConsumo {
        data = typeof data === 'object' ? data : {};
        let result = new ProduccionConsumo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["produccionConsumoId"] = this.produccionConsumoId;
        data["produccionInsumoId"] = this.produccionInsumoId;
        data["produccionConsumoR"] = this.produccionConsumoR;
        data["produccionConsumoF"] = this.produccionConsumoF;
        data["produccionConsumoVrUnt"] = this.produccionConsumoVrUnt;
        if (Array.isArray(this.lotes)) {
            data["lotes"] = [];
            for (let item of this.lotes)
                data["lotes"].push(item ? item.toJSON() : undefined as any);
        }
        data["porcentaje"] = this.porcentaje;
        data["totalMovimiento"] = this.totalMovimiento;
        return data;
    }
}

export interface IProduccionConsumo {
    produccionConsumoId?: number;
    produccionInsumoId?: string;
    produccionConsumoR?: number;
    produccionConsumoF?: number;
    produccionConsumoVrUnt?: number | undefined;
    lotes?: ConsumoLoteAsignacion[];
    porcentaje?: number | undefined;
    totalMovimiento?: number | undefined;
}

export class ConsumoLoteAsignacion implements IConsumoLoteAsignacion {
    loteId?: number;
    cantidad?: number;

    constructor(data?: IConsumoLoteAsignacion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loteId = _data["loteId"];
            this.cantidad = _data["cantidad"];
        }
    }

    static fromJS(data: any): ConsumoLoteAsignacion {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumoLoteAsignacion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loteId"] = this.loteId;
        data["cantidad"] = this.cantidad;
        return data;
    }
}

export interface IConsumoLoteAsignacion {
    loteId?: number;
    cantidad?: number;
}

export class ProduccionPT implements IProduccionPT {
    produccionId?: number;
    produccionPTId?: string;
    produccionCantidad?: number;
    produccionLoteId?: number | undefined;
    produccionLoteNo?: string | undefined;
    produccionLoteFecha?: Date | undefined;
    vrUnitario?: number | undefined;
    porcentaje?: number | undefined;
    totalMovimiento?: number | undefined;
    produccionItems?: number | undefined;
    produccionCantidadOP?: number | undefined;
    produccionCIFCosto?: number | undefined;
    produccionMOCosto?: number | undefined;
    produccionInsCosto?: number | undefined;
    produccionPTForm?: string | undefined;
    ptCon?: ProduccionPTCon[];

    constructor(data?: IProduccionPT) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.produccionId = _data["produccionId"];
            this.produccionPTId = _data["produccionPTId"];
            this.produccionCantidad = _data["produccionCantidad"];
            this.produccionLoteId = _data["produccionLoteId"];
            this.produccionLoteNo = _data["produccionLoteNo"];
            this.produccionLoteFecha = _data["produccionLoteFecha"] ? new Date(_data["produccionLoteFecha"].toString()) : undefined as any;
            this.vrUnitario = _data["vrUnitario"];
            this.porcentaje = _data["porcentaje"];
            this.totalMovimiento = _data["totalMovimiento"];
            this.produccionItems = _data["produccionItems"];
            this.produccionCantidadOP = _data["produccionCantidadOP"];
            this.produccionCIFCosto = _data["produccionCIFCosto"];
            this.produccionMOCosto = _data["produccionMOCosto"];
            this.produccionInsCosto = _data["produccionInsCosto"];
            this.produccionPTForm = _data["produccionPTForm"];
            if (Array.isArray(_data["ptCon"])) {
                this.ptCon = [] as any;
                for (let item of _data["ptCon"])
                    this.ptCon!.push(ProduccionPTCon.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProduccionPT {
        data = typeof data === 'object' ? data : {};
        let result = new ProduccionPT();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["produccionId"] = this.produccionId;
        data["produccionPTId"] = this.produccionPTId;
        data["produccionCantidad"] = this.produccionCantidad;
        data["produccionLoteId"] = this.produccionLoteId;
        data["produccionLoteNo"] = this.produccionLoteNo;
        data["produccionLoteFecha"] = this.produccionLoteFecha ? this.produccionLoteFecha.toISOString() : undefined as any;
        data["vrUnitario"] = this.vrUnitario;
        data["porcentaje"] = this.porcentaje;
        data["totalMovimiento"] = this.totalMovimiento;
        data["produccionItems"] = this.produccionItems;
        data["produccionCantidadOP"] = this.produccionCantidadOP;
        data["produccionCIFCosto"] = this.produccionCIFCosto;
        data["produccionMOCosto"] = this.produccionMOCosto;
        data["produccionInsCosto"] = this.produccionInsCosto;
        data["produccionPTForm"] = this.produccionPTForm;
        if (Array.isArray(this.ptCon)) {
            data["ptCon"] = [];
            for (let item of this.ptCon)
                data["ptCon"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProduccionPT {
    produccionId?: number;
    produccionPTId?: string;
    produccionCantidad?: number;
    produccionLoteId?: number | undefined;
    produccionLoteNo?: string | undefined;
    produccionLoteFecha?: Date | undefined;
    vrUnitario?: number | undefined;
    porcentaje?: number | undefined;
    totalMovimiento?: number | undefined;
    produccionItems?: number | undefined;
    produccionCantidadOP?: number | undefined;
    produccionCIFCosto?: number | undefined;
    produccionMOCosto?: number | undefined;
    produccionInsCosto?: number | undefined;
    produccionPTForm?: string | undefined;
    ptCon?: ProduccionPTCon[];
}

export class ProduccionPTCon implements IProduccionPTCon {
    produccionPTConInsumoId?: string;
    produccionPTConCantidad?: number;
    produccionPTConCosto?: number;

    constructor(data?: IProduccionPTCon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.produccionPTConInsumoId = _data["produccionPTConInsumoId"];
            this.produccionPTConCantidad = _data["produccionPTConCantidad"];
            this.produccionPTConCosto = _data["produccionPTConCosto"];
        }
    }

    static fromJS(data: any): ProduccionPTCon {
        data = typeof data === 'object' ? data : {};
        let result = new ProduccionPTCon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["produccionPTConInsumoId"] = this.produccionPTConInsumoId;
        data["produccionPTConCantidad"] = this.produccionPTConCantidad;
        data["produccionPTConCosto"] = this.produccionPTConCosto;
        return data;
    }
}

export interface IProduccionPTCon {
    produccionPTConInsumoId?: string;
    produccionPTConCantidad?: number;
    produccionPTConCosto?: number;
}

export class ExplosionMaterialesConInventarioRequest implements IExplosionMaterialesConInventarioRequest {
    bodegaInsumosId?: string;
    detalle?: ExplosionMaterialesConInventarioDetalleItem[];

    constructor(data?: IExplosionMaterialesConInventarioRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bodegaInsumosId = _data["bodegaInsumosId"];
            if (Array.isArray(_data["detalle"])) {
                this.detalle = [] as any;
                for (let item of _data["detalle"])
                    this.detalle!.push(ExplosionMaterialesConInventarioDetalleItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExplosionMaterialesConInventarioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExplosionMaterialesConInventarioRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bodegaInsumosId"] = this.bodegaInsumosId;
        if (Array.isArray(this.detalle)) {
            data["detalle"] = [];
            for (let item of this.detalle)
                data["detalle"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExplosionMaterialesConInventarioRequest {
    bodegaInsumosId?: string;
    detalle?: ExplosionMaterialesConInventarioDetalleItem[];
}

export class ExplosionMaterialesConInventarioDetalleItem implements IExplosionMaterialesConInventarioDetalleItem {
    productoId?: string;
    cantidad?: number;

    constructor(data?: IExplosionMaterialesConInventarioDetalleItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productoId = _data["productoId"];
            this.cantidad = _data["cantidad"];
        }
    }

    static fromJS(data: any): ExplosionMaterialesConInventarioDetalleItem {
        data = typeof data === 'object' ? data : {};
        let result = new ExplosionMaterialesConInventarioDetalleItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productoId"] = this.productoId;
        data["cantidad"] = this.cantidad;
        return data;
    }
}

export interface IExplosionMaterialesConInventarioDetalleItem {
    productoId?: string;
    cantidad?: number;
}

export class PagingOfProductor implements IPagingOfProductor {
    count?: number;
    data?: Productor[];

    constructor(data?: IPagingOfProductor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Productor.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfProductor {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfProductor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfProductor {
    count?: number;
    data?: Productor[];
}

export class Productor implements IProductor {
    productorId?: number;
    productorTerceroNombre?: string | undefined;
    productorTerceroNit?: string | undefined;
    productorEmail?: string | undefined;
    productorTerceroTelefono?: string | undefined;
    alRutaId?: string | undefined;
    productorFinca?: string;
    productorDepto?: string | undefined;
    productorMunicipio?: string | undefined;
    productorTelefono?: string;
    productorSecuencia?: number;
    productorTipoRecoleccion?: number;
    productorDistancia?: number | undefined;
    productorFleteLitro?: number | undefined;
    productorActivo?: string | undefined;
    productorHLB?: boolean | undefined;
    productorHLBVigencia?: Date | undefined;
    productorHLT?: boolean | undefined;
    productorHLTVigencia?: Date | undefined;
    productorFrio?: boolean | undefined;
    productorBPG?: boolean | undefined;
    productorDescuentoVias?: number | undefined;
    productorViasNit?: string | undefined;
    productorTipo?: string | undefined;
    productorTipoRete?: string | undefined;
    productorBonFrio?: number | undefined;
    productorBonSocio?: number | undefined;
    productorBonAsociado?: number | undefined;
    productorBonAjustePrecio?: number | undefined;
    productorCodigoLab?: number | undefined;
    productorTerceroId?: number | undefined;
    productorBancoId?: number | undefined;
    productorClienteId?: number | undefined;
    productorDesde?: Date | undefined;
    productorMotivoRetiro?: string | undefined;
    productorHasta?: Date | undefined;
    productorAsociado?: boolean;
    productorBPGVigencia?: Date;
    productorRUVFecha?: Date;
    productorRUVNo?: string;
    productorMunicipioId?: string | undefined;
    productorDireccion?: string;
    productorRutaId2?: string | undefined;
    productorFleteLitro2?: number | undefined;
    productorDistancia2?: number | undefined;
    alAcopioId?: number | undefined;
    productorBon5?: number | undefined;
    productorManejaDistribucion?: boolean | undefined;
    productorTipoRes0017?: string | undefined;
    productorCodPredio?: string | undefined;
    productorVereda?: string | undefined;
    productorGPS?: string | undefined;
    productorTanqueId?: string | undefined;
    productorNTC?: Date | undefined;
    extData?: ExtData[];
    distribucion?: ProductorDistribucion[];

    constructor(data?: IProductor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productorId = _data["productorId"];
            this.productorTerceroNombre = _data["productorTerceroNombre"];
            this.productorTerceroNit = _data["productorTerceroNit"];
            this.productorEmail = _data["productorEmail"];
            this.productorTerceroTelefono = _data["productorTerceroTelefono"];
            this.alRutaId = _data["alRutaId"];
            this.productorFinca = _data["productorFinca"];
            this.productorDepto = _data["productorDepto"];
            this.productorMunicipio = _data["productorMunicipio"];
            this.productorTelefono = _data["productorTelefono"];
            this.productorSecuencia = _data["productorSecuencia"];
            this.productorTipoRecoleccion = _data["productorTipoRecoleccion"];
            this.productorDistancia = _data["productorDistancia"];
            this.productorFleteLitro = _data["productorFleteLitro"];
            this.productorActivo = _data["productorActivo"];
            this.productorHLB = _data["productorHLB"];
            this.productorHLBVigencia = _data["productorHLBVigencia"] ? new Date(_data["productorHLBVigencia"].toString()) : undefined as any;
            this.productorHLT = _data["productorHLT"];
            this.productorHLTVigencia = _data["productorHLTVigencia"] ? new Date(_data["productorHLTVigencia"].toString()) : undefined as any;
            this.productorFrio = _data["productorFrio"];
            this.productorBPG = _data["productorBPG"];
            this.productorDescuentoVias = _data["productorDescuentoVias"];
            this.productorViasNit = _data["productorViasNit"];
            this.productorTipo = _data["productorTipo"];
            this.productorTipoRete = _data["productorTipoRete"];
            this.productorBonFrio = _data["productorBonFrio"];
            this.productorBonSocio = _data["productorBonSocio"];
            this.productorBonAsociado = _data["productorBonAsociado"];
            this.productorBonAjustePrecio = _data["productorBonAjustePrecio"];
            this.productorCodigoLab = _data["productorCodigoLab"];
            this.productorTerceroId = _data["productorTerceroId"];
            this.productorBancoId = _data["productorBancoId"];
            this.productorClienteId = _data["productorClienteId"];
            this.productorDesde = _data["productorDesde"] ? new Date(_data["productorDesde"].toString()) : undefined as any;
            this.productorMotivoRetiro = _data["productorMotivoRetiro"];
            this.productorHasta = _data["productorHasta"] ? new Date(_data["productorHasta"].toString()) : undefined as any;
            this.productorAsociado = _data["productorAsociado"];
            this.productorBPGVigencia = _data["productorBPGVigencia"] ? new Date(_data["productorBPGVigencia"].toString()) : undefined as any;
            this.productorRUVFecha = _data["productorRUVFecha"] ? new Date(_data["productorRUVFecha"].toString()) : undefined as any;
            this.productorRUVNo = _data["productorRUVNo"];
            this.productorMunicipioId = _data["productorMunicipioId"];
            this.productorDireccion = _data["productorDireccion"];
            this.productorRutaId2 = _data["productorRutaId2"];
            this.productorFleteLitro2 = _data["productorFleteLitro2"];
            this.productorDistancia2 = _data["productorDistancia2"];
            this.alAcopioId = _data["alAcopioId"];
            this.productorBon5 = _data["productorBon5"];
            this.productorManejaDistribucion = _data["productorManejaDistribucion"];
            this.productorTipoRes0017 = _data["productorTipoRes0017"];
            this.productorCodPredio = _data["productorCodPredio"];
            this.productorVereda = _data["productorVereda"];
            this.productorGPS = _data["productorGPS"];
            this.productorTanqueId = _data["productorTanqueId"];
            this.productorNTC = _data["productorNTC"] ? new Date(_data["productorNTC"].toString()) : undefined as any;
            if (Array.isArray(_data["extData"])) {
                this.extData = [] as any;
                for (let item of _data["extData"])
                    this.extData!.push(ExtData.fromJS(item));
            }
            if (Array.isArray(_data["distribucion"])) {
                this.distribucion = [] as any;
                for (let item of _data["distribucion"])
                    this.distribucion!.push(ProductorDistribucion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Productor {
        data = typeof data === 'object' ? data : {};
        let result = new Productor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productorId"] = this.productorId;
        data["productorTerceroNombre"] = this.productorTerceroNombre;
        data["productorTerceroNit"] = this.productorTerceroNit;
        data["productorEmail"] = this.productorEmail;
        data["productorTerceroTelefono"] = this.productorTerceroTelefono;
        data["alRutaId"] = this.alRutaId;
        data["productorFinca"] = this.productorFinca;
        data["productorDepto"] = this.productorDepto;
        data["productorMunicipio"] = this.productorMunicipio;
        data["productorTelefono"] = this.productorTelefono;
        data["productorSecuencia"] = this.productorSecuencia;
        data["productorTipoRecoleccion"] = this.productorTipoRecoleccion;
        data["productorDistancia"] = this.productorDistancia;
        data["productorFleteLitro"] = this.productorFleteLitro;
        data["productorActivo"] = this.productorActivo;
        data["productorHLB"] = this.productorHLB;
        data["productorHLBVigencia"] = this.productorHLBVigencia ? this.productorHLBVigencia.toISOString() : undefined as any;
        data["productorHLT"] = this.productorHLT;
        data["productorHLTVigencia"] = this.productorHLTVigencia ? this.productorHLTVigencia.toISOString() : undefined as any;
        data["productorFrio"] = this.productorFrio;
        data["productorBPG"] = this.productorBPG;
        data["productorDescuentoVias"] = this.productorDescuentoVias;
        data["productorViasNit"] = this.productorViasNit;
        data["productorTipo"] = this.productorTipo;
        data["productorTipoRete"] = this.productorTipoRete;
        data["productorBonFrio"] = this.productorBonFrio;
        data["productorBonSocio"] = this.productorBonSocio;
        data["productorBonAsociado"] = this.productorBonAsociado;
        data["productorBonAjustePrecio"] = this.productorBonAjustePrecio;
        data["productorCodigoLab"] = this.productorCodigoLab;
        data["productorTerceroId"] = this.productorTerceroId;
        data["productorBancoId"] = this.productorBancoId;
        data["productorClienteId"] = this.productorClienteId;
        data["productorDesde"] = this.productorDesde ? this.productorDesde.toISOString() : undefined as any;
        data["productorMotivoRetiro"] = this.productorMotivoRetiro;
        data["productorHasta"] = this.productorHasta ? this.productorHasta.toISOString() : undefined as any;
        data["productorAsociado"] = this.productorAsociado;
        data["productorBPGVigencia"] = this.productorBPGVigencia ? this.productorBPGVigencia.toISOString() : undefined as any;
        data["productorRUVFecha"] = this.productorRUVFecha ? this.productorRUVFecha.toISOString() : undefined as any;
        data["productorRUVNo"] = this.productorRUVNo;
        data["productorMunicipioId"] = this.productorMunicipioId;
        data["productorDireccion"] = this.productorDireccion;
        data["productorRutaId2"] = this.productorRutaId2;
        data["productorFleteLitro2"] = this.productorFleteLitro2;
        data["productorDistancia2"] = this.productorDistancia2;
        data["alAcopioId"] = this.alAcopioId;
        data["productorBon5"] = this.productorBon5;
        data["productorManejaDistribucion"] = this.productorManejaDistribucion;
        data["productorTipoRes0017"] = this.productorTipoRes0017;
        data["productorCodPredio"] = this.productorCodPredio;
        data["productorVereda"] = this.productorVereda;
        data["productorGPS"] = this.productorGPS;
        data["productorTanqueId"] = this.productorTanqueId;
        data["productorNTC"] = this.productorNTC ? this.productorNTC.toISOString() : undefined as any;
        if (Array.isArray(this.extData)) {
            data["extData"] = [];
            for (let item of this.extData)
                data["extData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.distribucion)) {
            data["distribucion"] = [];
            for (let item of this.distribucion)
                data["distribucion"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductor {
    productorId?: number;
    productorTerceroNombre?: string | undefined;
    productorTerceroNit?: string | undefined;
    productorEmail?: string | undefined;
    productorTerceroTelefono?: string | undefined;
    alRutaId?: string | undefined;
    productorFinca?: string;
    productorDepto?: string | undefined;
    productorMunicipio?: string | undefined;
    productorTelefono?: string;
    productorSecuencia?: number;
    productorTipoRecoleccion?: number;
    productorDistancia?: number | undefined;
    productorFleteLitro?: number | undefined;
    productorActivo?: string | undefined;
    productorHLB?: boolean | undefined;
    productorHLBVigencia?: Date | undefined;
    productorHLT?: boolean | undefined;
    productorHLTVigencia?: Date | undefined;
    productorFrio?: boolean | undefined;
    productorBPG?: boolean | undefined;
    productorDescuentoVias?: number | undefined;
    productorViasNit?: string | undefined;
    productorTipo?: string | undefined;
    productorTipoRete?: string | undefined;
    productorBonFrio?: number | undefined;
    productorBonSocio?: number | undefined;
    productorBonAsociado?: number | undefined;
    productorBonAjustePrecio?: number | undefined;
    productorCodigoLab?: number | undefined;
    productorTerceroId?: number | undefined;
    productorBancoId?: number | undefined;
    productorClienteId?: number | undefined;
    productorDesde?: Date | undefined;
    productorMotivoRetiro?: string | undefined;
    productorHasta?: Date | undefined;
    productorAsociado?: boolean;
    productorBPGVigencia?: Date;
    productorRUVFecha?: Date;
    productorRUVNo?: string;
    productorMunicipioId?: string | undefined;
    productorDireccion?: string;
    productorRutaId2?: string | undefined;
    productorFleteLitro2?: number | undefined;
    productorDistancia2?: number | undefined;
    alAcopioId?: number | undefined;
    productorBon5?: number | undefined;
    productorManejaDistribucion?: boolean | undefined;
    productorTipoRes0017?: string | undefined;
    productorCodPredio?: string | undefined;
    productorVereda?: string | undefined;
    productorGPS?: string | undefined;
    productorTanqueId?: string | undefined;
    productorNTC?: Date | undefined;
    extData?: ExtData[];
    distribucion?: ProductorDistribucion[];
}

export class ProductorDistribucion implements IProductorDistribucion {
    productorDestinoId?: number;
    productorPorcentaje?: number;

    constructor(data?: IProductorDistribucion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productorDestinoId = _data["productorDestinoId"];
            this.productorPorcentaje = _data["productorPorcentaje"];
        }
    }

    static fromJS(data: any): ProductorDistribucion {
        data = typeof data === 'object' ? data : {};
        let result = new ProductorDistribucion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productorDestinoId"] = this.productorDestinoId;
        data["productorPorcentaje"] = this.productorPorcentaje;
        return data;
    }
}

export interface IProductorDistribucion {
    productorDestinoId?: number;
    productorPorcentaje?: number;
}

export class ProductorBulkPriceItem implements IProductorBulkPriceItem {
    productorId?: number;
    productorBonAjustePrecio?: number | undefined;

    constructor(data?: IProductorBulkPriceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productorId = _data["productorId"];
            this.productorBonAjustePrecio = _data["productorBonAjustePrecio"];
        }
    }

    static fromJS(data: any): ProductorBulkPriceItem {
        data = typeof data === 'object' ? data : {};
        let result = new ProductorBulkPriceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productorId"] = this.productorId;
        data["productorBonAjustePrecio"] = this.productorBonAjustePrecio;
        return data;
    }
}

export interface IProductorBulkPriceItem {
    productorId?: number;
    productorBonAjustePrecio?: number | undefined;
}

export class PagingOfProducto implements IPagingOfProducto {
    count?: number;
    data?: Producto[];

    constructor(data?: IPagingOfProducto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Producto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfProducto {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfProducto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfProducto {
    count?: number;
    data?: Producto[];
}

export class Producto implements IProducto {
    productoId?: string;
    productoNaturaleza?: number;
    productoNombre?: string;
    productoUndVenta?: number | undefined;
    productoManejaKardex?: boolean | undefined;
    insumoUnidad?: string | undefined;
    insumoStockMinimo?: number | undefined;
    insumoStockMaximo?: number | undefined;
    insumoValorUltimaCompra?: number | undefined;
    insumoValorPromedio?: number | undefined;
    insumoFormulable?: boolean | undefined;
    insumoTipo?: string | undefined;
    productoGrupoContable?: number | undefined;
    productoTasaIVA?: number | undefined;
    productoTasaIVACompra?: number | undefined;
    productoManejo?: string | undefined;
    productoLineaId?: number | undefined;
    productoLineaNombre?: string | undefined;
    productoOrigen?: string | undefined;
    productoCosto?: number;
    productoCodBar?: string | undefined;
    productoGarantia?: number | undefined;
    productoFechaVenc?: Date | undefined;
    productoPeso?: number | undefined;
    productoUndLote?: number | undefined;
    productoUndCaja?: number | undefined;
    productoEstado?: string | undefined;
    productoMarcaId?: number | undefined;
    productoMarcaNombre?: string | undefined;
    productoImpoconsumo?: number | undefined;
    productoFormulaId?: string | undefined;
    productoUpdated?: Date | undefined;
    productoDescripcion?: string | undefined;
    productoMargenSugerido?: number | undefined;
    productoCodEAN?: string | undefined;
    insumoCategoriaId?: number | undefined;
    insumoCategoriaNombre?: string | undefined;
    productoPadreId?: string | undefined;
    productoFotoUrl?: string | undefined;
    concGastoPucId?: string | undefined;
    productoReteRentaId?: number | undefined;
    productoImpuestoId?: string | undefined;
    productoImpuestoPorcentaje?: number | undefined;
    productoImpuestoTipo?: number | undefined;
    productoImpuestoCategoria?: number | undefined;
    productoNit?: string | undefined;
    productoPresentacionUnd?: string | undefined;
    productoPresentacionCant?: number | undefined;
    productoLineaN2Id?: number | undefined;
    productoLineaN2Nombre?: string | undefined;
    productoLineaN3Id?: number | undefined;
    productoVrUltSobrecosto?: number | undefined;
    extData?: ExtData[];
    productoAlterno?: ProductoAlterno[];
    productoCombo?: ProductoCombo[];
    productoPrecio?: ProductoPrecio[];

    constructor(data?: IProducto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productoId = _data["productoId"];
            this.productoNaturaleza = _data["productoNaturaleza"];
            this.productoNombre = _data["productoNombre"];
            this.productoUndVenta = _data["productoUndVenta"];
            this.productoManejaKardex = _data["productoManejaKardex"];
            this.insumoUnidad = _data["insumoUnidad"];
            this.insumoStockMinimo = _data["insumoStockMinimo"];
            this.insumoStockMaximo = _data["insumoStockMaximo"];
            this.insumoValorUltimaCompra = _data["insumoValorUltimaCompra"];
            this.insumoValorPromedio = _data["insumoValorPromedio"];
            this.insumoFormulable = _data["insumoFormulable"];
            this.insumoTipo = _data["insumoTipo"];
            this.productoGrupoContable = _data["productoGrupoContable"];
            this.productoTasaIVA = _data["productoTasaIVA"];
            this.productoTasaIVACompra = _data["productoTasaIVACompra"];
            this.productoManejo = _data["productoManejo"];
            this.productoLineaId = _data["productoLineaId"];
            this.productoLineaNombre = _data["productoLineaNombre"];
            this.productoOrigen = _data["productoOrigen"];
            this.productoCosto = _data["productoCosto"];
            this.productoCodBar = _data["productoCodBar"];
            this.productoGarantia = _data["productoGarantia"];
            this.productoFechaVenc = _data["productoFechaVenc"] ? new Date(_data["productoFechaVenc"].toString()) : undefined as any;
            this.productoPeso = _data["productoPeso"];
            this.productoUndLote = _data["productoUndLote"];
            this.productoUndCaja = _data["productoUndCaja"];
            this.productoEstado = _data["productoEstado"];
            this.productoMarcaId = _data["productoMarcaId"];
            this.productoMarcaNombre = _data["productoMarcaNombre"];
            this.productoImpoconsumo = _data["productoImpoconsumo"];
            this.productoFormulaId = _data["productoFormulaId"];
            this.productoUpdated = _data["productoUpdated"] ? new Date(_data["productoUpdated"].toString()) : undefined as any;
            this.productoDescripcion = _data["productoDescripcion"];
            this.productoMargenSugerido = _data["productoMargenSugerido"];
            this.productoCodEAN = _data["productoCodEAN"];
            this.insumoCategoriaId = _data["insumoCategoriaId"];
            this.insumoCategoriaNombre = _data["insumoCategoriaNombre"];
            this.productoPadreId = _data["productoPadreId"];
            this.productoFotoUrl = _data["productoFotoUrl"];
            this.concGastoPucId = _data["concGastoPucId"];
            this.productoReteRentaId = _data["productoReteRentaId"];
            this.productoImpuestoId = _data["productoImpuestoId"];
            this.productoImpuestoPorcentaje = _data["productoImpuestoPorcentaje"];
            this.productoImpuestoTipo = _data["productoImpuestoTipo"];
            this.productoImpuestoCategoria = _data["productoImpuestoCategoria"];
            this.productoNit = _data["productoNit"];
            this.productoPresentacionUnd = _data["productoPresentacionUnd"];
            this.productoPresentacionCant = _data["productoPresentacionCant"];
            this.productoLineaN2Id = _data["productoLineaN2Id"];
            this.productoLineaN2Nombre = _data["productoLineaN2Nombre"];
            this.productoLineaN3Id = _data["productoLineaN3Id"];
            this.productoVrUltSobrecosto = _data["productoVrUltSobrecosto"];
            if (Array.isArray(_data["extData"])) {
                this.extData = [] as any;
                for (let item of _data["extData"])
                    this.extData!.push(ExtData.fromJS(item));
            }
            if (Array.isArray(_data["productoAlterno"])) {
                this.productoAlterno = [] as any;
                for (let item of _data["productoAlterno"])
                    this.productoAlterno!.push(ProductoAlterno.fromJS(item));
            }
            if (Array.isArray(_data["productoCombo"])) {
                this.productoCombo = [] as any;
                for (let item of _data["productoCombo"])
                    this.productoCombo!.push(ProductoCombo.fromJS(item));
            }
            if (Array.isArray(_data["productoPrecio"])) {
                this.productoPrecio = [] as any;
                for (let item of _data["productoPrecio"])
                    this.productoPrecio!.push(ProductoPrecio.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Producto {
        data = typeof data === 'object' ? data : {};
        let result = new Producto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productoId"] = this.productoId;
        data["productoNaturaleza"] = this.productoNaturaleza;
        data["productoNombre"] = this.productoNombre;
        data["productoUndVenta"] = this.productoUndVenta;
        data["productoManejaKardex"] = this.productoManejaKardex;
        data["insumoUnidad"] = this.insumoUnidad;
        data["insumoStockMinimo"] = this.insumoStockMinimo;
        data["insumoStockMaximo"] = this.insumoStockMaximo;
        data["insumoValorUltimaCompra"] = this.insumoValorUltimaCompra;
        data["insumoValorPromedio"] = this.insumoValorPromedio;
        data["insumoFormulable"] = this.insumoFormulable;
        data["insumoTipo"] = this.insumoTipo;
        data["productoGrupoContable"] = this.productoGrupoContable;
        data["productoTasaIVA"] = this.productoTasaIVA;
        data["productoTasaIVACompra"] = this.productoTasaIVACompra;
        data["productoManejo"] = this.productoManejo;
        data["productoLineaId"] = this.productoLineaId;
        data["productoLineaNombre"] = this.productoLineaNombre;
        data["productoOrigen"] = this.productoOrigen;
        data["productoCosto"] = this.productoCosto;
        data["productoCodBar"] = this.productoCodBar;
        data["productoGarantia"] = this.productoGarantia;
        data["productoFechaVenc"] = this.productoFechaVenc ? this.productoFechaVenc.toISOString() : undefined as any;
        data["productoPeso"] = this.productoPeso;
        data["productoUndLote"] = this.productoUndLote;
        data["productoUndCaja"] = this.productoUndCaja;
        data["productoEstado"] = this.productoEstado;
        data["productoMarcaId"] = this.productoMarcaId;
        data["productoMarcaNombre"] = this.productoMarcaNombre;
        data["productoImpoconsumo"] = this.productoImpoconsumo;
        data["productoFormulaId"] = this.productoFormulaId;
        data["productoUpdated"] = this.productoUpdated ? this.productoUpdated.toISOString() : undefined as any;
        data["productoDescripcion"] = this.productoDescripcion;
        data["productoMargenSugerido"] = this.productoMargenSugerido;
        data["productoCodEAN"] = this.productoCodEAN;
        data["insumoCategoriaId"] = this.insumoCategoriaId;
        data["insumoCategoriaNombre"] = this.insumoCategoriaNombre;
        data["productoPadreId"] = this.productoPadreId;
        data["productoFotoUrl"] = this.productoFotoUrl;
        data["concGastoPucId"] = this.concGastoPucId;
        data["productoReteRentaId"] = this.productoReteRentaId;
        data["productoImpuestoId"] = this.productoImpuestoId;
        data["productoImpuestoPorcentaje"] = this.productoImpuestoPorcentaje;
        data["productoImpuestoTipo"] = this.productoImpuestoTipo;
        data["productoImpuestoCategoria"] = this.productoImpuestoCategoria;
        data["productoNit"] = this.productoNit;
        data["productoPresentacionUnd"] = this.productoPresentacionUnd;
        data["productoPresentacionCant"] = this.productoPresentacionCant;
        data["productoLineaN2Id"] = this.productoLineaN2Id;
        data["productoLineaN2Nombre"] = this.productoLineaN2Nombre;
        data["productoLineaN3Id"] = this.productoLineaN3Id;
        data["productoVrUltSobrecosto"] = this.productoVrUltSobrecosto;
        if (Array.isArray(this.extData)) {
            data["extData"] = [];
            for (let item of this.extData)
                data["extData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productoAlterno)) {
            data["productoAlterno"] = [];
            for (let item of this.productoAlterno)
                data["productoAlterno"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productoCombo)) {
            data["productoCombo"] = [];
            for (let item of this.productoCombo)
                data["productoCombo"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productoPrecio)) {
            data["productoPrecio"] = [];
            for (let item of this.productoPrecio)
                data["productoPrecio"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProducto {
    productoId?: string;
    productoNaturaleza?: number;
    productoNombre?: string;
    productoUndVenta?: number | undefined;
    productoManejaKardex?: boolean | undefined;
    insumoUnidad?: string | undefined;
    insumoStockMinimo?: number | undefined;
    insumoStockMaximo?: number | undefined;
    insumoValorUltimaCompra?: number | undefined;
    insumoValorPromedio?: number | undefined;
    insumoFormulable?: boolean | undefined;
    insumoTipo?: string | undefined;
    productoGrupoContable?: number | undefined;
    productoTasaIVA?: number | undefined;
    productoTasaIVACompra?: number | undefined;
    productoManejo?: string | undefined;
    productoLineaId?: number | undefined;
    productoLineaNombre?: string | undefined;
    productoOrigen?: string | undefined;
    productoCosto?: number;
    productoCodBar?: string | undefined;
    productoGarantia?: number | undefined;
    productoFechaVenc?: Date | undefined;
    productoPeso?: number | undefined;
    productoUndLote?: number | undefined;
    productoUndCaja?: number | undefined;
    productoEstado?: string | undefined;
    productoMarcaId?: number | undefined;
    productoMarcaNombre?: string | undefined;
    productoImpoconsumo?: number | undefined;
    productoFormulaId?: string | undefined;
    productoUpdated?: Date | undefined;
    productoDescripcion?: string | undefined;
    productoMargenSugerido?: number | undefined;
    productoCodEAN?: string | undefined;
    insumoCategoriaId?: number | undefined;
    insumoCategoriaNombre?: string | undefined;
    productoPadreId?: string | undefined;
    productoFotoUrl?: string | undefined;
    concGastoPucId?: string | undefined;
    productoReteRentaId?: number | undefined;
    productoImpuestoId?: string | undefined;
    productoImpuestoPorcentaje?: number | undefined;
    productoImpuestoTipo?: number | undefined;
    productoImpuestoCategoria?: number | undefined;
    productoNit?: string | undefined;
    productoPresentacionUnd?: string | undefined;
    productoPresentacionCant?: number | undefined;
    productoLineaN2Id?: number | undefined;
    productoLineaN2Nombre?: string | undefined;
    productoLineaN3Id?: number | undefined;
    productoVrUltSobrecosto?: number | undefined;
    extData?: ExtData[];
    productoAlterno?: ProductoAlterno[];
    productoCombo?: ProductoCombo[];
    productoPrecio?: ProductoPrecio[];
}

export class ProductoAlterno implements IProductoAlterno {
    productoId?: string;
    productoAltId?: string;
    productoAltNombre?: string;

    constructor(data?: IProductoAlterno) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productoId = _data["productoId"];
            this.productoAltId = _data["productoAltId"];
            this.productoAltNombre = _data["productoAltNombre"];
        }
    }

    static fromJS(data: any): ProductoAlterno {
        data = typeof data === 'object' ? data : {};
        let result = new ProductoAlterno();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productoId"] = this.productoId;
        data["productoAltId"] = this.productoAltId;
        data["productoAltNombre"] = this.productoAltNombre;
        return data;
    }
}

export interface IProductoAlterno {
    productoId?: string;
    productoAltId?: string;
    productoAltNombre?: string;
}

export class ProductoCombo implements IProductoCombo {
    productoId?: string;
    productoComboId?: string;
    productoComboCant?: number;

    constructor(data?: IProductoCombo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productoId = _data["productoId"];
            this.productoComboId = _data["productoComboId"];
            this.productoComboCant = _data["productoComboCant"];
        }
    }

    static fromJS(data: any): ProductoCombo {
        data = typeof data === 'object' ? data : {};
        let result = new ProductoCombo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productoId"] = this.productoId;
        data["productoComboId"] = this.productoComboId;
        data["productoComboCant"] = this.productoComboCant;
        return data;
    }
}

export interface IProductoCombo {
    productoId?: string;
    productoComboId?: string;
    productoComboCant?: number;
}

export class ProductoPrecio implements IProductoPrecio {
    productoId?: string;
    precioListaId?: string;
    precioLista?: number;
    precioListaIVA?: number | undefined;
    productoPrecioUpdated?: Date | undefined;
    productoMargenLista?: number | undefined;
    productoPrecioIPC?: number | undefined;
    precioListaIVAIncluido?: boolean | undefined;

    constructor(data?: IProductoPrecio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productoId = _data["productoId"];
            this.precioListaId = _data["precioListaId"];
            this.precioLista = _data["precioLista"];
            this.precioListaIVA = _data["precioListaIVA"];
            this.productoPrecioUpdated = _data["productoPrecioUpdated"] ? new Date(_data["productoPrecioUpdated"].toString()) : undefined as any;
            this.productoMargenLista = _data["productoMargenLista"];
            this.productoPrecioIPC = _data["productoPrecioIPC"];
            this.precioListaIVAIncluido = _data["precioListaIVAIncluido"];
        }
    }

    static fromJS(data: any): ProductoPrecio {
        data = typeof data === 'object' ? data : {};
        let result = new ProductoPrecio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productoId"] = this.productoId;
        data["precioListaId"] = this.precioListaId;
        data["precioLista"] = this.precioLista;
        data["precioListaIVA"] = this.precioListaIVA;
        data["productoPrecioUpdated"] = this.productoPrecioUpdated ? this.productoPrecioUpdated.toISOString() : undefined as any;
        data["productoMargenLista"] = this.productoMargenLista;
        data["productoPrecioIPC"] = this.productoPrecioIPC;
        data["precioListaIVAIncluido"] = this.precioListaIVAIncluido;
        return data;
    }
}

export interface IProductoPrecio {
    productoId?: string;
    precioListaId?: string;
    precioLista?: number;
    precioListaIVA?: number | undefined;
    productoPrecioUpdated?: Date | undefined;
    productoMargenLista?: number | undefined;
    productoPrecioIPC?: number | undefined;
    precioListaIVAIncluido?: boolean | undefined;
}

export class ProductoSearchResponse implements IProductoSearchResponse {
    productoId?: string;
    productoNombre?: string;
    productoLineaNombre?: string | undefined;
    insumoUnidad?: string | undefined;
    productoFotoUrl?: string | undefined;
    saldoInventario?: number;
    precioLista?: number;
    precioConIVA?: number;
    score?: number;

    constructor(data?: IProductoSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productoId = _data["productoId"];
            this.productoNombre = _data["productoNombre"];
            this.productoLineaNombre = _data["productoLineaNombre"];
            this.insumoUnidad = _data["insumoUnidad"];
            this.productoFotoUrl = _data["productoFotoUrl"];
            this.saldoInventario = _data["saldoInventario"];
            this.precioLista = _data["precioLista"];
            this.precioConIVA = _data["precioConIVA"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): ProductoSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductoSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productoId"] = this.productoId;
        data["productoNombre"] = this.productoNombre;
        data["productoLineaNombre"] = this.productoLineaNombre;
        data["insumoUnidad"] = this.insumoUnidad;
        data["productoFotoUrl"] = this.productoFotoUrl;
        data["saldoInventario"] = this.saldoInventario;
        data["precioLista"] = this.precioLista;
        data["precioConIVA"] = this.precioConIVA;
        data["score"] = this.score;
        return data;
    }
}

export interface IProductoSearchResponse {
    productoId?: string;
    productoNombre?: string;
    productoLineaNombre?: string | undefined;
    insumoUnidad?: string | undefined;
    productoFotoUrl?: string | undefined;
    saldoInventario?: number;
    precioLista?: number;
    precioConIVA?: number;
    score?: number;
}

export class ProductoSugeridoResponse implements IProductoSugeridoResponse {
    productoId?: string;
    productoNombre?: string;
    cantidadPromedio?: number;
    saldoInventario?: number;
    precioLista?: number;
    precioConIVA?: number;
    clienteId?: number;
    clienteNombre?: string;

    constructor(data?: IProductoSugeridoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productoId = _data["productoId"];
            this.productoNombre = _data["productoNombre"];
            this.cantidadPromedio = _data["cantidadPromedio"];
            this.saldoInventario = _data["saldoInventario"];
            this.precioLista = _data["precioLista"];
            this.precioConIVA = _data["precioConIVA"];
            this.clienteId = _data["clienteId"];
            this.clienteNombre = _data["clienteNombre"];
        }
    }

    static fromJS(data: any): ProductoSugeridoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductoSugeridoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productoId"] = this.productoId;
        data["productoNombre"] = this.productoNombre;
        data["cantidadPromedio"] = this.cantidadPromedio;
        data["saldoInventario"] = this.saldoInventario;
        data["precioLista"] = this.precioLista;
        data["precioConIVA"] = this.precioConIVA;
        data["clienteId"] = this.clienteId;
        data["clienteNombre"] = this.clienteNombre;
        return data;
    }
}

export interface IProductoSugeridoResponse {
    productoId?: string;
    productoNombre?: string;
    cantidadPromedio?: number;
    saldoInventario?: number;
    precioLista?: number;
    precioConIVA?: number;
    clienteId?: number;
    clienteNombre?: string;
}

export class PagingOfPuc implements IPagingOfPuc {
    count?: number;
    data?: Puc[];

    constructor(data?: IPagingOfPuc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Puc.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfPuc {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfPuc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfPuc {
    count?: number;
    data?: Puc[];
}

export class Puc implements IPuc {
    pucID?: string;
    pucNombre?: string;
    pucRelacionaTercero?: boolean | undefined;
    pucPasaTercero?: string | undefined;
    pucRequiereDocumento?: boolean;
    pucEstado?: string;
    pucEstadoFecha?: Date;
    pucNivel?: number;
    pucPorcentajeFiscal?: number;
    pucNIIF?: boolean;
    pucNit?: string | undefined;
    pucrReqConceptoFlujo?: boolean | undefined;
    pucCreditoFlujoId?: string | undefined;
    pucDebitoFlujoId?: string | undefined;

    constructor(data?: IPuc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pucID = _data["pucID"];
            this.pucNombre = _data["pucNombre"];
            this.pucRelacionaTercero = _data["pucRelacionaTercero"];
            this.pucPasaTercero = _data["pucPasaTercero"];
            this.pucRequiereDocumento = _data["pucRequiereDocumento"];
            this.pucEstado = _data["pucEstado"];
            this.pucEstadoFecha = _data["pucEstadoFecha"] ? new Date(_data["pucEstadoFecha"].toString()) : undefined as any;
            this.pucNivel = _data["pucNivel"];
            this.pucPorcentajeFiscal = _data["pucPorcentajeFiscal"];
            this.pucNIIF = _data["pucNIIF"];
            this.pucNit = _data["pucNit"];
            this.pucrReqConceptoFlujo = _data["pucrReqConceptoFlujo"];
            this.pucCreditoFlujoId = _data["pucCreditoFlujoId"];
            this.pucDebitoFlujoId = _data["pucDebitoFlujoId"];
        }
    }

    static fromJS(data: any): Puc {
        data = typeof data === 'object' ? data : {};
        let result = new Puc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pucID"] = this.pucID;
        data["pucNombre"] = this.pucNombre;
        data["pucRelacionaTercero"] = this.pucRelacionaTercero;
        data["pucPasaTercero"] = this.pucPasaTercero;
        data["pucRequiereDocumento"] = this.pucRequiereDocumento;
        data["pucEstado"] = this.pucEstado;
        data["pucEstadoFecha"] = this.pucEstadoFecha ? this.pucEstadoFecha.toISOString() : undefined as any;
        data["pucNivel"] = this.pucNivel;
        data["pucPorcentajeFiscal"] = this.pucPorcentajeFiscal;
        data["pucNIIF"] = this.pucNIIF;
        data["pucNit"] = this.pucNit;
        data["pucrReqConceptoFlujo"] = this.pucrReqConceptoFlujo;
        data["pucCreditoFlujoId"] = this.pucCreditoFlujoId;
        data["pucDebitoFlujoId"] = this.pucDebitoFlujoId;
        return data;
    }
}

export interface IPuc {
    pucID?: string;
    pucNombre?: string;
    pucRelacionaTercero?: boolean | undefined;
    pucPasaTercero?: string | undefined;
    pucRequiereDocumento?: boolean;
    pucEstado?: string;
    pucEstadoFecha?: Date;
    pucNivel?: number;
    pucPorcentajeFiscal?: number;
    pucNIIF?: boolean;
    pucNit?: string | undefined;
    pucrReqConceptoFlujo?: boolean | undefined;
    pucCreditoFlujoId?: string | undefined;
    pucDebitoFlujoId?: string | undefined;
}

export class PagingOfReciboCaja implements IPagingOfReciboCaja {
    count?: number;
    data?: ReciboCaja[];

    constructor(data?: IPagingOfReciboCaja) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ReciboCaja.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfReciboCaja {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfReciboCaja();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfReciboCaja {
    count?: number;
    data?: ReciboCaja[];
}

export class ReporteDisponibleDto implements IReporteDisponibleDto {
    gnQueryId?: number;
    gnQueryRepository?: string | undefined;
    gnQueryName?: string | undefined;
    gnQueryDescription?: string | undefined;
    gnQueryModule?: string | undefined;
    gnQueryGroup?: string | undefined;
    gnQueryOrder?: number | undefined;
    gnQueryURL?: string | undefined;
    gnQueryType?: number | undefined;
    gnQueryStructure?: string | undefined;
    gnQueryStatus?: number | undefined;
    gnQueryAIRules?: string | undefined;
    gnQueryAIPrompt?: boolean | undefined;
    gnQueryPermission?: string | undefined;
    gnQueryRequired?: boolean | undefined;
    gnQueryUser?: string | undefined;
    gnQueryInsHr?: Date | undefined;

    constructor(data?: IReporteDisponibleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gnQueryId = _data["gnQueryId"];
            this.gnQueryRepository = _data["gnQueryRepository"];
            this.gnQueryName = _data["gnQueryName"];
            this.gnQueryDescription = _data["gnQueryDescription"];
            this.gnQueryModule = _data["gnQueryModule"];
            this.gnQueryGroup = _data["gnQueryGroup"];
            this.gnQueryOrder = _data["gnQueryOrder"];
            this.gnQueryURL = _data["gnQueryURL"];
            this.gnQueryType = _data["gnQueryType"];
            this.gnQueryStructure = _data["gnQueryStructure"];
            this.gnQueryStatus = _data["gnQueryStatus"];
            this.gnQueryAIRules = _data["gnQueryAIRules"];
            this.gnQueryAIPrompt = _data["gnQueryAIPrompt"];
            this.gnQueryPermission = _data["gnQueryPermission"];
            this.gnQueryRequired = _data["gnQueryRequired"];
            this.gnQueryUser = _data["gnQueryUser"];
            this.gnQueryInsHr = _data["gnQueryInsHr"] ? new Date(_data["gnQueryInsHr"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ReporteDisponibleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReporteDisponibleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gnQueryId"] = this.gnQueryId;
        data["gnQueryRepository"] = this.gnQueryRepository;
        data["gnQueryName"] = this.gnQueryName;
        data["gnQueryDescription"] = this.gnQueryDescription;
        data["gnQueryModule"] = this.gnQueryModule;
        data["gnQueryGroup"] = this.gnQueryGroup;
        data["gnQueryOrder"] = this.gnQueryOrder;
        data["gnQueryURL"] = this.gnQueryURL;
        data["gnQueryType"] = this.gnQueryType;
        data["gnQueryStructure"] = this.gnQueryStructure;
        data["gnQueryStatus"] = this.gnQueryStatus;
        data["gnQueryAIRules"] = this.gnQueryAIRules;
        data["gnQueryAIPrompt"] = this.gnQueryAIPrompt;
        data["gnQueryPermission"] = this.gnQueryPermission;
        data["gnQueryRequired"] = this.gnQueryRequired;
        data["gnQueryUser"] = this.gnQueryUser;
        data["gnQueryInsHr"] = this.gnQueryInsHr ? this.gnQueryInsHr.toISOString() : undefined as any;
        return data;
    }
}

export interface IReporteDisponibleDto {
    gnQueryId?: number;
    gnQueryRepository?: string | undefined;
    gnQueryName?: string | undefined;
    gnQueryDescription?: string | undefined;
    gnQueryModule?: string | undefined;
    gnQueryGroup?: string | undefined;
    gnQueryOrder?: number | undefined;
    gnQueryURL?: string | undefined;
    gnQueryType?: number | undefined;
    gnQueryStructure?: string | undefined;
    gnQueryStatus?: number | undefined;
    gnQueryAIRules?: string | undefined;
    gnQueryAIPrompt?: boolean | undefined;
    gnQueryPermission?: string | undefined;
    gnQueryRequired?: boolean | undefined;
    gnQueryUser?: string | undefined;
    gnQueryInsHr?: Date | undefined;
}

export class GetReportRequest implements IGetReportRequest {
    gnQueryId?: number;
    properties?: ReportParameterDto[];

    constructor(data?: IGetReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gnQueryId = _data["gnQueryId"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(ReportParameterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gnQueryId"] = this.gnQueryId;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetReportRequest {
    gnQueryId?: number;
    properties?: ReportParameterDto[];
}

export class ReportParameterDto implements IReportParameterDto {
    name?: string;
    value?: string;

    constructor(data?: IReportParameterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ReportParameterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportParameterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IReportParameterDto {
    name?: string;
    value?: string;
}

export class ReprocesoRequest implements IReprocesoRequest {
    procesoId?: number;
    year?: number;
    month?: number;
    productoId?: string | undefined;

    constructor(data?: IReprocesoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.procesoId = _data["procesoId"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.productoId = _data["productoId"];
        }
    }

    static fromJS(data: any): ReprocesoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReprocesoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["procesoId"] = this.procesoId;
        data["year"] = this.year;
        data["month"] = this.month;
        data["productoId"] = this.productoId;
        return data;
    }
}

export interface IReprocesoRequest {
    procesoId?: number;
    year?: number;
    month?: number;
    productoId?: string | undefined;
}

export class PagingOfRequisicionDto implements IPagingOfRequisicionDto {
    count?: number;
    data?: RequisicionDto[];

    constructor(data?: IPagingOfRequisicionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RequisicionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfRequisicionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfRequisicionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfRequisicionDto {
    count?: number;
    data?: RequisicionDto[];
}

export class RequisicionDto implements IRequisicionDto {
    docGeneralId?: number | undefined;
    documentoId?: number;
    id2?: string | undefined;
    prefijo?: string | undefined;
    numero?: number | undefined;
    fecha?: Date | undefined;
    fechaEntrega?: Date;
    bodegaDestinoId?: string;
    bodegaOrigenId?: string | undefined;
    proyectoId?: string | undefined;
    proyectoNombre?: string | undefined;
    tipoReq?: string | undefined;
    notas?: string | undefined;
    estado?: string | undefined;
    insHr?: Date | undefined;
    user?: string | undefined;
    items?: RequisicionItemDto[];
    documentoReferente?: string | undefined;
    bodegaDestinoNombre?: string | undefined;
    bodegaOrigenNombre?: string | undefined;
    extData?: ExtData[] | undefined;

    constructor(data?: IRequisicionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docGeneralId = _data["docGeneralId"];
            this.documentoId = _data["documentoId"];
            this.id2 = _data["id2"];
            this.prefijo = _data["prefijo"];
            this.numero = _data["numero"];
            this.fecha = _data["fecha"] ? new Date(_data["fecha"].toString()) : undefined as any;
            this.fechaEntrega = _data["fechaEntrega"] ? new Date(_data["fechaEntrega"].toString()) : undefined as any;
            this.bodegaDestinoId = _data["bodegaDestinoId"];
            this.bodegaOrigenId = _data["bodegaOrigenId"];
            this.proyectoId = _data["proyectoId"];
            this.proyectoNombre = _data["proyectoNombre"];
            this.tipoReq = _data["tipoReq"];
            this.notas = _data["notas"];
            this.estado = _data["estado"];
            this.insHr = _data["insHr"] ? new Date(_data["insHr"].toString()) : undefined as any;
            this.user = _data["user"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RequisicionItemDto.fromJS(item));
            }
            this.documentoReferente = _data["documentoReferente"];
            this.bodegaDestinoNombre = _data["bodegaDestinoNombre"];
            this.bodegaOrigenNombre = _data["bodegaOrigenNombre"];
            if (Array.isArray(_data["extData"])) {
                this.extData = [] as any;
                for (let item of _data["extData"])
                    this.extData!.push(ExtData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RequisicionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequisicionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docGeneralId"] = this.docGeneralId;
        data["documentoId"] = this.documentoId;
        data["id2"] = this.id2;
        data["prefijo"] = this.prefijo;
        data["numero"] = this.numero;
        data["fecha"] = this.fecha ? this.fecha.toISOString() : undefined as any;
        data["fechaEntrega"] = this.fechaEntrega ? this.fechaEntrega.toISOString() : undefined as any;
        data["bodegaDestinoId"] = this.bodegaDestinoId;
        data["bodegaOrigenId"] = this.bodegaOrigenId;
        data["proyectoId"] = this.proyectoId;
        data["proyectoNombre"] = this.proyectoNombre;
        data["tipoReq"] = this.tipoReq;
        data["notas"] = this.notas;
        data["estado"] = this.estado;
        data["insHr"] = this.insHr ? this.insHr.toISOString() : undefined as any;
        data["user"] = this.user;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["documentoReferente"] = this.documentoReferente;
        data["bodegaDestinoNombre"] = this.bodegaDestinoNombre;
        data["bodegaOrigenNombre"] = this.bodegaOrigenNombre;
        if (Array.isArray(this.extData)) {
            data["extData"] = [];
            for (let item of this.extData)
                data["extData"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRequisicionDto {
    docGeneralId?: number | undefined;
    documentoId?: number;
    id2?: string | undefined;
    prefijo?: string | undefined;
    numero?: number | undefined;
    fecha?: Date | undefined;
    fechaEntrega?: Date;
    bodegaDestinoId?: string;
    bodegaOrigenId?: string | undefined;
    proyectoId?: string | undefined;
    proyectoNombre?: string | undefined;
    tipoReq?: string | undefined;
    notas?: string | undefined;
    estado?: string | undefined;
    insHr?: Date | undefined;
    user?: string | undefined;
    items?: RequisicionItemDto[];
    documentoReferente?: string | undefined;
    bodegaDestinoNombre?: string | undefined;
    bodegaOrigenNombre?: string | undefined;
    extData?: ExtData[] | undefined;
}

export class RequisicionItemDto implements IRequisicionItemDto {
    itemId?: number | undefined;
    productoId?: string;
    descripcion?: string | undefined;
    cantidad?: number;
    notas?: string | undefined;

    constructor(data?: IRequisicionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.productoId = _data["productoId"];
            this.descripcion = _data["descripcion"];
            this.cantidad = _data["cantidad"];
            this.notas = _data["notas"];
        }
    }

    static fromJS(data: any): RequisicionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequisicionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["productoId"] = this.productoId;
        data["descripcion"] = this.descripcion;
        data["cantidad"] = this.cantidad;
        data["notas"] = this.notas;
        return data;
    }
}

export interface IRequisicionItemDto {
    itemId?: number | undefined;
    productoId?: string;
    descripcion?: string | undefined;
    cantidad?: number;
    notas?: string | undefined;
}

export class RequisicionTrasladoDto implements IRequisicionTrasladoDto {
    kardexId?: number;
    kardexId2?: string;
    kardexFecha?: Date;
    kardexDescripcion?: string;
    kardexEstado?: string;

    constructor(data?: IRequisicionTrasladoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kardexId = _data["kardexId"];
            this.kardexId2 = _data["kardexId2"];
            this.kardexFecha = _data["kardexFecha"] ? new Date(_data["kardexFecha"].toString()) : undefined as any;
            this.kardexDescripcion = _data["kardexDescripcion"];
            this.kardexEstado = _data["kardexEstado"];
        }
    }

    static fromJS(data: any): RequisicionTrasladoDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequisicionTrasladoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kardexId"] = this.kardexId;
        data["kardexId2"] = this.kardexId2;
        data["kardexFecha"] = this.kardexFecha ? this.kardexFecha.toISOString() : undefined as any;
        data["kardexDescripcion"] = this.kardexDescripcion;
        data["kardexEstado"] = this.kardexEstado;
        return data;
    }
}

export interface IRequisicionTrasladoDto {
    kardexId?: number;
    kardexId2?: string;
    kardexFecha?: Date;
    kardexDescripcion?: string;
    kardexEstado?: string;
}

export class PagingOfRutum implements IPagingOfRutum {
    count?: number;
    data?: Rutum[];

    constructor(data?: IPagingOfRutum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Rutum.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfRutum {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfRutum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfRutum {
    count?: number;
    data?: Rutum[];
}

export class Rutum implements IRutum {
    rutaId?: number;
    rutaNombre?: string;
    rutaZonaId?: number | undefined;
    rutaVehiculoId?: number | undefined;
    rutaBodegaId?: string | undefined;
    rutaPrecioListaId?: string | undefined;
    rutaViajera?: boolean | undefined;

    constructor(data?: IRutum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rutaId = _data["rutaId"];
            this.rutaNombre = _data["rutaNombre"];
            this.rutaZonaId = _data["rutaZonaId"];
            this.rutaVehiculoId = _data["rutaVehiculoId"];
            this.rutaBodegaId = _data["rutaBodegaId"];
            this.rutaPrecioListaId = _data["rutaPrecioListaId"];
            this.rutaViajera = _data["rutaViajera"];
        }
    }

    static fromJS(data: any): Rutum {
        data = typeof data === 'object' ? data : {};
        let result = new Rutum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rutaId"] = this.rutaId;
        data["rutaNombre"] = this.rutaNombre;
        data["rutaZonaId"] = this.rutaZonaId;
        data["rutaVehiculoId"] = this.rutaVehiculoId;
        data["rutaBodegaId"] = this.rutaBodegaId;
        data["rutaPrecioListaId"] = this.rutaPrecioListaId;
        data["rutaViajera"] = this.rutaViajera;
        return data;
    }
}

export interface IRutum {
    rutaId?: number;
    rutaNombre?: string;
    rutaZonaId?: number | undefined;
    rutaVehiculoId?: number | undefined;
    rutaBodegaId?: string | undefined;
    rutaPrecioListaId?: string | undefined;
    rutaViajera?: boolean | undefined;
}

export class LoginRequest implements ILoginRequest {
    user?: string;
    password?: string;
    companyName?: string;

    constructor(data?: ILoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"];
            this.password = _data["password"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user;
        data["password"] = this.password;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface ILoginRequest {
    user?: string;
    password?: string;
    companyName?: string;
}

export class Session implements ISession {
    repId?: number;
    sesToken?: string;
    sesDate?: Date;
    sesSts?: string;
    sesType?: number;
    sesURL?: string;
    sesIPAdd?: string;
    opeSysId?: number | undefined;
    sesLastAcc?: Date;
    sesTimeOut?: number;
    sesLogAtt?: number;
    sesLogDate?: Date;
    sesSharedData?: string;
    sesEndDate?: Date;
    sesReload?: boolean;
    brwId?: number | undefined;
    sesLastURL?: string;
    sesLogin?: string;
    sesExtToken?: string;
    userGUID?: string | undefined;
    sesAppTokenExp?: Date | undefined;
    sesRefreshToken?: string | undefined;
    sesAppId?: number | undefined;
    sesDeviceId?: string | undefined;
    sesOauthScope?: string | undefined;
    sesOauthTokenExpires?: number | undefined;
    sesOauthTokenMaxRenew?: number | undefined;
    sesAutTypeName?: string | undefined;
    sesExtToken2?: string | undefined;
    sesJson?: string | undefined;
    sesExtTokenRefresh?: string | undefined;
    sesExtTokenExpires?: Date | undefined;
    sesExtToken3?: string | undefined;
    sesEndedByOtherLogin?: boolean | undefined;
    sesOTPExpire?: Date | undefined;
    sesOTP?: string | undefined;
    sesIdToken?: string | undefined;

    constructor(data?: ISession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.repId = _data["repId"];
            this.sesToken = _data["sesToken"];
            this.sesDate = _data["sesDate"] ? new Date(_data["sesDate"].toString()) : undefined as any;
            this.sesSts = _data["sesSts"];
            this.sesType = _data["sesType"];
            this.sesURL = _data["sesURL"];
            this.sesIPAdd = _data["sesIPAdd"];
            this.opeSysId = _data["opeSysId"];
            this.sesLastAcc = _data["sesLastAcc"] ? new Date(_data["sesLastAcc"].toString()) : undefined as any;
            this.sesTimeOut = _data["sesTimeOut"];
            this.sesLogAtt = _data["sesLogAtt"];
            this.sesLogDate = _data["sesLogDate"] ? new Date(_data["sesLogDate"].toString()) : undefined as any;
            this.sesSharedData = _data["sesSharedData"];
            this.sesEndDate = _data["sesEndDate"] ? new Date(_data["sesEndDate"].toString()) : undefined as any;
            this.sesReload = _data["sesReload"];
            this.brwId = _data["brwId"];
            this.sesLastURL = _data["sesLastURL"];
            this.sesLogin = _data["sesLogin"];
            this.sesExtToken = _data["sesExtToken"];
            this.userGUID = _data["userGUID"];
            this.sesAppTokenExp = _data["sesAppTokenExp"] ? new Date(_data["sesAppTokenExp"].toString()) : undefined as any;
            this.sesRefreshToken = _data["sesRefreshToken"];
            this.sesAppId = _data["sesAppId"];
            this.sesDeviceId = _data["sesDeviceId"];
            this.sesOauthScope = _data["sesOauthScope"];
            this.sesOauthTokenExpires = _data["sesOauthTokenExpires"];
            this.sesOauthTokenMaxRenew = _data["sesOauthTokenMaxRenew"];
            this.sesAutTypeName = _data["sesAutTypeName"];
            this.sesExtToken2 = _data["sesExtToken2"];
            this.sesJson = _data["sesJson"];
            this.sesExtTokenRefresh = _data["sesExtTokenRefresh"];
            this.sesExtTokenExpires = _data["sesExtTokenExpires"] ? new Date(_data["sesExtTokenExpires"].toString()) : undefined as any;
            this.sesExtToken3 = _data["sesExtToken3"];
            this.sesEndedByOtherLogin = _data["sesEndedByOtherLogin"];
            this.sesOTPExpire = _data["sesOTPExpire"] ? new Date(_data["sesOTPExpire"].toString()) : undefined as any;
            this.sesOTP = _data["sesOTP"];
            this.sesIdToken = _data["sesIdToken"];
        }
    }

    static fromJS(data: any): Session {
        data = typeof data === 'object' ? data : {};
        let result = new Session();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["repId"] = this.repId;
        data["sesToken"] = this.sesToken;
        data["sesDate"] = this.sesDate ? this.sesDate.toISOString() : undefined as any;
        data["sesSts"] = this.sesSts;
        data["sesType"] = this.sesType;
        data["sesURL"] = this.sesURL;
        data["sesIPAdd"] = this.sesIPAdd;
        data["opeSysId"] = this.opeSysId;
        data["sesLastAcc"] = this.sesLastAcc ? this.sesLastAcc.toISOString() : undefined as any;
        data["sesTimeOut"] = this.sesTimeOut;
        data["sesLogAtt"] = this.sesLogAtt;
        data["sesLogDate"] = this.sesLogDate ? this.sesLogDate.toISOString() : undefined as any;
        data["sesSharedData"] = this.sesSharedData;
        data["sesEndDate"] = this.sesEndDate ? this.sesEndDate.toISOString() : undefined as any;
        data["sesReload"] = this.sesReload;
        data["brwId"] = this.brwId;
        data["sesLastURL"] = this.sesLastURL;
        data["sesLogin"] = this.sesLogin;
        data["sesExtToken"] = this.sesExtToken;
        data["userGUID"] = this.userGUID;
        data["sesAppTokenExp"] = this.sesAppTokenExp ? this.sesAppTokenExp.toISOString() : undefined as any;
        data["sesRefreshToken"] = this.sesRefreshToken;
        data["sesAppId"] = this.sesAppId;
        data["sesDeviceId"] = this.sesDeviceId;
        data["sesOauthScope"] = this.sesOauthScope;
        data["sesOauthTokenExpires"] = this.sesOauthTokenExpires;
        data["sesOauthTokenMaxRenew"] = this.sesOauthTokenMaxRenew;
        data["sesAutTypeName"] = this.sesAutTypeName;
        data["sesExtToken2"] = this.sesExtToken2;
        data["sesJson"] = this.sesJson;
        data["sesExtTokenRefresh"] = this.sesExtTokenRefresh;
        data["sesExtTokenExpires"] = this.sesExtTokenExpires ? this.sesExtTokenExpires.toISOString() : undefined as any;
        data["sesExtToken3"] = this.sesExtToken3;
        data["sesEndedByOtherLogin"] = this.sesEndedByOtherLogin;
        data["sesOTPExpire"] = this.sesOTPExpire ? this.sesOTPExpire.toISOString() : undefined as any;
        data["sesOTP"] = this.sesOTP;
        data["sesIdToken"] = this.sesIdToken;
        return data;
    }
}

export interface ISession {
    repId?: number;
    sesToken?: string;
    sesDate?: Date;
    sesSts?: string;
    sesType?: number;
    sesURL?: string;
    sesIPAdd?: string;
    opeSysId?: number | undefined;
    sesLastAcc?: Date;
    sesTimeOut?: number;
    sesLogAtt?: number;
    sesLogDate?: Date;
    sesSharedData?: string;
    sesEndDate?: Date;
    sesReload?: boolean;
    brwId?: number | undefined;
    sesLastURL?: string;
    sesLogin?: string;
    sesExtToken?: string;
    userGUID?: string | undefined;
    sesAppTokenExp?: Date | undefined;
    sesRefreshToken?: string | undefined;
    sesAppId?: number | undefined;
    sesDeviceId?: string | undefined;
    sesOauthScope?: string | undefined;
    sesOauthTokenExpires?: number | undefined;
    sesOauthTokenMaxRenew?: number | undefined;
    sesAutTypeName?: string | undefined;
    sesExtToken2?: string | undefined;
    sesJson?: string | undefined;
    sesExtTokenRefresh?: string | undefined;
    sesExtTokenExpires?: Date | undefined;
    sesExtToken3?: string | undefined;
    sesEndedByOtherLogin?: boolean | undefined;
    sesOTPExpire?: Date | undefined;
    sesOTP?: string | undefined;
    sesIdToken?: string | undefined;
}

export class PagingOfTercero implements IPagingOfTercero {
    count?: number;
    data?: Tercero[];

    constructor(data?: IPagingOfTercero) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Tercero.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfTercero {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfTercero();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfTercero {
    count?: number;
    data?: Tercero[];
}

export class Tercero implements ITercero {
    terceroId?: number;
    tipoPersona?: string;
    tipoNit?: string;
    nit?: string;
    nitDV?: number;
    razonSocial?: string;
    terceroNombreComercial?: string;
    rlNombre1?: string;
    rlNombre2?: string;
    rlApellido1?: string;
    rlApellido2?: string;
    nombreFull?: string;
    terceroDireccion?: string;
    terceroTelefono?: string;
    tipodeContribuyente?: string;
    autoRetenedorRenta?: boolean;
    regimenRenta?: string | undefined;
    regimenImpIva?: string;
    autoRetenedorIca?: boolean;
    terceroICA?: number;
    actividadEconomica?: string;
    terceroObligaciones?: string;
    terceroTarifaReteIVA?: number;
    terceroRegimenICA?: string;
    ciudadId?: string | undefined;
    terceroLimiteRentaF?: number | undefined;
    terceroLimiteRentaC?: number | undefined;
    terceroLimiteIVAF?: number | undefined;
    terceroCuentaADebitar?: string | undefined;
    terceroTipoCuenta?: string | undefined;
    terceroEmail?: string;
    terceroEstado?: boolean;
    terceroIdExterior?: string;
    terceroTieneRut?: boolean;
    terceroBancoCod?: string | undefined;
    terceroReteRentaId?: number | undefined;
    terceroReteICAId?: number | undefined;
    terceroCodPostal?: number | undefined;
    terceroPaisId?: number | undefined;
    terceroNotas?: string | undefined;
    terceroFactElect?: boolean | undefined;
    extData?: ExtData[];

    constructor(data?: ITercero) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.terceroId = _data["terceroId"];
            this.tipoPersona = _data["tipoPersona"];
            this.tipoNit = _data["tipoNit"];
            this.nit = _data["nit"];
            this.nitDV = _data["nitDV"];
            this.razonSocial = _data["razonSocial"];
            this.terceroNombreComercial = _data["terceroNombreComercial"];
            this.rlNombre1 = _data["rlNombre1"];
            this.rlNombre2 = _data["rlNombre2"];
            this.rlApellido1 = _data["rlApellido1"];
            this.rlApellido2 = _data["rlApellido2"];
            this.nombreFull = _data["nombreFull"];
            this.terceroDireccion = _data["terceroDireccion"];
            this.terceroTelefono = _data["terceroTelefono"];
            this.tipodeContribuyente = _data["tipodeContribuyente"];
            this.autoRetenedorRenta = _data["autoRetenedorRenta"];
            this.regimenRenta = _data["regimenRenta"];
            this.regimenImpIva = _data["regimenImpIva"];
            this.autoRetenedorIca = _data["autoRetenedorIca"];
            this.terceroICA = _data["terceroICA"];
            this.actividadEconomica = _data["actividadEconomica"];
            this.terceroObligaciones = _data["terceroObligaciones"];
            this.terceroTarifaReteIVA = _data["terceroTarifaReteIVA"];
            this.terceroRegimenICA = _data["terceroRegimenICA"];
            this.ciudadId = _data["ciudadId"];
            this.terceroLimiteRentaF = _data["terceroLimiteRentaF"];
            this.terceroLimiteRentaC = _data["terceroLimiteRentaC"];
            this.terceroLimiteIVAF = _data["terceroLimiteIVAF"];
            this.terceroCuentaADebitar = _data["terceroCuentaADebitar"];
            this.terceroTipoCuenta = _data["terceroTipoCuenta"];
            this.terceroEmail = _data["terceroEmail"];
            this.terceroEstado = _data["terceroEstado"];
            this.terceroIdExterior = _data["terceroIdExterior"];
            this.terceroTieneRut = _data["terceroTieneRut"];
            this.terceroBancoCod = _data["terceroBancoCod"];
            this.terceroReteRentaId = _data["terceroReteRentaId"];
            this.terceroReteICAId = _data["terceroReteICAId"];
            this.terceroCodPostal = _data["terceroCodPostal"];
            this.terceroPaisId = _data["terceroPaisId"];
            this.terceroNotas = _data["terceroNotas"];
            this.terceroFactElect = _data["terceroFactElect"];
            if (Array.isArray(_data["extData"])) {
                this.extData = [] as any;
                for (let item of _data["extData"])
                    this.extData!.push(ExtData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Tercero {
        data = typeof data === 'object' ? data : {};
        let result = new Tercero();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["terceroId"] = this.terceroId;
        data["tipoPersona"] = this.tipoPersona;
        data["tipoNit"] = this.tipoNit;
        data["nit"] = this.nit;
        data["nitDV"] = this.nitDV;
        data["razonSocial"] = this.razonSocial;
        data["terceroNombreComercial"] = this.terceroNombreComercial;
        data["rlNombre1"] = this.rlNombre1;
        data["rlNombre2"] = this.rlNombre2;
        data["rlApellido1"] = this.rlApellido1;
        data["rlApellido2"] = this.rlApellido2;
        data["nombreFull"] = this.nombreFull;
        data["terceroDireccion"] = this.terceroDireccion;
        data["terceroTelefono"] = this.terceroTelefono;
        data["tipodeContribuyente"] = this.tipodeContribuyente;
        data["autoRetenedorRenta"] = this.autoRetenedorRenta;
        data["regimenRenta"] = this.regimenRenta;
        data["regimenImpIva"] = this.regimenImpIva;
        data["autoRetenedorIca"] = this.autoRetenedorIca;
        data["terceroICA"] = this.terceroICA;
        data["actividadEconomica"] = this.actividadEconomica;
        data["terceroObligaciones"] = this.terceroObligaciones;
        data["terceroTarifaReteIVA"] = this.terceroTarifaReteIVA;
        data["terceroRegimenICA"] = this.terceroRegimenICA;
        data["ciudadId"] = this.ciudadId;
        data["terceroLimiteRentaF"] = this.terceroLimiteRentaF;
        data["terceroLimiteRentaC"] = this.terceroLimiteRentaC;
        data["terceroLimiteIVAF"] = this.terceroLimiteIVAF;
        data["terceroCuentaADebitar"] = this.terceroCuentaADebitar;
        data["terceroTipoCuenta"] = this.terceroTipoCuenta;
        data["terceroEmail"] = this.terceroEmail;
        data["terceroEstado"] = this.terceroEstado;
        data["terceroIdExterior"] = this.terceroIdExterior;
        data["terceroTieneRut"] = this.terceroTieneRut;
        data["terceroBancoCod"] = this.terceroBancoCod;
        data["terceroReteRentaId"] = this.terceroReteRentaId;
        data["terceroReteICAId"] = this.terceroReteICAId;
        data["terceroCodPostal"] = this.terceroCodPostal;
        data["terceroPaisId"] = this.terceroPaisId;
        data["terceroNotas"] = this.terceroNotas;
        data["terceroFactElect"] = this.terceroFactElect;
        if (Array.isArray(this.extData)) {
            data["extData"] = [];
            for (let item of this.extData)
                data["extData"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITercero {
    terceroId?: number;
    tipoPersona?: string;
    tipoNit?: string;
    nit?: string;
    nitDV?: number;
    razonSocial?: string;
    terceroNombreComercial?: string;
    rlNombre1?: string;
    rlNombre2?: string;
    rlApellido1?: string;
    rlApellido2?: string;
    nombreFull?: string;
    terceroDireccion?: string;
    terceroTelefono?: string;
    tipodeContribuyente?: string;
    autoRetenedorRenta?: boolean;
    regimenRenta?: string | undefined;
    regimenImpIva?: string;
    autoRetenedorIca?: boolean;
    terceroICA?: number;
    actividadEconomica?: string;
    terceroObligaciones?: string;
    terceroTarifaReteIVA?: number;
    terceroRegimenICA?: string;
    ciudadId?: string | undefined;
    terceroLimiteRentaF?: number | undefined;
    terceroLimiteRentaC?: number | undefined;
    terceroLimiteIVAF?: number | undefined;
    terceroCuentaADebitar?: string | undefined;
    terceroTipoCuenta?: string | undefined;
    terceroEmail?: string;
    terceroEstado?: boolean;
    terceroIdExterior?: string;
    terceroTieneRut?: boolean;
    terceroBancoCod?: string | undefined;
    terceroReteRentaId?: number | undefined;
    terceroReteICAId?: number | undefined;
    terceroCodPostal?: number | undefined;
    terceroPaisId?: number | undefined;
    terceroNotas?: string | undefined;
    terceroFactElect?: boolean | undefined;
    extData?: ExtData[];
}

export class PaginatedListOfTodoItemBriefDto implements IPaginatedListOfTodoItemBriefDto {
    items?: TodoItemBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfTodoItemBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TodoItemBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfTodoItemBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfTodoItemBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfTodoItemBriefDto {
    items?: TodoItemBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class TodoItemBriefDto implements ITodoItemBriefDto {
    id?: number;
    listId?: number;
    title?: string | undefined;
    done?: boolean;

    constructor(data?: ITodoItemBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.listId = _data["listId"];
            this.title = _data["title"];
            this.done = _data["done"];
        }
    }

    static fromJS(data: any): TodoItemBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new TodoItemBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["listId"] = this.listId;
        data["title"] = this.title;
        data["done"] = this.done;
        return data;
    }
}

export interface ITodoItemBriefDto {
    id?: number;
    listId?: number;
    title?: string | undefined;
    done?: boolean;
}

export class CreateTodoItemCommand implements ICreateTodoItemCommand {
    listId?: number;
    title?: string | undefined;

    constructor(data?: ICreateTodoItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listId = _data["listId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): CreateTodoItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTodoItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listId"] = this.listId;
        data["title"] = this.title;
        return data;
    }
}

export interface ICreateTodoItemCommand {
    listId?: number;
    title?: string | undefined;
}

export class UpdateTodoItemCommand implements IUpdateTodoItemCommand {
    id?: number;
    title?: string | undefined;
    done?: boolean;

    constructor(data?: IUpdateTodoItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.done = _data["done"];
        }
    }

    static fromJS(data: any): UpdateTodoItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["done"] = this.done;
        return data;
    }
}

export interface IUpdateTodoItemCommand {
    id?: number;
    title?: string | undefined;
    done?: boolean;
}

export class UpdateTodoItemDetailCommand implements IUpdateTodoItemDetailCommand {
    id?: number;
    listId?: number;
    priority?: PriorityLevel;
    note?: string | undefined;

    constructor(data?: IUpdateTodoItemDetailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.listId = _data["listId"];
            this.priority = _data["priority"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateTodoItemDetailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoItemDetailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["listId"] = this.listId;
        data["priority"] = this.priority;
        data["note"] = this.note;
        return data;
    }
}

export interface IUpdateTodoItemDetailCommand {
    id?: number;
    listId?: number;
    priority?: PriorityLevel;
    note?: string | undefined;
}

export enum PriorityLevel {
    None = 0,
    Low = 1,
    Medium = 2,
    High = 3,
}

export class TodosVm implements ITodosVm {
    priorityLevels?: LookupDto[];
    lists?: TodoListDto[];

    constructor(data?: ITodosVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["priorityLevels"])) {
                this.priorityLevels = [] as any;
                for (let item of _data["priorityLevels"])
                    this.priorityLevels!.push(LookupDto.fromJS(item));
            }
            if (Array.isArray(_data["lists"])) {
                this.lists = [] as any;
                for (let item of _data["lists"])
                    this.lists!.push(TodoListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TodosVm {
        data = typeof data === 'object' ? data : {};
        let result = new TodosVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.priorityLevels)) {
            data["priorityLevels"] = [];
            for (let item of this.priorityLevels)
                data["priorityLevels"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lists)) {
            data["lists"] = [];
            for (let item of this.lists)
                data["lists"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITodosVm {
    priorityLevels?: LookupDto[];
    lists?: TodoListDto[];
}

export class LookupDto implements ILookupDto {
    id?: number;
    title?: string | undefined;

    constructor(data?: ILookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): LookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    }
}

export interface ILookupDto {
    id?: number;
    title?: string | undefined;
}

export class TodoListDto implements ITodoListDto {
    id?: number;
    title?: string | undefined;
    colour?: string | undefined;
    items?: TodoItemDto[];

    constructor(data?: ITodoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.colour = _data["colour"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TodoItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TodoListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TodoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["colour"] = this.colour;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITodoListDto {
    id?: number;
    title?: string | undefined;
    colour?: string | undefined;
    items?: TodoItemDto[];
}

export class TodoItemDto implements ITodoItemDto {
    id?: number;
    listId?: number;
    title?: string | undefined;
    done?: boolean;
    priority?: number;
    note?: string | undefined;

    constructor(data?: ITodoItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.listId = _data["listId"];
            this.title = _data["title"];
            this.done = _data["done"];
            this.priority = _data["priority"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): TodoItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TodoItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["listId"] = this.listId;
        data["title"] = this.title;
        data["done"] = this.done;
        data["priority"] = this.priority;
        data["note"] = this.note;
        return data;
    }
}

export interface ITodoItemDto {
    id?: number;
    listId?: number;
    title?: string | undefined;
    done?: boolean;
    priority?: number;
    note?: string | undefined;
}

export class CreateTodoListCommand implements ICreateTodoListCommand {
    title?: string | undefined;

    constructor(data?: ICreateTodoListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): CreateTodoListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTodoListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        return data;
    }
}

export interface ICreateTodoListCommand {
    title?: string | undefined;
}

export class UpdateTodoListCommand implements IUpdateTodoListCommand {
    id?: number;
    title?: string | undefined;

    constructor(data?: IUpdateTodoListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): UpdateTodoListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    }
}

export interface IUpdateTodoListCommand {
    id?: number;
    title?: string | undefined;
}

export class PagingOfTomaFisica implements IPagingOfTomaFisica {
    count?: number;
    data?: TomaFisica[];

    constructor(data?: IPagingOfTomaFisica) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TomaFisica.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfTomaFisica {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfTomaFisica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfTomaFisica {
    count?: number;
    data?: TomaFisica[];
}

export class TomaFisica implements ITomaFisica {
    tomaFisicaId?: number;
    tomaFisicaFecha?: Date;
    bodegaId?: string;
    tomaFisicaItems?: number;
    tomaFisicaTipo?: string;
    tomaFisicaEstado?: string;
    tomaFisicaKardexId?: number | undefined;
    kardexId2?: string | undefined;
    kardexUser?: string | undefined;
    kardexNotas?: string | undefined;
    tomaFisicaIdDocumento?: string | undefined;

    constructor(data?: ITomaFisica) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tomaFisicaId = _data["tomaFisicaId"];
            this.tomaFisicaFecha = _data["tomaFisicaFecha"] ? new Date(_data["tomaFisicaFecha"].toString()) : undefined as any;
            this.bodegaId = _data["bodegaId"];
            this.tomaFisicaItems = _data["tomaFisicaItems"];
            this.tomaFisicaTipo = _data["tomaFisicaTipo"];
            this.tomaFisicaEstado = _data["tomaFisicaEstado"];
            this.tomaFisicaKardexId = _data["tomaFisicaKardexId"];
            this.kardexId2 = _data["kardexId2"];
            this.kardexUser = _data["kardexUser"];
            this.kardexNotas = _data["kardexNotas"];
            this.tomaFisicaIdDocumento = _data["tomaFisicaIdDocumento"];
        }
    }

    static fromJS(data: any): TomaFisica {
        data = typeof data === 'object' ? data : {};
        let result = new TomaFisica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tomaFisicaId"] = this.tomaFisicaId;
        data["tomaFisicaFecha"] = this.tomaFisicaFecha ? this.tomaFisicaFecha.toISOString() : undefined as any;
        data["bodegaId"] = this.bodegaId;
        data["tomaFisicaItems"] = this.tomaFisicaItems;
        data["tomaFisicaTipo"] = this.tomaFisicaTipo;
        data["tomaFisicaEstado"] = this.tomaFisicaEstado;
        data["tomaFisicaKardexId"] = this.tomaFisicaKardexId;
        data["kardexId2"] = this.kardexId2;
        data["kardexUser"] = this.kardexUser;
        data["kardexNotas"] = this.kardexNotas;
        data["tomaFisicaIdDocumento"] = this.tomaFisicaIdDocumento;
        return data;
    }
}

export interface ITomaFisica {
    tomaFisicaId?: number;
    tomaFisicaFecha?: Date;
    bodegaId?: string;
    tomaFisicaItems?: number;
    tomaFisicaTipo?: string;
    tomaFisicaEstado?: string;
    tomaFisicaKardexId?: number | undefined;
    kardexId2?: string | undefined;
    kardexUser?: string | undefined;
    kardexNotas?: string | undefined;
    tomaFisicaIdDocumento?: string | undefined;
}

export class TomaFisicaCompletoDto implements ITomaFisicaCompletoDto {
    tomaFisicaId?: number;
    tomaFisicaFecha?: Date;
    bodegaId?: string;
    bodegaNombre?: string | undefined;
    tomaFisicaTipo?: string;
    tomaFisicaEstado?: string;
    tomaFisicaItems?: number;
    tomaFisicaKardexId?: number | undefined;
    tomaFisicaIdDocumento?: string | undefined;
    detalles?: TomaFisicaCompletoDetalleDto[];
    conteos?: TomaFisicaCompletoContDto[];

    constructor(data?: ITomaFisicaCompletoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tomaFisicaId = _data["tomaFisicaId"];
            this.tomaFisicaFecha = _data["tomaFisicaFecha"] ? new Date(_data["tomaFisicaFecha"].toString()) : undefined as any;
            this.bodegaId = _data["bodegaId"];
            this.bodegaNombre = _data["bodegaNombre"];
            this.tomaFisicaTipo = _data["tomaFisicaTipo"];
            this.tomaFisicaEstado = _data["tomaFisicaEstado"];
            this.tomaFisicaItems = _data["tomaFisicaItems"];
            this.tomaFisicaKardexId = _data["tomaFisicaKardexId"];
            this.tomaFisicaIdDocumento = _data["tomaFisicaIdDocumento"];
            if (Array.isArray(_data["detalles"])) {
                this.detalles = [] as any;
                for (let item of _data["detalles"])
                    this.detalles!.push(TomaFisicaCompletoDetalleDto.fromJS(item));
            }
            if (Array.isArray(_data["conteos"])) {
                this.conteos = [] as any;
                for (let item of _data["conteos"])
                    this.conteos!.push(TomaFisicaCompletoContDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TomaFisicaCompletoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TomaFisicaCompletoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tomaFisicaId"] = this.tomaFisicaId;
        data["tomaFisicaFecha"] = this.tomaFisicaFecha ? this.tomaFisicaFecha.toISOString() : undefined as any;
        data["bodegaId"] = this.bodegaId;
        data["bodegaNombre"] = this.bodegaNombre;
        data["tomaFisicaTipo"] = this.tomaFisicaTipo;
        data["tomaFisicaEstado"] = this.tomaFisicaEstado;
        data["tomaFisicaItems"] = this.tomaFisicaItems;
        data["tomaFisicaKardexId"] = this.tomaFisicaKardexId;
        data["tomaFisicaIdDocumento"] = this.tomaFisicaIdDocumento;
        if (Array.isArray(this.detalles)) {
            data["detalles"] = [];
            for (let item of this.detalles)
                data["detalles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.conteos)) {
            data["conteos"] = [];
            for (let item of this.conteos)
                data["conteos"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITomaFisicaCompletoDto {
    tomaFisicaId?: number;
    tomaFisicaFecha?: Date;
    bodegaId?: string;
    bodegaNombre?: string | undefined;
    tomaFisicaTipo?: string;
    tomaFisicaEstado?: string;
    tomaFisicaItems?: number;
    tomaFisicaKardexId?: number | undefined;
    tomaFisicaIdDocumento?: string | undefined;
    detalles?: TomaFisicaCompletoDetalleDto[];
    conteos?: TomaFisicaCompletoContDto[];
}

export class TomaFisicaCompletoDetalleDto implements ITomaFisicaCompletoDetalleDto {
    tomaFisicaProductoId?: string;
    productoNombre?: string | undefined;
    productoLineaNombre?: string | undefined;
    productoSublineaNombre?: string | undefined;
    productoMarcaNombre?: string | undefined;
    tomaFisicaCantidad?: number;
    tomaFisicaCantidadInv?: number;
    tomaFisicaDiferencia?: number | undefined;
    tomaFisicaCostoUnt?: number | undefined;
    tomaFisicaUptadetime?: Date;

    constructor(data?: ITomaFisicaCompletoDetalleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tomaFisicaProductoId = _data["tomaFisicaProductoId"];
            this.productoNombre = _data["productoNombre"];
            this.productoLineaNombre = _data["productoLineaNombre"];
            this.productoSublineaNombre = _data["productoSublineaNombre"];
            this.productoMarcaNombre = _data["productoMarcaNombre"];
            this.tomaFisicaCantidad = _data["tomaFisicaCantidad"];
            this.tomaFisicaCantidadInv = _data["tomaFisicaCantidadInv"];
            this.tomaFisicaDiferencia = _data["tomaFisicaDiferencia"];
            this.tomaFisicaCostoUnt = _data["tomaFisicaCostoUnt"];
            this.tomaFisicaUptadetime = _data["tomaFisicaUptadetime"] ? new Date(_data["tomaFisicaUptadetime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TomaFisicaCompletoDetalleDto {
        data = typeof data === 'object' ? data : {};
        let result = new TomaFisicaCompletoDetalleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tomaFisicaProductoId"] = this.tomaFisicaProductoId;
        data["productoNombre"] = this.productoNombre;
        data["productoLineaNombre"] = this.productoLineaNombre;
        data["productoSublineaNombre"] = this.productoSublineaNombre;
        data["productoMarcaNombre"] = this.productoMarcaNombre;
        data["tomaFisicaCantidad"] = this.tomaFisicaCantidad;
        data["tomaFisicaCantidadInv"] = this.tomaFisicaCantidadInv;
        data["tomaFisicaDiferencia"] = this.tomaFisicaDiferencia;
        data["tomaFisicaCostoUnt"] = this.tomaFisicaCostoUnt;
        data["tomaFisicaUptadetime"] = this.tomaFisicaUptadetime ? this.tomaFisicaUptadetime.toISOString() : undefined as any;
        return data;
    }
}

export interface ITomaFisicaCompletoDetalleDto {
    tomaFisicaProductoId?: string;
    productoNombre?: string | undefined;
    productoLineaNombre?: string | undefined;
    productoSublineaNombre?: string | undefined;
    productoMarcaNombre?: string | undefined;
    tomaFisicaCantidad?: number;
    tomaFisicaCantidadInv?: number;
    tomaFisicaDiferencia?: number | undefined;
    tomaFisicaCostoUnt?: number | undefined;
    tomaFisicaUptadetime?: Date;
}

export class TomaFisicaCompletoContDto implements ITomaFisicaCompletoContDto {
    tomaFisicaContId?: number;
    bodegaUbicacionId?: number;
    bodegaUbicacionNombre?: string | undefined;
    productoId?: string;
    productoNombre?: string | undefined;
    productoLineaNombre?: string | undefined;
    productoSublineaNombre?: string | undefined;
    productoMarcaNombre?: string | undefined;
    tomaFisicaContCant?: number;
    tomaFisicaContValorUnt?: number;
    tomaFisicaContUpdated?: Date;
    tomaFisicaContUser?: string;

    constructor(data?: ITomaFisicaCompletoContDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tomaFisicaContId = _data["tomaFisicaContId"];
            this.bodegaUbicacionId = _data["bodegaUbicacionId"];
            this.bodegaUbicacionNombre = _data["bodegaUbicacionNombre"];
            this.productoId = _data["productoId"];
            this.productoNombre = _data["productoNombre"];
            this.productoLineaNombre = _data["productoLineaNombre"];
            this.productoSublineaNombre = _data["productoSublineaNombre"];
            this.productoMarcaNombre = _data["productoMarcaNombre"];
            this.tomaFisicaContCant = _data["tomaFisicaContCant"];
            this.tomaFisicaContValorUnt = _data["tomaFisicaContValorUnt"];
            this.tomaFisicaContUpdated = _data["tomaFisicaContUpdated"] ? new Date(_data["tomaFisicaContUpdated"].toString()) : undefined as any;
            this.tomaFisicaContUser = _data["tomaFisicaContUser"];
        }
    }

    static fromJS(data: any): TomaFisicaCompletoContDto {
        data = typeof data === 'object' ? data : {};
        let result = new TomaFisicaCompletoContDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tomaFisicaContId"] = this.tomaFisicaContId;
        data["bodegaUbicacionId"] = this.bodegaUbicacionId;
        data["bodegaUbicacionNombre"] = this.bodegaUbicacionNombre;
        data["productoId"] = this.productoId;
        data["productoNombre"] = this.productoNombre;
        data["productoLineaNombre"] = this.productoLineaNombre;
        data["productoSublineaNombre"] = this.productoSublineaNombre;
        data["productoMarcaNombre"] = this.productoMarcaNombre;
        data["tomaFisicaContCant"] = this.tomaFisicaContCant;
        data["tomaFisicaContValorUnt"] = this.tomaFisicaContValorUnt;
        data["tomaFisicaContUpdated"] = this.tomaFisicaContUpdated ? this.tomaFisicaContUpdated.toISOString() : undefined as any;
        data["tomaFisicaContUser"] = this.tomaFisicaContUser;
        return data;
    }
}

export interface ITomaFisicaCompletoContDto {
    tomaFisicaContId?: number;
    bodegaUbicacionId?: number;
    bodegaUbicacionNombre?: string | undefined;
    productoId?: string;
    productoNombre?: string | undefined;
    productoLineaNombre?: string | undefined;
    productoSublineaNombre?: string | undefined;
    productoMarcaNombre?: string | undefined;
    tomaFisicaContCant?: number;
    tomaFisicaContValorUnt?: number;
    tomaFisicaContUpdated?: Date;
    tomaFisicaContUser?: string;
}

export class TomaFisicaBloquearBodegaRequest implements ITomaFisicaBloquearBodegaRequest {
    tomaFisicaId?: number;

    constructor(data?: ITomaFisicaBloquearBodegaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tomaFisicaId = _data["tomaFisicaId"];
        }
    }

    static fromJS(data: any): TomaFisicaBloquearBodegaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TomaFisicaBloquearBodegaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tomaFisicaId"] = this.tomaFisicaId;
        return data;
    }
}

export interface ITomaFisicaBloquearBodegaRequest {
    tomaFisicaId?: number;
}

export class TomaFisicaAplicarRequest implements ITomaFisicaAplicarRequest {
    documentoId?: number;
    kardexNotas?: string | undefined;

    constructor(data?: ITomaFisicaAplicarRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentoId = _data["documentoId"];
            this.kardexNotas = _data["kardexNotas"];
        }
    }

    static fromJS(data: any): TomaFisicaAplicarRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TomaFisicaAplicarRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoId"] = this.documentoId;
        data["kardexNotas"] = this.kardexNotas;
        return data;
    }
}

export interface ITomaFisicaAplicarRequest {
    documentoId?: number;
    kardexNotas?: string | undefined;
}

export class TomaFisicaContLineaDto implements ITomaFisicaContLineaDto {
    tomaFisicaContId?: number;
    bodegaUbicacionId?: number;
    productoId?: string;
    productoNombre?: string | undefined;
    insumoUnidad?: string | undefined;
    tomaFisicaContCant?: number;
    tomaFisicaContValorUnt?: number;
    tomaFisicaContUpdated?: Date;
    tomaFisicaContUser?: string;

    constructor(data?: ITomaFisicaContLineaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tomaFisicaContId = _data["tomaFisicaContId"];
            this.bodegaUbicacionId = _data["bodegaUbicacionId"];
            this.productoId = _data["productoId"];
            this.productoNombre = _data["productoNombre"];
            this.insumoUnidad = _data["insumoUnidad"];
            this.tomaFisicaContCant = _data["tomaFisicaContCant"];
            this.tomaFisicaContValorUnt = _data["tomaFisicaContValorUnt"];
            this.tomaFisicaContUpdated = _data["tomaFisicaContUpdated"] ? new Date(_data["tomaFisicaContUpdated"].toString()) : undefined as any;
            this.tomaFisicaContUser = _data["tomaFisicaContUser"];
        }
    }

    static fromJS(data: any): TomaFisicaContLineaDto {
        data = typeof data === 'object' ? data : {};
        let result = new TomaFisicaContLineaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tomaFisicaContId"] = this.tomaFisicaContId;
        data["bodegaUbicacionId"] = this.bodegaUbicacionId;
        data["productoId"] = this.productoId;
        data["productoNombre"] = this.productoNombre;
        data["insumoUnidad"] = this.insumoUnidad;
        data["tomaFisicaContCant"] = this.tomaFisicaContCant;
        data["tomaFisicaContValorUnt"] = this.tomaFisicaContValorUnt;
        data["tomaFisicaContUpdated"] = this.tomaFisicaContUpdated ? this.tomaFisicaContUpdated.toISOString() : undefined as any;
        data["tomaFisicaContUser"] = this.tomaFisicaContUser;
        return data;
    }
}

export interface ITomaFisicaContLineaDto {
    tomaFisicaContId?: number;
    bodegaUbicacionId?: number;
    productoId?: string;
    productoNombre?: string | undefined;
    insumoUnidad?: string | undefined;
    tomaFisicaContCant?: number;
    tomaFisicaContValorUnt?: number;
    tomaFisicaContUpdated?: Date;
    tomaFisicaContUser?: string;
}

export class TomaFisicaProductoValidarDto implements ITomaFisicaProductoValidarDto {
    productoId?: string;
    productoNombre?: string;
    insumoUnidad?: string | undefined;
    tomaFisicaContValorUnt?: number;
    valorUnitarioSoloLectura?: boolean;

    constructor(data?: ITomaFisicaProductoValidarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productoId = _data["productoId"];
            this.productoNombre = _data["productoNombre"];
            this.insumoUnidad = _data["insumoUnidad"];
            this.tomaFisicaContValorUnt = _data["tomaFisicaContValorUnt"];
            this.valorUnitarioSoloLectura = _data["valorUnitarioSoloLectura"];
        }
    }

    static fromJS(data: any): TomaFisicaProductoValidarDto {
        data = typeof data === 'object' ? data : {};
        let result = new TomaFisicaProductoValidarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productoId"] = this.productoId;
        data["productoNombre"] = this.productoNombre;
        data["insumoUnidad"] = this.insumoUnidad;
        data["tomaFisicaContValorUnt"] = this.tomaFisicaContValorUnt;
        data["valorUnitarioSoloLectura"] = this.valorUnitarioSoloLectura;
        return data;
    }
}

export interface ITomaFisicaProductoValidarDto {
    productoId?: string;
    productoNombre?: string;
    insumoUnidad?: string | undefined;
    tomaFisicaContValorUnt?: number;
    valorUnitarioSoloLectura?: boolean;
}

export class TomaFisicaContUpsertRequest implements ITomaFisicaContUpsertRequest {
    productoId?: string;
    tomaFisicaContCant?: number;
    tomaFisicaContValorUnt?: number;

    constructor(data?: ITomaFisicaContUpsertRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productoId = _data["productoId"];
            this.tomaFisicaContCant = _data["tomaFisicaContCant"];
            this.tomaFisicaContValorUnt = _data["tomaFisicaContValorUnt"];
        }
    }

    static fromJS(data: any): TomaFisicaContUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TomaFisicaContUpsertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productoId"] = this.productoId;
        data["tomaFisicaContCant"] = this.tomaFisicaContCant;
        data["tomaFisicaContValorUnt"] = this.tomaFisicaContValorUnt;
        return data;
    }
}

export interface ITomaFisicaContUpsertRequest {
    productoId?: string;
    tomaFisicaContCant?: number;
    tomaFisicaContValorUnt?: number;
}

export class TransArcolactRequest implements ITransArcolactRequest {
    alPlanillaId?: number;
    bancoId?: number;
    transferenciaSecuencia?: string;
    transferenciaDescripcion?: string;
    transferenciaFechaTrasmision?: Date;
    transferenciaFechaAplicacion?: Date;

    constructor(data?: ITransArcolactRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alPlanillaId = _data["alPlanillaId"];
            this.bancoId = _data["bancoId"];
            this.transferenciaSecuencia = _data["transferenciaSecuencia"];
            this.transferenciaDescripcion = _data["transferenciaDescripcion"];
            this.transferenciaFechaTrasmision = _data["transferenciaFechaTrasmision"] ? new Date(_data["transferenciaFechaTrasmision"].toString()) : undefined as any;
            this.transferenciaFechaAplicacion = _data["transferenciaFechaAplicacion"] ? new Date(_data["transferenciaFechaAplicacion"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TransArcolactRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TransArcolactRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alPlanillaId"] = this.alPlanillaId;
        data["bancoId"] = this.bancoId;
        data["transferenciaSecuencia"] = this.transferenciaSecuencia;
        data["transferenciaDescripcion"] = this.transferenciaDescripcion;
        data["transferenciaFechaTrasmision"] = this.transferenciaFechaTrasmision ? formatDate(this.transferenciaFechaTrasmision) : undefined as any;
        data["transferenciaFechaAplicacion"] = this.transferenciaFechaAplicacion ? formatDate(this.transferenciaFechaAplicacion) : undefined as any;
        return data;
    }
}

export interface ITransArcolactRequest {
    alPlanillaId?: number;
    bancoId?: number;
    transferenciaSecuencia?: string;
    transferenciaDescripcion?: string;
    transferenciaFechaTrasmision?: Date;
    transferenciaFechaAplicacion?: Date;
}

export class PagingOfVehiculo implements IPagingOfVehiculo {
    count?: number;
    data?: Vehiculo[];

    constructor(data?: IPagingOfVehiculo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Vehiculo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfVehiculo {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfVehiculo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfVehiculo {
    count?: number;
    data?: Vehiculo[];
}

export class Vehiculo implements IVehiculo {
    vehiculoId?: number;
    vehiculoPlacas?: string;
    vehiculoTipo?: string;
    terceroId?: number;
    terceroNombre?: string | undefined;
    vehiculoConductorNombre?: string;
    vehiculoTarifa?: number;
    vehiculoIdExterno?: string | undefined;
    vehiculoBodegaId?: string | undefined;
    vehiculoActivo?: boolean | undefined;

    constructor(data?: IVehiculo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehiculoId = _data["vehiculoId"];
            this.vehiculoPlacas = _data["vehiculoPlacas"];
            this.vehiculoTipo = _data["vehiculoTipo"];
            this.terceroId = _data["terceroId"];
            this.terceroNombre = _data["terceroNombre"];
            this.vehiculoConductorNombre = _data["vehiculoConductorNombre"];
            this.vehiculoTarifa = _data["vehiculoTarifa"];
            this.vehiculoIdExterno = _data["vehiculoIdExterno"];
            this.vehiculoBodegaId = _data["vehiculoBodegaId"];
            this.vehiculoActivo = _data["vehiculoActivo"];
        }
    }

    static fromJS(data: any): Vehiculo {
        data = typeof data === 'object' ? data : {};
        let result = new Vehiculo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehiculoId"] = this.vehiculoId;
        data["vehiculoPlacas"] = this.vehiculoPlacas;
        data["vehiculoTipo"] = this.vehiculoTipo;
        data["terceroId"] = this.terceroId;
        data["terceroNombre"] = this.terceroNombre;
        data["vehiculoConductorNombre"] = this.vehiculoConductorNombre;
        data["vehiculoTarifa"] = this.vehiculoTarifa;
        data["vehiculoIdExterno"] = this.vehiculoIdExterno;
        data["vehiculoBodegaId"] = this.vehiculoBodegaId;
        data["vehiculoActivo"] = this.vehiculoActivo;
        return data;
    }
}

export interface IVehiculo {
    vehiculoId?: number;
    vehiculoPlacas?: string;
    vehiculoTipo?: string;
    terceroId?: number;
    terceroNombre?: string | undefined;
    vehiculoConductorNombre?: string;
    vehiculoTarifa?: number;
    vehiculoIdExterno?: string | undefined;
    vehiculoBodegaId?: string | undefined;
    vehiculoActivo?: boolean | undefined;
}

export class PagingOfVendedor implements IPagingOfVendedor {
    count?: number;
    data?: Vendedor[];

    constructor(data?: IPagingOfVendedor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Vendedor.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagingOfVendedor {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOfVendedor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagingOfVendedor {
    count?: number;
    data?: Vendedor[];
}

export class Vendedor implements IVendedor {
    vendedorId?: number;
    vendedorTerceroId?: number;
    vendedorNombre?: string | undefined;
    vendedorLiquidaCobros?: number | undefined;
    vendedorComisionVenta?: number | undefined;
    vendedorComisionCobro?: number | undefined;
    vendedorBonifCobro?: number | undefined;
    vendedorMaxPlazoComision?: number | undefined;
    vendedorMaxPlazoBonif?: number | undefined;
    vendedorBaseLiquidacion?: number | undefined;
    vendedorActivo?: boolean | undefined;
    vendedorReteRentaId?: number | undefined;
    vendedorRutaId?: number | undefined;
    vendedorRutaNombre?: string | undefined;
    vendedorMeta?: number | undefined;
    vendedorClave?: number | undefined;
    vendedorVehiculoId?: number | undefined;
    vendedorVehiculoPlacas?: string | undefined;
    vendedorMarcas?: string | undefined;
    vendedorSucursalId?: number | undefined;
    vendedorSucursalNombre?: string | undefined;
    vendedorCategoriaId?: number | undefined;
    vendedorCategoriaNombre?: string | undefined;
    vendedorCambiaRuta?: boolean | undefined;

    constructor(data?: IVendedor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendedorId = _data["vendedorId"];
            this.vendedorTerceroId = _data["vendedorTerceroId"];
            this.vendedorNombre = _data["vendedorNombre"];
            this.vendedorLiquidaCobros = _data["vendedorLiquidaCobros"];
            this.vendedorComisionVenta = _data["vendedorComisionVenta"];
            this.vendedorComisionCobro = _data["vendedorComisionCobro"];
            this.vendedorBonifCobro = _data["vendedorBonifCobro"];
            this.vendedorMaxPlazoComision = _data["vendedorMaxPlazoComision"];
            this.vendedorMaxPlazoBonif = _data["vendedorMaxPlazoBonif"];
            this.vendedorBaseLiquidacion = _data["vendedorBaseLiquidacion"];
            this.vendedorActivo = _data["vendedorActivo"];
            this.vendedorReteRentaId = _data["vendedorReteRentaId"];
            this.vendedorRutaId = _data["vendedorRutaId"];
            this.vendedorRutaNombre = _data["vendedorRutaNombre"];
            this.vendedorMeta = _data["vendedorMeta"];
            this.vendedorClave = _data["vendedorClave"];
            this.vendedorVehiculoId = _data["vendedorVehiculoId"];
            this.vendedorVehiculoPlacas = _data["vendedorVehiculoPlacas"];
            this.vendedorMarcas = _data["vendedorMarcas"];
            this.vendedorSucursalId = _data["vendedorSucursalId"];
            this.vendedorSucursalNombre = _data["vendedorSucursalNombre"];
            this.vendedorCategoriaId = _data["vendedorCategoriaId"];
            this.vendedorCategoriaNombre = _data["vendedorCategoriaNombre"];
            this.vendedorCambiaRuta = _data["vendedorCambiaRuta"];
        }
    }

    static fromJS(data: any): Vendedor {
        data = typeof data === 'object' ? data : {};
        let result = new Vendedor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendedorId"] = this.vendedorId;
        data["vendedorTerceroId"] = this.vendedorTerceroId;
        data["vendedorNombre"] = this.vendedorNombre;
        data["vendedorLiquidaCobros"] = this.vendedorLiquidaCobros;
        data["vendedorComisionVenta"] = this.vendedorComisionVenta;
        data["vendedorComisionCobro"] = this.vendedorComisionCobro;
        data["vendedorBonifCobro"] = this.vendedorBonifCobro;
        data["vendedorMaxPlazoComision"] = this.vendedorMaxPlazoComision;
        data["vendedorMaxPlazoBonif"] = this.vendedorMaxPlazoBonif;
        data["vendedorBaseLiquidacion"] = this.vendedorBaseLiquidacion;
        data["vendedorActivo"] = this.vendedorActivo;
        data["vendedorReteRentaId"] = this.vendedorReteRentaId;
        data["vendedorRutaId"] = this.vendedorRutaId;
        data["vendedorRutaNombre"] = this.vendedorRutaNombre;
        data["vendedorMeta"] = this.vendedorMeta;
        data["vendedorClave"] = this.vendedorClave;
        data["vendedorVehiculoId"] = this.vendedorVehiculoId;
        data["vendedorVehiculoPlacas"] = this.vendedorVehiculoPlacas;
        data["vendedorMarcas"] = this.vendedorMarcas;
        data["vendedorSucursalId"] = this.vendedorSucursalId;
        data["vendedorSucursalNombre"] = this.vendedorSucursalNombre;
        data["vendedorCategoriaId"] = this.vendedorCategoriaId;
        data["vendedorCategoriaNombre"] = this.vendedorCategoriaNombre;
        data["vendedorCambiaRuta"] = this.vendedorCambiaRuta;
        return data;
    }
}

export interface IVendedor {
    vendedorId?: number;
    vendedorTerceroId?: number;
    vendedorNombre?: string | undefined;
    vendedorLiquidaCobros?: number | undefined;
    vendedorComisionVenta?: number | undefined;
    vendedorComisionCobro?: number | undefined;
    vendedorBonifCobro?: number | undefined;
    vendedorMaxPlazoComision?: number | undefined;
    vendedorMaxPlazoBonif?: number | undefined;
    vendedorBaseLiquidacion?: number | undefined;
    vendedorActivo?: boolean | undefined;
    vendedorReteRentaId?: number | undefined;
    vendedorRutaId?: number | undefined;
    vendedorRutaNombre?: string | undefined;
    vendedorMeta?: number | undefined;
    vendedorClave?: number | undefined;
    vendedorVehiculoId?: number | undefined;
    vendedorVehiculoPlacas?: string | undefined;
    vendedorMarcas?: string | undefined;
    vendedorSucursalId?: number | undefined;
    vendedorSucursalNombre?: string | undefined;
    vendedorCategoriaId?: number | undefined;
    vendedorCategoriaNombre?: string | undefined;
    vendedorCambiaRuta?: boolean | undefined;
}

export class WeatherForecast implements IWeatherForecast {
    date?: Date;
    temperatureC?: number;
    temperatureF?: number;
    summary?: string;

    constructor(data?: IWeatherForecast) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.temperatureC = _data["temperatureC"];
            this.temperatureF = _data["temperatureF"];
            this.summary = _data["summary"];
        }
    }

    static fromJS(data: any): WeatherForecast {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherForecast();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["temperatureC"] = this.temperatureC;
        data["temperatureF"] = this.temperatureF;
        data["summary"] = this.summary;
        return data;
    }
}

export interface IWeatherForecast {
    date?: Date;
    temperatureC?: number;
    temperatureF?: number;
    summary?: string;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}